import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import i18n from 'i18next';
import 'intl-pluralrules';
import { DateTime } from 'luxon';

// src/assets/translations/en.json
var en_default = {
  currency: "{{val, currency(currency)}}",
  states: {
    AL: "Alabama",
    AR: "Arkansas",
    AS: "American Samoa",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VI: "Virgin Islands",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming"
  },
  printerStatus: {
    missing_paper: "Missing Paper",
    printer_error: "Printer Error",
    cover_open: "Cover Open",
    printer_offline: "Offline",
    active: "Active",
    paused: "Paused"
  },
  printerTypes: {
    kitchen: "KITCHEN PRINTERS",
    receipt: "RECEIPT PRINTERS"
  },
  screenNames: {
    CategoriesScreen: "Categories",
    SubcategoriesScreen: "Subcategories",
    ItemsScreen: "Items",
    ModifierItemsScreen: "ModifierItems",
    ModifierGroupsScreen: "ModifierGroups",
    ItemGroupsScreen: "ItemGroups",
    MenuTypesScreen: "Menus",
    DiscountScreen: "Discounts",
    CombosScreen: "Combos",
    UsersSettingsScreen: "Users",
    SpecialsScreen: "Specials",
    IngredientsScreen: "Ingredients",
    ReportingGroupsScreen: "Reporting Groups"
  },
  commonButtons: {
    pick: "Pick",
    copy: "Copy",
    paste: "Paste",
    associate: "Associate",
    add: "Add",
    cancel: "Cancel",
    close: "Close",
    signIn: "Sign In",
    back: "Back",
    logOut: "Log Out",
    save: "Save",
    ok: "Ok",
    continue: "Continue",
    saveChanges: "Save Changes",
    dontSaveChanges: "Don't save",
    discardChanges: "Discard Changes",
    reset: "Reset",
    done: "Done",
    clearAll: "Clear All",
    clear: "Clear",
    discard: "Discard",
    clone: "Clone",
    remove: "Remove",
    delete: "Delete",
    duplicate: "Duplicate",
    transfer: "Transfer",
    push: "Push",
    pull: "Pull",
    selectAll: "Select All",
    unassociate: "Unassociate",
    goBack: "Go Back",
    pushChanges: "Push Changes",
    dontPrint: "Don't print",
    create: "Create",
    edit: "Edit",
    confirm: "Confirm",
    next: "Next",
    retry: "Retry",
    skip: "Skip",
    enable: "Enable",
    hide: "Hide",
    deleteAll: "Delete All",
    removing: "Removing",
    stay: "Stay",
    anyway: "Anyway",
    leave: "Leave",
    pay: "Pay",
    setToPaid: "Set to Paid",
    hold: "Hold",
    rearrange: "Rearrange",
    settings: "Settings",
    override: "Override",
    update: "Update",
    sort: "Sort",
    set: "Set",
    apply: "Apply",
    more: "More",
    send: "Send",
    mergeOrders: "Merge Orders",
    printAll: "Print All",
    paid: "Paid",
    voided: "Voided",
    void: "Void",
    refund: "Refund",
    closeCheck: "Close Check",
    previousBucket: "Previous {{bucket}}",
    nextBucket: "Next {{bucket}}",
    choosePrinter: "Choose a Printer",
    chooseAPrinterForReceipt: "Choose a Printer for Receipt",
    distribute: "Distribute",
    download: "Download",
    reload: "Reload",
    deleteMultiple: "Delete {{ description }}",
    inactiveMultiple: "Inactivate {{ description }}",
    exit: "Exit",
    details: "Details"
  },
  commonTexts: {
    placeholderDropdown: "Select option",
    status: "Status",
    total: "Total",
    alert: "Alert",
    allSections: "All Sections",
    adding: "Adding",
    associated: "Associated",
    editing: "Editing",
    email: "Email",
    phone: "Phone",
    password: "Password",
    emailExample: "email@example.com",
    continue: "Continue",
    success: "Success",
    yes: "Yes",
    no: "No",
    and: "and",
    active: "Active",
    inactive: "Inactive",
    none: "None",
    before: "Before",
    after: "After",
    all: "All",
    location: "Location",
    na: "N/A",
    error: "Error",
    viewAll: "View All",
    default: "Default",
    defaultColor: "Default",
    updating: "Updating",
    creating: "Creating",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    name: "Name",
    emptyField: "Empty Field",
    notAvailable: "Not Available",
    delete: "Delete",
    selected: "Selected",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    other: "Other",
    user: "User",
    somethingWentWrong: "Something went wrong",
    noAssociations: "No Associations",
    noneFound: "No {{elementName}} Found With Selected Filters",
    kitchen: "Kitchen",
    table: "Table",
    receipt: "Receipt",
    refreshingData: "Refreshing Data",
    superAdmin: "Super Admin",
    multiple: "Multiple",
    noChanges: "No Changes",
    bank: "Bank",
    date: "Date",
    time: "Time",
    several: "Several"
  },
  components: {
    starCheckBox: {
      checked: "Marked as Favorite",
      unChecked: "Mark as Favorite"
    },
    menuCard: {
      tag: {
        menuTypeCount_zero: "{{count}} Menus",
        menuTypeCount_one: "1 Menu",
        menuTypeCount_other: "{{count}} Menus",
        itemCount_zero: "{{count}} Items",
        itemCount_one: "1 Item",
        itemCount_other: "{{count}} Items",
        elementCount_zero: "{{count}} Elements",
        elementCount_one: "1 Element",
        elementCount_other: "{{count}} Elements",
        itemGroupCount_zero: "{{count}} Item Groups",
        itemGroupCount_one: "1 Item Group",
        itemGroupCount_other: "{{count}} Item Groups",
        comboCount_zero: "{{count}} Combos",
        comboCount_one: "1 Combo",
        comboCount_other: "{{count}} Combos",
        itemFraction_zero: "{{count}} Items",
        itemFraction_one: "{{count}}/{{total}} Items",
        itemFraction_other: "{{count}}/{{total}} Items",
        itemAll: "All Items",
        categoryCount_zero: "{{count}} Categories",
        categoryCount_one: "1 Category",
        categoryCount_other: "{{count}} Categories",
        categoryFraction_zero: "{{count}} Categories",
        categoryFraction_one: "{{count}}/{{total}} Categories",
        categoryFraction_other: "{{count}}/{{total}} Categories",
        categoryAll: "All Categories",
        subcategoryCount_zero: "{{count}} Subcategories",
        subcategoryCount_one: "1 Subcategory",
        subcategoryCount_other: "{{count}} Subcategories",
        subcategoryCountShort_zero: "{{count}} Subcats",
        subcategoryCountShort_one: "1 Subcat",
        subcategoryCountShort_other: "{{count}} Subcats",
        subcategoryFraction_zero: "{{count}} Subcategories",
        subcategoryFraction_one: "{{count}}/{{total}} Subcategories",
        subcategoryFraction_other: "{{count}}/{{total}} Subcategories",
        subcategoryAll: "All Subcategories",
        modifierGroupCount_zero: "{{count}} Modifier Groups",
        modifierGroupCount_one: "1 Modifier Group",
        modifierGroupCount_other: "{{count}} Modifier Groups",
        modifierGroupFraction_zero: "{{count}} Modifier Groups",
        modifierGroupFraction_one: "{{count}}/{{total}} Modifier Groups",
        modifierGroupFraction_other: "{{count}}/{{total}} Modifier Groups",
        modifierGroupAll: "All Modifier Groups",
        modifierItemCount_zero: "{{count}} Modifier Items",
        modifierItemCount_one: "1 Modifier Item",
        modifierItemCount_other: "{{count}} Modifier Items",
        modifierItemFraction_zero: "{{count}} Modifier Items",
        modifierItemFraction_one: "{{count}}/{{total}} Modifier Items",
        modifierItemFraction_other: "{{count}}/{{total}} Modifier Items",
        modifierItemAll: "All Modifier Items",
        locationCount_zero: "{{count}} Locations",
        locationCount_one: "1 Location",
        locationCount_other: "{{count}} Locations",
        locationFraction_zero: "{{count}} Locations",
        locationFraction_one: "{{count}}/{{total}} Locations",
        locationFraction_other: "{{count}}/{{total}} Locations",
        locationAll: "All locations",
        modifierItemAbrevCountTag_zero: "{{count}} M. Items",
        modifierItemAbrevCountTag_one: "{{count}} M. Item",
        modifierItemAbrevCountTag_other: "{{count}} M. Items",
        roleCount_zero: "{{count}} Roles",
        roleCount_one: "1 Role",
        roleCount_other: "{{count}} Roles",
        userCount_zero: "{{count}} Users",
        userCount_one: "1 User",
        userCount_other: "{{count}} Users"
      }
    },
    actionButtons: {
      addNewCategory: "Add New Category",
      addExistingCategory: "Add Existing Category",
      cloneCategoryTag: "Cloning Category - {{element}}",
      addNewMenuType: "Add New Menu",
      addExistingMenuType: "Add Existing Menu",
      cloneMenuTypeTag: "Cloning Menu - {{element}}",
      addNewLocation: "Add New Location",
      addExistingLocation: "Add Existing Location",
      addNewSubcategory: "Add New Subcategory",
      addExistingSubcategory: "Add Existing Subcategory",
      cloneSubcategoryTag: "Cloning Subcategory - {{element}}",
      addNewItem: "Add New Item",
      addExistingItem: "Add Existing Item",
      addNewTax: "Add New Tax",
      addExistingTax: "Add Existing Tax",
      cloneItemTag: "Cloning Item - {{element}}",
      addNewModifierItem: "Add New Modifier Item",
      addExistingModifierItem: "Add Existing Modifier Item",
      cloneModifierItemTag: "Cloning Modifier Item - {{element}}",
      addNewModifierGroup: "Add New Modifier Group",
      addExistingModifierGroup: "Add Existing Modifier Group",
      cloneModifierGroupTag: "Cloning Modifier Group - {{element}}",
      addNewPricingVersion: "Add New Pricing Version",
      addNewCategoryTag: "New Category",
      addExistingCategoryTag: "Existing Category",
      addNewMenuTypeTag: "New Menu",
      addExistingMenuTypeTag: "Existing Menu",
      addNewLocationTag: "New Location",
      addExistingLocationTag: "Existing Location",
      addNewSubcategoryTag: "New Subcategory",
      addExistingSubcategoryTag: "Existing Subcategory",
      addNewItemTag: "New Item",
      addExistingItemTag: "Existing Item",
      addNewModifierItemTag: "New Modifier Item",
      addExistingModifierItemTag: "Existing Modifier Item",
      addNewModifierGroupTag: "New Modifier Group",
      addExistingModifierGroupTag: "Existing Modifier Group",
      addNewSpecial: "Add New Special",
      addExistingSpecial: "Add Existing Special",
      addNewDiscount: "Add New Discount",
      addNewDiscountTag: "New Discount",
      addExistingDiscount: "Add Existing Discount",
      addExistingDiscountTag: "Existing Discount",
      addNewCombo: "Add New Combo",
      addNewComboTag: "New Combo",
      addExistingCombo: "Add Existing Combo",
      addExistingComboTag: "Existing Combo",
      addNewSpecialTag: "New Special",
      addExistingSpecialTag: "Existing Special",
      addNewRole: "Add New Role",
      addNewRoleTag: "New Role",
      addExistingRole: "Add Existing Role",
      addExistingRoleTag: "Existing Role",
      addNewIngredient: "Add New Ingredient",
      addExistingIngredient: "Add Existing Ingredient",
      addNewIngredientTag: "New Ingredient",
      addExistingIngredientTag: "Existing Ingredient",
      addNewItemGroupTag: "New Item Group",
      addExistingDashboard: "Add Existing Dashboard"
    }
  },
  dateFormatter: {
    date: "{{date, DATE}}",
    dateHuge: "{{date, DATE_HUGE}}",
    time: "{{date, TIME}}",
    weekday: "{{date, WEEKDAY}}"
  },
  navBar: {
    common: {
      printerCenter: {
        title: "PRINTER CENTER",
        selectBackupPrinter: "Select Backup Printer",
        selectBackupPrinterPlaceholder: "Select a Printer",
        noMorePrinters: "No More Printers",
        backupPrinterUpdated: "Backup Printer Selected",
        printerNotFound: "Printer Not Found",
        noPrinterOption: "No Printer",
        transferToPrinter: "Transfer to Printer",
        printers: "Printers",
        printer: {
          viewJobs: "View Jobs",
          resume: "Resume",
          pause: "Pause",
          pauseSuccess: "Printer Paused Successfully",
          resumeSuccess: "Printer Resumed Successfully",
          printerErrorTitle: "Printer Error"
        },
        backupPrinter: {
          title: "Backup Printer",
          updating: "Updating Backup Printer",
          updateSuccess: "Backup Printer Updated Successfully"
        },
        printerStatus: {
          updating: "Updating printer status",
          error: "Error updating printer status"
        },
        printJobs: {
          title: "PRINT JOBS",
          printerName: "Printer Name",
          printerLocationName: "Printer Location",
          timePlaced: "Time",
          orderNumber: "Order",
          tabletPlacedFrom: "Tablet",
          userPlacedFrom: "User",
          printType: "Type",
          deleting: "Deleting Print Jobs",
          reprinting: "Reprinting Print Jobs",
          reprintSuccess: "Print Jobs Reprinted",
          deleteSuccess: "Print Jobs Deleted",
          deleteError: "Error Deleting Print Jobs",
          transferring: "Transferring Print Jobs",
          transferSuccess: "Print Jobs Transferred",
          transferError: "Error Transferring Print Jobs",
          noPrinterJobs: "No Print Jobs",
          deleteConfirmation: {
            title: "Delete Print Jobs",
            description: "Are you sure you want to delete the selected print jobs?"
          },
          jobType: {
            kitchen: "Kitchen",
            receipt: "Receipt",
            check: "Check",
            fire: "Fire"
          },
          status: {
            pending: "Pending",
            error: "Failed",
            inTransit: "Printing",
            complete: "Complete"
          },
          loadingPrintJobs: "Loading Print Jobs...",
          transferErrorModal: {
            description: "You cannot transfer Complete or Printing jobs."
          },
          transferReprint: {
            printer: "Select printer for {{types}} print jobs",
            printerLocation: "Select printer location for {{types}} print jobs"
          },
          notConfirmedWarning: "Print confirmation not received"
        }
      }
    }
  },
  register: {
    modals: {
      reprintTicketElement: {
        assignedPrepStations: "Assigned Printer Locations"
      },
      hotButtonsModifierItemNotFoundModal: {
        title: "not available",
        description: "cannot be added to"
      },
      itemDetails: {
        title: "Item Details",
        noModifiers: "No Modifiers",
        noItems: "No Items"
      },
      ticketElementInClosedChecks: {
        title: "Reopen closed checks",
        description: "The ticket item you are trying to modify is part of 1 or more closed checks. Re open related closed checks to continue.",
        btnSuccessText: "Reopen Checks"
      },
      printingReceiptOnPrinter: {
        success: "Printing receipt on {{name}}",
        error: "Error printing receipt on {{name}}"
      },
      discounts: {
        title: "Discounts",
        noItemSelected: "Select an Item to Apply an Item Discount",
        customDiscount: "Custom Discount",
        itemDiscounts: "Item Discounts",
        orderDiscounts: "Order Discounts",
        reason: "Discount Reason",
        noReason: "No Reason",
        additionalInfo: "Additional Info",
        discountType: "Discount Type",
        exclusiveDiscount: "Exclusive Discount",
        exclusiveDiscountDescription: "The selected Discount is marked as exclusive, all other discounts applied to the selected items will be replaced.",
        exclusiveDiscountOrderDescription: "The selected Discount is marked as exclusive, all other discounts applied to the current order will be replaced.",
        removingExclusiveDiscount: "Exclusive discount currently applied",
        removingExclusiveDiscountDescription: "The selected items have applied an exclusive discount, if you continue adding '{{selectedDiscount}}' the exclusive discount applied will be removed.",
        removingExclusiveOrderDiscountDescription: "The current order has applied an exclusive discount, if you continue adding '{{selectedDiscount}}' the exclusive discount applied will be removed.",
        overrideOrderDiscount: "Current order with discounts applied.",
        overrideOrderDiscountDescription: "The current order has {{discountsList}}, if you want to continue, all previous discounts would be removed.",
        multiple: "Multiple",
        multipleOrderDiscounts: "Multiple Discounts Applied",
        overridePriceUnderTheMax: "The override value should be under the lowest price: {{maxOverrideValue}}",
        itemsUnderOverrideValueTitle: "Item price below the override",
        itemsUnderOverrideValueSingleDescription: "The price of {{posName}} is below the desire override price: ${{overridePrice}}, you are not allowed to apply this discount.",
        itemsUnderOverrideValueMultipleDescription: "There are {{itemCount}} items, ({{posName}}) with a price below the desire override price: ${{overridePrice}}, you are not allowed to apply this discount to them."
      }
    },
    check: {
      masterCheckName: "Main"
    },
    detailsArea: {
      modals: {
        entity86ed: {
          entity: {
            item: "Item",
            modifierItem: "Modifier Item",
            ingredient: "Ingredient"
          },
          article: {
            item: "an",
            modifierItem: "a",
            ingredient: "an"
          },
          title: "{{entity}} 86'd",
          description: "You are trying to add {{article}} {{entity}} that has been 86'd.",
          continueMessage: "Do you want to continue?",
          orderAnyway: "Order Anyway",
          remove86Description: "Do you want to remove 86 on this {{entity}}?",
          confirmationDescription: "Do you want to 86 this {{entity}}?",
          remove86: "Remove 86",
          confirmationTitle: "86 {{entity}}?",
          remove86Title: "Remove 86?"
        }
      }
    },
    item: {
      quantitySelector: {
        quantity: "Quantity",
        ungroup: "Ungroup Item",
        custom: "10+"
      },
      singularItem: "Item",
      pluralItem: "Items",
      modifierGroups: {
        seats: {
          singular: "Seat",
          title: "Seats",
          shareItem: "Share Item",
          forTable: "For Table",
          noSeat: "No Seat",
          toGo: "To Go"
        }
      },
      courses: "Courses",
      type: "Item Type",
      noResultsLayer: "No Modifier Items associated with this Modifier Group match your Search",
      noResultsLayerGlobalActive: "No Modifier Items in the Menu match your Search",
      searchAllMods: "Search All Mods",
      itemStockCount: "Qty: {{stockCount}}",
      taxInc: "Tax Inc"
    },
    seating: {
      prompt: "Prompt\nSeat",
      seatLabel: "Seat {{seatId}}",
      seatColonLabel: "Seat: {{seatId}}",
      nextSeat: "Next Seat",
      seatManagement: "SEAT MANAGEMENT",
      unassignedQuantity: "{{quantity}} UNASSIGNED",
      share: "Share",
      addSeat: "Add Seat",
      forTable: "For Table",
      noSeat: "No Seat",
      emptySeating: "Pick Seat",
      allSeats: "All Seats",
      noTagsFound: "No Tags found",
      clearTags: "Clear Tags",
      resetAllTags: "Reset All Tags",
      seatTags: "Seat Tags",
      cannotDecrementSeatsModal: {
        title: "Minimum Seat Count: {{minSeats}}",
        description: "The Current Order contains Items or Checks related to the seats you are trying to remove."
      }
    },
    tabs: {
      sortBy: "Sort By",
      startTime: "Start Time",
      status: "Status",
      orderNumber: "Order Number"
    },
    tablesScreen: {
      messages: {}
    },
    ticketElements: {
      noItemsAddedToTheTicket: "No Items have been Added to the Ticket"
    }
  },
  app: {
    weightTypes: {
      kg: "kg",
      g: "g",
      oz: "Oz",
      lb: "Lb"
    },
    modals: {
      similarItems: {
        title: "{{count}} Similar Items Found",
        description: "There are already items ({{count}}) that are similar to the name entered. Would you like to edit one of them instead of creating a new one?",
        btnSuccessText: "Create New Item"
      },
      prepStation: {
        title: "Printer Location Selection",
        description: "The selected Item doesn't have a Printer Location assigned, please select one:",
        noPrepStations: "No Printer Locations available.",
        noPrepStation: "No Printer Location"
      },
      guestReceiptDiffModal: {
        basic: {
          showLogo: "Show Logo",
          showCheckTotals: "Show Check Totals",
          printMerchantCopy: "Print Merchant Copy",
          fontSize: "Font Size",
          fontWeight: "Font Weight",
          spaceBetweenItems: "Space between Items",
          showSuggestedTips: "Show Suggested Tips",
          showTipTotalLines: "Print tip/total lines",
          tipOption1: "Tip Option 1",
          tipOption2: "Tip Option 2",
          tipOption3: "Tip Option 3",
          showFooterDescription: "Show Footer Description",
          footerDescription: "Footer Description",
          showTaxesIndividually: "Show Taxes Individually",
          printOrderQr: "Print Order # QR Code in Footer"
        },
        items: {
          showItems: "Show Items",
          showItemUnitPrice: "Show Item Unit Price",
          displayDefaultModifiers: "Display Default Modifiers",
          groupSameModItems: "Group Same Mod Items",
          noForDeselectedDefaultModifiers: '"No" for Deselected Default Modifiers',
          hideModGroupTitles: "Hide Mod Group Titles",
          addSubForMultiSelectOff: 'Add "Sub" for Multi-Select Off',
          printZeroForFreeModItems: "Print $0.00 for free Mod Items",
          onlyPrintModItemsWithPrice: "Only Print Mod Items with Price",
          modifierItemDisplayMode: "Modifier Display Type"
        }
      },
      deactivateLicenseFromDevice: {
        title: "Deactivating License",
        description: "Are you sure you want to deactivate license"
      },
      userDetailsDiffModal: {
        basic: {
          active: "Status",
          firstName: "First Name",
          lastName: "Last Name",
          phoneNumber: "Phone Number",
          email: "E-mail",
          posName: "POS Name",
          payrollId: "Payroll ID",
          pin: "PIN",
          locationIds: "Locations",
          roleIds: "Roles",
          webPortalAccess: "Web Portal Access"
        },
        associations: {
          locations: "Locations",
          roles: "Roles"
        }
      },
      rolesDiffModal: {
        basic: {
          active: "Active",
          name: "Name",
          posName: "POS Name",
          backgroundColor: "Background Color",
          textColor: "Text Color"
        },
        home: {
          registerModuleDefault: "Register Module Default",
          menuModuleDefault: "Menu Module Default",
          settingsModuleDefault: "Settings Module Default",
          managementModuleDefault: "Management Module Default",
          reportsModuleDefault: "Reports Module Default",
          customersModuleDefault: "Customers Module Default",
          defaultModule: "Auto Open From Lock Screen",
          requireClockInOnPrompt: "Require Clock-In On Prompt"
        },
        endOfDay: {
          viewShiftSummary: "View Shift Summary"
        },
        register: {
          registerModuleAvailable: "Allow Access to this Module",
          createOrders: "Create Order",
          deleteOrders: "Void Order",
          modifyItemsSentToKitchen: "Modify Items Sent to Kitchen",
          editOtherUsersOrders: "Modify an order belonging to someone else",
          transferOrderOwner: "Transfer Order Owner",
          manageTables: "Manage Tables",
          addAnyDiscount: "Apply Discounts",
          addCustomDiscount: "Create Custom Discounts",
          overrideLicenseEditingId: 'Take "Edit" Control of an Order',
          reprint: "Reprint",
          deletePrintJobs: "Delete Print Jobs",
          allowChangeMenuType: "Change Menu",
          editItemPrice: "Edit Item Price",
          allow86: "86 Items, Modifiers, and Ingredients",
          showMenuSelector: "Show Menu Selector",
          behaviorOnNewOrder: "Behavior on New Order",
          createChecks: "Create Checks",
          voidRefundPayments: "Void/Refund Payments",
          createPayments: "Create Payments",
          batch: "Batch",
          manageDrawers: "Manage Drawers",
          reopenClosedOrders: "Reopen Closed Orders",
          transferPayments: "Transfer Payments to other Order",
          viewDrawerBalance: "View Drawer Balance",
          serverBankEnabled: "Server Bank Enabled",
          allowCashPaymentsToDrawersNotAttached: "Allow Cash Payments On Stations With No Drawers",
          createOpenItemsOrModItems: "Create Open Item or Mod Item",
          allowNoTaxInclusive: "Allow No Tax Inclusive",
          exemptTax: "Exempt Tax",
          manageServiceCharges: "Manage Service Charges",
          qsrActionOnPay: "QSR - Action on Pay/Send",
          defaultOrderType: "Default Order Type",
          autoFilterTableTabsOrders: "Auto Filter Orders To User",
          navigationActionOnSendButton: 'TSR - Action on "Send"',
          navigationActionOnDoneButton: 'TSR - Action on "Done"',
          navigationActionOnSendButtonToolTip: 'Select what should happen when using the "send" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
          navigationActionOnSendStayButton: 'TSR - Action on "Send/Stay"',
          navigationActionOnSendStayButtonToolTip: 'Select what should happen when using the "send/stay" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
          defaultRegisterScreen: "Default Register Screen",
          voidIndividualItems: "Void Individual Items",
          sendIndividualItems: "Send Individual Items",
          makeHouseChargePayments: "Make House Charge Payments",
          makeGiftCardPayments: "Make Gift Card Payments",
          navigationActionOnCloseOrder: "Action on Close Order",
          navigationActionOnTipPending: "Action on Tip Pending",
          navigationActionOnPrintChecks: "Action on Print Checks",
          navigationActionOnFire: "Action on Fire",
          viewPrinterCenter: "View Printer Center",
          changePrinterStatus: "Change Printer Status",
          transferPrintJobs: "Re-assign Backup Printer",
          reAssignBackupPrinter: "Transfer Print Jobs",
          reprintClosedCheck: "Reprint closed check",
          reprintReceipt: "Reprint receipt",
          refundTypeRefund: "Refund",
          refundTypeAsDiscount: "Refund as Discount",
          refundTypeToBalanceDueOfZero: "Refund to Balance Due of Zero",
          refundTypeReplacePayment: "Replace Payment",
          printEndOfShiftReportOnClockOut: "Print End of Shift Report on Clock Out",
          cashPaymentOptions: "Cash Payment Options"
        },
        menu: {
          menuModuleAvailable: "Allow Access to this Module",
          accessMasterMenu: "Access Enterprise Mode",
          massUpdate: "Mass Update"
        },
        settings: {
          settingsModuleAvailable: "Allow Access to this Module",
          accessMasterSettings: "Access Enterprise Mode"
        },
        management: {
          managementModuleAvailable: "Allow Access to this Module"
        },
        reports: {
          reportsModuleAvailable: "Allow Access to this Module"
        },
        customers: {
          customersModuleAvailable: "Allow Access to this Module"
        },
        webHomeScreen: {
          dashboardIds: "Dashboards",
          defaultDashboardId: "Default Dashboard",
          noDefaultDashboardId: "No Default Dashboard"
        }
      },
      registerTicketDiffModal: {
        ticketDisplay: {
          showTimestamps: "Show Timestamp",
          showSendCourseButton: "Show Send Course Button",
          autoCollapseLineItems: "Auto Collapse Line Items",
          displayDefaultModifiers: "Display Default Modifiers",
          showModifierItemPrice: "Show Mod Item Price",
          hideModGroupTitles: "Hide Mod Group Titles",
          modifierItemDisplayMode: "Modifier Display Type",
          groupSameModItems: "Group Same Mod Items",
          addSubForMultiSelectOff: 'Show "Sub" for MultiSelect Off',
          noForDeselectedDefaultModifiers: 'Show "No" for Deselected Mod Items',
          separateSentItems: "Separate Sent Items"
        }
      },
      registerModeDiffModal: {
        general: {
          registerDisplay: {
            showModTagBar: "Show Mod Tag Bar",
            showConfirmPopupToRemoveItem: 'Show "Confirm Pop-Up" to Remove an Item',
            showConfirmPopUpOnClearUnsentWithinAnItem: 'Show "Confirm Pop-Up" on "Clear Unsent" Within an Item',
            showSentItemModificationsOnRegisterTicket: "Show Sent Item Modifications",
            showConfirmPopUpOnLeaveIncompleteItem: 'Show "Confirm Pop-Up" when Navigating Away from an Incomplete Item',
            showHotButtonToggle: "Show Hot Buttons toggle",
            enforceItemGroupOrderForCombos: "Enforce Item Group Order For Combos",
            defaultRestaurantMode: "Restaurant Mode",
            persistSelectedCategoryOnItemSelection: "Persist Selected Category on Item Selection",
            showNotificationMessageForPrinterErrors: "Show Printer Errors Notification",
            showPrinterStatusNotifications: "Show Printer Status Notifications",
            firePositionOnRegisterTicket: "Fire Position on Register Ticket",
            showDoneButton: 'Show "Done" Button',
            printHeldItems: "Print Held Items"
          },
          orderTypesAvailable: {
            isCateringAvailable: "Catering",
            isCurbsideAvailable: "Curbside",
            isDeliveryAvailable: "Delivery",
            isDineInAvailable: "Dine-In",
            isToGoAvailable: "To go"
          },
          specialTags: {
            active: "Status",
            name: "Name",
            posName: "POS Name",
            abbreviation: "Abbreviation",
            specialTagId: "Special Tag",
            color: "Color",
            textColor: "Text Color"
          },
          modifierTags: {
            active: "Status",
            name: "Name",
            posName: "POS Name",
            checkName: "Check Name",
            tagPosition: "Tag Position",
            sortPriority: "Sort Priority",
            menuTypeIds: "Menus"
          },
          discountReasons: {
            active: "Status",
            name: "Name",
            posName: "POS Name",
            sortPriority: "Sort Priority",
            isDiscount: "Void or Discount Reason",
            isVoid: "Void or Discount Reason"
          },
          timeBasedMenuType: {
            id: "No.",
            time: "Time",
            day: "Day",
            startTime: "From",
            endTime: "To",
            menuTypeId: "Menu",
            defaultMenuTypeId: "Default Menu"
          }
        },
        tags: {
          orderSeatTags: {
            sortPriority: "Sort Priority",
            active: "Status",
            isOrderTag: "Order Or Seat Tag",
            isSeatTag: "Order Or Seat Tag",
            type: "Type",
            name: "Name",
            posName: "POS Name",
            backgroundColor: "Color",
            textColor: "Text Color",
            orderTagFavorite: "Order Favorite",
            seatTagFavorite: "Seat Favorite"
          },
          openItemTypes: {
            active: "Status",
            name: "Name",
            posName: "POS Name",
            dontPromptOpenItemName: "Don't Prompt Name",
            sortPriority: "Sort Priority",
            prepStationId: "Printer Location",
            taxIds: "Taxes",
            reportingGroupsIds: "Reporting Groups"
          }
        },
        tableService: {
          general: {
            seating: "Seating",
            allowForTableButton: 'Allow "For Table"',
            enableDragDropForSeatPopover: "Enable Drag & Drop for Seat Popover",
            ticketSeatBar: "Ticket Seat Bar",
            showConfirmPopUpWhenSendingItemsInSeatView: "Show Confirm Pop-Up when Sending Items In Seat View",
            showSeatOneDescription: "Show Seat One Description",
            showSendItemsModal: 'Show pop-up window when using the "Send" key',
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: "Don\u2019t allow navigation when Items have not been sent to Kitchen",
            showIndicatorWhenItemsOnTicketNotSentToKitchen: 'Show "Items not Sent to Kitchen" Indicator',
            seatingMode: "Seating Mode",
            prepStationForFireTicketId: "Fire Tickets To Printer Location:",
            showOrderDetailsForNewOrderTsr: "Show Order Details for New Order",
            showOrderDetailsForDefaultNewOrder: "Show Order Details for Default New Order",
            showGuestCount: "Show Guest Count",
            defaultGuestCountOnNewOrder: "Default Guest Count On New Order",
            setGuestCountToZeroWhenNoTable: "Set Guest Count to Zero When No Table",
            setGuestCountToZeroOnToGoOrders: "Set Guest Count to Zero On To-Go Orders",
            attachNoSeatToToGo: 'Attach "No Seat" to "To Go"',
            keepTipPendingOrdersAssociatedToTable: "Keep Tip Pending Orders Associated to a Table",
            enableMapLayoutDragAndDrop: "Enable Drag & Drop for Table Map",
            showTableBorderForLoggedInUsersOrders: "Highlight User's Tables",
            seatManagementButtonFunction: "Seat Management Button Function"
          },
          tableLayout: {
            showSeatsOnTableLayout: "Show number of seats for a table",
            showTimerOnTableLayout: "Show status timer",
            useCleaningStatusOnTableLayout: 'Use "Cleaning" status',
            allowOpenTabsOnTableLayout: "Allow Open Tabs"
          },
          coursing: {
            coursingMode: "Coursing Mode",
            coursing: "Coursing",
            autoTriggering: "Auto Trigger",
            active: "Status",
            sortPriority: "Sort Priority",
            name: "Course",
            posName: "POS Name",
            kitchenName: "Kitchen Name",
            triggerTime: "Auto Trigger (min)",
            groupRounds: "Group Rounds"
          }
        },
        quickService: {
          general: {
            assignOrderTag: "Show Order Tag",
            sendOrderToKitchenTrigger: "Send order to Kitchen when",
            qsrSendAndPayActionButtons: "Send and Pay Action Buttons",
            showOrderDetailsForNewOrderQsr: "Show Order Details For New Order"
          }
        },
        customerFacingDisplay: {
          general: {
            receiptScreenTimeout: "Receipt Screen Timeout (seconds)",
            requireClientSignature: "Prompt Client Signature",
            payThroughCfdOnly: "Pay through CFD only",
            promptStarRatings: "Prompt Star Ratings",
            darkMode: "Dark Mode",
            promptPrintReceipt: "Prompt Print Receipt"
          },
          ads: {
            isFacebookActive: "Facebook",
            isXActive: "X",
            isInstagramActive: "Instagram",
            facebookAccount: "Facebook user name",
            xAccount: "X user name",
            instagramAccount: "Instagram user name",
            placeholderBackground: "Placeholder Background",
            adTextBackground: "Ad Text Background",
            mediaLinksBackground: "Text/Social Media links"
          },
          tips: {
            showTippingOptionsAtCheckout: "Prompt for tip",
            showCfdTipSelectionOnRegister: "Show tip to cashier",
            defaultSuggestedTip: "Suggested Tip as Default",
            suggestedTip1: "Tip Option 1",
            suggestedTip2: "Tip Option 2",
            suggestedTip3: "Tip Option 3"
          },
          adsTable: {
            sortPriority: "Sort Priority",
            active: "Active",
            imageUrl: "Image",
            title: "Title",
            text: "Text",
            price: "Price"
          }
        },
        endOfDay: {
          clockOut: {
            requireNoOpenOrders: "Require no Open Orders",
            requireNonCashTips: "Require Non-Cash Tips",
            requireServerBankSettlement: "Require Server Bank Settlement",
            netNonCashTipsOnSettlement: "Tips on Cash Settlement",
            requireCashtipReporting: "Require Cash Tip Reporting",
            requireDrawerSettlement: "Require Drawer Settlement",
            displayTipsDueInHeader: 'Display "Tips Due" in Header on Shift Report',
            zeroTipsDueOnClockOut: 'Zero "Tips Due" on clockout',
            autoSettleDrawerId: "Auto Settle Drawer"
          }
        }
      },
      prepStationsDiffModal: {
        active: "Status",
        name: "Name",
        posName: "POS Name",
        printerIds: "Printer (s)",
        defaultPrepStationId: "Default Printer Location"
      },
      kitchenTicketDiffModal: {
        prepStations: {
          applyChangesToOtherPrepStation: {
            title: "Apply to Specific Printer Locations",
            buttonTitle: "Apply these changes to other Printer Locations",
            description: "Select the other Printer Locations to which you want to apply the changes.",
            applyChanges: "Apply Changes",
            selectAllPrepStations: "Select All Printer Locations",
            applyChangesToAllPrepStations: "Apply to All Printer Locations"
          }
        },
        ticketDisplay: {
          showCheckTotals: "Show Check Totals",
          showSuggestedTips: "Show Suggested Tips",
          showTipTotalLines: "Print tip/total lines",
          tipOptionOne: "Tip Option 1",
          tipOptionTwo: "Tip Option 2",
          tipOptionThree: "Tip Option 3",
          showFooterDescription: "Show Footer Description",
          footerDescription: "Footer Description",
          showItems: "Show Items",
          showLogo: "Show Logo",
          fontSize: "Font Size",
          printUnfiredItems: "Print Unfired Items",
          printModifications: "Print Modifications",
          showCourses: "Show Courses",
          showOrderTags: "Show Order Tags",
          showSeatTags: "Show Seat Tags",
          headerBlankSpace: "Header Blank Space",
          elementSpacing: "Space between Items",
          orderTagsFontSize: "Order Tags Font Size",
          orderTagColors: "Order Tag Colors",
          displayDefaultModifiers: "Display Default Modifiers",
          consolidateByItem: "Consolidate By Item",
          hideModGroupTitles: "Hide Mod Group Titles",
          groupSameModItems: "Group Same Mod Items",
          addSubForMultiSelectOff: 'Add "Sub" for Multi-Select Off',
          noForDeselectedDefaultModifiers: '"No" for Deselected Default Modifiers',
          modifierItemDisplayMode: "Modifier Display Type",
          colorOfModifierItems: "Color Of Modifier Items",
          groupBySeat: "Group By Seat",
          updateOrderNewText: "New Item",
          updateOrderVoidText: "Item Voided",
          updateOrderTextPosition: "Position for Updated Item Text",
          updateOrderTextColor: "Text Color",
          printPriceForFreeModItems: "Print $0.00 for free Mod Items",
          onlyPrintModItemsWithPrice: "Only Print Mod Items with Price",
          showItemUnitPrice: "Show Item Unit Price",
          taxIndicatorPosition: "Position for Indicator",
          taxIndicatorColor: "Indicator Color",
          taxIndicator: "Taxable Indicator",
          taxExemptIndicator: "Tax Exempt Indicator",
          showTaxIndicator: "Show Tax Indicator",
          fontWeight: "Font Weight",
          sortItemsBy: "Sort Items By",
          secondSortItemsBy: "Second Sort Priority",
          customTypeNameDineIn: "Custom Dine-In Name",
          customTypeNameCurbside: "Custom Curbside Name",
          customTypeNameToGo: "Custom To Go Name",
          customTypeNameDelivery: "Custom Delivery Name",
          customTypeNamePickup: "Custom Pickup Name",
          showCourseName: "Show Course Name",
          changeNoSeatTextInToGoOrders: "Change No Seat Text In To Go Orders",
          showTaxesIndividually: "Show Taxes Individually",
          printOrderQr: "Print Order # QR Code in Footer"
        }
      },
      generalSettingsDiffModal: {
        information: {
          name: "N/A",
          websiteUrl: "N/A",
          phoneNumber: "N/A",
          digitalLogoUrl: "Digital Logo",
          printLogoUrl: "Print Logo",
          organizationPhoneNumber: "Organization Phone Number",
          locationPhoneNumber: "Location Phone Number",
          organizationName: "Organization Name",
          organizationWebsiteUrl: "Organization Website",
          locationName: "Location Name",
          locationWebsiteUrl: "Location Website",
          streetLine1: "Street",
          streetLine2: "Street 2",
          city: "City",
          state: "State",
          postalCode: "Zip Code"
        },
        general: {
          clockInMode: "Clock-In behavior",
          pinpadLayout: "Pin Pad Layout",
          allowUserToBeLoggedIntoMultipleTablets: "Allow User to be logged into Multiple Tablets"
        },
        hoursOfOperation: {
          changes: {
            timeZone: "Time Zone",
            endOfBusinessDay: "End of Business Day"
          },
          hoursOfOperation: {
            day: "Day",
            startTime: "From",
            endTime: "To"
          }
        }
      },
      customersDiffModal: {
        basic: {
          firstName: "First Name",
          middleName: "Middle Name",
          lastName: "Last Name",
          dateOfBirth: "Date Of Birth",
          email: "Email",
          phoneNumber: "Phone Number",
          customerNotes: "Customer Notes"
        },
        addressInfo: {
          isDefault: "Default",
          addressType: "Address Type",
          addressName: "Hotel/Office Name",
          unitNumber: "Unit #",
          streetLine1: "Street 1",
          streetLine2: "Street 2",
          state: "State",
          city: "City",
          postalCode: "Zip",
          hotelName: "Hotel Name",
          roomNumber: "Room #",
          officeName: "Office Name",
          apartmentNumber: "Apartment #"
        }
      },
      freshSheetDiffModal: {
        items: {
          currentAmount: "On-Hand Qty",
          is86ed: "Is 86'd?",
          freshSheetSortPriority: "Order",
          name: "Name"
        }
      },
      reportingGroupsDiff: {
        changes: {
          name: "Name",
          active: "Status",
          itemIds: "Items",
          comboIds: "Combos"
        }
      },
      itemsDiff: {
        linkedModifierItems: {
          shareNames: "Share Names",
          sharePrice: "Share Price",
          shareMods: "Share Mods"
        },
        guestCheckDisplay: {
          showModifiers: "Show Modifiers",
          showModItemPrice: "Show Mod Item Price"
        },
        prepStationsChanges: {
          showPrepStationSelectionModal: "Show Printer Location Selection Modal"
        },
        modifierGroupsExtra: {
          showAllMods: 'Show "All Mods"',
          allModsBehavior: '"All Mods" Behavior',
          showAllModsAlphabetizeButtons: 'Show "All Mods" Alphabetize Buttons',
          showAllModsHalfSizeButtons: '"All Mods" Half Size Buttons'
        },
        sectionTitles: {
          changesByMenuTypes: "CHANGES BY MENUS",
          register: "REGISTER",
          pricing: "PRICING",
          modifierGroups: "MODIFIERS",
          premadeModifierGroups: "PREMADE MODIFIER GROUP",
          suggestiveOrdering: "SUGGESTIVE ORDERING",
          inventory: "INVENTORY",
          prepStations: "PRINTER LOCATIONS"
        },
        menuType: {
          description: "Select the Menus you want to see the Item information for.",
          newMenuType: "New Menu",
          newModifierGroup: "New Modifier Group",
          menuTypeRemoved: "You have removed this Menu",
          applyChangesToOtherMenuTypes: {
            buttonTitle: "Apply these changes to other Menus",
            title: "Apply changes to other Menus",
            description: "Select the other Menus to which you want to apply the changes.",
            applyChanges: "Apply Changes",
            selectAllMenuTypes: "Select All Menus",
            deselectAllMenuTypes: "Deselect All Menus"
          },
          applyChangesToAllMenusTypes: {
            buttonTitle: "Apply to All Menus",
            title: "Apply changes to all Menus",
            description: "Select all Menus to apply the changes.",
            applyChanges: "Apply Changes",
            selectAllMenuTypes: "Select All Menus",
            deselectAllMenuTypes: "Deselect All Menus"
          },
          applyChangesToSpecificMenusTypes: {
            buttonTitle: "Apply to Specific Menus",
            title: "Apply changes to specific Menus",
            description: "Select the specific Menus to which you want to apply the changes.",
            applyChanges: "Apply Changes",
            selectAllMenuTypes: "Select All Menus",
            deselectAllMenuTypes: "Deselect All Menus"
          }
        },
        master: {
          name: "Name",
          customId: "Custom ID",
          categoryId: "Category",
          subcategoryId: "Subcategory",
          locationIds: "Locations",
          linkedModifierItems: "Linked Mod Item(s)",
          reportingGroupIds: "Reporting Groups",
          removeReportingGroupIds: "Remove Reporting Groups"
        },
        basic: {
          name: "Name",
          posName: "POS Name",
          kdsName: "Kitchen Name",
          checkName: "Check Name",
          onlineName: "Online Name",
          courseId: "Coursing",
          allowSharing: "Allow Sharing",
          active: "Status",
          activeOnline: "Show Item Online",
          delivery: "Disable delivery",
          calories: "Calories",
          prepTime: "Prep Time",
          restrictions: "Restrictions",
          ageRestricted: "Age Restriction",
          ageThreshold: "Age Threshold",
          imageUrl: "Item Image",
          secondaryImageUrl: "Secondary Image",
          defaultNoSeat: "Default No Seat",
          required: "Make Required"
        },
        registerInfo: {
          transparentBackground: "Transparent Background",
          hideItemName: "Hide Item Name",
          hideComboName: "Hide Combo Name",
          customizer: "Customizer",
          customizerShape: "Customizer Shape",
          backgroundColor: "Background Color",
          textColor: "Text Color",
          kdsColor: "Kitchen Color",
          specialTagId: "Special Tag",
          displayPictureOnCard: "Display Picture on Item Card",
          enterItemDetails: "Enter Item Details when added to ticket",
          exitItemDetailsOnRequiredModCompletion: " Exit Item Details on Required Mod Completion",
          displayItemPriceOnRegister: "Display Item Price on Register",
          displayComboPriceOnRegister: "Display Combo Price on Register",
          doneIsForTable: '"Done" is "For Table"'
        },
        moreInfo: {
          description: "Description",
          onlineDescription: "Online Description",
          recipe: "Recipe"
        },
        ingredientsExtra: {
          showIngredients: "Show Ingredients"
        },
        pricing: {
          itemPrice: "Item Base Price",
          onlinePrice: "Online Price",
          deliveryPrice: "Delivery Price",
          toGoPrice: "To Go Price",
          taxInclusive: "Tax Inclusive",
          excludeFromSuggestedTip: "Exclude From Suggested Tip",
          defaultModifiersPrice: "Total Price",
          itemPriceNormal: "Item Price",
          modPrice: "Mod Price",
          total: "Total",
          excludeFromDiscounts: "Exclude From Discounts",
          removeFromCheck: "Remove from Check",
          comboBasePrice: "Combo Base Price",
          promptForPrice: "Prompt for Price",
          taxExempt: "Tax Exempt"
        },
        dimensions: {
          dimensionsSellBy: "Sell By",
          dimensionsVolumePerUnit: "Volume Per Unit",
          dimensionsWeightPerUnit: "Weight Per Unit",
          dimensionsVolumeUnit: "Volume Unit",
          dimensionsWeightUnit: "Weight Unit"
        },
        inventory: {
          initialAmount: "Initial Amount",
          currentAmount: "Current Amount",
          resetStockDaily: "Reset stock daily",
          showOnFreshSheet: "Show on Fresh Sheet",
          noCurrentStock86Item: "86 Item when Current Stock is 0",
          resetStockToInitialAtZero: "Reset Stock to Initial when at 0",
          trackInventory: "Inventory Tracking",
          is86ed: "Is 86'd",
          actionWhenCurrentStockZero: "Action when Stock hits 0",
          showQuantityOnItemCard: "Show Amount in Item Card",
          volume: "Volume",
          unit: "Unit",
          universalProductCode: "UPC"
        },
        suggestiveOrdering: {
          suggestiveOrdering: "Item has Suggestive ordering",
          suggestiveOrderingItemPrice: "Suggestion Special Price",
          suggestiveOrderingPrompt: "Prompt",
          suggestiveOrderingItemId: "Item"
        },
        modifierGroup: {
          active: "Status",
          requiredModifierItems: "Required",
          includedModifierItems: "Included",
          maximumModifierItems: "Maximum",
          defaultModifierGroupPricingVersionId: "Pricing Version",
          sortPriority: "Sort Priority",
          selectedDefault: "Selected Default",
          defaultSelectionPrice: "Mod Price",
          advancedModifier: "Advanced Modifier",
          isAllMod: "Premade"
        },
        modifierItem: {
          defaultQuantitySelected: "Default Quantity",
          defaultAmountSelected: "Default Amount",
          isSelected: "Selected",
          active: "Status",
          includedMasterPrice: "Included Price",
          additionalMasterPrice: "Additional Price",
          includedLightPrice: "Included Lite",
          includedRegularPrice: "Included Regular",
          includedExtraPrice: "Included Extra",
          additionalLightPrice: "Additional Lite",
          additionalRegularPrice: "Additional Regular",
          additionalExtraPrice: "Additional Extra",
          maximumQuantity: "Maximum Quantity"
        },
        taxes: {
          isActive: "Active",
          menuTypeInheritedTaxes: "Inherited Menu Taxes",
          categoryInheritedTaxes: "Inherited Category Taxes",
          subcategoryInheritedTaxes: "Inherited Subcategory Taxes",
          taxIds: "Custom Item Taxes"
        }
      },
      combosDiff: {
        sectionTitles: {
          itemGroups: "ITEM GROUPS"
        },
        menuType: {
          description: "Select the Menus you want to see the Combo information for.",
          newItemGroup: "New Item Group"
        },
        itemGroup: {
          posName: "Name",
          required: "Required",
          active: "Active",
          sortPriority: "Sort Priority",
          quantity: "Quantity"
        },
        itemOfItemGroup: {
          active: "Active",
          additionalPrice: "Upcharge",
          sortPriority: "Sort Priority"
        },
        registerInfo: {
          displayPictureOnCard: "Display Picture on Combo Card"
        },
        taxes: {
          isActive: "Active",
          menuTypeInheritedTaxes: "Inherited Menu Taxes",
          categoryInheritedTaxes: "Inherited Category Taxes",
          subcategoryInheritedTaxes: "Inherited Subcategory Taxes",
          taxIds: "Custom Combo Taxes"
        }
      },
      specialsDiff: {
        master: {
          name: "Name"
        },
        sectionTitles: {
          specialsScheme: "SPECIALS SCHEME",
          availability: "AVAILABILITY"
        },
        menuType: {
          description: "Select the Menus you want to see the Special information for."
        },
        specialsScheme: {
          specialApplyTo: "Apply To",
          discountType: "Discount Type",
          discountAmountPercentage: "Discount Percentage",
          discountAmount: "Discount Amount",
          thresholdAmount: "Threshold Amount",
          buyQuantity: "Buy Quantity",
          getQuantity: "Get Quantity"
        },
        getItemsFields: {
          mimicItems: "Mimic Buy Items/Combos",
          buyItemIds: {
            title: {
              bogo: {
                combos: "Buy Combos",
                items: "Buy Items"
              },
              item: {
                combos: "Combos",
                items: "Items"
              }
            }
          },
          getItemIds: {
            title: {
              bogo: {
                combos: "Get Combos",
                items: "Get Items"
              }
            }
          }
        }
      },
      menuTypesDiffModal: {
        sectionTitles: {
          taxes: "TAXES",
          associations: "ASSOCIATIONS"
        },
        basic: {
          active: "Status",
          posName: "POS Name",
          enableSimpleMode: "Simple Mode (No Categories Bar)",
          comboDisplayName: "Combo Display Name",
          coursingType: "Coursing Type",
          defaultToHomeScreen: "Default to Home Screen after Item Selection"
        },
        master: {
          name: "Name",
          itemIds: "Items",
          categoryIds: "Categories",
          comboIds: "Combos"
        },
        moreInfo: {
          description: "Description"
        }
      },
      discountsDiffModal: {
        sectionTitles: {
          taxes: "TAXES",
          associations: "ASSOCIATIONS"
        },
        basic: {
          active: "Status",
          posName: "POS Name",
          checkName: "Check Name",
          requireReason: "Require Reason"
        },
        master: {
          name: "Name",
          locationIds: "Locations"
        },
        moreInfo: {
          description: "Description"
        },
        discountScheme: {
          applyTo: "Apply To",
          type: "Discount Type",
          value: {
            percentage: "Discount Percentage",
            amount: "Discount Amount"
          },
          exclusive: "Exclusive Discount",
          taxes: "Taxes"
        }
      },
      subcategoriesDiffModal: {
        master: {
          name: "Name",
          categoryId: "Subcategory"
        },
        basic: {
          posName: "POS Name",
          active: "Status",
          backgroundColor: "Background Color",
          textColor: "Text Color",
          customizer: "Customizer Subcategory",
          imageUrl: "Image",
          description: "Description"
        },
        moreInfo: {
          description: "Description"
        },
        associations: {
          itemIds: "Items",
          comboIds: "Combos"
        }
      },
      categoriesDiffModal: {
        master: {
          name: "Name",
          childrenType: "Category Children",
          customizer: "Customizer Category"
        },
        basic: {
          posName: "POS Name",
          active: "Status",
          backgroundColor: "Background Color",
          textColor: "Text Color"
        },
        moreInfo: {
          description: "Description"
        },
        associations: {
          itemIds: "Items",
          subcategoryIds: "Subcategories",
          comboIds: "Combos"
        }
      },
      modifierItemsDiffModal: {
        newPricingVersion: "New Pricing Version",
        sectionTitles: {
          pricing: "PRICING"
        },
        master: {
          name: "Name"
        },
        basic: {
          posName: "POS Name",
          kdsName: "Kitchen Name",
          checkName: "Check Name",
          onlineName: "Online Name",
          active: "Active",
          removeItemTaxExempt: "Remove Item Tax Exempt"
        },
        pricing: {
          description: "Select the Pricing Version you want to see the information for.",
          pricingVersionRemoved: "You have removed this Pricing Version",
          name: "Name",
          includedMasterPrice: "Included Price",
          additionalMasterPrice: "Additional Price",
          quarterPricePercent: "Quarter price",
          halfPricePercent: "Half Price",
          includedLightPrice: "Included Light Price",
          includedRegularPrice: "Included Regular Price",
          includedExtraPrice: "Included Extra Price",
          additionalLightPrice: "Additional Lite Price",
          additionalRegularPrice: "Additional Regular Price",
          additionalExtraPrice: "Additional Extra Price",
          onSidePrice: "On the Side Price"
        }
      },
      modifierGroupsDiffModal: {
        newModifierItem: "New Modifier Item",
        selectedDefault: "Default Selected",
        pricingVersionRemoved: "You have removed this Pricing Version",
        sectionTitles: {
          associations: "ASSOCIATIONS",
          modifierItems: "Modifier Items"
        },
        master: {
          name: "Name"
        },
        basic: {
          posName: "POS Name",
          kdsName: "Kitchen Name",
          checkName: "Check Name",
          onlineName: "Online Name",
          active: "Active",
          multiselect: "Multiselect",
          allowNoneSelection: 'Allow "None" Selection',
          requiredModifierItems: "Required Modifier Items",
          includedModifierItems: "Included Modifier Items",
          maximumModifierItems: "Maximum Modifier Items",
          quantityMode: "Quantity Mode",
          priceCalcMode: "Pricing Mode",
          activeCustomizerSectionSelector: "Activate Pizza Section Selector",
          hidePriceIfFree: "Hide price if Free",
          showModGroupTitleOnRegisterTicket: "Show Mod Group titles on Register Ticket",
          showModGroupTitleOnKitchenTicket: "Show Mod Groups titles on Kitchen Ticket",
          guestCheck: "Show Mod Group titles on Guest Check",
          advancedModifier: 'Show in "More Mods"',
          showSearchBar: "Show Search Bar",
          searchAllModifierItems: "Search All Modifier Items",
          global: "Global Mod",
          enableModTags: "Enable Mod Tags",
          enableQuantityBar: "Enable Quantity Bar",
          customizerSlicing: "Customizer Slicing"
        },
        register: {
          backgroundColor: "Background",
          textColor: "Text"
        },
        associations: {
          description: "Select the Pricing Version you want to see the information for."
        },
        modifierItem: {
          active: "Status",
          isSelected: "Selected",
          defaultAmountSelected: "Default Amount",
          defaultQuantitySelected: "Default Quantity",
          includedMasterPrice: "Included Price",
          additionalMasterPrice: "Additional Price",
          quarterPricePercent: "Quarter price",
          halfPricePercent: "Half Price",
          includedLightPrice: "Included Light Price",
          includedRegularPrice: "Included Regular Price",
          includedExtraPrice: "Included Extra Price",
          additionalLightPrice: "Additional Lite Price",
          additionalRegularPrice: "Additional Regular Price",
          additionalExtraPrice: "Additional Extra Price",
          sortPriority: "Sort Priority",
          defaultSelectionPrice: "Selection Price",
          linesBefore: "Line Break",
          spacesBefore: "Blank Space",
          maximumQuantity: "Maximum Quantity"
        },
        modifierGroupPricingVersions: {
          name: "Name",
          modItemPricingVersions: "Pricing Version"
        }
      },
      itemMassUpdate: {
        title: "Item Mass Update",
        description: "Please select the parameters that will determine what groups of items you will be updating and the field you will be editing.",
        itemsIn: {
          label: "Select All Items In"
        },
        fieldToChange: {
          label: "Field To Change",
          options: {
            taxes: "Taxes"
          }
        },
        itemsToBeUpdated: {
          label: "Items To Be Updated"
        },
        buttons: {
          selectItems: "Select {{count}} items"
        },
        categoryOrSubcategory: "Category Or Subcategory",
        menuTypesPlaceholder: "Select Menus",
        confirmationTitle: "Entering Mass Update Mode",
        confirmation: "You are about to modify {{count}} Items. Changes made to these Items cannot be reverted in the future. Do you want to continue?"
      },
      loadingAdd: {
        items: "Adding existing Items",
        discounts: "Adding existing Discounts",
        combos: "Adding existing Combos",
        specials: "Adding existing Specials",
        itemGroups: "Adding existing Item Groups",
        reportingGroups: "Adding existing Reporting Groups",
        menuTypes: "N/A",
        ingredients: "N/A",
        hotButtons: "N/A",
        modifierGroups: "N/A",
        modifierItems: "N/A",
        categories: "N/A",
        subcategories: "N/A"
      },
      selectLocation: {
        title: "Apply To Other Locations",
        selectAll: "SELECT ALL"
      },
      diffModal: {
        reviewChanges: "Review Changes",
        descriptionForSave: "Please review your changes. When you are done, click \u201CSave\u201D.",
        youHaveUnsavedChanges: "You have unsaved changes for this {{bucket}}.",
        descripTionForContinue: "Please review your changes and click \u201CContinue\u201D.",
        sectionTitles: {
          basic: "BASIC",
          commonChanges: "COMMON CHANGES",
          changesByMenuTypes: "CHANGES BY MENUS",
          massUpdateChanges: "MASS UPDATE CHANGES",
          moreInformation: "MORE INFORMATION",
          ingredients: "INGREDIENTS",
          associations: "ASSOCIATIONS",
          inventory: "INVENTORY",
          discountScheme: "DISCOUNT SCHEME",
          taxes: "TAXES",
          guestCheckDisplay: "GUEST CHECK DISPLAY",
          categoriesSubcategories: "CATEGORIES AND SUBCATEGORIES",
          pricingVersions: "PRICING VERSIONS",
          settings: {
            home: "HOME",
            endOfDay: "END OF DAY",
            register: "REGISTER",
            menu: "MENU",
            settings: "SETTINGS",
            management: "MANAGEMENT",
            reports: "REPORTS",
            general: "GENERAL SETTINGS",
            organizationInformation: "ORGANIZATION INFORMATION",
            locationInformation: "LOCATION INFORMATION",
            hoursOfOperation: "HOURS OF OPERATION",
            ticketDisplay: "TICKET DISPLAY SETTINGS",
            customizingReceipts: "CUSTOMIZING RECEIPTS",
            checkDisplay: "CHECK DISPLAY",
            itemSortPriority: "ITEM SORT PRIORITY"
          }
        },
        changes: "Changes",
        change: "Change",
        removed: "Removed"
      },
      discardChangesConfirmation: {
        title: "Discard changes",
        description: "Do you want to discard all changes?"
      },
      infoConfirmationModal: {
        unsavedChanges: "You have unsaved changes",
        unsavedChangesMessage: "Do you want to save your unsaved changes before leaving?"
      },
      creationConfirmation: {
        continue: "Continue Creation",
        exit: "Exit Creation"
      },
      optionsModal: {
        selectedOptions: "Selected Options",
        noOptionsSelected: "No Options Selected",
        clearOptions: "Clear Options",
        selectedTags: "Selected Tags",
        noTagsSelected: "No Tags Selected",
        clearAllTags: "Clear All Tags",
        clearTags: "Clear Tags"
      },
      clone: {
        title: {
          items: "Cloning Item - {{name}}",
          menuTypes: "Cloning Menu - {{name}}",
          modifierGroups: "Cloning Modifier Group - {{name}}",
          modifierItems: "Cloning Modifier Item - {{name}}",
          categories: "Cloning Category - {{name}}",
          subcategories: "Cloning Subcategory - {{name}}",
          discounts: "Cloning Discount - {{name}}",
          combos: "Cloning Combo - {{name}}",
          specials: "Cloning Special - {{name}}",
          ingredients: "Cloning Ingredient - {{name}}",
          settings: {
            roles: "Cloning Role - {{name}}"
          },
          itemGroups: "Cloning Item Group - {{name}}",
          reportingGroups: "Cloning Reporting Group - {{name}}"
        },
        description: {
          items: "Please enter the new name for this Item",
          menuTypes: "Please enter the new name for this Menu",
          modifierGroups: "Please enter the new name for this Modifier Group",
          modifierItems: "Please enter the new name for this Modifier Item",
          categories: "Please enter the new name for this Category",
          subcategories: "Please enter the new name for this Subcategory",
          discounts: "Please enter the new name for this Discount",
          combos: "Please enter the new name for this Combo",
          specials: "Please enter the new name for this Special",
          ingredients: "Please enter the new name for this Ingredient",
          settings: {
            roles: "Please enter the new name for this Role"
          },
          itemGroups: "Please enter the new name for this Item Group",
          reportingGroups: "Please enter the new name for this Reporting Group"
        },
        placeholder: "Enter new name"
      },
      cannotDeleteMenuTypeModal: {
        title: "Cannot delete Menu",
        description: "In order to delete, you must first assign another Menu to the following items:"
      }
    }
  },
  validations: {
    invalidCodePleaseTryAgain: "Invalid code. Please try again.",
    unsavedChanges: "Unsaved changes",
    settings: {
      timeBasedMenuTypeError: "Rule No.|divider|on day|divider|with Menu|divider|has an invalid range.",
      prepStationVersionTitle: "Printer Location: {{prepStation}}"
    },
    includedModifierItemsInvalid: "Included Modifier Items cannot be greater than the number of associated Modifier Items.",
    requiredModifierItemsMIInvalid: "Required Modifier Items cannot be greater than the number of associated Modifier Items.",
    requiredModifierItemsInvalid: "Number of Required Modifier Items must be equal to or less than Included Modifier Items.",
    validationFailed: "Incomplete {{bucket}}",
    subtitle: "Please fix the issues below and try again.",
    discardSubtitle: "Please fix the issues below and try again or discard the changes.",
    issues: "Issues",
    issuesInMenuTypes: "Issues in Specific Menus",
    nameRequired: "Name cannot be empty",
    emailRequired: "Must enter a valid E-mail",
    posNameRequired: "POS Name cannot be empty",
    invalidPin: "PIN is invalid",
    pinAlreadyInUse: "PIN is already in use",
    firstNameRequired: "First Name cannot be empty",
    lastNameRequired: "Last Name cannot be empty",
    premadeModifierGroupRequired: "Premade Modifier Group is required",
    phoneNumberRequired: "Phone Number cannot be empty",
    kdsNameRequired: "Kitchen Name cannot be empty",
    checkNameRequired: "Check Name cannot be empty",
    onlineNameRequired: "Online Name cannot be empty",
    categoryRequired: "{{bucket}} must belong to a Category",
    subcategoryRequired: "{{bucket}} must belong to a Subcategory",
    categoryHasNoSubcategories: "The Category you have chosen does not have any Subcategories, please change the Category, or associate a Subcategory in the Categories bucket",
    priceRequired: "{{bucket}} Price is Required",
    priceGreaterThanZero: "Price Greater Than Zero",
    valueGreaterThanZero: "Value Greater Than Zero",
    promptMessageRequired: "Suggestive Ordering Prompt cannot be empty",
    suggestiveOrderingItemRequired: "Suggestive Ordering Item is required",
    notEmpty: "cannot be empty",
    itemMustBelongTo: "{{bucket}} must belong to a ",
    menuTypeTitle: "Menu: {{menuType}}",
    itemGroupTitle: "Item Group: {{itemGroup}}",
    allChangesSaved: "All changes saved",
    reasonRequired: "Discount Reason is Required",
    reasonRequiredDescription: "Please select a Discount Reason.",
    quantityRequired: "Quantity must be greater than 0",
    discount: {
      title: "Cannot apply discount",
      basePriceZero: "Item Price is 0",
      totalPriceZero: "Item total price is 0",
      excludedFromDiscounts: "Item excluded from discounts",
      voidedElement: "Element is Voided"
    },
    noElements: "No {{elementName}}",
    permissionRequired: "Permission required",
    youDontHavePermissionsToManageTables: "You don't have permission to manage tables.",
    noItems: "No Items",
    itemGroupUniqueNameRequired: "Item Groups name needs to be unique.",
    ingredientNameRepeated: "Ingredients Name must be unique.",
    ingredientTitle: "Ingredient: {{itemGroup}}",
    itemsOfItemGroupRequired: "An Item Group needs to have at least 1 item.",
    specials: {
      buyQuantityRequired: '"Buy Quantity" must be greater than 0',
      getQuantityRequired: '"Get Quantity" must be greater than 0',
      availabilityError: "Invalid Availability time range(s)"
    },
    invalidPhoneNumber: "Phone Number is invalid",
    atLeast1Bucket: "There must be at least 1 {{bucketName}} assigned.",
    comboDisplayNameRequired: "Combo Display Name cannot be empty",
    subcategoryMenuTypeItemsIdsRequired: "You must select a Subcategory for ALL Items",
    subcategoryMenuTypeCombosIdsRequired: "You must select a Subcategory for ALL Combos",
    uniqueCustomIdRequired: "Custom ID already exists on another Item in this Org: {{name}} is using it.",
    modifierItems: {
      maxModifiersErrorTitle: "Max Modifiers Error",
      maximumReached: "You have reached the maximum number ({{maximumModifierItems}}) of modifier items allowed for this group.",
      wrongQuantity: "You can't set the quantity: {{quantity}} for this group, because them maximum number allowed is {{maximumModifierItems}}."
    },
    startDateInvalid: "Start Date is invalid",
    endDateInvalid: "End Date is invalid",
    endDateBeforeStartDate: "End Date must be after Start Date",
    startDateRequired: "Start Date is required",
    endDateRequired: "End Date is required",
    specificDateRequired: "Date is required",
    scheduleStartDateTimeRequired: "Schedule Start Date is required",
    recipientsRequired: "Recipients are required"
  },
  menuScreen: {
    bucketDisabled: "You need to make a Menu first.",
    deleteToast: "You can only Delete {{bucket}} from Enterprise Mode.",
    commonSections: {
      registerDisplay: {
        title: "REGISTER SETTINGS",
        updatingTitle: "UPDATING REGISTER SETTINGS",
        registerDisplayOptions: {
          title: "Register Display",
          generalSettings: "General Settings",
          registerNavigation: "Register Navigation",
          colors: "Register Colors",
          displayPictureOnCard: "Display Picture on Item Card",
          background: "Background",
          text: "Text",
          image: "Image",
          reset: "Reset",
          mods: "Mods",
          global: "Global",
          customizerDisplay: "Customizer Display",
          customizerShape: {
            label: "Customizer Shape",
            placeholder: "Select a Shape",
            options: {
              square: "Pizza Square",
              round: "Pizza Circle"
            }
          },
          specialTag: {
            label: "Special Tag",
            emptyOption: "No Special Tag"
          }
        },
        kdsDisplay: {
          title: "Kitchen Display",
          kdsColor: "Kitchen Color",
          reset: "Reset"
        },
        registerPreview: {
          title: "Preview"
        },
        enterItemDetails: "Enter Item Details when added to ticket",
        exitItemDetailsOnRequiredModsCompletion: "Exit Item Details On Required Mods Completion"
      }
    },
    hotButtons: {
      giftCards: "Gift Cards",
      openCashDrawer: "Open Cash Drawer",
      scanId: "Scan ID",
      openItem: "Open Item",
      customers: "Customers",
      item: "Item",
      menuType: "Menu",
      fire: "Fire",
      newCourse: "New\nCourse",
      printChecks: "Print Check(s)"
    },
    refreshModal: {
      successButton: "Review Changes",
      edit: {
        settings: {
          title: "Settings Updated",
          description: "Someone else recently made changes to the Settings. Changes successfully merged."
        },
        customers: {
          title: "Customer Updated",
          description: "Someone else recently made changes to the Customer. Changes successfully merged."
        },
        preview: {
          savingChanges: "Saving Changes",
          menuUpdated: "Menu Updated Successfully",
          refresh: {
            outdatedMenu: {
              title: "Outdated Menu Version",
              description: '\nThe Menu version on this tablet is outdated due to someone changing the menu from another device.\nPlease hit "Refresh" to pull the latest version.'
            },
            outdatedSettings: {
              title: "Outdated Settings Version",
              description: '\nThe Settings version on this tablet is outdated due to someone changing the settings from another device.\nPlease hit "Refresh" to pull the latest version.'
            },
            outdatedMenuAndSettings: {
              title: "Outdated Menu and Settings Versions",
              description: '\nThe Menu and Settings versions on this tablet are outdated due to someone changing the the Menu or Settings from another device.\nPlease hit "Refresh" to pull the latest versions.'
            }
          }
        },
        bucketMessages: {
          items: {
            massUpdateTitle: "Items Updated",
            title: "Item Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Item.\nPlease review your changes, and hit "Save" again.'
          },
          itemGroups: {
            title: "Item Group Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Item Group.\nPlease review your changes, and hit "Save" again.'
          },
          reportingGroups: {
            title: "Reporting Group Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Reporting Group.\nPlease review your changes, and hit "Save" again.'
          },
          subcategories: {
            title: "Subcategory Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Subcategory.\nPlease review your changes, and hit "Save" again.'
          },
          categories: {
            title: "Category Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Category.\nPlease review your changes, and hit "Save" again.'
          },
          menuTypes: {
            title: "Menu Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Menu.\nPlease review your changes, and hit "Save" again.'
          },
          modifierItems: {
            title: "Modifier Item Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Modifier Item.\nPlease review your changes, and hit "Save" again.'
          },
          modifierGroups: {
            title: "Modifier Group Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Modifier Group.\nPlease review your changes, and hit "Save" again.'
          },
          discounts: {
            title: "Discount Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Discount.\nPlease review your changes, and hit "Save" again.'
          },
          combos: {
            title: "Combo Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Combo.\nPlease review your changes, and hit "Save" again.'
          },
          specials: {
            title: "Special Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Special.\nPlease review your changes, and hit "Save" again.'
          },
          ingredients: {
            title: "Ingredient Updated",
            description: 'Someone changed the menu from another device.\nThis resulted in a change to this Ingredient.\nPlease review your changes, and hit "Save" again.'
          },
          hotButtons: {
            title: "N/A",
            description: "N/A"
          }
        }
      },
      create: {
        bucketMessages: {
          items: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          itemGroups: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          reportingGroups: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          subcategories: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          categories: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          menuTypes: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          modifierItems: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          modifierGroups: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          discounts: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          combos: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          specials: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          ingredients: {
            title: "Menu Updated",
            description: 'The Menu on this tablet has been updated due to someone changing the menu from another device.\nPlease review your changes and hit "Save" again.'
          },
          hotButtons: {
            title: "N/A",
            description: "N/A"
          }
        }
      }
    },
    massUpdate: {
      updating: "Updating Selected Items"
    },
    refreshToast: {
      title: {
        menu: "Menu Updated Remotely",
        settings: "Settings Updated Remotely",
        reports: "Reports Updated Remotely"
      },
      bucketMessages: {
        items: {
          title: "Item Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        itemGroups: {
          title: "Item Group Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        menuTypes: {
          title: "Menu Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        categories: {
          title: "Category Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        subcategories: {
          title: "Subcategory Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        modifierGroups: {
          title: "Modifier Group Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        modifierItems: {
          title: "Modifier Item Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        discounts: {
          title: "Discount Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        combos: {
          title: "Combo Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        specials: {
          title: "Special Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        ingredients: {
          title: "Ingredient Updated",
          description: "Someone else recently made changes to the Menu. Changes successfully merged."
        },
        hotButtons: {
          title: "N/A",
          description: "N/A"
        }
      }
    },
    freshSheetDetails: {
      unsavedChangesModal: {
        description: "You have unsaved changes. Please save or discard your changes in order to navigate away from this page."
      },
      addFreshSheetItem: "Add Fresh Sheet Item",
      title: "Fresh Sheet",
      updating: "Updating Fresh Sheet",
      items: {
        name: "Item Name",
        currentAmount: "On-Hand Qty",
        is86ed: "Is 86'd?",
        delete: "Delete"
      }
    },
    common: {
      settings: {
        register: {
          singular: "Register Mode",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        general: {
          singular: "General Settings",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        online: {
          singular: "Online Settings",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        registerTicket: {
          singular: "Register Ticket",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        lockScreen: {
          singular: "Lock Screen",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        kitchenTicket: {
          singular: "Kitchen Ticket",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        prepStations: {
          singular: "Printer Location",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        printerRules: {
          singular: "Printing Rules",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        taxes: {
          singular: "Taxes",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        dashboards: {
          singular: "Dashboard",
          plural: "Dashboards",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        reportingGroups: {
          singular: "Reporting Groups",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenseSpecificPrinterRules: {
          singular: "License Specific Printing Rules",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenseSettings: {
          singular: "License Settings",
          creation: {
            title: "End License Settings Creation?",
            message: "You are currently creating a new License Settings. Before navigating away, you must either finish the License Settings creation or cancel License Settings creation."
          }
        },
        roles: {
          singular: "Role",
          creation: {
            title: "End Role Creation?",
            message: "You are currently creating a new Role. Before navigating away, you must either finish the Role creation or cancel Role creation."
          }
        },
        users: {
          singular: "User",
          creation: {
            title: "End User Creation?",
            message: "You are currently creating a new User. Before navigating away, you must either finish the User creation or cancel User creation."
          }
        },
        devices: {
          singular: "Device",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenses: {
          singular: "License",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        guestCheck: {
          singular: "Guest Check",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        guestReceipt: {
          singular: "Guest Receipt",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        payments: {
          singular: "Payments",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        }
      },
      reports: {
        customReports: {
          singular: "Custom Report",
          creation: {
            title: "End Custom Report Creation?",
            message: "You are currently creating a new Custom Report. Before navigating away, you must either finish the Custom Report creation or cancel Custom Report creation."
          }
        },
        itemComboSalesReports: {
          singular: "Item Combo Sales Report",
          creation: {
            title: "End Item Combo Sales Report Creation?",
            message: "You are currently creating a new Item Combo Sales Report. Before navigating away, you must either finish the Item Combo Sales Report creation or cancel Item Combo Sales Report creation."
          }
        },
        salesOverviewReports: {
          singular: "Sales Overview Report",
          creation: {
            title: "End Sales Overview Report Creation?",
            message: "You are currently creating a new Sales Overview Report. Before navigating away, you must either finish the Sales Overview Report creation or cancel Sales Overview Report creation."
          }
        },
        endOfShiftReports: {
          singular: "End Of Shift Report",
          creation: {
            title: "End End Of Shift Report Creation?",
            message: "You are currently creating a new End Of Shift Report. Before navigating away, you must either finish the End Of Shift Report creation or cancel End Of Shift Report creation."
          }
        },
        creditCardBatchReports: {
          singular: "Batch Report",
          creation: {
            title: "End Batch Report Creation?",
            message: "You are currently creating a new Batch Report. Before navigating away, you must either finish the Batch Report creation or cancel Batch Report creation."
          }
        },
        employeeSalesAndTipsReports: {
          singular: "Employee Sales Report",
          creation: {
            title: "End Employee Sales Report Creation?",
            message: "You are currently creating a new Employee Sales Report. Before navigating away, you must either finish the Employee Sales Report creation or cancel Employee Sales Report creation."
          }
        },
        voidReasonsReports: {
          singular: "Void Reasons Report",
          creation: {
            title: "End Void Reasons Report Creation?",
            message: "You are currently creating a new Void Reasons Report. Before navigating away, you must either finish the Void Reasons Report creation or cancel Void Reasons Report creation."
          }
        },
        inventoryOnHandReports: {
          singular: "Inventory Report",
          creation: {
            title: "End Inventory Report Creation?",
            message: "You are currently creating a new Inventory Report. Before navigating away, you must either finish the Inventory Report creation or cancel Inventory Report creation."
          }
        },
        creditBalancesReports: {
          singular: "Credit Balances Report",
          creation: {
            title: "End Credit Balances Report Creation?",
            message: "You are currently creating a new Credit Balances Report. Before navigating away, you must either finish the Credit Balances Report creation or cancel Credit Balances Report creation."
          }
        }
      },
      forbiddenChangeLocation: {
        title: "Can't change location",
        description: {
          categories: "You can only create Categories in Enterprise Mode.",
          subcategories: "You can only create Subcategories in Enterprise Mode.",
          menuTypes: "You can only create Menus in Enterprise Mode.",
          modifierItems: "You can only create Modifier Items in Enterprise Mode.",
          modifierGroups: "You can only create Modifier Groups in Enterprise Mode.",
          itemGroups: "N/A",
          reportingGroups: "N/A",
          items: "N/A",
          discounts: "N/A",
          hotButtons: "N/A",
          combos: "N/A",
          specials: "N/A",
          ingredients: "N/A"
        }
      },
      preventLeaveModal: {
        title: "Finish Creation",
        items: "You must finish creation and save before you can add new Items.",
        menuTypes: "You must finish creation and save before you can add new Menus.",
        categories: "You must finish creation and save before you can add new Categories.",
        subcategories: "You must finish creation and save before you can add new Subcategories.",
        modifierGroups: "You must finish creation and save before you can add new Modifier Groups.",
        modifierItems: "You must finish creation and save before you can add new Modifier Items.",
        itemGroups: "You must finish creation and save before you can add new Item Groups.",
        reportingGroups: "You must finish creation and save before you can add new Reporting Groups.",
        discounts: "N/A",
        hotButtons: "N/A",
        combos: "N/A",
        specials: "N/A",
        ingredients: "N/A"
      },
      editDisabled: {
        items: "You can only delete Items associations in Enterprise mode.",
        categories: "You can only delete Categories associations in Enterprise mode.",
        subcategories: "You can only delete Subcategories associations in Enterprise mode.",
        menuTypes: "You can only delete Menus associations in Enterprise mode.",
        modifierGroups: "You can only delete Modifier Groups associations in Enterprise mode.",
        modifierItems: "You can only delete Modifier Items associations in Enterprise mode.",
        prepStationsItems: "You can only delete Items Printer Locations in Enterprise mode."
      },
      addDisabled: {
        items: "You can only add Items associations in Enterprise mode.",
        categories: "You can only add Categories associations in Enterprise mode.",
        subcategories: "You can only add Subcategories associations in Enterprise mode.",
        menuTypes: "You can only add Menus associations in Enterprise mode.",
        modifierGroups: "You can only add Modifier Groups associations in Enterprise mode.",
        modifierItems: "You can only add Modifier Items associations in Enterprise mode."
      },
      associations: "ASSOCIATIONS",
      updatingAssociations: "UPDATING ASSOCIATIONS",
      changesSaved: {
        title: "All Changes Saved",
        description: "Your changes were saved successfully"
      },
      bucket: {
        menuTypes: {
          plural: "Menus",
          singular: "Menu",
          creation: {
            title: "End Menu Creation?",
            message: "You are currently creating a new Menu. Before navigating away, you must either finish the Menu creation or cancel Menu creation."
          }
        },
        categories: {
          plural: "Categories",
          singular: "Category",
          creation: {
            title: "End Category Creation?",
            message: "You are currently creating a new Category. Before navigating away, you must either finish the Category creation or cancel Category creation."
          }
        },
        subcategories: {
          plural: "Subcategories",
          singular: "Subcategory",
          creation: {
            title: "End Subcategory Creation?",
            message: "You are currently creating a new Subcategory. Before navigating away, you must either finish the Subcategory creation or cancel Subcategory creation."
          }
        },
        items: {
          plural: "Items",
          singular: "Item",
          creation: {
            title: "End Item Creation?",
            message: "You are currently creating a new Item. Before navigating away, you must either finish the Item creation or cancel Item creation."
          }
        },
        modifierGroups: {
          plural: "Modifier Groups",
          singular: "Modifier Group",
          creation: {
            title: "End Modifier Group Creation?",
            message: "You are currently creating a new Modifier Group. Before navigating away, you must either finish the Modifier Group creation or cancel Modifier Group creation."
          }
        },
        modifierItems: {
          plural: "Modifier Items",
          singular: "Modifier Item",
          creation: {
            title: "End Modifier Item Creation?",
            message: "You are currently creating a new Modifier Item. Before navigating away, you must either finish the Modifier Item creation or cancel Modifier Item creation."
          }
        },
        discounts: {
          plural: "Discounts",
          singular: "Discount",
          creation: {
            title: "End Discount Creation?",
            message: "You are currently creating a new Discount. Before navigating away, you must either finish the Discount creation or cancel Discount creation."
          }
        },
        hotButtons: {
          singular: "Hot Button",
          plural: "Hot Buttons",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        combos: {
          plural: "Combos",
          singular: "Combo",
          creation: {
            title: "End Combo Creation?",
            message: "You are currently creating a new Combo. Before navigating away, you must either finish the Combo creation or cancel Combo creation."
          }
        },
        specials: {
          plural: "Specials",
          singular: "Special",
          creation: {
            title: "End Special Creation?",
            message: "You are currently creating a new Special. Before navigating away, you must either finish the Special creation or cancel Special creation."
          }
        },
        ingredients: {
          singular: "Ingredient",
          plural: "Ingredients",
          creation: {
            title: "End Ingredient Creation?",
            message: "You are currently creating a new Ingredient. Before navigating away, you must either finish the Ingredient creation or cancel Ingredient creation."
          }
        },
        itemGroups: {
          singular: "Item Group",
          plural: "Item Groups",
          creation: {
            title: "End Item Group Creation?",
            message: "You are currently creating a new Item Group. Before navigating away, you must either finish the Item Group creation or cancel Item Group creation."
          }
        },
        reportingGroups: {
          singular: "Reporting Group",
          plural: "Reporting Groups",
          creation: {
            title: "End Reporting Group Creation?",
            message: "You are currently creating a new Reporting Group. Before navigating away, you must either finish the Reporting Group creation or cancel Reporting Group creation."
          }
        }
      }
    },
    selectionModal: {
      selectButton: "SELECT",
      unselectButton: "UNSELECT",
      header: {
        options: {
          cancel: "Cancel",
          associate: "Associate"
        }
      },
      locations: {
        selectedSectionTitle: "Selected Locations",
        title: "Select Locations",
        titleSingular: "Select Location",
        emptySectionText: "Please select an existing location to associate",
        emptySectionRemoveText: "Please select an existing location to remove",
        noCardSelectedText: "No Locations Selected",
        noAvailableCardsText: "No Locations available"
      },
      roles: {
        selectedSectionTitle: "Selected Roles",
        title: "Select Roles",
        titleSingular: "Select Role",
        emptySectionText: "Please select an existing role to associate",
        noCardSelectedText: "No Roles Selected",
        noAvailableCardsText: "No Roles available"
      },
      dashboards: {
        selectedSectionTitle: "Selected Dashboards",
        title: "Select Dashboards",
        titleSingular: "Select a Dashboard",
        emptySectionText: "Please select an existing Dasboard to associate",
        noCardSelectedText: "No Dashboards Selected",
        noAvailableCardsText: "No Dashboards available"
      },
      items: {
        selectedSectionTitle: "Selected Items",
        title: "Select Items",
        emptySectionText: "Please select an existing item to associate",
        noCardSelectedText: "No Items Selected",
        noAvailableCardsText: "No Items available",
        menuTypes: {
          description: "Select the Menu you want to copy the information from",
          label: "Show Menus where the Item is",
          status: {
            active: "Active Menus",
            inactive: "Inactive Menus"
          }
        }
      },
      ingredients: {
        selectedSectionTitle: "Selected Ingredients",
        title: "Select Ingredients",
        emptySectionText: "Please select an existing Ingredient to associate",
        noCardSelectedText: "No Ingredients Selected",
        noAvailableCardsText: "No Ingredients available"
      },
      reportingGroups: {
        selectedSectionTitle: "Selected Reporting Groups",
        title: "Select Reporting Groups",
        emptySectionText: "Please select an existing Reporting Group to associate",
        noCardSelectedText: "No Reporting Groups Selected",
        noAvailableCardsText: "No Reporting Groups available"
      },
      modifierItems: {
        selectedSectionTitle: "Selected Options",
        title: "Select Modifier Items",
        emptySectionText: "Please select an existing modifier item to associate",
        noCardSelectedText: "No Modifier Items Selected",
        noAvailableCardsText: "No Modifier Items available"
      },
      modifierGroups: {
        selectedSectionTitle: "Selected Options",
        title: "Select Modifier Groups",
        emptySectionText: "Please select an existing modifier group to associate",
        emptySectionRemoveText: "Please select an existing modifier group to remove",
        noCardSelectedText: "No Modifier Groups Selected",
        noAvailableCardsText: "No Modifier Groups available"
      },
      itemGroups: {
        selectedSectionTitle: "Selected Options",
        title: "Select Item Groups",
        emptySectionText: "Please select an existing item group to associate",
        emptySectionRemoveText: "Please select an existing item group to remove",
        noCardSelectedText: "No Item Groups Selected",
        noAvailableCardsText: "No Item Groups available"
      },
      subcategories: {
        selectedSectionTitle: "Selected Subcategories",
        title: "Select Subcategories",
        emptySectionText: "Please select an existing subcategory to associate",
        noCardSelectedText: "No Subcategories Selected",
        noAvailableCardsText: "No Subcategories available"
      },
      menuTypes: {
        selectedSectionTitle: "Selected Menus",
        title: "Select Menus",
        createTitle: "Creating New Item",
        description: "Select all Menus you want this Item to be available in",
        emptySectionText: "Please select an existing Menu to associate",
        noCardSelectedText: "No Menus Selected",
        noAvailableCardsText: "No Menus available",
        allMenuTypes: "All Menus"
      },
      categories: {
        selectedSectionTitle: "Selected Categories",
        title: "Select Categories",
        emptySectionText: "Please select an existing category to associate",
        noCardSelectedText: "No Categories Selected",
        noAvailableCardsText: "No Categories available"
      },
      discounts: {
        selectedSectionTitle: "Selected Discounts",
        title: "Select Discounts",
        emptySectionText: "Please select an existing Discount to associate",
        noCardSelectedText: "No Discounts Selected",
        noAvailableCardsText: "No Discounts available"
      },
      combos: {
        selectedSectionTitle: "Selected Combos",
        title: "Select Combos",
        emptySectionText: "Please select an existing Combo to associate",
        noCardSelectedText: "No Combos Selected",
        noAvailableCardsText: "No Combos available",
        menuTypes: {
          label: "Show Menus where the Combo is"
        },
        locations: {
          sectionTitle: "Additional Locations",
          title: "Restaurant Locations",
          description: "Restaurant Locations to which the Combo belongs",
          emptyCardsMessage: "No additional Locations for this Combo"
        }
      },
      combosItems: {
        selectedSectionTitle: "Selected Items/Combos",
        title: "Select Items/Combos",
        emptySectionText: "Please select an existing Item/Combo to associate",
        noCardSelectedText: "No Items/Combos Selected",
        noAvailableCardsText: "No Items/Combos available",
        locations: {
          emptyCardsMessage: "No additional Locations for this Item/Combo"
        }
      },
      specials: {
        selectedSectionTitle: "Selected Specials",
        title: "Select Specials",
        emptySectionText: "Please select an existing Special to associate",
        noCardSelectedText: "No Specials Selected",
        noAvailableCardsText: "No Specials available",
        menuTypes: {
          label: "Show Menus where the Special is"
        }
      },
      prepStations: {
        selectedSectionTitle: "Selected Printer Locations",
        title: "Select Printer Locations",
        emptySectionText: "Please select an existing Printer Location to associate",
        noCardSelectedText: "No Printer Locations Selected",
        noAvailableCardsText: "No Printer Locations available"
      },
      taxes: {
        selectedSectionTitle: "Selected Taxes",
        title: "Select Taxes",
        emptySectionText: "Please select an existing Tax to associate",
        noCardSelectedText: "No Taxes Selected",
        noAvailableCardsText: "No Taxes available"
      }
    },
    sectionsTitles: {
      basic: "Basic",
      register: "Register Settings",
      taxes: "Taxes",
      guestCheckDisplay: "Guest Check Display",
      inventory: "Inventory",
      moreInfo: "More Information",
      ingredients: "Ingredients",
      modifiers: "Modifiers",
      modItems: "Mod Items",
      itemsAndModItems: "Items and Mod Items",
      association: "Associated",
      linkedModItems: "Linked Modifier Items",
      prepStations: "Printer Locations",
      suggestiveOrdering: "Suggestive Ordering",
      specials: "Specials",
      reportingGroups: "Reporting",
      pricing: "Pricing",
      nestedMods: "Nested Modifiers",
      modGroupsAndItems: "Mod. Groups and Items",
      availability: "Availability",
      specialScheme: "Specials Scheme",
      itemGroups: "Item Groups",
      discountScheme: "Discount Scheme"
    },
    bucketElement: {
      menuTypes: "Menu",
      categories: "Category",
      subcategories: "Subcategory",
      items: "Item",
      modifierGroups: "Modifier Group",
      modifierItems: "Modifier Item",
      discounts: "Discount",
      combos: "Combo",
      specials: "Special",
      ingredients: "Ingredient",
      itemGroups: "Item Group",
      reportingGroups: "Reporting Group"
    },
    commonFields: {
      basic: {
        title: "BASIC",
        description: "POS, Kitchen, and Check names will default to the regular \u201CName\u201D if they are left empty.",
        name: "Name",
        posName: "POS Name",
        kdsName: "Kitchen Name",
        checkName: "Check Name",
        onlineName: "Online Name",
        advancedOptions: "Advanced Options",
        ticketDisplayOptions: "Ticket Display Options",
        customizerSelector: "Customizer Selector",
        backgroundColor: "Color",
        textColor: "Text Color"
      }
    },
    menuLocation: {
      noLocationsMessage: "No Locations in this Location Group",
      actionButtons: {
        addNewCategory: "Add New Category",
        addExistingCategory: "Add Existing Category",
        cloneCategoryTag: "Cloning Category - {{element}}",
        addNewMenuType: "Add New Menu",
        addExistingMenuType: "Add Existing Menu",
        cloneMenuTypeTag: "Cloning Menu - {{element}}",
        addNewLocation: "Add New Location",
        addExistingLocation: "Add Existing Location",
        addNewSubcategory: "Add New Subcategory",
        addExistingSubcategory: "Add Existing Subcategory",
        cloneSubcategoryTag: "Cloning Subcategory - {{element}}",
        addNewItem: "Add New Item",
        addExistingItem: "Add Existing Item",
        cloneItemTag: "Cloning Item - {{element}}",
        addNewModifierItem: "Add New Modifier Item",
        addExistingModifierItem: "Add Existing Modifier Item",
        cloneModifierItemTag: "Cloning Modifier Item - {{element}}",
        addNewModifierGroup: "Add New Modifier Group",
        addExistingModifierGroup: "Add Existing Modifier Group",
        cloneModifierGroupTag: "Cloning Modifier Group - {{element}}",
        addNewPricingVersion: "Add New Pricing Version",
        addNewCategoryTag: "New Category",
        addExistingCategoryTag: "Existing Category",
        addNewMenuTypeTag: "New Menu",
        addExistingMenuTypeTag: "Existing Menu",
        addNewLocationTag: "New Location",
        addExistingLocationTag: "Existing Location",
        addNewSubcategoryTag: "New Subcategory",
        addExistingSubcategoryTag: "Existing Subcategory",
        addNewItemTag: "New Item",
        addExistingItemTag: "Existing Item",
        addNewModifierItemTag: "New Modifier Item",
        addExistingModifierItemTag: "Existing Modifier Item",
        addNewModifierGroupTag: "New Modifier Group",
        addExistingModifierGroupTag: "Existing Modifier Group",
        addNewItemGroup: "Add New Item Group",
        addNewItemGroupTag: "New Item Group",
        addNewReportingGroup: "Add New Reporting Group",
        addNewReportingGroupTag: "New Reporting Group",
        addExistingReportingGroup: "Add Existing Reporting Group",
        addExistingReportingGroupTag: "Existing Reporting Group",
        addExistingItemGroupTag: "Existing Item Group",
        addExistingItemGroup: "Add Existing Item Group",
        addNewSpecial: "Add New Special",
        addExistingSpecial: "Add Existing Special",
        addNewDiscount: "Add New Discount",
        addNewDiscountTag: "New Discount",
        addExistingDiscount: "Add Existing Discount",
        addExistingDiscountTag: "Existing Discount",
        addNewCombo: "Add New Combo",
        addNewComboTag: "New Combo",
        addExistingCombo: "Add Existing Combo",
        addExistingComboTag: "Existing Combo",
        addNewSpecialTag: "New Special",
        addExistingSpecialTag: "Existing Special",
        addNewRole: "Add New Role",
        addNewRoleTag: "New Role",
        addExistingRole: "Add Existing Role",
        addExistingRoleTag: "Existing Role",
        addNewIngredient: "Add New Ingredient",
        addExistingIngredient: "Add Existing Ingredient",
        addNewIngredientTag: "New Ingredient",
        addExistingIngredientTag: "Existing Ingredient"
      }
    },
    itemDetails: {
      dimensions: {
        title: "Dimensions",
        dimensionsSellBy: {
          label: "Sell By",
          options: {
            unit: "Unit",
            volume: "Volume",
            weight: "Weight"
          }
        }
      },
      reportingSection: {
        title: "Reporting",
        emptyCardsMessage: "No Reporting Groups for this Item",
        removeReportingSection: {
          title: "Remove Reporting Groups",
          description: "Select the Reporting Groups to remove from all the selected Items",
          empty: "No Reporting Groups To Remove"
        },
        addReportingSection: {
          title: "Add Reporting Groups",
          description: "Select the Reporting Groups to add to all the selected Items",
          empty: "No Reporting Groups To Add"
        }
      },
      customId: "Custom ID",
      taxesSection: {
        removeTaxesSection: {
          title: "Remove Custom Taxes",
          description: "Select the Custom Taxes to remove from all the selected Items",
          empty: "No Custom Taxes To Remove"
        },
        addTaxesSection: {
          title: "Add Custom Taxes",
          description: "Select the Custom Taxes to add to all the selected Items",
          empty: "No Custom Taxes To Add"
        }
      },
      categoriesSubcategories: {
        title: "Categories and Subcategories",
        removeCategoriesSection: {
          title: "Remove Categories and Subcategories",
          description: "Select the Categories to remove from all the selected Items",
          empty: "No Categories To Remove"
        },
        addCategoriesSection: {
          title: "Add Categories and Subcategories",
          description: "Select the Categories to add to all the selected Items",
          empty: "No Categories To Add"
        }
      },
      modifierGroupsSection: {
        activeModifierGroupError: "The Modifier Group is inactive, so you can't show it in this Item",
        nestedModifiers: "Nested Modifiers",
        nestedModifierstoolTip: "Nested Modifiers allow a modifier item to call a modifier group.\nFor example, a steak comes with a side salad.  The side salad is the modifier item. The side salad as a modifier item can then call the assigned Nested Modifier Group \u201Cdressing choice\u201D when the side salad is selected.",
        addModifierGroup: "Add Modifier Group",
        modifierGroup: "Modifier Group",
        modifierName: "Modifier Name: {{name}}",
        quantity: "Quantity",
        multiselect: "Multiselect",
        pricingMode: "Pricing Mode",
        editModifier: "Edit Modifier",
        selectedDefault: "Default Selected",
        required: "Required",
        included: "Inc.",
        maximum: "Max.",
        totalPrice: "Mod Price",
        hideModifierGroup: "Hide Modifier Group",
        showAllPricing: "Show All Pricing",
        pricingVersion: "Pricing Version",
        noModifierItemsAssignedToThisGroup: "No Modifier Items assigned to this Group",
        noModifierGroupsAssignedToThisItem: "No Modifier Groups assigned to this item",
        itemModsSubsectionTitle: "Item Mods",
        allMods: {
          title: "All Mods",
          description: "Any changes made to the below fields or Mod Item pricing will be a custom override specific for this item, represented by a blue dot",
          showAllModsAlphabetizeButtons: 'Show "All Mods" Alphabetize Buttons',
          showAllModsHalfSizeButtons: '"All Mods" Half Size Buttons',
          allModsBehavior: {
            options: {
              all: "All",
              associated: "Associated",
              premade: "Premade"
            }
          }
        }
      },
      pricingSection: {
        title: "Pricing",
        updatingTitle: "Updating Pricing",
        description: "Online and Delivery Price will default to the Item Price if they are left empty.",
        allLocationsBtn: "View Pricing for All Locations",
        itemPrice: "Item Base Price",
        itemPricetoolTip: "Standard price of item when ordered. Default price seen on physical menu.",
        onlinePrice: "Online Price",
        onlinePricetoolTip: "Price of item when ordered via online ordering. Price may include adjustments for convenience, service fees or special promotions.",
        deliveryPrice: "Delivery Price",
        deliveryPricetoolTip: "Price of item when ordered for delivery. Price may include adjustments for packaging, delivery fees, or third-party delivery apps.",
        toGoPrice: "To Go Price",
        toGoPricetoolTip: "Price of item when ordered for takeout or pickup",
        increaseOrDecrease: "Increase or Decrease",
        isTaxInclusive: "Item is Tax inclusive",
        isTaxInclusivetoolTip: "When enabled, this setting calculates the tax as an inclusive tax, meaning the displayed price of the menu item already includes the applicable tax. The system will automatically determine and separate the tax portion from the total item price.",
        excludeFromSuggestedTip: "Exclude from Suggested Tip",
        excludeFromSuggestedTiptoolTip: "When enabled, this item will not be included in the calculation of the Suggested Tip amount",
        excludeFromDiscounts: "Exclude From Discounts",
        excludeFromDiscountstoolTip: "When enabled, the item will not be eligible for discounts",
        removeFromCheck: "Remove from Check",
        removeFromCheckToolTip: "Exclude on Check and printed Guest Check",
        taxExempt: "Tax Exempt",
        taxExemptToolTip: "When enabled, no tax is charged for this item"
      },
      associations: {
        title: "Linked Modifier Items",
        linkedModItems: "Linked Mod Items"
      },
      itemLocation: {
        title: "ITEM LOCATION",
        category: "Category",
        categorytoolTip: "Select the Category to which the item belongs. Item will display in that category on the register",
        subcategory: "Subcategory",
        subcategorytoolTip: "Select the Subcategory to which the item belongs.  If the Category does contain Subcategories, and a Subcategory is not assigned to this item, the item will appear in the \u201CAll\u201D Subcategory within the Category.",
        removeLocation: "Remove",
        locations: {
          sectionTitle: "Additional Locations",
          title: "Restaurant Locations",
          description: "Restaurant Locations to which the item belongs",
          emptyCardsMessage: "No additional Locations for this Item"
        },
        locationsAdd: {
          title: "Add Restaurant Locations",
          description: "Select the Restaurant Locations to add to all the selected items",
          emptyCardsMessage: "No Restaurant Locations to add to selected items"
        },
        locationsRemove: {
          title: "Remove Restaurant Locations",
          description: "Select the Restaurant Locations to remove from all the selected items",
          emptyCardsMessage: "No Restaurant Locations to remove from the selected items"
        },
        specials: {
          title: "Specials",
          description: "The order the Specials are arranged here is the order it will be displayed in the register. Hit the Edit button to drag and drop Specials in to the desired order.",
          emptyCardsMessage: "No Specials for this Item"
        }
      },
      prepStationsSection: {
        title: "PRINTER LOCATIONS",
        updatingTitle: "UPDATING PRINTER LOCATIONS",
        prepStations: {
          title: "Printer Locations",
          toolTip: 'Add and select the printer locations where this menu item will print. If no printer locations are added, the Printer Locations Selection Modal will appear when the item is ordered, prompting the user to manually select where the item will print.\nWhen "Show Printer Location Selection Modal" is disabled, the item will not print to any remote devices',
          addTitle: "Add Printer Locations",
          removeTitle: "Remove Printer Locations",
          disabledActionToast: {
            title: "Alert"
          },
          actionButtons: {
            addExistingStation: "Add Existing Printer Location"
          },
          emptyCardsMessage: "No Printer Locations for this Item",
          emptyRemoveCardsMessage: "No Printer Locations to Remove",
          showPrepStationSelectionModal: "Show Printer Location Selection Modal"
        }
      },
      suggestiveOrdering: {
        title: "SUGGESTIVE ORDERING",
        toolTip: "After ordering the menu item, a prompt will display asking if the item below should be added to the ticket.",
        updatingTitle: "UPDATING SUGGESTIVE ORDERING",
        promptCheckText: "Prompt a Suggestion to the User After Ordering",
        promptCheckTexttoolTip: "Enable to prompt the user to ask to add the following item to the Order",
        addButtonText: "Tap to Add Item",
        addButtonLabel: "Tap to change",
        allowSpecialPrice: "Allow Special Price",
        allowSpecialPricetoolTip: "Enable to allow the Suggested Item to be added to the Order at a special price, different from the regular price on the menu",
        inputs: {
          suggestionPrice: {
            label: "Suggestion Special Price",
            toolTip: "Enter the amount the Suggested Item will be sold for as part of the Suggestion Prompt",
            placeholder: "Add Suggestion Special Price"
          },
          prompt: {
            label: "Prompt",
            toolTip: "Enter any information that should be displayed to the user as part of the Suggestion Prompt",
            placeholder: "Add Prompt"
          }
        }
      },
      applyChangesToMenuType: {
        error: {
          title: "Merging Warning",
          description: "Some of the Ingredients are not found in the other Menus. Please review the changes that will be applied to the other Menus."
        }
      },
      inventorySection: {
        title: "INVENTORY",
        updatingTitle: "UPDATING INVENTORY",
        description: "Control Stock levels for this Item. Inventory Tracking is common/shared among all Menus for this Item.\nAny changes here will be automatically copied over to all other Menus.",
        shortDescription: "Control Stock levels for this Item.",
        trackInventory: "Inventory Tracking",
        initialAmountInStock: "Initial Quantity In Stock",
        initialAmountInStocktoolTip: "Set the quantity of an item available at the start of a tracking period. This value represents the starting inventory and is used to track sales and inventory depletion.",
        currentAmountInStock: "Current Amount in Stock",
        currentAmountInStocktoolTip: "Quantity of an item that is currently available in inventory",
        "86ItemWhenCurrentStockIs0": "Is 86'd",
        "86ItemWhenCurrentStockIs0toolTip": "Enable to set an item out of stock and unavailable for sale",
        showOnFreshSheet: "Show on Fresh Sheet",
        showOnFreshSheettoolTip: "When enabled, item will show in the Fresh Sheet",
        resetCurrentStockDaily: "Reset Current Stock Daily",
        resetStockToInitialWhenAt0: "Reset Stock to Initial when at 0",
        volume: "Volume",
        actionWhenCurrentStockZero: {
          label: "Action When Stock Hits Zero",
          toolTip: `Select what happens when stock hits zero for an item
86'd - Item is marked as 86'd, making it unavailable
Reset to Initial - System automatically reverts the current stock to the "initial quantity in stock"
No Action - No action is taken by the system and allows for manual intervention by staff to decide the next steps`,
          placeholder: "Select option",
          options: {
            null: "No Action",
            "86": "86'd",
            resetToInitial: "Reset To Initial"
          }
        },
        showQuantityOnItemCard: "Show Amount in Item Card",
        showQuantityOnItemCardtoolTip: "Enable to display the Current Quantity count in the upper right corner of the menu item card",
        universalProductCode: "UPC",
        universalProductCodetoolTip: "Enter the barcode number in this field so the menu item can be rung up by scanning the barcode on the product"
      },
      registerDisplay: {
        title: "REGISTER SETTINGS",
        updatingTitle: "UPDATING REGISTER SETTINGS",
        registerDisplayOptions: {
          title: "Register Display",
          colors: "Register Colors",
          displayPictureOnCard: "Display Picture on Item Card",
          displayPictureOnCardtoolTip: "Enable to display uploaded image on the menu item button on the register",
          background: "Background",
          text: "Text",
          image: "Image",
          uploadImage: "Upload Item Image",
          uploadSecondaryImage: "Upload Secondary Item Image",
          reset: "Reset",
          mods: "Mods",
          global: "Global",
          customizerDisplay: "Customizer Display",
          customizerDisplaytoolTip: "Enable to have the customizer display appear when ordering this item. Customizer display will allow for modifying the whole, half, or quarter of an item. Typically used for pizza.",
          customizerShape: {
            label: "Customizer Shape",
            placeholder: "Select a Shape",
            toolTip: "This field becomes active if \u201Ccustomizer display\u201D option is enabled. Select either \u201Csquare\u201D or \u201Cround\u201D for the shape of the item.",
            options: {
              square: "Pizza Square",
              round: "Pizza Circle"
            }
          },
          specialTag: {
            label: "Special Tag",
            toolTip: "Select a special tag to appear in the bottom right corner of a menu item card.",
            emptyOption: "No Special Tag"
          }
        },
        kdsDisplay: {
          title: "Kitchen Display",
          kdsColor: "Kitchen Color",
          kdsColortoolTip: "Color the item will display as on the Kitchen Display System",
          reset: "Reset"
        },
        registerPreview: {
          title: "Preview"
        },
        enterItemDetails: "Enter Item Details when added to ticket",
        enterItemDetailstoolTip: "For use when an item has no required modifiers. When enabled, after adding the menu item to the order, user will automatically be taken to the Item Details screen where optional modifiers can be added. When this option is disabled, the user will need to select the menu item in the ticket to enter the Item Details screen to modify the item",
        exitItemDetailsOnRequiredModsCompletion: "Exit Item Details On Required Mods Completion",
        exitItemDetailsOnRequiredModsCompletiontoolTip: "Enable to close the Item Details modification window after all required modifiers have been selected for the menu item",
        transparentBackground: "Image Overlay",
        transparentBackgroundtoolTip: "This field becomes active if an image has been uploaded for the menu item. Enable to place the uploaded item image on top of the background.",
        displayItemPriceOnRegister: "Display Item Price on Item Card",
        displayItemPriceOnRegistertoolTip: "Enable to display the menu item price in the upper left corner of the menu item button on the register",
        hideItemName: "Hide Item Name",
        hideItemNametoolTip: "Enable to prevent the item name from displaying on the item card. Typically used when an image has been uploaded for the menu item.",
        doneIsForTable: '"Done" is "For Table"'
      },
      hiddenItemSection: {
        itemsTitle: {
          inactive: "Hidden due to Category/Subcategory Inactive"
        },
        title: {
          empty: "Hidden due to No Category",
          inactive: "Hidden due to Inactive Category",
          simpleMode: "Hidden due to Simple Mode Menu"
        },
        itemDescription: {
          categoryInactive: `"{{name}}" is not showing in the register module. The category containing the Item is inactive and it won't show in the register module.`,
          categoryEmpty: '"{{name}}" is not showing in the register module. Please associate a Category to see this Item in the Register',
          subcategoryInactive: `"{{name}}" is not showing in the register module. The subcategory containing the Item is inactive and it won't show in the register module.`,
          subcategoryEmpty: '"{{name}}" is not showing in the register module. Please associate a Subcategory to see this Item in the Register',
          menuTypeSimpleMode: '"{{menuTypeName}}" is in Simple Mode and neither this {{bucket}} nor its respective Category/Subcategory are on the Home Screen.',
          couple: "There does not exist a Category and Subcategory couple where both Category and Subcategory are Active"
        },
        comboDescription: {
          categoryInactive: `"{{name}}" is not showing in the register module. The category containing the Combo is inactive and it won't show in the register module.`,
          categoryEmpty: '"{{name}}" is not showing in the register module. Please associate a Category to see this Combo in the Register',
          subcategoryInactive: `"{{name}}" is not showing in the register module. The subcategory containing the Combo is inactive and it won't show in the register module.`,
          subcategoryEmpty: '"{{name}}" is not showing in the register module. Please associate a Subcategory to see this Combo in the Register'
        },
        subcategoryDescription: {
          categoryInactive: `"{{name}}" is not showing in the register module. The category containing the Subcategory is inactive and it won't show in the register module.`,
          categoryEmpty: '"{{name}}" is not showing in the register module. Please associate a Category to see this Subcategory in the Register'
        },
        button: {
          category: "Edit Category",
          subcategory: "Edit Subcategory",
          menuType: "Edit Menu",
          review: "Review"
        }
      },
      noMenuType: {
        title: "No Menu added",
        description: "Please add a Menu on the top right of the Menus section to continue"
      },
      menuTypes: {
        title: "Menus",
        description: "Select the Menus you want to see the Item information for.",
        onHomeScreen: "On Home Screen",
        active: "Active Menus",
        inactive: "Inactive Menus",
        toastRemoveErrorTitle: "Cannot remove this",
        toastRemoveErrorDescription: "You need at least one Menu added",
        filterModal: {
          statusText: "Show Menus with Status:"
        }
      },
      noElementFoundMessage: "This Item does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Item",
        success: "Successfully created Item",
        error: "Error sending new Item",
        massLoading: "Creating Items",
        massSuccess: "Successfully created Items",
        massError: "Error sending new Items"
      },
      editElement: {
        loading: "Updating Item",
        success: "Successfully updated Item",
        error: "Error updating Item",
        massLoading: "Updating Items",
        massSuccess: "Successfully updated Items",
        massError: "Error updating Items"
      },
      deleteElement: {
        loading: "Deleting Item",
        success: "Successfully deleted",
        error: "Error deleting Item",
        massLoading: "Deleting Items",
        massSuccess: "Successfully deleted Items",
        massError: "Error deleting Items"
      },
      unassociateElement: {
        loading: "Unassociating Item",
        success: "Successfully unassociated",
        error: "Error unassociating Item"
      },
      validationFields: {
        name: "Name",
        posName: "POS Name",
        kdsName: "Kitchen Name",
        checkName: "Check Name",
        onlineName: "Online Name",
        categoryId: "Category",
        subcategoryId: "Subcategory",
        itemPrice: "Item Price",
        suggestiveOrdering: "Suggestive Ordering",
        suggestiveOrderingItemPrice: "Suggestive Price",
        suggestiveOrderingPrompt: "Suggestive Ordering Prompt"
      },
      moreInformation: {
        title: "MORE INFORMATION",
        updatingTitle: "UPDATING MORE INFORMATION",
        inputs: {
          description: {
            label: "Description",
            toolTip: "Enter the information that will display in the \u201Cdescription\u201D field when the Item Details window is open. Max 1000 characters",
            placeholder: "Add Description"
          },
          onlineDescription: {
            label: "Online Description",
            toolTip: "Enter the description for the item that will display when ordering online",
            placeholder: "Add Description"
          },
          recipe: {
            label: "Recipe",
            toolTip: "Enter important recipe information here such as ingredients, preparation instructions, portion size, cooking equipment, glassware, and allergens.",
            placeholder: "Add Recipe"
          }
        }
      },
      basic: {
        namesTitle: "Names",
        nameInfo: "Name of the item in the Enterprise menu, this is the name that will be displayed in the POS, KDS, and Online Ordering if those fields are left empty.",
        posNameInfo: "The name of the item that will be displayed in the POS (Point Of Sale).",
        checkNameInfo: "The name of the item that will be displayed on the check.",
        onlineNameInfo: "The name of the item that will be displayed in Online Ordering."
      },
      linkedModItems: {
        title: 'Linked Mod Items in "{{name}}"'
      }
    },
    itemGroupDetails: {
      noElementFoundMessage: "This Item Group does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Item Group",
        success: "Successfully created Item Group",
        error: "Error sending new Item Group"
      },
      editElement: {
        loading: "Updating Item Group",
        success: "Successfully updated Item Group",
        error: "Error updating Item Group"
      },
      deleteElement: {
        loading: "Deleting Item Group",
        success: "Successfully deleted",
        error: "Error deleting Item Group"
      },
      unassociateElement: {
        loading: "Unassociating Item Group",
        success: "Successfully unassociated",
        error: "Error unassociating Item Group"
      },
      basic: {
        required: "Make Required",
        optionsDisabled: {
          creation: "You must finish creation of this Item Group before you can Clone or Delete it.",
          location: "You can only Clone or Delete Item Groups from Enterprise mode."
        }
      },
      associations: {
        items: {
          description: "The Items below belong to this Item Group",
          showUpcharge: "Show Upcharge"
        },
        combos: {
          subtitle: 'Combos using "{{name}}"',
          description: "This Item Group is being used in the Combos listed below",
          emptyCardsMessage: "No Combos are using this Item Group"
        }
      }
    },
    reportingGroupDetails: {
      noElementFoundMessage: "This Reporting Group does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Reporting Group",
        success: "Successfully created Reporting Group",
        error: "Error sending new Reporting Group"
      },
      editElement: {
        loading: "Updating Reporting Group",
        success: "Successfully updated Reporting Group",
        error: "Error updating Reporting Group"
      },
      deleteElement: {
        loading: "Deleting Reporting Group",
        success: "Successfully deleted",
        error: "Error deleting Reporting Group"
      },
      optionsDisabled: {
        creation: "You must finish creation of this Reporting Group before you can Clone or Delete it.",
        location: "You can only Clone or Delete Reporting Groups from Enterprise mode."
      },
      associations: {
        items: {
          description: "This Reporting Group is being used in the Items listed below",
          emptyCardsMessage: "No Items for this Reporting Group"
        },
        combos: {
          description: "This Reporting Group is being used in the Combos listed below",
          emptyCardsMessage: "No Combos for this Reporting Group"
        }
      }
    },
    categoryDetails: {
      noElementFoundMessage: "This Category does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Category",
        success: "Successfully created Category",
        error: "Error sending new Category"
      },
      editElement: {
        loading: "Updating Category",
        success: "Successfully updated Category",
        error: "Error updating Category"
      },
      deleteElement: {
        loading: "Deleting Category",
        success: "Successfully deleted",
        error: "Error deleting Category"
      },
      unassociateElement: {
        loading: "Unassociating Category",
        success: "Successfully unassociated",
        error: "Error unassociating Category"
      },
      childrenType: {
        options: {
          item: "Items/Combos",
          subcategory: "Subcategories"
        }
      },
      basic: {
        title: "BASIC",
        toolTip: "Subcategories allow further grouping of items within a category. Up to 10 subcategories can be added to a category. Subcategories will display when their parent category is selected.\nExamples: \nCategory Beer>Subcategories Draft Beer, Bottle Beer\nCategory Entrees>Subcategories Chicken, Steak, Seafood",
        name: "Name",
        posName: "POS Name",
        hide: "Hide Category",
        hideInfo: "Hide Category",
        customizer: "Customizer Category",
        previewTitle: "Preview:",
        children: "Category Children",
        childrenPlaceholder: "Category Children",
        childrenItems: "Items/Combos",
        childrenSubcategories: "Subcategories",
        childrenTypeModal: {
          title: "Children Type Change:",
          subcategories: {
            body: "This will automatically create a subcategory called Other and assign all existing Items and Combos in this category to this subcategory. You can then rename the Other subcategory, or create new subcategories and associate them to this category."
          },
          items: {
            body: "This will automatically delete all subcategories that were associated with this category. All Items and Combos that belonged to these subcategories will still be associated with this category."
          }
        },
        removeAssociationsModal: {
          title: "Remove Category Associations",
          subcategories: {
            body: "In order to delete, please reassign all Subcategories to another Category."
          },
          items: {
            body: "In order to delete, please reassign all Items and Combos to another Category."
          }
        },
        optionsDisabled: {
          creation: "You must finish creation of this Category before you can Clone or Delete it.",
          location: "You can only Clone or Delete Categories from Enterprise mode."
        }
      },
      taxesSection: {
        title: "TAXES",
        toolTip: "Add the taxes that apply to all items in this category. Individual menu items can have the taxes removed, or custom tax rates added on an item-by-item basis.",
        categoryTaxes: "Custom Category Taxes",
        emptyCardsMessage: "No Taxes for this Category",
        table: {
          headers: {
            taxRateName: "Tax Rate Name",
            type: "Type",
            tax: "Tax",
            details: "Details",
            enable: "Enable"
          }
        }
      },
      associations: {
        title: " Subcategories, Items, Combos, and Menus",
        subcategories: {
          title: "Subcategories",
          description: "The Subcategories below are the Subcategories enabled in the Item and Combo Versions associated to the Location Group.",
          emptyCardsMessage: "No Subcategories for this Category",
          addExistingSubcategory: "Transfer Over Existing Subcategory",
          noSubcategory: "No Subcategory",
          noCategory: "No Category"
        },
        items: {
          title: "Items",
          description: "Items assigned to this Category.",
          emptyCardsMessage: "No Items for this Category"
        },
        combos: {
          title: "Combos",
          description: "Combos assigned to this Category.",
          emptyCardsMessage: "No Combos for this Category"
        },
        menuTypes: {
          title: "Menus",
          description: "The Menus below are the Menus enabled in the Items and Combos associated to this Category.",
          emptyCardsMessage: "No Menus for this Category"
        }
      }
    },
    subcategoryDetails: {
      noElementFoundMessage: "This Subcategory does not exist in {{location}}",
      basic: {
        title: "BASIC",
        toolTip: "Subcategories allow further grouping of items within a category. Up to 10 subcategories can be added to a category. Subcategories will display when their parent category is selected.\nExamples: \nCategory Beer>Subcategories Draft Beer, Bottle Beer\nCategory Entrees>Subcategories Chicken, Steak, Seafood",
        name: "Name",
        posName: "POS Name",
        hide: "Hide Subcategory",
        hideInfo: "Hide Subcategory",
        previewTitle: "Preview:",
        customizer: "Customizer Size Subcategory",
        customizertoolTip: "Should only be enabled for subcategories that will include menu items using the Customizer Display. Enable to be prompted for a size selection for the item prior to adding forced or optional modifiers. This feature allows changing sizes of menu items while also changing the Modifier Item Pricing Versions. An example of when to enable this would be a pizza subcategory, where the user is selecting the size of the pizza first, and topping costs change based on the size of the pizza ordered.",
        deleteModal: {
          title: "Remove Subcategory Associations",
          body: "In order to delete, please reassign all Items to another Subcategory."
        },
        optionsDisabled: {
          creation: "You must finish creation of this Subcategory before you can Clone or Delete it.",
          location: "You can only Clone or Delete Subcategories from Enterprise mode."
        }
      },
      associations: {
        title: "Category, Items, and Combos",
        category: {
          label: "Category",
          toolTip: "Select the Category to which the Subcategory belongs",
          placeholder: "Select Category"
        },
        items: {
          title: "Items",
          description: "The order the items are arranged here is the order it will be displayed in the register. Hit the Edit button to drag an drop Item in to the desired order.",
          emptyCardsMessage: "No Items for this Subcategory"
        },
        combos: {
          title: "Combos",
          description: "The order the Combos are arranged here is the order it will be displayed in the register. Hit the Edit button to drag an drop Item in to the desired order.",
          emptyCardsMessage: "No Combos for this Subcategory"
        }
      },
      taxesSection: {
        title: "TAXES",
        toolTip: "Add the taxes that apply to all items in this subcategory. Individual menu items can have the taxes removed, or custom tax rates added on an item-by-item basis.",
        subcategoryTaxes: "Custom Subcategory Taxes",
        emptyCardsMessage: "No Taxes for this Subcategory"
      },
      createNewElement: {
        loading: "Creating Subcategory",
        success: "Successfully created Subcategory",
        error: "Error sending new Subcategory"
      },
      editElement: {
        loading: "Updating Subcategory",
        success: "Successfully updated Subcategory",
        error: "Error updating Subcategory"
      },
      deleteElement: {
        loading: "Deleting Subcategory",
        success: "Successfully deleted",
        error: "Error deleting Subcategory"
      },
      unassociateElement: {
        loading: "Unassociating Subcategory",
        success: "Successfully unassociated",
        error: "Error unassociating Subcategory"
      }
    },
    menuTypeDetails: {
      noElementFoundMessage: "This Menu does not have any Items in {{location}}",
      createNewElement: {
        loading: "Creating Menu",
        success: "Successfully created Menu",
        error: "Error sending new Menu"
      },
      editElement: {
        loading: "Updating Menu",
        success: "Successfully updated Menu",
        error: "Error updating Menu"
      },
      deleteElement: {
        loading: "Deleting Menu",
        success: "Successfully deleted",
        error: "Error deleting Menu"
      },
      unassociateElement: {
        loading: "Unassociating Menu",
        success: "Successfully unassociated",
        error: "Error unassociating Menu"
      },
      basic: {
        hide: "Hide Menu",
        online: "Online Menu",
        enableSimpleMode: "Simple Display Mode",
        enableSimpleModetoolTip: "Enable for a menu with no categories. When in an order, no search bar will appear for searching within the menu. Screen layout is simple, with the category buttons removed, there is more space on screen for additional menu items",
        onlineInfo: "Menu is Available Online",
        hideInfo: "Hide Menu",
        optionsDisabled: {
          creation: "You must finish creation of this Menu before you can Clone or Delete it.",
          location: "You can only Clone or Delete Menus from Enterprise mode."
        },
        comboDisplayName: "Combo Display Name",
        comboDisplayNametoolTip: "Enter the name a \u201Ccombo\u201D will display as in this menu. For example, Value Meal, Set Menu, Package Deal, Platter",
        disableCoursing: "Disable Coursing",
        disableCoursingtoolTip: "Enable to turn off coursing for items in this menu",
        enableRounding: "Enable Rounding",
        enableRoundingtoolTip: "Enable to allow items in this menu to be grouped \u201Cby round\u201D.  Typically used for drinks, items will be assigned to a round and can quickly be reordered by round",
        defaultToHomeScreen: "Default to Home Screen after Item Selection",
        coursingType: "Coursing Type",
        coursingTypeOptions: {
          none: "None",
          coursing: "Coursing",
          rounding: "Rounding"
        },
        coursingDisabledLabel: "Coursing is currently disabled. Please ensure that your organization or license is not QSR and verify that coursing is enabled in your settings."
      },
      itemAssociations: {
        title: "ITEM ASSOCIATIONS",
        subtitle: "Categories",
        label: "The Categories below are the Categories enabled in the Item and Combo Versions associated to the Location Group.",
        emptyCardsMessage: "No Categories for this Menu"
      },
      assignedItems: {
        title: "ASSIGNED ITEMS",
        subtitle: "Items",
        label: "Items assigned to this Menu",
        actionButtons: {
          addNewItem: "Add New Item",
          addExistingItem: "Add Existing Item"
        },
        emptyCardsMessage: "No Items for this Menu"
      },
      assignedCombos: {
        title: "ASSIGNED COMBOS",
        subtitle: "Combos",
        label: "Combos assigned to this Menu",
        emptyCardsMessage: "No Combos for this Menu"
      },
      taxes: {
        title: "Taxes",
        menuTypeTaxes: "Custom Menu Taxes",
        emptyCardsMessage: "No Taxes for this Menu"
      },
      associations: {
        title: "Items, Combos, Categories, and Subcategories"
      }
    },
    modifierGroupDetails: {
      noElementFoundMessage: "This Modifier Group does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Modifier Group",
        success: "Successfully created Modifier Group",
        error: "Error sending new Modifier Group"
      },
      editElement: {
        loading: "Updating Modifier Group",
        success: "Successfully updated Modifier Group",
        error: "Error updating Modifier Group"
      },
      deleteElement: {
        loading: "Deleting Modifier Group",
        success: "Successfully deleted",
        error: "Error deleting Modifier Group"
      },
      unassociateElement: {
        loading: "Unassociating Modifier Group",
        success: "Successfully unassociated",
        error: "Error unassociating Modifier Group"
      },
      associations: {
        title: 'Items and Mod Items using "{{name}}"',
        items: {
          title: 'Items using "{{name}}"',
          description: "This Modifier group is being used in the Items listed below.",
          emptyCardsMessage: "No Items for this Modifier Group"
        },
        modifierItems: {
          modItems: "Mod Items",
          title: 'Modifier Items using "{{name}}"',
          description: "This Modifier group is being used in the Modifier Items listed below.",
          emptyCardsMessage: "No Modifier Items for this Modifier Group",
          showPricing: "Show Pricing",
          showPricingtoolTip: "Select to view and change the Included and Additional price for each modifier item based on pricing version",
          showMaximums: "Show Maximums"
        },
        modifierGroups: {
          title: "Modifier Group Pricing Versions",
          description: "Select the pricing Version you want to see the information for.",
          emptyCardsMessage: "No Pricing versions for this Modifier Group",
          editMaximums: "Edit Maximums"
        },
        modifierItemsPricing: {
          title: "Modifier Items",
          description: "The order that the Modifier Items are arranged here is the order it will be displayed in the register. Hit the Edit button to drag and drop Modifier Items in to the desired order.",
          emptyCardsMessage: "No Modifier Items for this Modifier Group",
          modals: {
            updatePricingVersion: "Update Pricing Version",
            addPricingVersion: "Add Pricing Version",
            deletePricingVersion: "Delete Pricing Version",
            pricingVersionName: "Pricing Version Name"
          },
          editDisabled: "You can only Delete Modifier Group Pricing Versions in Enterprise mode.",
          addDisabled: "You can only add Modifier Group Pricing Versions in Enterprise mode.",
          breaksSpacesModal: {
            title: "Add Blank Space/Line Break",
            blankSpaces: "Blank Spaces Before the Item",
            lineBreaks: "Line Breaks Before the Item"
          },
          maximumQuantity: "Maximum Quantity"
        }
      },
      basic: {
        quantityMode: "Quantity Mode",
        quantityModetoolTip: "Select the behavior for the quantity of modifier items entered\n<1/>x1,x2,x3 - One or more of each item can be added to the menu item. For example, adding a quantity of salad dressings when prompted for a dressing choice, or selecting individual bottled beers in a \u201Cbeer bucket\u201D menu item\n<1/>Lt,Reg,Ext - Modifiers added will display as Light, Regular or Extra when using the modifier. For example, a burger comes with lettuce, tomato, and onion.  The user will be able to adjust the modifiers using the \u2013 and + sign to indicate light or extra of the chosen modifier.  Extra Lettuce, light onion in this example.\n<1/>None - Modifiers will appear either selected or unselected",
        requiredModifierItems: "Required Modifier Items",
        requiredModifierItemstoolTip: "Enter the number of required modifiers that are part of the menu item. These are required choices, and the user is unable to complete the menu item until all required selections have been made.",
        selectRequired: "Select Required",
        includedModifierItems: "Included Modifier Items",
        includedModifierItemstoolTip: "Enter the number of modifier items that are included as part of the menu item",
        maximumModifierItems: "Maximum Modifier Items",
        maximumModifierItemstooltip: "Enter the maximum number of modifier items that are allowed to be ordered for this modifier group",
        noMax: "No Max",
        pricingMode: "Pricing Mode",
        pricingModetoolTip: "Select the pricing mode that will be used when modifiers have upcharges\n<1/>Maximize - The system prioritizes the most expensive upcharge modifiers, resulting in the best deal for the restaurant. This mode ensures any potential upcharges are maximized.\n<1/>Example: A customer is allowed to add premium toppings sandwich, and the first two are free.  The customer chooses Bacon ($1.00), Cheddar ($1.00) and Avocado ($2.00).  The system will charge $2.00 for the avocado, even if the avocado was entered as one of the first two modifiers.  The $1.00 toppings will be considered the free items in this example.\n<1/>Minimize - The system prioritizes the modifiers so that any upcharges result in the best deal for the customer, making the item the least expensive based on modifiers added to the item.\n<1/>Example: A customer is allowed to add premium toppings sandwich, and the first two are free.  The customer chooses Bacon ($1.00), Cheddar ($1.00) and Avocado ($2.00).  The system will minimize the price, causing the Avocado ($2.00) to be one of the free toppings, and will add the upcharge of $1.00 for either Bacon or Cheddar depending on the order they were entered.",
        selectIncluded: "Select Included",
        hideModifierGroup: "Hide Modifier Group",
        multiselect: "Multiselect",
        multiselecttoolTip: "Allows the selection of multiple modifiers in the modifier group. De-select to allow only one choice/entry to be made in this modifier group.",
        activatePizzaSectionSelector: "Activate Customizer Selector",
        activatePizzaSectionSelectortoolTip: "Enable to show the customizer selector for this menu item. This is used when an item can be modified by the whole, half, and quarters. Typically used for pizza.",
        allowNoneSelection: 'Allow "None" Selection',
        allowNoneSelectiontoolTip: "Enable to allow user to select \u201Cnone\u201D when the modifier group is displayed on screen. A user is not required to make a choice of modifier and may select \u201Cnone\u201D to move on.",
        hidePriceIfFree: "Hide price if Free",
        showModGroupTitleOn: "Show Mod Group Title on:",
        showModGroupTitleOntoolTip: "The Mod Group Title serves as a header that categorizes and organizes the individual modifiers selected by Modifier Group.",
        showModGroupTitleOnRegisterTicket: "Register Ticket",
        showModGroupTitleOnRegisterTickettoolTip: "Enable to show the Mod Group Title on the Register Ticket, so the user entering the order can see the Mod Group Title followed by the modifiers in the ticket detail area",
        showModGroupTitleOnKitchenTicket: "Kitchen Ticket",
        showModGroupTitleOnKitchenTickettoolTip: "Enable to show the Mod Group Title on the Kitchen Ticket, so the kitchen staff can see the Mod Group Title followed by the modifiers on the kitchen ticket",
        guestCheck: "Guest Check",
        guestChecktoolTip: "Enable to show the Mod Group Title on the Guest check, so the customer can see the Mod Group Title followed by the modifiers on the guest check",
        advancedModifier: 'Show in "More Mods"',
        showSearchBar: "Show Search Bar",
        showSearchBartoolTip: "Enable to display a search bar in the modifier group on the register, to search for a modifier by name",
        searchAllModifierItems: "Search All Modifier Items",
        searchAllModifierItemstoolTip: "This option becomes available when \u201CShow Search Bar\u201D is enabled. Enable to allow searching all modifier items in the Search Bar.",
        global: "Global Mod",
        optionsDisabled: {
          creation: "You must finish creation of this Modifier Group before you can Clone or Delete it.",
          location: "You can only Clone or Delete Modifier Groups from Enterprise mode."
        },
        enableModTags: "Enable Mod Tags",
        enableModTagstoolTip: "Enable to allow user to use the Mod Tags for this menu item. This will allow the user access to the No, On Side, Lite, Extra, and any custom mod tags when selecting a modifier in this modifier group",
        enableQuantityBar: "Enable Quantity Bar",
        enableQuantityBartoolTip: "For use when Quantity Mode is set to x1,x2,x3. Enable to add a quantity bar in the item details area when modifying a menu item.",
        customizerSlicing: {
          title: "Customizer Slicing",
          halves: "Halves",
          quarters: "Quarters"
        }
      }
    },
    modifierItemDetails: {
      noElementFoundMessage: "This Modifier Item does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Modifier Item",
        success: "Successfully created Modifier Item",
        error: "Error sending new Modifier Item"
      },
      editElement: {
        loading: "Updating Modifier Item",
        success: "Successfully updated Modifier Item",
        error: "Error updating Modifier Item"
      },
      deleteElement: {
        loading: "Deleting Modifier Item",
        success: "Successfully deleted",
        error: "Error deleting Modifier Item"
      },
      unassociateElement: {
        loading: "Unassociating Modifier Item",
        success: "Successfully unassociated",
        error: "Error unassociating Modifier Item"
      },
      basic: {
        optionsDisabled: {
          creation: "You must finish creation of this Modifier Item before you can Clone or Delete it.",
          location: "You can only Clone or Delete Modifier Items from Enterprise mode."
        },
        removeItemTaxExempt: "Remove Item Tax Exempt",
        removeItemTaxExemptToolTip: "When enabled, taxes will always apply to this item, even if it's normally tax-exempt"
      },
      associations: {
        title: 'Modifier Groups and Items using "{{name}}"',
        modifierGroups: {
          title: 'Modifier Groups Using "{{name}}"',
          description: "This Modifier Item is being used in the Modifier Groups listed below",
          emptyCardsMessage: "No Modifier Groups for this Modifier Item",
          activeModifierGroupError: "The Modifier Group is inactive, so you can't show it in this Modifier Item"
        },
        linkedItem: {
          title: "Linked Item",
          emptyCardsMessage: "No Linked Items for this Modifier Item"
        }
      },
      pricing: {
        title: "PRICING",
        subtitle: "Modifier Item Pricing Versions",
        description: "Select the Pricing Version you want to see the information for.",
        labels: {
          price: "Price",
          includedPrice: "Included Price",
          additionalPrice: "Additional Price",
          lightPrice: "Light Price",
          regularPrice: "Regular Price",
          extraPrice: "Extra Price",
          includedLightPrice: "Included Light Price",
          includedRegularPrice: "Included Regular Price",
          includedExtraPrice: "Included Extra Price",
          additionalLightPrice: "Additional Light Price",
          additionalRegularPrice: "Additional Regular Price",
          additionalExtraPrice: "Additional Extra Price",
          applyQuarterHalfAndWholePricing: "Apply Quarter, Half And Whole Pricing",
          applyQuarterHalfAndWholePricingtooltip: "Only in use when the modifier item belongs to a modifier group using the \u201CActivate Customizer Selector\u201D option. Set the percentage of the price that will apply when adding the modifier to a quarter or half of a parent item. Typically used with pizza, to change the price for toppings added to quarter or half of the pizza.",
          quarterPrice: "Quarter Price",
          halfPrice: "Half Price",
          wholePrice: "Whole Price",
          pricingMode: "Pricing Mode",
          otherOptions: "Other Options",
          advancedPricingMode: "Advanced Pricing Mode",
          advancedPricingModetoolTip: "Enable to allow additional pricing options for the modifier item. x1, x2,x3 pricing, Light/Regular/Extra/On the Side pricing, and quarter/half/whole pricing",
          x1x2x3PricingModeTitle: "Pricing for modifier items when the item belongs to a modifier group using the \u201CX1,X2,X3\u201D Quantity Mode. Prices can be $0.00, negative or positive dollar values.",
          x1x2x3IncludedPrice: "Set the price for the modifier item when it is included with the parent item.\n<1/>For example, a burger comes with a choice of side.  Fries ($0.00) or Side Salad ($1.00).  This would be the amount entered in the included price field.",
          x1x2x3AdditionalPrice: "Set the price for the modifier item when it is ordered as an additional modifier, not part of the included quantity that comes with an item.\n<1/>For example, a specialty pizza can have additional toppings added.  Pepperoni as an additional topping is $2.00.  This would be the amount entered in the additional price field.",
          LtRegExtPricingModeTitle: "Pricing for modifier items when the item belongs to a modifier group using the \u201CLt, Reg,Ext\u201D Quantity Mode. Prices can be $0.00, negative or positive dollar values.",
          LtRegExtIncludedLightPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CLight\u201D option is selected.",
          LtRegExtAdditionalLightPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CLight\u201D option is selected.",
          LtRegExtIncludedRegularPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CRegular\u201D option is selected.",
          LtRegExtAdditionalRegularPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CRegular\u201D option is selected.",
          LtRegExtIncludedExtraPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CExtra\u201D option is selected.",
          LtRegExtAdditionalExtraPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CExtra\u201D option is selected.",
          masterPrice: "Price",
          onSidePrice: "On the Side Price",
          onSidePricetoolTip: "Set the price for the modifier item when it is ordered using the \u201Con the side\u201D mod tag."
        },
        editDisabled: "You can only Delete Modifier Item Pricing Versions in Enterprise mode.",
        addDisabled: "You can only add Modifier Item Pricing Versions in Enterprise mode."
      },
      modifier: {
        buttonDisabled: {
          title: "Cannot Modify",
          body: "You can only edit defaulted Modifier Items from within their Modifier Group."
        }
      }
    },
    itemGroupsDetails: {
      associations: {
        title: "Items and Combos",
        items: {
          title: "Items",
          description: "Items assigned to this Item Group.",
          emptyCardsMessage: "No Items for this Item Group"
        },
        combos: {
          title: "Combos",
          description: "Combos assigned to this Item Group.",
          emptyCardsMessage: "No Combos for this Item Group"
        }
      },
      itemAssociationsSection: {
        showUpCharge: "Show Upcharge"
      },
      basic: {
        required: "Make Required",
        upCharge: "Upcharge",
        optionsDisabled: {
          creation: "You must finish creation of this Item Group before you can Clone or Delete it.",
          location: "You can only Delete Item Group from Enterprise mode."
        }
      }
    },
    discountDetails: {
      discountScheme: {
        inputs: {
          applyTo: {
            label: "Apply To",
            placeholder: "Apply To",
            toolTip: "Select whether the discount is an item discount or applies to the entire order\n<1/>Item - Discount applied to a single item\n<1/>Order - Discount applied to entire order, for all items eligible for discount",
            options: {
              item: "Item",
              order: "Order"
            }
          },
          discountType: {
            label: "Discount Type",
            placeholder: "Select a Discount Type",
            toolTip: "Select which method of discounting applies to the item/order\n<1/>Percent - Percent discount on the item/order\n<1/>Fixed - Dollar amount discount on the item/order",
            options: {
              percent: "Percent",
              fixed: "Fixed",
              override: "Override"
            }
          },
          value: {
            percentage: {
              label: "Discount Percentage",
              toolTip: "Enter the percent off that will be applied for the discount",
              placeholder: "Discount Percentage"
            },
            amount: {
              label: "Discount Amount",
              toolTip: "Enter the dollar amount of the fixed discount",
              placeholder: "Discount Amount"
            },
            override: {
              label: "Price Override",
              placeholder: "Price Override"
            }
          },
          taxes: {
            label: "Taxes",
            placeholder: "Taxes",
            toolTip: "Select whether taxes will be applied before or after the item/order when using the discount\n<1/>Apply Before: Discount will be applied before taxes are calculated on the item/order.  Any applicable sales tax will be due on the item/order\n<1/>Apply After: Discount will be applied after taxes are calculated on the item/order.  Applicable sales taxes will be calculated based on the taxes due after the item/order is discounted. ",
            options: {
              applyBefore: "Apply Before",
              applyAfter: "Apply After"
            }
          },
          exclusive: {
            label: "Exclusive Discount"
          }
        }
      },
      noElementFoundMessage: "This Discount does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Discount",
        success: "Successfully created Discount",
        error: "Error sending new Discount"
      },
      editElement: {
        loading: "Updating Discount",
        success: "Successfully updated Discount",
        error: "Error updating Discount"
      },
      deleteElement: {
        loading: "Deleting Discount",
        success: "Successfully deleted",
        error: "Error deleting Discount"
      },
      unassociateElement: {
        loading: "Unassociating Discount",
        success: "Successfully unassociated",
        error: "Error unassociating Discount"
      }
    },
    comboDetails: {
      reportingSection: {
        emptyCardsMessage: "No Reporting Groups for this Combo"
      },
      menuTypes: {
        title: "Creating New Combo",
        description: "Select all Menus you want this Combo to be available in",
        sectionDescription: "Select the Menus you want to see the Combo information for.",
        emptyCardsMessage: "No Menus for this Combo",
        emptyActiveCardsMessage: "No Active Menus for this Combo",
        emptyInactiveCardsMessage: "No Inactive Menus for this Combo"
      },
      applyChangesToMenuType: {
        error: {
          title: "Merging Warning",
          description: "Some of the Items or Item Groups are not found in the other Menus. Please review the changes that will be applied to the other Menus."
        }
      },
      noElementFoundMessage: "This Combo does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Combo",
        success: "Successfully created Combo",
        error: "Error sending new Combo"
      },
      editElement: {
        loading: "Updating Combo",
        success: "Successfully updated Combo",
        error: "Error updating Combo"
      },
      deleteElement: {
        loading: "Deleting Combo",
        success: "Successfully deleted",
        error: "Error deleting Combo"
      },
      unassociateElement: {
        loading: "Unassociating Combo",
        success: "Successfully unassociated",
        error: "Error unassociating Combo"
      },
      registerDisplay: {
        hideComboName: "Hide Combo Name",
        displayComboPriceOnRegister: "Display Combo Price on Register",
        uploadImage: "Upload Combo Image",
        uploadSecondaryImage: "Upload Secondary Image"
      },
      basic: {
        showComboOnline: "Show Combo online",
        sharingLabel: "Allow Combo Sharing"
      },
      pricingSection: {
        isTaxInclusive: "Combo is Tax Inclusive"
      },
      taxesSection: {
        comboTaxes: "Custom Combo Taxes"
      },
      itemGroups: {
        editItemGroup: "Edit Item Group",
        activeItemGroupError: "The Item Group is inactive, so you can't show it in this Combo",
        description: "Below are the Item Groups associated to this Combo. Any changes made to the Item Groups will be an override, represented by a blue dot"
      },
      associations: {
        title: "Category and Subcategory"
      }
    },
    specialDetails: {
      menuTypes: {
        title: "Menus",
        description: "Select all Menus you want this Special to be available in",
        sectionDescription: "Select the Menus you want to see the Special information for.",
        emptyCardsMessage: "No Menus for this Special",
        emptyActiveCardsMessage: "No Active Menus for this Special",
        emptyInactiveCardsMessage: "No Inactive Menus for this Special"
      },
      applyChangesToMenuType: {
        error: {
          title: "Merging Warning",
          description: "Some of the Items/Combos are not found in the other Menus. Please review the changes that will be applied to the other Menus."
        }
      },
      associations: {
        title: "Items and Combos",
        addExistingItemCombo: "Add Existing Item/Combo",
        restaurantLocations: {
          title: "Restaurant Locations",
          description: "Restaurant Locations to which the Special belongs",
          emptyCardsMessage: "No additional Locations for this Special"
        },
        buyItemIds: {
          emptyCardsMessage: {
            bogo: "No Buy Items/Combos for this Special",
            item: "No Items/Combos for this Special"
          },
          title: {
            bogo: "Buy Items/Combos",
            item: "Items/Combos"
          },
          description: {
            bogo: 'Items/Combos the customer has to "Buy" in order to be eligible for Buy X Get X',
            item: "Items/Combos to which the Special Belongs to:"
          }
        },
        getItemIds: {
          mimicItems: "Mimic Buy Items/Combos",
          mimicOverlay: "Get Items/Combos are mimicing (copying) Buy Items/Combos",
          clearAllItems: "Clear All",
          emptyCardsMessage: {
            bogo: "No Get Items/Combos for this Special"
          },
          title: {
            bogo: "Get Items/Combos"
          },
          description: {
            bogo: 'Items/Combos to which the Special Discount can be applied to, upon purchase of the "Buy" quantity.'
          }
        }
      },
      scheme: {
        title: "SPECIALS SCHEME",
        toolTip: "Item/Combo - menu items assigned will be able to be discounted by a set amount\n<1/>Order - the entire order will be able to be discounted by a set amount\n<1/>Buy X Get X - Set the parameters for the menu items that can be ordered to trigger the special, and set the items that will be awarded, as well as the discount amount. ",
        discountTypetoolTip: "Select which method of discounting applies to this item\n<1/>Percent - Percent discount on the item/combo\nFixed - Dollar amount discount on the item/combo\n<1/>Override - Set a price for the item/combo that will override the regular menu price while the special is in effect",
        discountPercentagetoolTip: "Enter the percent off that will be applied during the time the special is available",
        discountAmounttoolTip: "Enter the dollar amount of the fixed discount",
        discountOverridetoolTip: "Enter the dollar amount of the fixed discount",
        applyTo: {
          options: {
            item: "Item/Combo",
            order: "Order",
            bogo: "Buy X Get X"
          }
        },
        inputs: {
          thresholdAmount: {
            label: "Threshold Amount"
          },
          buyQuantity: {
            label: "Buy Qty:",
            toolTip: "Enter the purchase quantity required to trigger the special",
            error: "Zero Not Allowed"
          },
          getQuantity: {
            label: "Get Qty:",
            toolTip: "Enter the quantity to be awarded when the trigger threshold is met",
            error: "Zero Not Allowed"
          }
        }
      },
      noElementFoundMessage: "This Special does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Special",
        success: "Successfully created Special",
        error: "Error sending new Special"
      },
      editElement: {
        loading: "Updating Special",
        success: "Successfully updated Special",
        error: "Error updating Special"
      },
      deleteElement: {
        loading: "Deleting Special",
        success: "Successfully deleted",
        error: "Error deleting Special"
      },
      unassociateElement: {
        loading: "Unassociating Special",
        success: "Successfully unassociated",
        error: "Error unassociating Special"
      },
      basic: {
        optionsDisabled: {
          creation: "You must finish creation of this Special before you can Clone or Delete it.",
          location: "You can only Clone or Delete Specials from Enterprise mode."
        }
      },
      availability: {
        title: "AVAILABILITY",
        toolTip: "Set the days and times the special will be available",
        table: {
          title: "Available Times",
          addTime: "Add Time",
          noData: "No Times"
        }
      }
    },
    ingredientDetails: {
      noElementFoundMessage: "This Ingredient does not exist in {{location}}",
      createNewElement: {
        loading: "Creating Ingredient",
        success: "Successfully created Ingredient",
        error: "Error sending new Ingredient"
      },
      editElement: {
        loading: "Updating Ingredient",
        success: "Successfully updated Ingredient",
        error: "Error updating Ingredient"
      },
      deleteElement: {
        loading: "Deleting Ingredient",
        success: "Successfully deleted",
        error: "Error deleting Ingredient"
      },
      unassociateElement: {
        loading: "Unassociating Ingredient",
        success: "Successfully unassociated",
        error: "Error unassociating Ingredient"
      },
      associations: {
        title: "Items",
        description: "Items assigned to this Ingredient",
        selectionModal: {
          menuTypeDescription: "Select the Menus that you want to include the ingredient."
        },
        emptyCardsMessage: "No Items for this Ingredient"
      }
    },
    noElementToast: {
      title: "Element Not Found"
    },
    itemsMain: {
      showListView: "Show List View",
      table: {
        varies: "*Varies",
        noTaxes: "No Taxes",
        noCategories: "No Categories",
        noModifierGroups: "No Modifier Groups",
        noReportingGroups: "No Reporting Groups",
        noPrinterLocations: "No Printer Locations",
        headers: {
          name: "Name",
          price: "Price",
          taxes: "Taxes",
          quantity: "Qty",
          categoriesSubcategories: "Cat./Subcat.",
          modifierGroups: "Mod Groups",
          printerLocations: "Printer Locations",
          reportingGroups: "Reporting Groups"
        }
      },
      massUpdate: {
        button: "Mass Update",
        massUpdateInformation: {
          itemsSelectedFrom: "Items Selected From",
          editItemsSelection: "Edit Items Selection",
          viewSelection: "View Selection"
        }
      },
      multiselect: {
        button: "Multiselect",
        multiselectInformation: {
          itemsSelectedFrom: "Items Selected From",
          editItemsSelection: "Edit Items Selection",
          viewSelection: "View Selection"
        }
      }
    },
    combosMain: {
      table: {
        noItemGroups: "No Item Groups"
      }
    },
    specialsMain: {
      table: {
        bogo: "Buy {{buy}} Get {{get}}"
      }
    },
    menuTypesMain: {
      table: {
        headers: {
          itemCount: "Items|Combos|Cat.|Subcat."
        }
      },
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Menus from Enterprise mode."
      }
    },
    ingredientsMain: {
      table: {
        headers: {
          items: "Items Associated"
        }
      },
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Ingredients from Enterprise mode."
      }
    },
    reportingGroupsMain: {
      table: {
        noCombos: "No Combos",
        headers: {
          combos: "Combos Associated"
        }
      }
    },
    categoryMain: {
      table: {
        noSubcategories: "No Subcategories",
        headers: {
          itemCount: "Items|Combos"
        }
      },
      menuTypesDropdown: {
        label: "Menus",
        placeholder: "Menus"
      },
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Categories from Enterprise mode."
      }
    },
    subcategoryMain: {
      categoriesDropdown: {
        label: "Categories",
        placeholder: "Categories"
      },
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Subcategories from Enterprise mode."
      }
    },
    modifierItemsMain: {
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Modifier Items from Enterprise mode."
      },
      modifierGroupDropdownLabel: "Assigned to Modifier Group",
      table: {
        inStock: "In Stock",
        headers: {
          pricing: "Pricing",
          is86ed: "Inventory",
          nestedModifiers: "Nested Modifiers",
          modifierGroups: "Mod Groups Using This Mod Item"
        }
      }
    },
    modifierGroupsMain: {
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Modifier Groups from Enterprise mode."
      },
      table: {
        noModifierItems: "No Mod Items",
        headers: {
          quantityMode: "Quantity Mode",
          maximumModifierItems: "Max",
          includedModifierItems: "Incl.",
          requiredModifierItems: "Req.",
          modifierItems: "Mod Items",
          itemCount: "Asssoc. Items"
        }
      }
    },
    itemGroupsMain: {
      disabledActionToast: {
        title: "Alert",
        description: "You can only add Item Groups from Enterprise mode."
      }
    }
  },
  customersScreen: {
    newCustomer: "New Customer",
    diffModal: {
      title: "Customer Details"
    },
    errors: {
      dateOfBirth: "Invalid date of birth format",
      firstName: "First name cannot be empty",
      lastName: "Last name cannot be empty",
      phoneNumber: {
        empty: "Phone Number cannot be empty.",
        invalid: "Phone Number must be 10 digits.",
        duplicated: "A customer with this phone number already exists."
      }
    },
    singular: "Customer",
    plural: "Customers",
    creation: {
      title: "End Customer Creation?",
      message: "You are currently creating a new Customer. Before navigating away, you must either finish the Customer creation or cancel Customer creation."
    },
    editElement: {
      loading: "Updating Customer",
      success: "Successfully updated Customer",
      error: "Error updating Customer"
    },
    createNewElement: {
      loading: "Creating Customer",
      success: "Successfully created Customer",
      error: "Error sending new Customer"
    },
    mainScreen: {
      searchingMessage: "Searching Customer",
      loadingMessage: "Loading Customers",
      emptyDataText: "No Customers has been registered yet"
    },
    basic: {
      firstName: "First Name",
      middleName: "Middle Name",
      lastName: "Last Name",
      dateOfBirth: "Date Of Birth",
      email: "Email",
      phoneNumber: "Phone Number",
      customerNotes: "Customer Notes",
      contactDetails: "Contact Details"
    },
    addressInfo: {
      title: "ADDRESS INFO",
      emptyDataText: "No address has been registered yet",
      addressType: {
        house: "House",
        hotel: "Hotel",
        office: "Office",
        apartment: "Apartment"
      },
      addressInfoModal: {
        title: {
          create: "Create Customer Address",
          edit: "Edit Customer Address"
        }
      },
      table: {
        isDefault: "Default",
        addressType: "Address Type",
        streetLine1: "Street 1",
        streetLine2: "Street 2",
        city: "City",
        state: "State",
        postalCode: "Zip",
        addressName: "Hotel/Office Name",
        unitNumber: "Unit #",
        apartmentNumber: "Apartment #",
        officeName: "Office Name",
        hotelName: "Hotel Name",
        roomNumber: "Room #"
      }
    },
    cardInfo: {
      title: "CARD INFO",
      emptyDataText: "No cards has been registered yet",
      cardType: {
        MasterCard: "MasterCard",
        Visa: "Visa",
        AmericanExpress: "American Express"
      },
      table: {
        lastFourDigits: "Last 4 digits of card",
        cardType: "Card Type",
        dateOfLastUsed: "Date of Last Used"
      }
    },
    orders: {
      title: "ORDERS",
      summary: {
        totalOfOrdersPlaced: "Total # of Orders Placed",
        avgSpend: "Avg Spend",
        lifetimeSpend: "Lifetime Spend",
        avgTip: "Avg Tip %",
        avgTipAmount: "Avg Tip Amount",
        percentageBreakdownOfDineIn: "% Breakdown of Dine In",
        percentageBreakdownOfDelivery: "% Breakdown of Delivery",
        percentageBreakdownOfToGo: "% Breakdown of To go",
        percentageBreakdownOfCatering: "% Breakdown of Catering"
      },
      lastOrders: {
        title: "Previous Orders",
        emptyDataText: "No order has been registered",
        table: {
          orderId: "Order Id",
          createdAt: "Created Time",
          total: "Total Amount",
          locationId: "Location Name",
          status: "Status"
        }
      }
    }
  },
  viewAllOrdersScreen: {
    modals: {
      filter: {
        title: "FILTERS",
        subtitle: "All Orders",
        orderOwner: "Order Owner",
        orderStatus: "Order Status",
        orderType: "Order Type",
        orderCreated: "Order Created",
        orderModified: "Order Modified",
        selectedOwners: "Selected Owners",
        noOwnersSelected: "No Owners Selected",
        dineIn: "Dine in",
        curbside: "Curbside",
        pickUp: "Pickup",
        delivery: "Delivery",
        toGo: "To go",
        today: "Today",
        start: "Start",
        end: "End",
        orderStatusNames: {
          open: "Open",
          "tip-pending": "Tip Pending",
          failed: "Failed",
          closed: "Closed",
          other: "Other"
        },
        orderSubstatusNames: {
          initiated: "Initiated",
          ordered: "Ordered",
          checkPrinted: "Check Printed",
          "tip-pending": "Tip Pending",
          batchPending: "Batch Pending",
          complete: "Complete",
          readyForPickup: "Ready For Pickup",
          onTheWay: "On The Way",
          voided: "Voided"
        }
      }
    }
  },
  settingsModule: {
    selectionModal: {
      printers: {
        title: "Select Printer",
        selectedSectionTitle: "Selected Printers",
        emptySectionText: "Please select an existing printer to associate",
        noCardSelectedText: "No Printers Selected",
        noAvailableCardsText: "No Printers available"
      }
    },
    devices_licenses: {
      addTablet: "Add Tablet",
      editTabletModal: {
        title: "Edit Tablet",
        titleAdd: "Add Tablet",
        success: "Tablet Updated Successfully",
        successAdd: "Tablet Added Successfully"
      },
      addPrinter: "Add Printer",
      editPrinterModal: {
        title: "Edit Printer",
        titleAdd: "Add Printer",
        success: "Printer Updated Successfully",
        successAdd: "Printer Added Successfully",
        successRemove: "Printer Removed Successfully",
        selectBackupPrinter: "Select Backup Printer",
        selectPrinterMake: "Select Printer Make",
        selectType: "Select Type",
        deletePrinter: "Delete Printer"
      },
      title: "Devices and Licenses",
      addLicenses: "Add Licenses",
      addTerminal: "Add Terminal",
      myLicenseSettings: "My License Settings",
      currentDevice: "Current Device",
      deactivate: {
        loading: "Deactivating License"
      },
      associateLocation: {
        loading: "Changing License Location"
      },
      editElement: {
        success: "Successfully updated Devices and Licenses",
        error: "Error updating Devices and Licenses",
        loading: "Updating Devices and Licenses"
      },
      buttons: {
        devices: "Devices",
        licenses: "Licenses",
        printers: "Printers",
        tablets: "Tablets",
        terminals: "Terminals",
        connectPrinter: "Connect Printer"
      },
      tabletsTable: {
        name: "Name",
        status: "Status",
        license: "License",
        androidId: "Android ID #",
        appVersion: "App Version",
        emptyDataTitle: "No tablets have been added yet",
        emptyDataSubtitle: 'Hit the "Add Tablet" button to add new Tablets',
        emptyBySearchTitle: "No results for your search",
        emptyBySearchSubtitle: "Make sure all the words are spelled correctly",
        activate: "Activate",
        deactivate: "Deactivate",
        notLicensed: "No License"
      },
      licensesTable: {
        licenseSerial: "License Serial #",
        nickname: "Name",
        activationDate: "Activation Date",
        licenseType: "License Type",
        location: "Location",
        associatedDevice: "Associated Device",
        actions: "Actions",
        emptyDataTitle: "No licenses have been added yet",
        emptyDataSubtitle: 'Hit the "Add Licenses" button to add new Licenses',
        emptyBySearchTitle: "No results for your search",
        emptyBySearchSubtitle: "Make sure all the words are spelled correctly",
        deactivate: "Deactivate",
        activationCode: "Activation Code:",
        noDevice: "No Device",
        actionsButtons: {
          editLicenseSettings: "Edit License Settings",
          changeLocation: "Change Location"
        }
      },
      printersTable: {
        name: "Name",
        deviceSerial: "Device Serial #",
        model: "Model",
        make: "Make",
        paperWidth: "Paper Width",
        type: "Type",
        backupPrinter: "Backup Printer",
        status: "Status",
        macAddress: "MAC Address",
        actions: "Actions",
        emptyDataTitle: "No printers have been added yet",
        emptyDataSubtitle: 'Hit the "Connect Printer" button to add new Printers',
        emptyBySearchTitle: "No results for your search",
        emptyBySearchSubtitle: "Make sure all the words are spelled correctly",
        positionOne: "Cash Drawer Position 1",
        positionTwo: "Cash Drawer Position 2",
        showInPrinterCenter: "Show in Printer Center"
      },
      terminalsTable: {
        name: "Name",
        tpn: "TPN",
        authKey: "Auth Key",
        authToken: "Auth Token",
        licenses: "Licenses",
        actions: "Actions",
        emptyDataTitle: "No Terminals have been added yet",
        emptyDataSubtitle: 'Hit the "Connect Terminal" button to add new Terminals',
        emptyBySearchTitle: "No results for your search",
        emptyBySearchSubtitle: "Make sure all the words are spelled correctly",
        noLicenses: "No Licenses",
        associatedLicenses: "Associated Licenses"
      },
      editTerminalModal: {
        title: "Edit Terminal",
        success: "Terminal Updated Successfully",
        associateLicense: "Associate License",
        associatedLicense: "Associated License",
        deleteTerminal: "Delete Terminal",
        deleteSuccess: "Terminal Deleted Successfully"
      }
    },
    usersSettings: {
      webPortalAccess: "Web Portal Access",
      roles: "Roles",
      description: "Add all roles the user may select to sign in to the register",
      generateNewPin: "Generate New PIN",
      enterEmailAddress: "Please enter the E-mail address you want to associate to this New User",
      activeSwitchInfo: "A User's status can only be changed for individual locations",
      addExistingUser: "Assign User to this Location",
      addNewUser: "Add New User",
      addNewUserTag: "New User",
      addingNewUser: "Adding New User",
      editElement: {
        success: "Successfully updated User",
        error: "Error updating User",
        loading: "Updating User"
      },
      selectionModal: {
        selectButton: "SELECT",
        unselectButton: "UNSELECT",
        header: {
          options: {
            cancel: "Cancel",
            associate: "Add user"
          }
        },
        selectedSectionTitle: "Selected Users",
        title: "Select Users",
        emptySectionText: "Please select an existing user to associate",
        noCardSelectedText: "No Users Selected",
        noAvailableCardsText: "No Users available"
      },
      locationSelectionModal: {
        rolesSectionDescription: "Select at least 1 role to assign to"
      },
      createNewElement: {
        loading: "Creating User",
        success: "Successfully created User",
        error: "Error sending new User"
      },
      deleteElement: {
        loading: "Deleting User",
        error: "Error deleting User",
        success: "Successfully deleted"
      },
      forbiddenChangesToasts: {
        deactivateCurrentUser: {
          title: "Cannot Deactivate",
          description: "You cannot deactivate your own user."
        },
        removeAcccessToCurrentUser: {
          title: "Cannot Remove Access",
          description: "You cannot remove access to the web portal for your own user."
        }
      },
      emailErrorToast: {
        emailToastErrorTitleLocation: "User already exists in current Location",
        emailToastErrorTitleOrganization: "User already exists in current Organization",
        emailToastErrorDescription: "Please enter a different email"
      },
      loader: {
        text: "Looking for existing User with E-mail:"
      },
      unassociateElement: {
        loading: "Unassociating User",
        success: "Successfully unassociated",
        error: "Error unassociating User"
      }
    },
    guestCheckSettings: {
      title: "Guest Check",
      subtitle: "GUEST CHECK SETTINGS",
      customizingReceipts: {
        title: "HEADER/FOOTER CUSTOMIZATION",
        checkHeader: "Check Header",
        checkFooter: "Check Footer"
      },
      editElement: {
        success: "Successfully updated Guest Check Settings",
        error: "Error updating Guest Check Settings",
        loading: "Updating Guest Check Settings"
      },
      sortItemsBy: {
        options: {
          registerCourse: "Register Course",
          menuCourse: "Menu Course",
          timeAddedToTicket: "Time Added to Ticket",
          timeSentToKitchen: "Time Sent to Kitchen"
        }
      },
      secondSortItemsBy: {
        options: {
          alphabetical: "Alphabetical",
          alphabeticalReverse: "Alphabetical Reverse",
          timeAddedToTicket: "Time Added to Ticket"
        }
      },
      taxIndicators: {
        title: "Tax Indicators",
        taxIndicatorPosition: "Position for Indicator",
        taxIndicatorColor: "Indicator Color",
        taxIndicator: "Taxable Indicator",
        taxExemptIndicator: "Tax Exempt Indicator",
        showTaxIndicator: "Show Tax Indicator"
      },
      customOrderTypeNames: {
        title: "Custom Order Type Names"
      }
    },
    guestReceiptSettings: {
      customizingReceipts: {
        receiptHeader: "Receipt Header",
        receiptFooter: "Receipt Footer"
      },
      editElement: {
        success: "Successfully updated Guest Receipt Settings",
        error: "Error updating Guest Receipt Settings",
        loading: "Updating Guest Receipt Settings"
      },
      checkDisplay: {
        showCheckTotals: "Show Check Totals",
        printMerchantCopy: "Print Merchant Copy",
        showTaxesIndividually: "Show Taxes Individually",
        printOrderQr: "Print Order # QR Code in Footer"
      },
      suggestedTips: {
        title: "Suggested Tips",
        showSuggestedTips: "Show Suggested Tips",
        showTipTotalLines: "Print tip/total lines",
        tipOption1: "Tip Option 1",
        tipOption2: "Tip Option 2",
        tipOption3: "Tip Option 3"
      },
      footerDescription: {
        title: "Footer Description",
        showFooterDescription: "Show Footer Description",
        addFooterDescription: "Add Footer Description"
      },
      items: {
        title: "Items",
        showItems: "Show Items"
      }
    },
    licenseSpecificPrinterRules: {
      editElement: {
        success: "Successfully Updated License Specific Printing Rules Settings",
        error: "Error Updating License Specific Printing Rules Settings",
        loading: "Updating License Specific Printing Rules Settings"
      }
    },
    userDetailsSettings: {
      title: "User Data",
      noElementFoundMessage: "This User does not exist in {{location}}",
      emailModalPlaceholder: "user@example.com",
      resendInvite: "Resend Invite",
      resendInviteRequest: {
        loading: "Resending Invite",
        success: "Invite Resent",
        error: "Error Resending Invite"
      },
      basic: {
        email: "E-mail",
        firstName: "First Name",
        lastName: "Last Name",
        phone: "Phone",
        pin: "PIN",
        pintoolTip: "Enter the number the user will use to clock in and sign into the register",
        changeEmailBtn: "Change E-mail",
        changeUserBtn: "Change Associated TT account",
        changeEmailTitle: "Change User E-mail",
        changeAccountTitle: "Change TableTurn Account Email",
        optionsDisabled: {
          creation: "You must finish creation of this User before you can Delete it.",
          location: "You can only Delete Users from Enterprise mode."
        },
        tableTurnAccount: "Table Turn Account",
        organizationAccount: "Organization Account",
        userStatus: "User Status:",
        orgStatus: "Org Status:",
        swipeCardDescription: "Swipe or Enter the card to link to this user",
        linkCard: "Link Card",
        status: {
          new: {
            name: "New TableTurn User",
            userStatusDescription: "This email does not exist within TT. Once you finish creating the user, please have the user check his/her email and follow the steps to verify their email address.",
            orgStatusDescription: ""
          },
          unverified: {
            name: "Awaiting TableTurn Email Confirmation",
            userStatusDescription: "This email already exists within TT, so their information is prefilled. Because the user has not yet verified their email, all data is editable. Once you finish adding the user to your organization, please have the user check his/her email and follow the steps to verify their email address.",
            orgName: "Awaiting Organization Email Confirmation",
            orgStatusDescription: "This user has not logged in to the portal and accepted the invite to this organization. They can still login at this location and use all features."
          },
          verified: {
            name: "TableTurn Verified",
            userStatusDescription: "This email already exists to a verified user within TT, so their information is prefilled. To change this information, have the user log in to the portal.",
            orgName: "Organization Verified",
            orgStatusDescription: "The user is verified in your Org and can access their web portal to view permitted information."
          },
          noVerificationRequired: {
            name: "Email Confirmation Not Required",
            userStatusDescription: "This user does not have access to the organization's web portal.",
            orgName: "Email Confirmation Not Required",
            orgStatusDescription: "This user does not have access to the organization's web portal."
          }
        }
      },
      associations: {
        clockedInError: {
          title: "Cannot Remove Role",
          description: "{{userName}} is currently clocked in as {{roleName}}"
        },
        locationsSubsectionTitle: "Restaurant Locations",
        locationsSubsectionSubtitle: "Select the Location you want to see the User's Roles for",
        emptyLocationsMessage: "User not assigned to any location",
        emptyRolesMessage: "No Roles associated to this User in this Location"
      }
    },
    prepStationsSettings: {
      title: "Printer Locations",
      addPrepStationButtonText: "Add Printer Location",
      addPrinterButtonText: "Add Printer",
      selectedPrinters: "Selected Printers",
      noPrintersSelected: "No Printers Selected",
      printers: "Printers",
      printerTypes: {
        receipt: "Receipt",
        kitchen: "Kitchen",
        sticky: "Sticky"
      },
      general: {
        status: "Status",
        name: "Name",
        posName: "POS Name",
        printers: "Printer (s) - If multiple printers are added, the first available printer will print the ticket.",
        delete: "Delete"
      },
      editElement: {
        success: "Successfully updated Printer Locations Settings",
        error: "Error updating Printer Locations Settings",
        loading: "Updating Printer Locations Settings"
      },
      errors: {
        name: "Error in Printer Location table."
      },
      defaultPrepStationSection: {
        title: "DEFAULT PRINTER LOCATION",
        description: "If a default Printer Location is selected, all items that are not associated to a Printer Location will print at this Printer Location.",
        defaultPrepStationId: {
          label: "Select Default Printer Location",
          noDefaultPrepStation: "No Default Printer Location"
        }
      }
    },
    licenseSettings: {
      overrides: "Overrides",
      description: " - Only set the below settings specific for this license if you wish to override your restaurant\u2019s default setting.",
      createNewElement: {
        loading: "Creating License Settings",
        success: "Successfully created License Settings",
        error: "Error creating new License Settings"
      },
      editElement: {
        success: "Successfully Updated License Settings",
        error: "Error Updating License Settings",
        loading: "Updating License Settings"
      },
      errors: {
        registerAutoLock: "Enter a valid Register Auto-logout time.",
        nickname: "Nickname is required.",
        revenueCenterId: "Revenue Center is required.",
        defaultServiceAreaId: "Default Service Area is required.",
        eGiftCardTerminalId: "A 4-digit number is required for Terminal ID."
      },
      basicSettings: {
        title: "LICENSE BASIC SETTINGS",
        description: "Select the Basic Settings for this License",
        nickname: "Name",
        stationNumber: "Number",
        revenueCenter: "Revenue Center (For Reporting)",
        registerAutoLogout: "Register Auto-logout time",
        registerAutoLogouttoolTip: "Enter the amount of time in seconds before the register will log out due to inactivity",
        language: "Language",
        displayMode: "Display Mode (Light/Dark)",
        fontSize: "Font Size",
        restaurantMode: "Restaurant Mode",
        menu: "Menu",
        suppressSuggestiveOrderingPrompts: "Suppress Suggestive Ordering Prompts",
        printOrderNumberOnSend: "Print Order Number On Send",
        nicknamePlaceholder: "Nickname",
        autoLogoutPlaceholder: "Time",
        languageDropdownOptions: {
          english: "English",
          spanish: "Spanish"
        },
        displayModeDropdownOptions: {
          light: "Light",
          dark: "Dark"
        },
        fontSizeDropdownOptions: {
          small: "Small",
          normal: "Normal",
          big: "Big"
        },
        restaurantModeDropdownOptions: {
          tsr: "Table Service",
          qsr: "Quick Service"
        }
      },
      paymentSettings: {
        title: "PAYMENT SETTINGS",
        description: "Set the Payment Settings for this License",
        eGiftCardTerminalId: "Egift Terminal ID"
      },
      tableServiceOrderSettings: {
        title: "TABLE SERVICE ORDER SETTINGS",
        description: "Set the Order Settings for this Device",
        makingAndPlacingOrders: "Making and Placing Orders",
        defaultServiceArea: "Default Service Area",
        defaultServiceAreaOptions: {
          all: "All",
          no_table: "No Table",
          to_go: "To Go",
          delivery: "Delivery",
          catering: "Catering"
        },
        suppressCoursing: "Suppress Coursing",
        suppressSeating: "Suppress Seating",
        suppressAutoTriggering: "Suppress Auto-triggering"
      },
      quickServiceOrderSettings: {
        title: "QUICK SERVICE ORDER SETTINGS",
        description: "Set the Order Settings for this License",
        sendAndPaymentSettings: "Send and Payment Settings",
        customerFacingDisplay: "Customer Facing Display",
        useCFD: "Use CFD",
        sendAndPaymentActionButtons: "Send And Pay Action Buttons",
        sendOrderToKitchenWhen: "Send Order To Kitchen When:",
        sendAndPayOverrideDropdownOptions: {
          sendOnly: "Send Only",
          payOnly: "Pay Only",
          both: "Both"
        },
        SendToKitchenOverrideDropdownOptions: {
          paymentCompleted: "Payment Completed",
          paymentInitiated: "Payment Initiated"
        }
      },
      printerSettings: {
        title: "PRINTER SETTINGS",
        description: "Select the Printing Settings for this Device",
        printing: "Printing",
        autoPrint: "Automatically print a chit for all orders placed",
        printReceiptOnPayment: "Print Receipt on Payment",
        viewEditPrintingRules: "View / Edit Printing Rules",
        overrideDescription: "Printing rules help you ensure that incoming orders are printed from the correct printers in your restaurant.",
        defaultCheckPrinter: {
          description: "Check Printer",
          modalTitle: "Default Printer",
          noPrinter: "No Printer"
        }
      },
      deviceDeactivation: {
        title: "DEVICE DEACTIVATION",
        description: "Deactivating the device will remove the license from this device. All of the data and settings will stay with the license and be removed from this device.",
        button: "Deactivate Device"
      }
    },
    roleDetailsSettings: {
      basic: {
        displayOptions: {
          title: "Display Options",
          description: "Select the text color and background color that will display for the role when prompted to select a role upon clock in"
        },
        optionsDisabled: {
          creation: "You must finish creation of this Role before you can Clone it.",
          location: "You can only Clone Roles from Enterprise mode."
        }
      },
      home: {
        title: "HOME",
        subtitle: "Home",
        homeScreenDefaultModules: {
          noAccess: "No Access",
          title: "Home Screen Default Modules",
          description: 'All modules this role has access to are listed below. The modules that are "on" (in blue) are those that will be shown in the home screen. Toggle modules on/off by tapping on them.',
          emptyCardMessage: "No Modules",
          modules: {
            registerModuleDefault: "Register",
            menuModuleDefault: "Menu",
            settingsModuleDefault: "Settings",
            managementModuleDefault: "Management",
            reportsModuleDefault: "Reports",
            homeModuleDefault: "Home",
            customersModuleDefault: "Customers"
          }
        },
        autoOpenFromLockScreen: {
          title: "Default Home Screen",
          description: "Select the module that will be automatically opened upon user sign in."
        },
        requireClockInOnPrompt: "Require Clock-In On Prompt",
        requireClockInOnPromptToolTip: "If enabled, the user will be required to clock in after selecting a role."
      },
      general: {
        title: "TABLET HOME SCREEN"
      },
      endOfDay: {
        title: "End of Day",
        endOfDayPermissions: {
          viewShiftSummary: {
            label: "End Of Day Shift Summary",
            options: {
              always: "Always",
              never: "Never",
              onClockout: "On Clock Out"
            }
          }
        }
      },
      allowAccessToThisModule: "Allow Access to this Module",
      settings: {
        cannotDeactivate: {
          title: "Cannot Deactivate",
          description: "You cannot deactivate Settings for the role you are currently logged in as."
        }
      },
      register: {
        title: "REGISTER",
        description: "These settings apply to orders belonging to the user",
        navigationOnAction: {
          title: "Navigation Options",
          qsrActionOnPay: {
            label: "QSR - Action on Pay/Send",
            toolTip: "Select what will happen when a user finishes taking payment on an order\n<1/>Logout - user will be signed out\n<1/>New Order - user will begin a new order\n<1/>View Orders - user will be taken to the Orders screen, displaying all open orders for the current user",
            options: {
              logout: "Logout",
              newOrder: "New Order",
              viewOrders: "View Orders"
            }
          },
          navigationActionOnSendButton: {
            label: 'TSR - Action on "Send"',
            toolTip: 'Select what should happen when using the "send" key\n<1/>Logout - user is signed out of the system\n<1/>View Tables - user is taken to the table layout map\n<1/>View Orders - user is taken to the orders screen',
            options: {
              viewTables: "View Tables",
              viewOrders: "View Orders"
            }
          },
          navigationActionOnDoneButton: {
            label: 'TSR - Action on "Done"'
          },
          navigationActionOnSendStayButton: {
            label: 'TSR - Action on "Send/Stay"',
            toolTip: 'Select what should happen when using the "send/stay" key\n<1/>Logout - user is signed out of the system\n<1/>View Tables - user is taken to the table layout map\n<1/>View Orders - user is taken to the orders screen',
            options: { stayInOrder: "Stay in Order" }
          },
          defaultRegisterScreen: {
            label: "Register Default Screen",
            toolTip: "Select what will happen when a user selects the register module\nEnter Order - user will be taken to the default menu to begin adding items to the ticket\nStay In Table Layout - user will stay on the Table Layout screen",
            options: {
              viewTables: "View Tables",
              viewTabs: "View Tabs",
              viewOrders: "View Orders",
              newOrder: "New Order"
            }
          },
          navigationActionOnCloseOrder: {
            label: "TSR - Action on Close Order",
            toolTip: "Select what should happen what screen should be displayed automaticall when an order is closed"
          },
          navigationActionOnTipPending: {
            label: "TSR - Action on Tip Pending",
            toolTip: "Select what should happen when an order status is set to Tip Pending"
          },
          navigationActionOnPrintChecks: {
            label: "Action on Print Checks",
            toolTip: "Select what should happen when the user prints checks\n<1/>Logout - user is signed out of the system\n<1/>View Tables - user is taken to the table layout map\n<1/>View Orders - user is taken to the orders screen",
            options: {
              sendAndLogout: "Send Items And Logout",
              sendAndViewTables: "Send Items And View Tables",
              sendAndViewTabs: "Send Items And View Tabs",
              sendAndViewOrders: "Send Items And View Orders",
              sendAndClearRegister: "Send Items And Clear Register",
              send: "Send Items",
              none: "None"
            }
          },
          navigationActionOnFire: {
            label: "Action on Fire",
            toolTip: "Select what should happen when the user fires an order\n<1/>Logout - user is signed out of the system\n<1/>View Tables - user is taken to the table layout map\n<1/>View Orders - user is taken to the orders screen"
          },
          defaultOrderType: {
            label: "Default Order Type",
            toolTip: "Select what will be the default order type between dine in or to go",
            options: {
              dineIn: "Dine In",
              toGo: "To Go"
            }
          },
          autoFilterTableTabsOrders: {
            label: "Auto Filter Orders To User",
            toolTip: "Enables auto-filtering of orders by user"
          }
        },
        orderPermissionsForOwners: {
          title: "Order Permissions",
          description: "These settings apply to orders belonging to the user.",
          createOrders: "Create Order",
          createOrderstoolTip: "Enable to allow users to begin a new order via the table layout or \u201Cnew order\u201D button",
          deleteOrders: "Void Order",
          deleteOrderstoolTip: 'Enable to allow the user to use the "void order" key',
          modifyItemsSentToKitchen: "Modify Items Sent to Print",
          modifyItemsSentToKitchentoolTip: "Enable to allow user to modify items which have already been sent to remote printers",
          manageTables: "Manage Tables",
          manageTablestoolTip: "Enable to allow user to merge/unmerge tables, set table availability and status",
          addAnyDiscount: "Apply Discounts",
          addAnyDiscounttoolTip: "Enable to allow user to apply discounts to an order. If option is disabled, user will be prompted for authorization before being able to apply discounts to an order.",
          addCustomDiscount: "Create Custom Discounts",
          addCustomDiscounttoolTip: "Enable to allow user to enter a custom percent, fixed, or override discount when discounting an item or ticket",
          editItemPrice: "Edit Item Price",
          allow86: "86 Items, Modifiers, and Ingredients",
          allow86toolTip: "Enable to allow user to 86 items, modifiers, and ingredients",
          editItemPricetoolTip: "Enable to allow user to edit an item\u2019s price using the \u201Cedit price\u201D key",
          allowChangeMenuType: "Show Menu Selector",
          allowChangeMenuTypetoolTip: "Enable to allow user to navigate between different menus using the Menu Selector",
          createOpenItemsOrModItems: "Create Open Item or Mod Item",
          createOpenItemsOrModItemstoolTip: "Enable to allow user to use \u201COpen Item\u201D or \u201COpen Mod\u201D keys, creating a custom name and price for an item or modifier",
          exemptTax: "Exempt Tax",
          exemptTaxtoolTip: "Exempt Tax",
          allowNoTaxInclusive: "Allow No Tax Inclusive",
          allowNoTaxInclusiveToolTip: "Allows to remove the tax amount from the item price for tax inclusive items and adds the tax based on the item total price",
          manageServiceCharges: "Manage Service Charges",
          manageServiceChargestoolTip: "Enable to allow user to add or remove service charges",
          voidIndividualItems: "Void Individual Items",
          voidIndividualItemstoolTip: "Enable to allow user to void individual items from an order",
          reopenClosedOrders: "Reopen Closed Orders",
          reopenClosedOrderstoolTip: "Enable to allow user to reopen closed orders",
          sendIndividualItems: "Send Individual Items",
          sendIndividualItemstoolTip: "Enable to allow user to send items to the kitchen individually"
        },
        printingPermissions: {
          title: "Printing Permissions",
          reprint: "Reprint",
          reprinttoolTip: "Enable to allow user to reprint a ticket",
          deletePrintJobs: "Delete Print Jobs",
          deletePrintJobstoolTip: "Enable to allow user to delete a print job"
        },
        orderPermissionsForNonOwners: {
          title: "Permissions for orders belonging to another user",
          description: "The following permissions are those associated with an Order not owned by a user in this role.",
          editOtherUsersOrders: "Modify an order belonging to another user",
          editOtherUsersOrderstoolTip: "Enable to allow current user to view and make changes to an order belonging to another user",
          transferOrderOwner: "Transfer Order Owner",
          transferOrderOwnertoolTip: "Enable to allow user to transfer an order to a different user",
          overrideLicenseEditingId: 'Take "Edit" Control of an Order',
          overrideLicenseEditingIdtoolTip: "When the same order is opened on multiple devices at the same time, only one user can have \u201Cedit\u201D control of an order. When this option is enabled, a user who is in \u201Cview mode\u201D when accessing an order, can override control of the order and take edit control of the order allowing for modifications to the order"
        },
        behaviorOnNewOrder: {
          label: "Behavior on New Order",
          toolTip: "Select what will happen when a user begins a new order\n<1/>Enter Order - user will be taken to the default menu to begin adding items to the ticket\n<1/>Stay In Table Layout - user will stay on the Table Layout screen",
          options: {
            enter_order: "Enter Order",
            stay_in_table_layout: "Stay in Table Layout"
          }
        },
        payments: {
          title: "Payments",
          createChecks: "Create Separate Checks / Split Check",
          createCheckstoolTip: "Enable to allow user to split ticket into multiple checks when tendering the order",
          voidRefundPayments: "Void/Refund Payments",
          voidRefundPaymentstoolTip: "Enable to allow user to void or refund a payment.",
          createPayments: "Create Payments",
          createPaymentstoolTip: "Enable to allow user to apply payments to split checks",
          transferPayments: "Transfer Payments to Other Order",
          transferPaymentsTooltip: "Enable to allow user to transfer payments from one order to another",
          batch: "Batch",
          makeHouseChargePayments: "Make House Charge Payments",
          makeHouseChargePaymentstoolTip: "Enable to allow user to make house charge payments",
          makeGiftCardPayments: "Make Gift Card Payments",
          makeGiftCardPaymentstoolTip: "Enable to allow user to make gift card payments"
        },
        drawers: {
          title: "Cash Drawers",
          manageDrawers: "Manage Drawers",
          viewDrawerBalance: "View Drawer Balance",
          serverBankEnabled: "Server Bank Enabled",
          allowCashPaymentsToDrawersNotAttached: "Allow Cash Payments On Stations With No Drawers",
          cashPaymentOptions: {
            label: "Cash Payment Options",
            options: {
              payToDrawerOnly: "Pay to Drawer Only",
              payToServerBankOnly: "Pay to Server Bank Only"
            }
          }
        },
        refundOptions: {
          title: "Refund Options",
          refundTypeRefund: "Refund",
          refundTypeAsDiscount: "Refund as Discount",
          refundTypeToBalanceDueOfZero: "Refund to Balance Due of Zero",
          refundTypeReplacePayment: "Replace Payment"
        }
      },
      createNewElement: {
        loading: "Creating Role",
        success: "Successfully created Role",
        error: "Error sending new Role"
      },
      editElement: {
        loading: "Updating Role",
        success: "Successfully updated Role",
        error: "Error updating Role"
      },
      deleteElement: {
        loading: "Deleting Role",
        success: "Successfully deleted",
        error: "Error deleting Role"
      },
      reports: { title: "REPORTS" },
      webHomeScreen: {
        title: "WEB HOME SCREEN",
        description: "Default Dashboard selected in blue.",
        dashboards: {
          emptyCardsMessage: "No Dashboards for this Role"
        }
      }
    },
    bucketBar: {
      header: {
        text: "SETTINGS"
      },
      general: {
        text: "General",
        onlineOrdering: "Online Ordering"
      },
      accounts: {
        text: "Accounts",
        users: "Users",
        roles: "Roles"
      },
      printing: {
        text: "Printing",
        prepStations: "Printer Locations",
        printingRules: "Printing Rules",
        tickets: {
          text: "Tickets",
          registerTicket: "Register Ticket",
          kitchenTicket: "Kitchen Ticket",
          customerReceipt: "Guest Receipt"
        }
      },
      management: "Management",
      lockScreen: "Lock Screen",
      homeScreen: "Home Screen",
      menu: "Menu",
      register: {
        text: "Register",
        registerMode: "Register Mode"
      },
      taxes: "Taxes",
      payments: "Payments"
    },
    tabs: {
      general: {
        general: "General",
        onlineOrdering: "Online Ordering"
      },
      accounts: {
        accounts: "Accounts",
        users: "Users",
        roles: "Roles"
      },
      printing: {
        printing: "Printing",
        prepStations: "Printer Locations",
        printingRules: "Printing Rules",
        ticket: "Ticket",
        registerTicket: "Register Ticket",
        kitchenTicket: "Kitchen Ticket",
        guestReceipt: "Guest Receipt"
      },
      management: "Management",
      lockScreen: "Lock Screen",
      homeScreen: "Home Screen",
      register: {
        register: "Register",
        registerMode: "Register Mode"
      },
      payments: "Payments",
      taxes: "Taxes"
    },
    lockScreenSettings: {
      title: "Lock Screen Settings",
      editElement: {
        success: "Successfully updated Lock Screen Settings",
        error: "Error updating Lock Screen Settings",
        loading: "Updating Lock Screen Settings"
      },
      basic: {
        title: "BASIC SETTINGS",
        description: "Basic Settings for the Lock Screen are listed below.",
        general: {
          title: "General Settings",
          showGiftCardButton: "Show Gift Card Button"
        },
        announcement: {
          title: "Announcement",
          titleInput: {
            label: "Title"
          },
          descriptionInput: {
            label: "Description"
          }
        }
      },
      tabs: {
        title: "TABS",
        description: "The following will be shown in the Lock Screen",
        tab: {
          showFreshSheetTab: "Show Fresh Sheet Tab",
          showSeatingLayoutTab: "Show Seating Layout Tab",
          showEmployeesTab: "Show Employees Tab",
          showLocationsTab: "Show Locations Tab"
        }
      }
    },
    generalSettings: {
      title: "General Settings",
      editElement: {
        success: "Successfully updated General Settings",
        error: "Error updating General Settings",
        loading: "Updating General Settings"
      },
      errors: {
        organizationInformation: {
          name: {
            singleLocation: "Organization/Location Name cannot be empty.",
            location: "Location Name cannot be empty.",
            master: "Organization Name cannot be empty."
          },
          websiteUrl: {
            empty: {
              singleLocation: "Organization/Location Website cannot be empty.",
              location: "Location Website cannot be empty.",
              master: "Organization Website cannot be empty."
            },
            invalid: {
              singleLocation: "Organization/Location Website is invalid.",
              location: "Location Website is invalid.",
              master: "Organization Website is invalid."
            }
          },
          streetLine1: "Street cannot be empty.",
          city: "City cannot be empty.",
          postalCode: {
            empty: "Zip Code cannot be empty.",
            invalid: "Zip Code must be 5 digits."
          },
          endOfBusinessDay: {
            empty: "End of Business Day is required.",
            invalid: "End of Business Day is invalid."
          }
        },
        operationalDayHours: "Invalid Hours of Operation time Range(s)"
      },
      organizationInformation: {
        title: {
          singleLocation: "ORGANIZATION/LOCATION INFORMATION",
          master: "ORGANIZATION INFORMATION",
          location: "LOCATION INFORMATION"
        },
        organizationName: {
          label: {
            singleLocation: "Organization/Location Name",
            master: "Organization Name",
            location: "Location Name"
          },
          description: {
            singleLocation: "Enter your Organization's/Location's Name",
            master: "Enter your Organization's Name",
            location: "Enter your Location's Name"
          }
        },
        organizationWebsite: {
          label: {
            singleLocation: "Organization/Location Website",
            master: "Organization Website",
            location: "Location Website"
          },
          description: {
            singleLocation: "Enter your Organization's/Location's Website",
            master: "Enter your Organization's Website",
            location: "Enter your Location's Website"
          }
        },
        organizationPhoneNumber: {
          label: {
            singleLocation: "Organization/Location Phone Number",
            master: "Organization Phone Number",
            location: "Location Phone Number"
          },
          description: {
            singleLocation: "Enter your Organization's/Location's Phone Number",
            master: "Enter your Organization's Phone Number",
            location: "Enter your Location's Phone Number"
          }
        },
        organizationLogo: {
          title: "Logo",
          digitalLogoUrl: {
            title: "Digital",
            description: "Upload Your Digital Logo"
          },
          printLogoUrl: {
            title: "Print",
            description: "Upload Your Print Logo"
          },
          modalTitle: {
            digital: "Upload a picture of the Digital Logo",
            print: "Upload a picture of the Print Logo"
          }
        },
        organizationAddress: {
          title: {
            singleLocation: "Organization/Location Address",
            master: "Organization Address",
            location: "Location Address"
          },
          streetLine1: "Street",
          streetLine2: "Street 2",
          city: "City",
          state: "State",
          postalCode: "Zip Code"
        }
      },
      hoursOfOperation: {
        title: "HOURS OF OPERATION",
        timeZone: {
          label: "Select the Time Zone"
        },
        times: {
          title: "Hours of Operation"
        },
        endOfBusinessDay: {
          label: "End of Business Day",
          placeholder: "Select a Time"
        }
      },
      generalSettings: {
        title: "GENERAL SETTINGS",
        clockInMode: {
          title: "Clock-In behavior",
          toolTip: "Auto - When not clocked in, upon first sign in user will be prompted to select the role they will be clocking in as, and they system will automatically clock in that user.\n<1/>Manual - User will be prompted to select a role when signing in, and will need to navigate to the home page to manually use the \u201Cclock in\u201D button to register their time punch.\n<1/>Prompt - When not clocked in, upon first sign in user will be prompted to select the role they will be clocking in as, then a prompt will display on screen asking to choose \u201Cclock in\u201D or \u201Clater\u201D",
          label: "Select the Clock-In behavior you wish to happen for employees.",
          values: {
            manual: "Manual",
            prompt: "Prompt",
            auto: "Auto"
          }
        },
        pinpadLayout: {
          title: "Pin Pad Layout",
          label: "Select the Pin Pad Layout you wish to use for the system.",
          values: {
            telephone: "Telephone",
            calculator: "Calculator"
          }
        },
        usersLogin: {
          title: "User Login",
          allowUserToBeLoggedIntoMultipleTablets: {
            title: "Allow User to be logged into Multiple Tablets"
          }
        }
      }
    },
    onlineSettings: {
      title: "Online Ordering Settings",
      basic: {
        title: "BASIC",
        acceptingOrders: "Accepting Orders",
        acceptingOrdersDisabled: {
          title: "Accepting Orders Disabled",
          description: "Pickup or Delivery must be enabled to Accept Online Orders"
        },
        defaultMenuTypeId: "Default Menu",
        onlineMenuTimes: "Online Menu Times",
        scheduleOutOrder: "Schedule Out Order"
      },
      pickup: {
        title: "Pick-up",
        pickupIsActive: "Offer pick-up",
        pickupBufferTime: "Pick-up Buffer Time",
        pickupAvailability: "Pick-up Availability"
      },
      delivery: {
        title: "Delivery",
        deliveryIsActive: "Offer Delivery",
        deliveryBufferTime: "Delivery Buffer Time",
        deliveryAvailability: "Delivery Availability",
        copyPickupTimes: "Copy Pick-up Times",
        deliveryRadius: "Delivery Radius",
        deliveryAvailabilitySetToPickupTimes: "Delivery availability is set with Pick-up Times"
      },
      pageDesign: {
        title: "Page Design",
        description: "Change aspects of the design to match your branding.",
        showItemImage: "Show Item Images in Online Ordering",
        allowSpecialInstructionsOnItems: "Allow Special Instructions on Items",
        brandingColors: "Branding Colors",
        primaryColor: "Main Color",
        secondaryColor: "Secondary Color",
        tertiaryColor: "Tertiary Color",
        backgroundColor: "Background Color",
        banner: "Banner",
        showBanner: "Show Banner",
        bannerDescription: "Banner Description",
        showCalories: "Show Calories"
      },
      tips: {
        title: "Tips",
        description: "Customers can choose between 3 suggested tips or enter a custom amount.",
        showTippingAtCheckout: "Prompt for tip",
        showCfdTipSelectionOnRegister: "Show tip to cashier",
        suggestedTipDefault: "Default Selected Tip",
        noDefaultTip: "No Default Tip",
        suggestedTip1: "Suggested Tip 1",
        suggestedTip2: "Suggested Tip 2",
        suggestedTip3: "Suggested Tip 3"
      },
      editElement: {
        success: "Successfully Updated Online Ordering Settings",
        error: "Error Updating Online Ordering Settings",
        loading: "Updating Online Ordering Settings"
      }
    },
    printerRulesSettings: {
      title: "Printing Rules",
      subTitle: "Printing Rules will be carried out based on the priority set below in order of top to bottom, you can reorder Rules with drag and drop.",
      addRuleText: "Add Rule",
      masterUnavailable: "Printing Rules must be added for a specific Location",
      editElement: {
        success: "Successfully Updated Printing Rules Settings",
        error: "Error Updating Printing Rules Settings",
        loading: "Updating Printing Rules Settings"
      },
      printerRulesTable: {
        emptyDataTitle: "No rules have been added yet",
        emptyDataSubtitle: 'Hit the "Add Rule" button to add new Printing Rules',
        name: "Name",
        namePlaceholder: "Name",
        serviceArea: "Service Area",
        orderType: "Order Type",
        daysOfWeek: "Days of Week",
        startTime: "Start Time",
        endTime: "End Time",
        fromStation: "From Printer Location",
        toStation: "To Printer Location",
        order: "Order",
        errors: {
          name: "Name is required.",
          fromPrepStationId: "From Printer Location is required.",
          toPrepStationId: "To Printer Location is required.",
          equalPrepStations: "The From Printer Location cannot be the same as the To Printer Location.",
          timeOverlap: "The Start Time must be earlier than the End Time."
        }
      },
      abbreviatedDays: {
        monday: "Mo",
        tuesday: "Tu",
        wednesday: "We",
        thursday: "Th",
        friday: "Fr",
        saturday: "Sa",
        sunday: "Su",
        noSelected: "No Days Selected",
        all: "All"
      }
    },
    taxesSettings: {
      title: "Taxes",
      titleLong: "Taxes Settings",
      disabled: "Taxes can only be edited in Enterprise mode",
      addTax: "Add Tax",
      editElement: {
        success: "Successfully Updated Taxes Settings",
        error: "Error Updating Taxes Settings",
        loading: "Updating Taxes Settings"
      },
      noElementFoundMessage: "This Tax does not exist in {{location}}",
      errors: {
        name: "Tax Rate Name is required.",
        orderTypes: "Order Types are required.",
        rate: "Rate must be greater than 0.",
        interval: "Interval must be greater than 0.",
        to: "To (Sale Price) must be greater than From (Sales Price)."
      },
      taxesTable: {
        emptyDataTitle: "No taxes have been added yet",
        emptyDataSubtitle: 'Hit the "Add Tax" button to add a new Tax',
        locationEmptyDataSubtitle: 'In Enterprise Mode, Hit the "Add Tax" button to add a new Tax',
        name: "Tax Rate Name",
        orderType: "Order Type",
        type: "Type",
        taxType: "Tax Type",
        taxTypeData: "Tax Type Data",
        tax: "Tax",
        actions: "Actions",
        orderTypes: "Order Type(s)",
        selectTaxType: "Select A Tax Type",
        rate: "Rate",
        interval: "Interval",
        unit: "Unit",
        addRow: "Add Row",
        taxTypes: {
          percent: "Percent (%)",
          fixed: "Fixed",
          table: "Tax Table",
          volumetric: "Volumetric"
        },
        taxTableType: {
          from: "From (Sale Price)",
          to: "To (Sale Price)",
          tax: "Tax",
          priceDifference: "Price Difference",
          repeat: "Repeat",
          delete: "Delete"
        },
        unitTypes: {
          ml: "mL",
          l: "L",
          gal: "Gal",
          qt: "Qt",
          pnt: "Pnt",
          flOz: "fl oz"
        }
      }
    },
    dashboardsSettings: {
      editElement: {
        success: "Successfully Updated Dashboard",
        error: "Error Updating Dashboard",
        loading: "Updating Dashboard"
      }
    },
    registerTicketSettings: {
      title: "Register Ticket",
      ticketDisplay: {
        title: "TICKET DISPLAY SETTINGS",
        separateSentItems: "Separate Sent Items",
        separateSentItemstoolTip: "Enable to have all sent items grouped together at the bottom of the register ticket. A \u201CSent\u201D header will display within the ticket, and all sent items will appear below this header.",
        ticketDisplay: {
          title: "Ticket Display",
          showTimestamps: "Show Timestamp",
          showTimestampstoolTip: "Enable to show a timestamp in the register ticket for every menu item, showing when the item was ordered. Once the item has been sent, it will display the sent time.",
          showSendCourseButton: "Show Send Course Button",
          showSendCourseButtontoolTip: "Enable to display a \u201Csend\u201D button within each course header. This allows the user to send an individual course, rather than using the send or send/stay buttons to send the entire order.",
          autoCollapseLineItems: "Auto Collapse Line Items",
          autoCollapseLineItemstoolTip: "When this option is enabled, a menu item will display collapsed in the register ticket, showing only the menu item name and price. Modifiers will be hidden in the register ticket, unless actively adding or editing that menu item."
        },
        modifiersDisplay: {
          title: "Modifier Display",
          displayDefaultModifiers: "Display Default Modifiers",
          displayDefaultModifierstoolTip: "Enable to display the default, pre-assigned modifiers that belong to a menu item. For example, a burger is configured with the default modifiers lettuce, tomato, onion. With this option enabled, lettuce, tomato, and onion will display on the register ticket when the item is ordered.",
          showModifierItemPrice: "Show Mod Item Price",
          showModifierItemPricetoolTip: "Enable to have individual modifier item prices display on register ticket",
          hideModGroupTitles: "Hide Mod Group Titles",
          hideModGroupTitlestoolTip: "Enable this option to hide the modifier group names on the Register Ticket",
          groupSameModItems: "Group Same Mod Items",
          groupSameModItemstoolTip: "When enabled, this option will cause modifier items that are the same to consolidate and display as a quantity of items on the register ticket. For example, ordering two sides for fries would appear as Fries (x2). When disabled, modifier items will not consolidate, and appear as separate entries either in a vertical list or comma separated depending on the \u201Cmodifiers display type\u201D selected.",
          addSubForMultiSelectOff: 'Show "Sub" for MultiSelect Off',
          addSubForMultiSelectOfftoolTip: "This option only applies when \u201Cmulti-select\u201D is off for a modifier group and a default modifier is assigned. When enabled, the word SUB will be added to the replaced modifier in the modifier group.",
          noForDeselectedDefaultModifiers: 'Show "No" for Deselected Mod Items',
          modifierItemDisplayMode: {
            label: "Modifier Display Type",
            toolTip: "Select how modifiers will display on the register ticket\n<1/>Vertical list: Modifiers will appear as one modifier per line vertically below the menu item\n<1/>Comma Separated: Modifiers will appear as a comma separated list extending the width of the register ticket, then continue on the next line below",
            options: {
              comma: "Comma Separated",
              vertical: "Vertical List"
            }
          }
        }
      },
      editElement: {
        success: "Successfully updated Register Ticket Settings",
        error: "Error updating Register Ticket Settings",
        loading: "Updating Register Ticket Settings"
      }
    },
    kitchenTicketSettings: {
      prepStationsSection: {
        title: "Printer Locations",
        description: "Select the Printer Locations you want to see the ticket information for.",
        active: "Active Printer Locations",
        inactive: "Inactive Printer Locations",
        filterLabel: "Printer Location Status:",
        emptyCardsMessage: "No Printer Locations",
        emptyActiveCardsMessage: "No Active Printer Locations",
        emptyInactiveCardsMessage: "No Inactive Printer Locations",
        pullFrom: "Pull From",
        pullFromTitle: "Select the Printer Location to pull from",
        pushTo: "Push To"
      },
      printTest: {
        success: "Example Kitchen Ticket sent to print at {{printerName}}."
      },
      editElement: {
        success: "Successfully updated Kitchen Ticket Settings",
        error: "Error updating Kitchen Ticket Settings",
        loading: "Updating Kitchen Ticket Settings"
      },
      errors: {
        ticketDisplay: {
          updateOrderNewText: "Update Order Display New Item cannot be empty.",
          updateOrderVoidText: "Update Order Display Item Voided cannot be empty."
        }
      },
      customizingReceiptsTable: {
        value: {
          options: {
            updateStatus: 'Update Status ("New" or "Update")',
            orderType: "Order Type",
            orderName: 'Order Name (e.g. "Alex")',
            orderNumber: "Order Number",
            table: "Table",
            placedBy: "Placed By",
            server: "Server",
            dateAndTime: "Date and Time",
            stationName: "Printer Location Name",
            address: "Address (Delivery Orders Only)",
            guestCount: "Guest Count",
            itemNameAndQuantity: "Item Name and Quantity",
            seatNumber: "Seat Number",
            seatTags: "Seat Tags",
            modifiersInfo: "Modifiers Information",
            organizationName: "Organization Name",
            locationName: "Location Name",
            locationAddress: "Location Address",
            checkName: "Check Name",
            deliveryAddress: "Delivery Address",
            phoneNumber: "Phone Number",
            time: "Time"
          }
        },
        justify: {
          options: {
            left: "Left",
            center: "Center",
            right: "Right"
          }
        },
        fontSize: {
          options: {
            a11: "Font A W1 H1",
            b11: "Font B W1 H1",
            a12: "Font A W1 H2",
            b12: "Font B W1 H2",
            a21: "Font A W2 H1",
            b21: "Font B W2 H1",
            a22: "Font A W2 H2",
            b22: "Font B W2 H2"
          }
        },
        fontWeight: {
          options: {
            light: "Light",
            normal: "Normal",
            bold: "Bold"
          }
        },
        line: {
          options: {
            none: "None",
            above: "Above",
            below: "Below"
          }
        }
      },
      printerColors: {
        negative: "Negative/Red",
        black: "Black"
      },
      ticketDisplay: {
        title: "Ticket Display",
        printUnfiredItems: "Print Unfired Items",
        printModifications: "Print Modifications",
        printUnfiredItemstoolTip: "Enable this setting to include any items that have not yet been fired to appear on the ticket. These items will be listed under a header labeled ****NOT FIRED**** at the bottom of the ticket.",
        showCourses: "Show Courses",
        showCoursestoolTip: "Enable to print each course header in the body of the kitchen ticket, with menu items belonging to that course displaying directly below the course header.",
        showSeats: "Show Seats",
        showSeatTags: "Show Seat Tags",
        showOrderTags: "Show Order Tags",
        printOrderQr: "Print Order # QR Code in Footer",
        showOrderTagstooltip: "Enable to have any order tags print on the kitchen ticket. Order tags will print below the ticket header, and above the ticket body where menu items display.",
        orderTagColors: {
          label: "Update Order Text Color"
        },
        headerBlankSpace: {
          label: "Header Blank Space",
          toolTip: "Select the amount of space that will be added above the kitchen ticket header. This will create additional blank space at the top of the kitchen ticket. This could be used to move text down the ticket, so everything displays without being covered while on the Rail/Board in the kitchen.",
          options: {
            zero: '0"',
            zeroTwoFive: '0.25"',
            zeroFive: '0.5"',
            zeroSevenFive: '0.75"',
            one: '1"',
            oneTwoFive: '1.25"',
            oneFive: '1.5"',
            oneSevenFive: '1.75"',
            two: '2.0"'
          }
        },
        elementSpacing: {
          label: "Space between Items",
          toolTip: "Select the amount of vertical space to be added between menu items in the body of the kitchen ticket",
          options: {
            zero: '0"',
            zeroTwoFive: '0.25"',
            zeroFive: '0.5"'
          }
        },
        orderTagsFontSize: {
          label: "Order Tags Font Size"
        },
        showCourseName: "Show Course Name",
        showCourseNameTooltip: "Enable or disable the display of the course name in the course header within the ticket area.",
        changeNoSeatTextInToGoOrders: "Change No Seat Text In To Go Orders"
      },
      modifierDisplay: {
        title: "Modifier Display",
        displayDefaultModifiers: "Display Default Modifiers",
        displayDefaultModifierstoolTip: "Enable to print the default, pre-assigned modifiers that belong to a menu item. For example, a burger is configured with the default modifiers lettuce, tomato, onion. With this option enabled, lettuce, tomato, and onion will print on the kitchen ticket, unless deselected/modified by the user.",
        consolidateByItem: "Consolidate By Item",
        consolidateByItemtoolTip: "When enabled, the same menu items ordered multiple times are grouped together on the ticket. Modifiers for each item are listed separately, separated by a dotted line to indicate they belong to another instance of that menu item.",
        hideModGroupTitles: "Hide Mod Group Titles",
        hideModGroupTitlestooltip: "Enable this option to hide the modifier group names on the kitchen ticket.",
        groupSameModItems: "Group Same Mod Items",
        addSubForMultiSelectOff: 'Add "Sub" for Multi-Select Off',
        addSubForMultiSelectOfftoolTip: "This option only applies when \u201Cmulti-select\u201D is off for a modifier group and a default modifier is assigned. When enabled, the word SUB will be added to the replaced modifier in the modifier group.",
        noForDeselectedDefaultModifiers: '"No" for Deselected Default Modifiers',
        groupBySeat: "Group By Seat",
        groupBySeattoolTip: "Enable to group menu items by seat in the ticket body. A header will display the seat number, and all items assigned to that seat will print under that seat number.\nWhen this option is disabled, each menu item will print the seat number to which it belongs directly below the menu item name, and above the modifiers for the item.",
        modifierItemDisplayMode: {
          label: "Modifier Display Type",
          toolTip: "Select how modifiers will display on the kitchen ticket\nVertical list: Modifiers will print as one modifier per line vertically below the menu item\nComma Separated: Modifiers will print as a comma separated list extending the width of the kitchen ticket, then continue on the next line below"
        },
        colorOfModifierItems: {
          label: "Color Of Modifier Items"
        },
        printPriceForFreeModItems: "Print $0.00 for free Mod Items",
        onlyPrintModItemsWithPrice: "Only Print Mod Items with Price"
      },
      updateOrderDisplay: {
        title: "Update Order Display",
        toolTip: "Configure these settings to control the behavior for items that have already been sent to a remote order device",
        updateOrderNewText: "New Item",
        updateOrderNewTexttoolTip: 'Enter the text that will display next to any modifiers updated on a previously sent order. This text will appear either before or after the modifier item, depending on the choice in the "position for udated item text" option.',
        updateOrderVoidText: "Item Voided",
        updateOrderVoidTexttoolTip: 'Enter the text that will display next to any items that are voided. This text will appear either before or after the voided item, depending on the choice in the "position for updated item text" option.',
        updateOrderTextPosition: {
          label: "Position for Updated Item Text",
          toolTip: "Select whether the \u201Cnew item indicator\u201D or \u201Citem voided indicator\u201D will print before or after the updated menu item"
        }
      }
    },
    paymentsSettings: {
      customTenders: {
        title: "Custom Tenders",
        addCustomTender: "Add Custom Tender",
        navigationBox: {
          description: "Create custom tenders to make payments on Orders.",
          button: "View/Edit Custom Tenders"
        },
        allowsTips: "Allows Tips",
        autoConfirmTip: "Auto-Confirm Tip",
        printReceipt: "Print Receipt",
        printMerchantCopy: "Print Merchant Copy",
        printTipTotalLines: "Print Tip/Total Lines"
      },
      title: "Payments Settings",
      errors: {
        customTenders: {
          name: "Error in Custom Tenders table."
        },
        name: "Name is required.",
        posName: "POS Name is required.",
        orderTypes: "Order Type(s) are required.",
        serviceAreas: "Service Area(s) are required.",
        charge: "Amount must be greater than 0.",
        eGiftCardMerchantId: "Merchant ID must be 7 digits long.",
        eGiftCardLocationId: "Location ID must be 4 digits long.",
        batchTime: {
          empty: "Batch Time is required.",
          invalid: "Batch Time is invalid."
        }
      },
      general: {
        title: "GENERAL SETTINGS",
        description: "The following settings will impact general payments actions.",
        confirmDrawerStartingBalance: "Confirm Drawer Starting Balance",
        printChecksOnCloseOrder: "Print Checks on Close Order",
        acceptHousePayments: "Accept House Payments",
        housePaymentsSettings: {
          title: "House Payment Settings"
        },
        preAuthOptions: {
          title: "Pre-Auth Options",
          defaultPreAuthAmount: "Default Pre-Auth Amount",
          dueExceedsPreAuth: "Show Indicator if Due Exceeds Pre-Auth"
        },
        batchSettings: {
          title: "Batch Settings",
          automatedBatching: "Auto-Batching",
          batchTime: "Batch Time"
        },
        forceAllPaidOrdersToTipPending: 'Force All Paid Orders to "Tip Pending"',
        requireManualClosingPostTip: "Require Manual Closing Post-Tip"
      },
      tenderTypes: {
        title: "TENDER TYPES",
        description: "The following settings will impact tender types.",
        tenderTypes: "Tender Types",
        defaultTenders: "Default Tenders",
        status: "Status",
        name: "Name",
        allowTips: "Allows Tips",
        autoConfirmTip: "Auto-Confirm Tip",
        printReceipt: "Print Receipt",
        printMerchantCopy: "Print Merchant Copy",
        printTipTotalLines: "Print Tip/Total Lines",
        backgroundColor: "Background Color",
        textColor: "Text Color",
        card: "Card",
        cash: "Cash",
        giftCard: "Gift Card",
        house: "House",
        eGiftIntegration: "E-Gift Integration",
        enableEGiftIntegration: "Enable E-Gift Integration",
        eGiftCardMerchantId: "Merchant ID",
        eGiftCardLocationId: "Location ID",
        acceptCashPayments: "Accept Cash Payments",
        cashBackgroundColor: "Cash Background Color",
        cashTextColor: "Cash Text Color",
        cashPrintMerchantCopy: "Cash Print Merchant Copy",
        cashPrintReceipt: "Cash Print Receipt",
        acceptCreditCardPayments: "Accept Credit Card Payments",
        creditCardBackgroundColor: "Credit Card Background Color",
        creditCardTextColor: "Credit Card Text Color",
        creditCardAllowTips: "Allow Tips for Credit Card",
        creditCardAutoConfirmTip: "Auto-Confirm Tip for Credit Card",
        creditCardPrintMerchantCopy: "Credit Card Print Merchant Copy",
        creditCardPrintReceipt: "Credit Card Print Receipt",
        creditCardPrintTip: "Credit Card Print Tip/Total Lines",
        acceptHousePayments: "Accept House Payments",
        houseBackgroundColor: "House Background Color",
        houseTextColor: "House Text Color",
        houseAllowTips: "Allow Tips for House",
        houseAutoConfirmTip: "Auto-Confirm Tip for House",
        housePrintMerchantCopy: "House Print Merchant Copy",
        housePrintReceipt: "House Print Receipt",
        housePrintTip: "House Print Tip/Total Lines",
        enableGiftCardPayments: "Accept Gift Card Payments",
        giftCardBackgroundColor: "Gift Card Background Color",
        giftCardTextColor: "Gift Card Text Color",
        giftCardAllowTips: "Allow Tips for Gift Card",
        giftCardAutoConfirmTip: "Auto-Confirm Tip for Gift Card",
        giftCardPrintMerchantCopy: "Gift Card Print Merchant Copy",
        giftCardPrintReceipt: "Gift Card Print Receipt",
        giftCardPrintTip: "Gift Card Print Tip/Total Lines"
      },
      drawerSettings: {
        title: "Drawer Settings",
        description: "The following settings will impact drawer actions."
      },
      tipSettings: {
        title: "Tip Settings",
        tipPayoutMethod: "Tip Payout Method",
        tipDistribution: "Tip Distribution",
        splitTipInterval: "Interval",
        shareBy: "Share By",
        rolesContributingToPool: "Roles Contributing to the Pool",
        rolesReceivingFromPool: "Roles Receiving from the Pool",
        sharingRules: "Sharing Rules",
        from: "From",
        to: "To",
        percentageGreater: "Percentage is greater than 100%. Enter a valid amount.",
        percentageSmaller: "Percentage is smaller than 100%. Enter a valid amount.",
        percentageContributed: "% Contributed",
        percentageReceived: "% Received",
        contributor: "Contributor",
        recipient: "Recipient",
        contribution: "Contribution",
        emptySharingRules: "No Sharing Rules",
        sharingRule: "Sharing Rule",
        manual: "Manual",
        payroll: "Payroll",
        individual: "Individual",
        poolingRules: "Pooling Rules",
        percentageContributedRequired: "% Contributed must be bigger than 0%.",
        addContributor: "Add Contributor",
        emptyContributorsPool: "No Contributors",
        emptyRecipientsPool: "No Recipients",
        noRecipientsError: "Recipients are required.",
        noContributorsError: "Contributors are required.",
        pooling: "Pooling",
        sharing: "Sharing",
        percentageReceivedRequired: "% Received must be bigger than 0%.",
        addRecipients: "Add Recipients",
        role: "Role",
        splittingRules: "Splitting Rules",
        interval: "Interval",
        shift: "Shift",
        evenly: "Evenly",
        day: "Full Work Day",
        tipSharing: "Tip Sharing",
        defaultTipInput: "Default Tip Input",
        newTotal: "Total Including Tip",
        tipAmount: "Tip Amount"
      },
      serviceChargeSettings: {
        title: "Service Charge Settings",
        serviceCharges: "Service Charges",
        prePostDiscount: "Pre/Post - Discount",
        restaurant: "Restaurant",
        checkOwner: "Check Owner",
        selectServiceAreas: "Select Service Areas",
        associatedTaxes: "Associated Taxes",
        selectOrderTypes: "Select Order Types",
        postDiscount: "Post-Discount",
        preDiscount: "Pre-Discount",
        minimumGuests: "Minimum Guests",
        actions: "Actions",
        editServiceCharge: "Edit Service Charge",
        posName: "POS Name",
        tableEmptyDataTitle: "No Service Charges",
        chargeType: "Charge Type",
        autoApply: "Auto Apply",
        status: "Status",
        name: "Name",
        amount: "Amount",
        charge: "Charge",
        assignTo: "Assign To",
        fixed: "Fixed Amount",
        percent: "Fixed Percent",
        customDollar: "Custom Dollar",
        customPercent: "Custom Percent",
        discount: "Pre/Post - Discount",
        orderTypes: "Order Type(s)",
        addServiceCharge: "Add Service Charge",
        serviceAreas: "Service Area(s)",
        post: "Post",
        pre: "Pre",
        noOrderTypes: "No Order Types",
        noServiceAreas: "No Service Areas",
        server: "Server",
        minGuests: "Min. Guests",
        taxes: "Taxes",
        active: {
          true: "Active",
          false: "Inactive"
        }
      },
      dualPricing: {
        title: "Dual Pricing",
        listPrice: {
          label: "List Price",
          options: {
            cash: "Cash",
            card: "Card"
          }
        },
        price: {
          card: "Cash Price",
          cash: "Card Price"
        }
      },
      editElement: {
        success: "Successfully Updated Payments Settings",
        error: "Error Updating Payments Settings",
        loading: "Updating Payments Settings"
      }
    },
    coursing: {
      noCourse: "No Course"
    },
    registerModeSettings: {
      editElement: {
        success: "Successfully updated Register Mode Settings",
        error: "Error updating Register Mode Settings",
        loading: "Updating Register Mode Settings"
      },
      general: {
        title: "GENERAL SETTINGS",
        description: "The following settings will impact general register actions.",
        registerDisplay: {
          title: "Register Display",
          showConfirmPopup: "Confirm to remove an Item",
          showConfirmPopupTooltip: "Enable to allow a pop up confirmation message to display when removing an item from a ticket.",
          enforceItemGroupOrderForCombos: "Require combo items to be entered according to display order",
          enforceItemGroupOrderForCombosTooltip: "Enable to require that combo items be entered based on the sequence in which they prompt while ordering. Disable to allow user to enter required combo item choices in any sequence.",
          persistSelectedCategoryOnItemSelection: "Persist selected menu category on item selection",
          persistSelectedCategoryOnItemSelectionTooltip: "Enable to remain in the current menu category after adding a menu item. Disable to revert to the default menu category after adding a menu item.",
          showConfirmPopUpOnClearUnsentWithinAnItem: 'Confirm on "clear unsent"',
          showConfirmPopUpOnClearUnsentWithinAnItemTooltip: "Enable to allow a pop up confirmation message to display when using the \u201Cclear unsent\u201D key to remove all unsent items from the ticket.",
          showSentItemModificationsOnRegisterTicket: "Show sent Item Modifications",
          showSentItemModificationsOnRegisterTicketTooltip: "When enabled, after an item has been sent, any modifiers added will display in green text on the ticket detail area.",
          showConfirmPopUpOnLeaveIncompleteItem: "Confirm when navigating away from an incomplete Item",
          showConfirmPopUpOnLeaveIncompleteItemTooltip: "Enable to allow a pop up confirmation message to display when navigating away from an item that is unfinished, where required choices still need to be selected.",
          showHotButtonToggle: "Show Hot Buttons toggle",
          showHotButtonToggleTooltip: "This setting controls the visibility of the 10 Hot Buttons on the bottom of the register screen. When enabled, a \u201CShow/Hide Hot Buttons\u201D button will appear, which much be selected to display or hide the Hot Buttons. If the option is not enabled, the hot buttons will always display.",
          showModTagBar: "Show Mod Tag Bar",
          showModTagBarToolTip: "Enable to display the Mod Tag Bar on the register. The Mod Tag Bar allows modifications to menu items by adding a prefix or suffix to customize the menu item, such as \u2018add\u2019, \u2018no\u2019, \u2018sub\u2019, \u2018extra\u2019. When this option is disabled, no mod tags will appear for any menu items.",
          comboDisplayName: "Combo Display Name",
          showNotificationMessageForPrinterErrors: "Show Printer Errors Notification",
          showNotificationMessageForPrinterErrorsTooltip: "This setting determines whether an alert should be displayed when an item fails to print correctly in the kitchen.",
          showPrinterStatusNotifications: "Show Printer Status Notifications",
          showPrinterStatusNotificationsTooltip: "This setting determines whether an alert should be displayed when the printer status changes.",
          firePositionOnRegisterTicket: "Fire Position on Register Ticket",
          firePositionOnRegisterTicketTooltip: "Fire Times section position on the Register Ticket.",
          showDoneButton: 'Show "Done" Button',
          printHeldItems: "Print Held Items"
        },
        defaultRestaurantMode: {
          label: "Restaurant Mode",
          tooltip: "Select which method of service will be used for placing orders:\nTable Service - Full-service restaurant, seating, coursing, table layout options\nQuick Service - Pay-at-order workflow, takeout and delivery concepts",
          options: {
            tsr: "Table Service",
            qsr: "Quick Service"
          }
        },
        firePositionOnRegisterTicket: {
          label: "Fire Position on Register Ticket",
          tooltip: "Fire Times section position on the Register Ticket",
          options: {
            top: "Top",
            bottom: "Bottom",
            topCommaSeparated: "Top & Comma Separated",
            bottomCommaSeparated: "Bottom & Comma Separated"
          }
        },
        discountReasons: {
          title: "Void / Discount Reasons",
          description: "Discount reasons are the list of reasons that can appear when a discount is used on a ticket. These can help determine why a discount took place.",
          loadingMoreMessage: "Loading more Discount Reasons",
          linkText: "View / Edit Discount Reasons",
          addDiscountReason: "Add Discount Reason",
          status: "Status",
          name: "Name",
          posName: "POS Name",
          delete: "Delete",
          voidOrDiscountReasons: {
            title: "Void or Discount Reasons",
            options: {
              voidOnly: "Void Only",
              discountOnly: "Discount Only",
              both: "Both"
            }
          }
        },
        orderTypes: {
          title: "Order Types Available",
          toolTip: "Select which order types will be available for use on the register",
          catering: "Catering",
          curbside: "Curbside",
          delivery: "Delivery",
          dineIn: "Dine In",
          toGo: "To Go"
        },
        specialTags: {
          title: "Special Tags",
          description: "Special tags can identify a menu item with a specific characteristic. These are customizable and could be used to alert to food allergens, dietary restrictions, promotions, spicy/heat levels, or customer favorites.",
          loadingMoreMessage: "Loading more Special Tags",
          linkText: "View / Edit Special Tags",
          addSpecialTag: "Add Special Tag",
          status: "Status",
          name: "Name",
          posName: "POS Name",
          abbreviation: "Abbreviation",
          abbreviationToolTip: "Enter the abbreviation for the Special Tag that will appear in the bottom right corner of the item card. This field may only contain up to 2 characters.",
          color: "Color",
          textColor: "Text Color",
          delete: "Delete"
        },
        modTags: {
          title: "Mod Tags",
          description: "Mod tags all text to be added before (prefix) or after (suffix) a modifier. Examples: Extra, Add, No, Lite, On Side.",
          loadingMoreMessage: "Loading more Mod Tags",
          linkText: "View / Edit Mod Tags",
          addModTag: "Add Mod Tag",
          status: "Status",
          name: "Name",
          posName: "POS Name",
          dontPromptOpenItemName: "Don't Prompt Name",
          checkName: "Kitchen/Check Name",
          tagPosition: "Tag Position",
          tagPositionTooltip: "Choose whether the tag should appear before or after the modifier item. This selection determines the placement of the tag in relation to the modifier.",
          menuType: "Menu(s)",
          menuTypeTooltip: "Assign the mod tag to the appropriate menu(s). Mod tags can belong to a single menu, multiple menus, or all menus.",
          menuTypeModalDescription: "Select all Menus you want this ModTag to be availabe in",
          delete: "Delete",
          allMenuTypes: "All Menus"
        },
        timeBasedMenuType: {
          noData: "No Rules",
          copyRules: {
            button: "Copy Rules",
            popover: {
              title: "COPY RULES TO"
            }
          },
          id: "No.",
          invalidRange: "Invalid Range",
          title: "Time Based Menu",
          menuType: "Menu",
          time: "Time",
          delete: "Delete",
          defaultMenuType: {
            label: "Default Menu",
            toolTip: "Select the menu that will display first when a new ticket is begun."
          },
          dayFilter: {
            label: "Day"
          },
          defaultMenuTypeRules: {
            title: "Default Menu Rules",
            toolTip: "Select a day of the week to customize the default menu that will be displayed and the time which the menu will appear as the default. Click and drag to set the time ranges or click the time boxes to bring up a pop up window which will allow a time selection",
            addRule: "Add Rule"
          }
        }
      },
      tags: {
        title: "TAGS SETTINGS",
        description: "The following tables list tag and reason options for the Register.",
        seatOrderTags: {
          loadingMoreMessage: "Loading more tags",
          title: "Seat/Order Tags",
          description: "Seat/Order tags allow tags to be assigned to individual seats or tickets. These tags are customizable and will be categorized as allergens, special occasions, or other descriptor.",
          linkText: "View / Edit Order Tags",
          addModTag: "Add Tag",
          status: "Status",
          orderOrSeatTag: {
            title: "Order or Seat Tag",
            toolTip: "Select whether this tag can be assigned to a seat, to an order, or to both",
            options: {
              seatOnly: "Seat Only",
              orderOnly: "Order Only",
              both: "Both"
            }
          },
          type: {
            title: "Type",
            toolTip: "Select the appropriate category for the tag from the dropdown menu: Allergy, Descriptor, or Special Event. The tag will appear within that category on the register.",
            options: {
              allergy: "Allergy",
              attribute: "Descriptor",
              milestone: "Special Event"
            }
          },
          name: "Name",
          posName: "POS Name",
          seatTagFavorite: "Seat Favorite",
          orderTagFavorite: "Order Favorite",
          color: "Color",
          textColor: "Text Color",
          delete: "Delete"
        },
        openItemTypes: {
          title: "Open Item Types",
          description: "Open Item Types allow for the creation of categories or specific items that a privileged employee can add to a ticket. The employee will be prompted to enter a custom name for the item and a price. Examples: Open Food, Open Liquor, Corkage Fee, or Room Rental.",
          printLocationTooltip: "Select a prep station for the item to designate where it will be printed.",
          linkText: "View / Edit Open Item Types",
          addOpenItemType: "Add Open Item Type",
          table: {
            headers: {
              taxIds: "Taxes",
              taxTooltip: "Add one or more tax rates for the item by selecting the applicable tax rates from the list."
            },
            emptyMessage: "No Open Item Types"
          }
        },
        reportingGroupsTypes: {
          table: {
            headers: {
              reportingGroups: "Reporting Groups",
              reportingGroupTooltip: "Add one or more Reporting Groups for the item by selecting the applicable from the list."
            },
            emptyMessage: "No Reporting Groups"
          }
        }
      },
      tableService: {
        title: "TABLE SERVICE SETTINGS",
        toolTip: "Set the general settings for the Table Service Restaurant Mode",
        description: "Set the General Settings for the Restaurant Mode you selected (Table Service)",
        general: {
          title: "General Settings",
          keepTipPendingOrdersAssociatedToTable: "Keep Tip Pending Orders Associated to a Table",
          enableMapLayoutDragAndDrop: "Enable Drag & Drop for Table Map",
          showTableBorderForLoggedInUsersOrders: "Highlight User's Tables",
          seating: {
            title: "Seating",
            description: "Enable to allow for seat entry options when in an order. Disable to have all seat entry functions turned off",
            allowForTableButton: 'Allow "For Table"',
            allowForTabletoolTip: "Enable to allow a menu item to be for the table rather than assigned to an individual seat",
            doneIsForTable: '"Done" is "For Table"',
            enableDragDropForSeatPopover: "Enable Drag & Drop for Seat Popover",
            enableDragDropForSeatPopovertooltip: "Enable to allow a user to tap and hold a seat, then drag the seat to another to another seat to order the same menu item for the chosen seat. Drag and drop allows for multiple seat entries without the seat modification window closing.",
            showTicketSeatBar: "Show Ticket Seat Bar",
            attachNoSeatToToGo: 'Attach "No Seat" to "To Go"',
            attachNoSeatToToGotoolTip: "Enable so that when using \u201CTo Go\u201D in the seat modification window, the menu item will be assigned to \u201Cno seat\u201D rather than a seat number.",
            showConfirmPopUpWhenSendingItemsInSeatView: "Confirm when sending Items in seat view",
            showConfirmPopUpWhenSendingItemsInSeatViewtoolTip: 'When in Seat View and using the "send" key, this option displays a pop up confirmation box to choose whether to send only the items for the selected seat or the entire order.  When this option is disabled, the system will send only the items for the selected seat.',
            showSeatOneDescription: "Show Seat One Description",
            seatingMode: {
              label: "Seating Mode",
              toolTip: "Prompt - Always prompt for seat number when adding an item to an Order\n<1/>No Prompt - User is responsible for selecting a seat number before a menu item is added, no prompt will display to select a seat number\n<1/>Hybrid - Allows user to select a seat number before adding a menu item to the order. If a seat is not selected, the user will be prompted to select a seat number when an item is added to an Order",
              options: {
                prompt: "Prompt",
                no_prompt: "No Prompt",
                hybrid: "Hybrid"
              }
            },
            showOrderDetailsForNewOrderTsr: "Show Order Details prompt for New Order",
            showOrderDetailsForNewOrderTsrtoolTip: "When beginning a new order, a pop up prompt will display, requiring information such as number of seats, order type, name and description.  Tags can also be added to the order from this window",
            showOrderDetailsForDefaultNewOrder: "Show Order Details prompt on Default Order creation",
            showOrderDetailsForDefaultNewOrderToolTip: "After creating an order, display its information such as order number, type, name, description and tags.",
            showGuestCount: "Show Guest Count",
            showGuestCountTooltip: "Enable to show the guest count on the Order creation prompt and Order details Pop over.",
            defaultGuestCountOnNewOrder: "Default Guest Count On New Order",
            defaultGuestCountOnNewOrderTooltip: "When beginning a new order, the guest count prompt will automatically be selected based on the number of guests assigned to that table. Disable to always require a custom number of guests entry when beginning a table.",
            setGuestCountToZeroWhenNoTable: "Set Guest Count to Zero When No Table",
            setGuestCountToZeroWhenNoTableTooltip: "Enable to set the guest count to zero when a table is not selected. Disable to require a custom number of guests entry when beginning an order without a table.",
            setGuestCountToZeroOnToGoOrders: "Set Guest Count to Zero On To-Go Orders",
            setGuestCountToZeroOnToGoOrdersTooltip: "Enable to set the guest count to zero when a To-Go order is selected. Disable to require a custom number of guests entry when beginning a To-Go order.",
            ticketSeatBar: {
              label: "Ticket Seat Bar",
              toolTip: "Select how seat options will behave and display above the ticket detail area\n<1/>None - No seat information appears above the ticket detail area\n<1/>Carousel - Items appear in the ticket detail area filtered by seat.  Arrows on the left and right sides allow for scrolling through seats to see items for each seat, and an \u201CAll Seats\u201D to show all items in the Order\n<1/>Buttons w/Filter - Buttons for \u201CNo Seat\u201D, \u201CFor Table\u201D, \u201CAll Seats\u201D, and each seat will appear above the ticket detail area. Based on the selection, filtering will occur to show the items attached to the selected seat. Allows for viewing items ordered by seat, and the ability to add menu items to the selected seat.\n<1/>Buttons No Filter - Buttons for \u201CNo Seat\u201D, \u201CFor Table\u201D, \u201CAll Seats\u201D, and each seat will appear above the ticket detail area.  No filtering will occur on the ticket based on the selection.  Allows for easy selection of a seat choice before adding an item to the Order",
              options: {
                none: "None",
                carousel: "Carousel",
                buttonsWithFilter: "Buttons W/Filter",
                buttonsNoFilter: "Buttons No Filter"
              }
            },
            seatManagementButtonFunction: {
              label: "Seat Management Button Function",
              options: {
                seatTagsOnly: "Seat Tags Only",
                allowPreselectSeats: "Allow Preselect Seats"
              }
            }
          },
          guests: {
            title: "New Order and Guests Settings"
          },
          sendToKitchen: {
            title: "Send to Kitchen Settings",
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: "Don\u2019t allow navigation when Items have not been sent to Kitchen",
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchentoolTip: "When this is enabled, the user is not able to navigate out of the order unless all items on the ticket have been sent to the kitchen or been placed on hold.",
            showIndicatorWhenItemsOnTicketNotSentToKitchen: 'Show "Items not Sent to Kitchen" Indicator',
            showIndicatorWhenItemsOnTicketNotSentToKitchentoolTip: "Show an icon on tables with orders that contain items not sent to the kithen.",
            showSendItemsModal: 'Show pop-up window when using the "Send" key',
            showSendItemsModaltooltip: "Enable to allow a pop up window to display when using the send key. This window shows a confirmation list of all items to be sent, and allows items to be selected and unselected for sending",
            prepStationForFireTicketId: 'Printer location for "Fire":',
            prepStationForFireTicketIdTooltip: "Choose the printer that will receive the FIRE ticket when the Fire button is used on the register. This ticket will notify the kitchen to prepare the next course in the sequence."
          }
        },
        tableLayout: {
          title: "Table Layout",
          description: "The following settings will impact how the View Tables tab will look in the Register Module.",
          showSeatsOnTableLayout: "Show number of seats per table",
          showSeatsOnTableLayouttoolTip: "Enable to have the default number of seats display on each table in the table layout",
          showTimerOnTableLayout: "Show status timer on table",
          showTimerOnTableLayouttooltip: "Enable to show a timer below each table on the table layout which shows the length of time (in hours and minutes) since the table was begun",
          useCleaningStatusOnTableLayout: 'Use "Cleaning" status',
          useCleaningStatusOnTableLayouttoolTip: "Enable to have a table put in \u201Ccleaning\u201D status once payment has been made on a ticket. Table will display as red \u201Ccleaning\u201D and will need to be manually \u201Cset available\u201D before the table can be used again",
          allowOpenTabsOnTableLayout: "Allow Open Tabs",
          allowOpenTabsOnTableLayouttooltip: "Enable to allow the creation of orders which are not assigned to a table.  Disable to require all orders be opened via a table on the table layout"
        },
        coursing: {
          title: "Coursing",
          description: "Enable to use coursing which allows for ordering menu items by course.",
          coursingMode: {
            label: "Coursing Mode",
            toolTip: "Select which method of coursing will be used\n<1/>On The Fly - In this mode, courses are sent to the kitchen as they are ready, rather than following a predetermined schedule. The user is responsible for timing and firing each course.\n<1/>Predetermined - Courses are pre-defined and fired according to a set sequence.  Menu items would also typically be linked to a set course when using the Predetermined option for coursing.",
            options: {
              onTheFly: "On The Fly",
              predefined: "Predetermined"
            }
          },
          disabledOverlay: "Coursing is Off",
          disabledOnTheFlyOverlay: "Coursing is set to On the Fly",
          linkTitle: "Predetermined Courses",
          linkDescription: "Create and manage courses to associate with your Items.",
          linkButton: "View / Edit Courses",
          loadingMoreMessage: "Loading more Courses",
          addCourse: "Add Course",
          status: "Status",
          course: "Course",
          posName: "POS Name",
          kitchenName: "Kitchen Name",
          autoTrigger: "Auto Trigger (min)",
          delete: "Delete",
          grouping: "Grouping",
          groupByRounds: "Group By Rounds"
        }
      },
      quickService: {
        title: "QUICK SERVICE SETTINGS",
        description: "Set the General Settings for Quick Service.",
        general: {
          title: "General Settings",
          assignOrderTag: "Show Order Tag",
          enableSimpleMode: "Simple Mode (No Categories Bar)",
          showOrderDetailsForNewOrderQsr: "Display Order Details On New Order",
          showOrderDetailsForNewOrderQsrtoolTip: "When beginning an order, the order details window will appear prompting for Order Type, Name, and Description to be entered if desired. Order Tags can also be added here. Disable to be taken to the default menu, with no order details entry, when a new order is started.",
          sendOrderToKitchenTrigger: {
            label: "Send Order to print when:",
            toolTip: "Select when the order will be sent to remote printing devices\n<1/>Payment Initiated - Order will send when payment is initiated at register\n<1/>Payment Completed - Order will send when ticket has been paid in full",
            options: {
              paymentInitiated: "Payment Initiated",
              paymentCompleted: "Payment Completed"
            }
          },
          qsrSendAndPayActionButtons: {
            label: "Send and Pay Action Buttons",
            toolTip: 'Select which buttons display, and their action, when in QSR Mode\n<1/>Pay Only - When entering an order, the "payment" button is available to finish an order. The Order will send to the kitchen depending on what is selected in the "Send Order to Kitchen When" field\n<1/>Send Only - When entering an Order, the "Send" button is available to be used to send the order. The Order will be tendered later through the Orders screen. One example would be a Drive-Thru, where the order is taken and sent, but no payment collected immediately\n<1/>Both - The Send, Send/Stay, and Payment buttons are available when entering an order, allowing the user to either send the order manually or take payment on the order',
            options: {
              payOnly: "Pay Only",
              sendOnly: "Send Only",
              both: "Both"
            }
          }
        }
      },
      customerFacingDisplay: {
        title: "CUSTOMER FACING DISPLAY",
        description: "Set the General Settings for Customer facing display.",
        general: {
          receiptScreenTimeout: "Receipt Screen Timeout (seconds)",
          requireClientSignature: "Prompt Client Signature",
          payThroughCfdOnly: "Pay through CFD only",
          promptStarRatings: "Prompt Star Ratings",
          darkMode: "Dark Mode",
          promptPrintReceipt: "Prompt Print Receipt"
        },
        adsSettings: {
          title: "Ads Settings",
          description: "The Username set here will be displayed in the CFD Ads.",
          adsTable: {
            image: {
              title: "Upload a picture of the Ad"
            },
            addAd: "Add Ad",
            imageUrl: "Image",
            title: "Title",
            text: "Text",
            price: "Price"
          },
          ads: {
            title: "Ads",
            description: "Add the image that will be displayed in each promotion. The Title, Text and the Price (if there's any).",
            viewEditAds: "View/Edit Ads"
          },
          addYourUserName: "Add your {{socialMedia}} user name",
          colorSettings: {
            title: "Color Settings",
            placeholderBackground: "Placeholder Background",
            adTextBackground: "Ad Text Background",
            mediaLinksBackground: "Text/Social Media links"
          }
        },
        tips: {
          defaultSuggestedTip: {
            label: "Suggested Tip as Default"
          }
        }
      },
      endOfDay: {
        title: "END OF DAY SETTINGS",
        description: "Settings for the End of Day flow.",
        clockOut: {
          title: "Clock-Out Settings",
          requireNoOpenOrders: "Require no Open Orders",
          requireNonCashTips: "Require Non-Cash Tips",
          requireServerBankSettlement: "Require Server Bank Settlement",
          netNonCashTipsOnSettlement: "Tips on Cash Settlement",
          requireCashtipReporting: "Require Cash Tip Reporting",
          requireDrawerSettlement: "Require Drawer Settlement",
          displayTipsDueInHeader: 'Display "Tips Due" in Header on Shift Report',
          zeroTipsDueOnClockOut: 'Zero "Tips Due" on clockout',
          autoSettleDrawerId: "Auto Settle Drawer"
        }
      },
      errors: {
        modifierTags: {
          name: "Error in Mod Tag Name table."
        },
        ads: {
          name: "Error in Ads table."
        },
        specialTags: {
          name: "Error in Special Tags table."
        },
        orderSeatTags: {
          name: "Error in Seat/Order Tags Table"
        },
        courses: {
          name: "Error in Courses table."
        },
        discountReasons: {
          name: "Error in Discount Reasons table."
        },
        openItemTypes: {
          name: "Error in Open Item Types table."
        },
        defaultMenuTypeTimes: {
          time: "Invalid Menu time range(s)."
        }
      }
    },
    tableLayoutCreator: {
      messages: {
        updatingLayoutPleaseWait: "Updating layout. Please wait...",
        changesSaved: "Changes saved successfully",
        errorUpdatingLayout: "Error updating layout",
        errorSavingChanges: "An error ocurred during the update. Please try again",
        unableToDeleteTable: {
          title: "Unable to delete",
          message: "This Table is related to an order"
        },
        unableToDeleteServiceArea: {
          title: "Unable to delete",
          message: "This Service Area has tables with active orders"
        },
        elementOverflows: {
          title: "Element overflows",
          description: "The Element doesn't fit"
        }
      },
      serviceArea: "Service Area",
      serviceAreas: "Service Areas",
      addServiceArea: "Add Service Area",
      updateServiceArea: "Update Service Area",
      noServiceArea: {
        title: "Welcome to the Table Layout Creator",
        message: "Start by adding a new Service Area",
        noServiceAreas: "No Service Areas"
      },
      noLayout: {
        title: "Layout Is Empty",
        message: "Start by adding a Table or Element to the Layout"
      },
      buttons: {
        rearrange: "Rearrange",
        undo: "Undo",
        addTable: "Add Table",
        addElement: "Add Element"
      },
      bottomSheet: {
        newElement: "New Element",
        newTable: "New Table",
        tableShapes: {
          circle: "Circle",
          square: "Square",
          rectangle: "Rectangle"
        },
        elements: {
          table: "Table",
          barriers: "Barriers",
          others: "Others",
          wall: "Wall",
          station: "Station",
          custom: "Custom",
          window: "Window",
          door: "Door",
          plant: "Plant"
        }
      },
      sideBar: {
        detailsPanel: "{{type}} details",
        name: "Name",
        tableType: "Table Type",
        selectTableType: "Select Table Type",
        seats: "Seats",
        geometryOptions: "Geometry Options",
        size: "Size",
        small: "small",
        large: "large",
        rotate: "Rotation"
      },
      modals: {
        title: "Update Service Area",
        name: "Service Area name",
        revenueCenter: "Revenue Center",
        noRevenueCenters: "No Revenue Centers",
        selectRevenueCenter: "Select Revenue Center",
        isActiveInRegister: "Show in the Register Module",
        removeServiceArea: "Remove Service Area",
        forceNoTaxInclusive: 'Force "No Tax Inclusive"'
      }
    }
  },
  authentication: {
    welcomeBack: "Welcome Back!",
    needHelp: "Need Help?",
    inactivity: {
      title: "Session Expired",
      description: "You have been logged out due to inactivity"
    },
    timeSummary: {
      clockIn: {
        alreadyClockedIn: "User already clocked in"
      }
    },
    login: {
      dontHaveAnAccount: "Don't have an account yet?",
      signUp: "Sign Up",
      callOrText: "Call or Text",
      insertPassword: "Password",
      incorrectEmailOrPassword: "The given email and password combination is incorrect."
    },
    forgotPassword: {
      forgotPassword: "Forgot Password?",
      enterYourEmailToBegin: "Enter your Email to begin the password recovery process",
      incorrectEmail: "Incorrect Email. Please try again",
      sendCode: "Send Code",
      sendingCode: "Sending Code",
      rememberPassword: "Remember Password?"
    },
    verifyCode: {
      enterVerificationCode: "Enter Verification Code",
      weHaveSentAVerificationCode: "We have sent a verification code to",
      verifyCode: "Verify Code",
      verifyingCode: "Verifying Code",
      didntGetTheCode: "Didn't get the code?",
      resend: "Resend",
      resending: "Resending"
    },
    resetPassword: {
      resetPassword: "Reset Password",
      pleaseCreateNewPassword: "Please create a new password to continue.",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      verifyCode: "Verify Code",
      thePasswordConfirmationDoesntMatch: "The password doesn't match.",
      passwordMustBe: {
        passwordMustBe: "Password must be",
        atLeast8Characters: "At least 8 characters",
        atLeastOneCapitalLetter: "At least one capital letter",
        atLeastOneSmallLetter: "At least one small letter",
        atLeastOneNumberOrSymbol: "At least one number or symbol"
      },
      resettingPassword: "Resetting password"
    },
    passwordChanged: {
      passwordChanged: "Password Changed",
      passwordHasBeenSuccessfullyChanged: "Your password has been successfully changed. Please use your new password to login.",
      backToSignIn: "Back to Sign In"
    },
    signUp: {
      accountInfo: {
        firstName: "First Name",
        lastName: "Last Name",
        phoneNumber: "Phone Number",
        alreadyHaveAnAccount: "Already have an account?",
        createAnAccount: "CREATE AN ACCOUNT",
        "10DigitsPhone": "10 digits phone"
      },
      wrongEmail: "Wrong Email?",
      wrongPhoneNumber: "Wrong Phone Number?",
      changePhoneNumber: "Change Number",
      verifyCodeInstructions: "Enter the six digit code we sent to",
      toVerifyEmail: "to verify your email",
      toVerifyPhoneNumber: "to verify your phone number",
      accountCreated: {
        title: "Welcome {{user}}!",
        description: "Your account has been created successfully. Sign In to choose your organization.",
        continueToSignIn: "Continue to Sign In"
      },
      steps: {
        accountInformation: "Account Information",
        confirmEmail: "Confirm Email",
        confirmPhone: "Confirm Phone",
        accountCreated: "ACCOUNT CREATED SUCCESSFULLY"
      },
      changeEmail: {
        changeEmail: "Change Email",
        newEmail: "New Email",
        title: "Change Email",
        description: "Enter a different email to send you a new verification code.",
        sendVerificationCode: "Send Verification Code"
      },
      changePhone: {
        changePhoneNumber: "Change Phone Number",
        newPhone: "New Phone Number",
        description: "Enter a different phone number to send you a new verification code."
      }
    },
    signUpInvitation: {
      welcome: "Welcome to Tableturn!",
      description: "has invited you to join their organization in Tableturn. Please create an account to get started.",
      getStarted: "Get Started"
    }
  },
  loggedIn: {
    myOrganizations: {
      title: "Select an Organization to Continue",
      description: " You can also add a new Organization if necessary or if no organization is available.",
      addOrganization: "Add Organization"
    }
  },
  reports: {
    addEditScreen: {
      customReportsEdit: "Edit Custom Report",
      customReportsAdd: "Add Custom Report",
      itemComboSalesReportsEdit: "Edit Item Combo Sales Report",
      itemComboSalesReportsAdd: "Add Item Combo Sales Report",
      salesOverviewReportsEdit: "Edit Sales Overview Report",
      salesOverviewReportsAdd: "Add Sales Overview Report",
      endOfShiftReportsEdit: "Edit End of Shift Report",
      endOfShiftReportsAdd: "Add End of Shift Report",
      creditCardBatchReportsEdit: "Edit Credit Card Batch Report",
      employeeSalesAndTipsReportsAdd: "Add Employee Sales Report",
      employeeSalesAndTipsReportsEdit: "Edit Employee Sales Report",
      voidReasonsReportsAdd: "Add Void Reasons Report",
      voidReasonsReportsEdit: "Edit Void Reasons Report",
      inventoryOnHandReportsAdd: "Add Inventory Report",
      inventoryOnHandReportsEdit: "Edit Inventory Report",
      creditCardBatchReportsAdd: "Add Credit Card Batch Report",
      creditBalancesReportsAdd: "Add Credit Balance Report",
      creditBalancesReportsEdit: "Edit Credit Balance Report",
      reportSettings: "REPORT SETTINGS",
      scheduling: "Scheduling"
    },
    displaySettings: "Display Settings",
    filters: "Filters",
    fields: {
      name: "Name",
      isFavorited: "Favorite",
      isActive: "Status",
      groupBy: "Group By",
      groupByOptions: {
        category: "Categories",
        reporting_groups: "Reporting Groups"
      },
      reportType: "Report Type",
      reportPeriod: "Report Period",
      period: "Time",
      periodSubtitle: "The report period is based on a business day ending at {{time}}.",
      periodOptions: {
        custom: "Custom",
        specific_date: "Specific Date",
        today: "Today",
        yesterday: "Yesterday",
        this_week: "This Week",
        last_week: "Last Week",
        this_month: "This Month",
        last_month: "Last Month",
        this_quarter: "This Quarter",
        last_quarter: "Last Quarter",
        this_year: "This Year",
        last_year: "Last Year"
      },
      startDate: "Start Date",
      endDate: "End Date",
      specificDate: "Specific Date",
      categoryIds: "Categories",
      subcategoryIds: "Subcategories",
      reportingGroupIds: "Reporting Groups",
      orderStatuses: "Order Statuses",
      orderTypes: "Order Types",
      orderTypeOptions: {
        "dine in": "Dine In",
        to_go: "To Go",
        delivery: "Delivery",
        curbside: "Curbside",
        catering: "Catering"
      },
      ownerIds: "Owners",
      showSalesByMenuType: "Show Orders by Menu",
      showSalesByOrderType: "Show Orders by Order Type",
      isSchedulingEnabled: "Scheduling Enabled",
      template: "Template",
      templateOptions: {
        default: "Default",
        legacy: "Legacy"
      },
      fileType: "File Type",
      fileTypeOptions: {
        pdf: "PDF",
        csv: "CSV",
        xls: "XLS",
        json: "JSON"
      },
      scheduleStartDateTime: "Start Date",
      repeatType: "Repeat Type",
      repeatTypeOptions: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        quarterly: "Quarterly",
        yearly: "Yearly"
      },
      recipients: "Recipients",
      noRecipients: "No Recipients",
      showModItemsSales: "Show Mod Items With Prices",
      combineForAll: "Combine For All",
      showSalesByRole: "Show Sales by Role",
      doNotPrintOrderHistory: "Do Not Print Order History"
    }
  },
  toasts: {
    customerRemoved: {
      title: "Customer Removed",
      description: "The Customer you are editing does not exist anymore"
    },
    cannotAccessLocation: {
      title: "Cannot Access Location",
      description: "Your user is inactive in this location"
    },
    settingRemoved: {
      title: "Setting Removed",
      description: "The Setting you are editing does not exist anymore"
    }
  },
  managementModule: {
    employeesScreen: {
      title: "Employees",
      topBar: {
        filters: {
          status: {
            title: "Current Status",
            all: "All",
            clockedIn: "Clocked-In",
            clockedOut: "Clocked-Out"
          }
        },
        clockedInThisPeriod: "Clocked In This Period",
        timePeriod: {
          title: "Time Period",
          today: "Today",
          yesterday: "Yesterday",
          week: "Week",
          month: "Month",
          year: "Year",
          custom: {
            button: "Custom",
            start: "Start Date",
            end: "End Date"
          }
        }
      },
      employeesTable: {
        loading: "Loading Employees...",
        pin: "PIN",
        name: "Name",
        status: "Current Status",
        role: "Role",
        hours: "Hours",
        sales: "Sales",
        tipsEarned: "Tips Earned",
        tipsPaid: "Tips Paid",
        tipsDue: "Tips Due",
        actions: "Actions",
        lastClockIn: "Last Clock-In",
        payTip: "Pay Tip"
      },
      employeeDetailsTable: {
        loading: "Loading Shifts...",
        payRollId: "Payroll ID",
        hoursWorked: "Hours Worked",
        shift: "Shift",
        report: "Report",
        addShift: "Add Shift",
        editShiftModal: {
          title: "Edit Shift",
          startOfShift: "Start of Shift",
          endOfShift: "End of Shift"
        }
      }
    }
  }
};

// src/assets/translations/es.json
var es_default = {
  currency: "{{val, currency(currency)}}",
  states: {
    AL: "Alabama",
    AR: "Arkansas",
    AS: "American Samoa",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VI: "Virgin Islands",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming"
  },
  printerStatus: {
    missing_paper: "Papel Faltante",
    printer_error: "Error de Impresora",
    cover_open: "Tapa Abierta",
    printer_offline: "Desconectada",
    active: "Activa",
    paused: "Detenido"
  },
  printerTypes: {
    kitchen: "IMPRESORAS DE COCINA",
    receipt: "IMPRESORAS DE RECIBOS"
  },
  screenNames: {
    CategoriesScreen: "Categor\xEDas",
    SubcategoriesScreen: "Subcategor\xEDas",
    ItemsScreen: "Elementos",
    ModifierItemsScreen: "Elementos Modificadores",
    ModifierGroupsScreen: "Grupos de Modificadores",
    ItemGroupsScreen: "Grupos de Articulos",
    MenuTypesScreen: "Tipos de Menu",
    DiscountScreen: "Descuentos",
    CombosScreen: "Combos",
    UsersSettingsScreen: "Usuarios",
    SpecialsScreen: "Especiales",
    IngredientsScreen: "Ingredientes",
    ReportingGroupsScreen: "Grupos de Reporte"
  },
  commonButtons: {
    pick: "Elegir",
    copy: "Copiar",
    paste: "Pegar",
    associate: "Asociar",
    add: "Agregar",
    cancel: "Cancelar",
    close: "Cerrar",
    signIn: "Iniciar Sesi\xF3n",
    back: "Regresar",
    logOut: "Cerrar Sesi\xF3n",
    save: "Guardar",
    ok: "Ok",
    continue: "Continuar",
    saveChanges: "Guardar Cambios",
    dontSaveChanges: "No guardar",
    discardChanges: "Descartar Cambios",
    reset: "Reiniciar",
    done: "Listo",
    clearAll: "Limpiar Todos",
    clear: "Limpiar",
    discard: "Descartar",
    clone: "Clonar",
    remove: "Remover",
    delete: "Eliminar",
    duplicate: "Duplicar",
    transfer: "Transferir",
    push: "Empujar",
    pull: "Jalar",
    selectAll: "Seleccionar Todos",
    unassociate: "Desasociar",
    goBack: "Go Back",
    pushChanges: "Push Changes",
    dontPrint: "Don't print",
    create: "Create",
    edit: "Edit",
    confirm: "Confirm",
    next: "Next",
    retry: "Retry",
    skip: "Skip",
    enable: "Enable",
    hide: "Hide",
    deleteAll: "Delete All",
    removing: "Removing",
    stay: "Stay",
    anyway: "Anyway",
    leave: "Leave",
    pay: "Pay",
    setToPaid: "Set to Paid",
    hold: "Hold",
    rearrange: "Rearrange",
    settings: "Settings",
    override: "Override",
    update: "Update",
    sort: "Sort",
    set: "Set",
    apply: "Apply",
    more: "More",
    send: "Send",
    mergeOrders: "Merge Orders",
    printAll: "Print All",
    paid: "Paid",
    voided: "Voided",
    void: "Void",
    refund: "Refund",
    closeCheck: "Close Check",
    previousBucket: "Previous {{bucket}}",
    nextBucket: "Next {{bucket}}",
    choosePrinter: "Choose a Printer",
    chooseAPrinterForReceipt: "Choose a Printer for Receipt",
    distribute: "Distribute",
    download: "Download",
    reload: "Reload",
    deleteMultiple: "Eliminar {{ description }}",
    inactiveMultiple: "Desactivar {{ description }}",
    exit: "Salir",
    details: "Detalles"
  },
  commonTexts: {
    placeholderDropdown: "Seleccione una opci\xF3n",
    status: "Estado",
    total: "Total",
    alert: "Alerta",
    allSections: "Todas las Secciones",
    adding: "A\xF1adiendo",
    editing: "Editando",
    associated: "Asociaciones",
    email: "Correo Electr\xF3nico",
    phone: "Tel\xE9fono",
    password: "Contrase\xF1a",
    emailExample: "email@ejemplo.com",
    continue: "Continuar",
    success: "\xC9xito",
    yes: "Si",
    no: "No",
    and: "y",
    active: "Activo",
    inactive: "Inactivo",
    none: "Ninguno",
    before: "Antes",
    after: "Despu\xE9s",
    all: "Todos",
    location: "Ubicaci\xF3n",
    na: "N/A",
    error: "Error",
    viewAll: "Ver Todos",
    default: "Por Defecto",
    defaultColor: "Predet.",
    updating: "Actualizando",
    creating: "Creando",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Mi\xE9rcoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sabado",
    sunday: "Domingo",
    name: "Nombre",
    emptyField: "Campo vac\xEDo",
    notAvailable: "No Disponible",
    delete: "Eliminar",
    selected: "Seleccionado",
    expandAll: "Expandir todo",
    collapseAll: "Colapsar todo",
    other: "Otro",
    user: "Usuario",
    somethingWentWrong: "Algo sali\xF3 mal",
    noAssociations: "Sin Asociaciones",
    noneFound: "No se encontraron {{elementName}} con los Filtros Seleccionados",
    kitchen: "Cocina",
    table: "Mesa",
    receipt: "Recibo",
    refreshingData: "Actualizando Datos",
    superAdmin: "Administrador",
    multiple: "Multiple",
    noChanges: "Sin Cambios",
    bank: "Banco",
    date: "Fecha",
    time: "Tiempo",
    several: "Varios"
  },
  components: {
    starCheckBox: {
      checked: "Marcado como Favorito",
      unChecked: "Marcar como Favorito"
    },
    menuCard: {
      tag: {
        menuTypeCount_zero: "{{count}} Men\xFAs",
        menuTypeCount_one: "1 Men\xFA",
        menuTypeCount_other: "{{count}} Men\xFAs",
        itemCount_zero: "{{count}} Articulos",
        itemCount_one: "1 Articulo",
        itemCount_other: "{{count}} Articulos",
        elementsCount_zero: "{{count}} Elementos",
        elementsCount_one: "1 Elemento",
        elementsCount_other: "{{count}} Elementos",
        itemGroupCount_zero: "{{count}} Grupos de Elementos",
        itemGroupCount_one: "1 Grupo de Elemenots",
        itemGroupCount_other: "{{count}} Grupos de Elementos",
        comboCount_zero: "{{count}} Combos",
        comboCount_one: "1 Combo",
        comboCount_other: "{{count}} Combos",
        itemFraction_zero: "{{count}} Elemento",
        itemFraction_one: "{{count}}/{{total}} Elementos",
        itemFraction_other: "{{count}}/{{total}} Elementos",
        itemAll: "Todos los Elementos",
        categoryCount_zero: "{{count}}a Categor\xEDa",
        categoryCount_one: "1 Categor\xEDa",
        categoryCount_other: "{{count}} Categor\xEDas",
        categoryFraction_zero: "{{count}} Categor\xEDa",
        categoryFraction_one: "{{count}}/{{total}} Categor\xEDas",
        categoryFraction_other: "{{count}}/{{total}} Categor\xEDas",
        categoryAll: "Todas las Categor\xEDas",
        subcategoryCount_zero: "{{count}} Subcategor\xEDas",
        subcategoryCount_one: "1 Subcategor\xEDa",
        subcategoryCount_other: "{{count}} Subcategor\xEDas",
        subcategoryCountShort_zero: "{{count}} Subcats",
        subcategoryCountShort_one: "1 Subcat",
        subcategoryCountShort_other: "{{count}} Subcats",
        subcategoryFraction_zero: "{{count}} Subcategor\xEDa",
        subcategoryFraction_one: "{{count}}/{{total}} Subcategor\xEDas",
        subcategoryFraction_other: "{{count}}/{{total}} Subcategor\xEDas",
        subcategoryAll: "Todas las Subcategor\xEDas",
        modifierGroupCount_zero: "{{count}} Grupo Modificador",
        modifierGroupCount_one: "1 Grupo Modificador",
        modifierGroupCount_other: "{{count}} Grupos Modificador",
        modifierGroupFraction_zero: "{{count}} Grupo Modificador",
        modifierGroupFraction_one: "{{count}}/{{total}} Grupos Modificador",
        modifierGroupFraction_other: "{{count}}/{{total}} Grupos Modificador",
        modifierGroupAll: "Todos los Grupos Modificador",
        modifierItemCount_zero: "{{count}} Art\xEDculo Modificador",
        modifierItemCount_one: "1 Art\xEDculo Modificador",
        modifierItemCount_other: "{{count}} Art\xEDculos Modificador",
        modifierItemFraction_zero: "{{count}} Art\xEDculo Modificador",
        modifierItemFraction_one: "{{count}}/{{total}} Art\xEDculos Modificador",
        modifierItemFraction_other: "{{count}}/{{total}} Art\xEDculos Modificador",
        modifierItemAll: "Todos los Art\xEDculos Modificador",
        locationCount_zero: "{{count}} Ubicaci\xF3n",
        locationCount_one: "1 Ubicaci\xF3n",
        locationCount_other: "{{count}} Ubicaciones",
        locationFraction_zero: "{{count}} Ubicaci\xF3n",
        locationFraction_one: "{{count}}/{{total}} Ubicaci\xF3n",
        locationFraction_other: "{{count}}/{{total}} Ubicaciones",
        locationAll: "Todas las Ubicaciones",
        modifierItemAbrevCountTag_zero: "{{0}} E. M.",
        modifierItemAbrevCountTag_one: "1 E. M.",
        modifierItemAbrevCountTag_other: "{{count}} E. M.",
        roleCount_zero: "{{count}} Roles",
        roleCount_one: "1 Rol",
        roleCount_other: "{{count}} Roles",
        userCount_zero: "{{count}} Usuarios",
        userCount_one: "1 Usuario",
        userCount_other: "{{count}} Usuarios"
      }
    },
    actionButtons: {
      addNewCategory: "Agregar nueva categor\xEDa",
      addExistingCategory: "Agregar categor\xEDa existente",
      cloneCategoryTag: "Clonando categor\xEDa - {{element}}",
      addNewMenuType: "Agregar nuevo Men\xFA",
      addExistingMenuType: "Agregar Men\xFA existente",
      cloneMenuTypeTag: "Clonando Men\xFA - {{element}}",
      addNewLocation: "Agregar nueva Ubicaci\xF3n",
      addExistingLocation: "Agregar Ubicaci\xF3n existente",
      addNewSubcategory: "Agregar nueva Subcategor\xEDa",
      addExistingSubcategory: "Agregar Subcategor\xEDa existente",
      cloneSubcategoryTag: "Clonando Subcategor\xEDa - {{element}}",
      addNewItem: "Agregar nuevo Elemento",
      addExistingItem: "Agregar Elemento existente",
      addNewTax: "Agregar nuevo Impuesto",
      addExistingTax: "Agregar Impuesto existente",
      cloneItemTag: "Clonando Elemento - {{element}}",
      addNewModifierItem: "Agregar nuevo Modificador de elemento",
      addExistingModifierItem: "Agregar Modificador de elemento existente",
      cloneModifierItemTag: "Clonando Modificador de elemento - {{element}}",
      addNewModifierGroup: "Agregar nuevo Modificador de grupo",
      addExistingModifierGroup: "Agregar Modificador de grupo existente",
      cloneModifierGroupTag: "Clonando Modificador de group - {{element}}",
      addNewPricingVersion: "Agregar nueva versi\xF3n del precio",
      addNewCategoryTag: "Nueva categor\xEDa",
      addExistingCategoryTag: "Nategor\xEDa existente",
      addNewMenuTypeTag: "Nuevo Men\xFA",
      addExistingMenuTypeTag: "Nipo de Men\xFA existente",
      addNewLocationTag: "Nueva Ubicaci\xF3n",
      addExistingLocationTag: "Nbicaci\xF3n existente",
      addNewSubcategoryTag: "Nueva Subcategor\xEDa",
      addExistingSubcategoryTag: "Nubcategor\xEDa existente",
      addNewItemTag: "Nuevo Elemento",
      addExistingItemTag: "Elemento existente",
      addNewModifierItemTag: "Nuevo Modificador de elemento",
      addExistingModifierItemTag: "Modificador de elemento existente",
      addNewModifierGroupTag: "Nuevo Modificador de grupo",
      addExistingModifierGroupTag: "Nodificador de grupo existente",
      addNewSpecial: "Agregar nuevo especial",
      addExistingSpecial: "Agregar especial existente",
      addNewDiscount: "Agregar Nuevo Descuento",
      addNewDiscountTag: "Nuevo Descuento",
      addExistingDiscount: "Agregar Descuento Existente",
      addExistingDiscountTag: "Descuento Existente",
      addNewCombo: "Agregar Nuevo Combo",
      addNewComboTag: "Nuevo Combo",
      addNewSpecialTag: "Nuevo Especial",
      addExistingSpecialTag: "Especial Existente",
      addExistingCombo: "Agregar Combo Existente",
      addExistingComboTag: "Combo Existente",
      addNewRole: "Agregar Nuevo Rol",
      addNewRoleTag: "Nuevo Rol",
      addExistingRole: "Agregar Rol Existente",
      addExistingRoleTag: "Rol Existente",
      addNewIngredient: "Agregar Nuevo Ingrediente",
      addExistingIngredient: "Agregar Ingrediente Existente",
      addNewIngredientTag: "Nuevo Ingrediente",
      addExistingIngredientTag: "Ingrediente Existente",
      addNewItemGroupTag: "Nuevo Grupo de Art\xEDculos",
      addExistingDashboard: "Agregar Tablero Existente"
    }
  },
  dateFormatter: {
    date: "{{date, DATE}}",
    dateHuge: "{{date, DATE_HUGE}}",
    time: "{{date, TIME}}",
    weekday: "{{date, WEEKDAY}}"
  },
  navBar: {
    common: {
      printerCenter: {
        title: "CENTRO DE IMPRESI\xD3N",
        selectBackupPrinter: "Seleccione la impresora de respaldo",
        selectBackupPrinterPlaceholder: "Selecciona una impresora",
        noMorePrinters: "Sin m\xE1s impresoras",
        backupPrinterUpdated: "Impresora de respaldo seleccionada",
        printerNotFound: "Impresora No Encontrada",
        noPrinterOption: "Sin Impresora",
        transferToPrinter: "Transferir a impresora",
        printers: "Impresoras",
        printer: {
          viewJobs: "Ver trabajos",
          resume: "Reanudar",
          pause: "Detener",
          pauseSuccess: "Impresora pausada",
          resumeSucess: "Impresora reanudada",
          printerErrorTitle: "Error de impresora"
        },
        backupPrinter: {
          title: "Impresora de Respaldo",
          updating: "Actualizando impresora de respaldo",
          updateSuccess: "Impresora de respaldo actualizada"
        },
        printerStatus: {
          updating: "Actualizando Estado de Impresora",
          error: "Error al actualizar el estado de la impresora"
        },
        printJobs: {
          title: "TRABAJOS DE IMPRESORA",
          printerName: "Nombre impr.",
          printerLocationName: "Ubicaci\xF3n impr.",
          timePlaced: "Hora",
          orderNumber: "Orden",
          tabletPlacedFrom: "Tablet",
          userPlacedFrom: "Usuario",
          printType: "Tipo",
          reprinting: "Reimprimiendo trabajos de impresi\xF3n",
          reprintSuccess: "Trabajos de impresi\xF3n reimpresos",
          deleting: "Borrando trabajos de impresi\xF3n",
          deleteSuccess: "Trabajos de impresi\xF3n eliminados",
          deleteError: "Error al eliminar trabajos de impresi\xF3n",
          transferring: "Transfiriendo trabajos de impresi\xF3n",
          transferSuccess: "Trabajos de impresi\xF3n transferidos",
          transferError: "Error al transferir trabajos de impresi\xF3n",
          noPrinterJobs: "Sin trabajos de impresi\xF3n",
          deleteConfirmation: {
            title: "Eliminar",
            description: "\xBFEst\xE1s seguro de que deseas eliminar las impresiones seleccionadas?"
          },
          jobType: {
            kitchen: "Cocina",
            receipt: "Recibo",
            check: "Cuenta",
            fire: "Disparar"
          },
          status: {
            pending: "Pendiente",
            error: "Fallado",
            inTransit: "Imprimiendo",
            complete: "Completado"
          },
          loadingPrintJobs: "Cargando Trabajos de Impresi\xF3n...",
          transferErrorModal: {
            description: "No puedes transferir trabajos completados o imprimiendo."
          },
          transferReprint: {
            printer: "Selecciona la impresora para los trabajos de impresi\xF3n de {{types}}",
            printerLocation: "Selecciona la ubicaci\xF3n de impresora para los trabajos de impresi\xF3n de {{types}}"
          },
          notConfirmedWarning: "Confirmaci\xF3n de impresi\xF3n no recibida"
        }
      }
    }
  },
  register: {
    modals: {
      reprintTicketElement: {
        assignedPrepStations: "Ubicaciones de Impresoras asignadas"
      },
      hotButtonsModifierItemNotFoundModal: {
        title: "not available",
        description: "cannot be added to"
      },
      ticketElementInClosedChecks: {
        title: "Reabrir cuentas cerradas",
        description: "El art\xEDculo que estas tratando de modificar pertenece a 1 o m\xE1s cuentas que estan cerradas. Re abre estas cuentas para continuar.",
        btnSuccessText: "Reabrir Cuentas"
      },
      discounts: {
        title: "Descuentos",
        noItemSelected: "Seleccione un art\xEDculo para aplicar descuentos individuales",
        customDiscount: "Descuento Manual",
        itemDiscounts: "Descuentos por art\xEDculo",
        orderDiscounts: "Descuentos a la \xF3rden",
        reason: "Motivo del descuento",
        noReason: "Sin Motivo",
        additionalInfo: "informaci\xF3n Adicional",
        discountType: "Tipo de descuento",
        exclusiveDiscount: "Descuento exclusivo",
        exclusiveDiscountDescription: "El descuento seleccionado est\xE1 marcado como exclusivo, todos los descuentos actualmente aplicados a los art\xEDculos seleccionados ser\xE1n reemplazados.",
        exclusiveDiscountOrderDescription: "El descuento seleccionado est\xE1 marcado como exclusivo, todos los descuentos actualmente aplicados a la orden actual ser\xE1n reemplazados.",
        removingExclusiveDiscount: "Descuento exclusivo actualmente aplicado",
        removingExclusiveDiscountDescription: "Los art\xEDculos seleccionados tienen aplicado un descuento exclusivo, si continua agregando: '{{selectedDiscount}}' se remover\xE1 el descuento exclusivo actual.",
        removingExclusiveOrderDiscountDescription: "Los \xF3rden actual tienen aplicado un descuento exclusivo, si continua agregando: '{{selectedDiscount}}' se remover\xE1 el descuento exclusivo actual.",
        overrideOrderDiscount: "\xD3rden actual con descuentos aplicados",
        overrideOrderDiscountDescription: "Actualmente tiene {{discountsList}}, si contin\xFAa aplicando el descuento, se remover\xE1n todos los descuentos previos.",
        multiple: "M\xFAltiple",
        multipleOrderDiscounts: "M\xFAltiples Descuentos Aplicados",
        overridePriceUnderTheMax: "La cantidad a sobreescribir debe ser menor a: {{maxOverrideValue}}",
        itemsUnderOverrideValueTitle: "Art\xEDculos seleccionados con precio menor al deseado",
        itemsUnderOverrideValueSingleDescription: "El precio de: {{posName}} se encuentra por debajo del precio con descuento deseado de: ${{overridePrice}}, no es posible aplicar el descuento {{discountName}}.",
        itemsUnderOverrideValueMultipleDescription: "Hay {{itemCount}} art\xEDculos, ({{posName}}) con un precio por debajo del precio con descuento deseado de: ${{overridePrice}}, no es posible aplicar el descuento {{discountName}}."
      }
    },
    check: {
      masterCheckName: "Principal"
    },
    detailsArea: {
      modals: {
        entity86ed: {
          entity: {
            item: "Art\xEDculo",
            modifierItem: "Modifier Item",
            ingredient: "Ingrediente"
          },
          article: {
            item: "un",
            modifierItem: "un",
            ingredient: "un"
          },
          title: "{{entity}} Agotado",
          description: "Est\xE1 intentando agregar {{article}} {{entity}} que se encuentra agotado.",
          continueMessage: "\xBFDesea continuar?",
          orderAnyway: "Ordenar de todas formas",
          remove86Description: "\xBFDesea actualizar el estado the este {{entity}} a disponible?",
          confirmationDescription: "\xBFDesea actualizar el estado the este {{entity}} a agotado?",
          remove86: "Marcar como disponible",
          confirmationTitle: "Marcar {{entity}} como agotado.",
          remove86Title: "Marcar {{entity}} como disponible."
        }
      }
    },
    item: {
      quantitySelector: {
        quantity: "Cantidad",
        ungroup: "Desagrupar articulo",
        custom: "10+"
      },
      singularItem: "Articulo",
      pluralItem: "Articulos",
      modifierGroups: {
        seats: {
          singular: "Asiento",
          title: "Asientos",
          shareItem: "Compartir art\xEDculo",
          forTable: "Al Centro",
          noSeat: "Sin Asignar",
          toGo: "Para llevar"
        }
      },
      courses: "Cursos",
      type: "Tipo de art\xEDculo",
      noResultsLayer: "No se encontr\xF3 ningun modificador en este grupo que coincida con la b\xFAsqueda",
      noResultsLayerGlobalActive: "No se encontr\xF3 ningun modificador en el men\xFA que coincida con la b\xFAsqueda",
      searchAllMods: "Buscar todos los Mods",
      itemStockCount: "Hay: {{stockCount}}",
      taxInc: "Tax Inc"
    },
    seating: {
      prompt: "Elegir Asiento",
      seatLabel: "Asiento {{seatId}}",
      seatColonLabel: "Asiento: {{seatId}}",
      nextSeat: "Sig.",
      seatNumber: "N\xDAMERO DE ASIENTO",
      share: "Compartir",
      seatManagement: "GESTI\xD3N DE ASIENTOS",
      unassignedQuantity: "{{quantity}} SIN ASIGNAR",
      addSeat: "Agregar asiento",
      forTable: "Al Centro",
      noSeat: "Sin Asignar",
      emptySeating: "Seleccionar",
      allSeats: "Todos los asientos",
      noTagsFound: "No hay etiquetas",
      clearTags: "Limpiar etiquetas",
      resetAllTags: "Limpiar todas",
      cannotDecrementSeatsModal: {
        title: "Minimo de asientos: {{minSeats}}",
        description: "Existen articulos o cuentas relactionadas a los asientos que se estan intentando remover en la orden acutal."
      },
      multiSeat: "Multi Asiento"
    },
    tabs: {
      sortBy: "Ordenar Por",
      startTime: "Hora de Inicio",
      status: "Estatus",
      orderNumber: "N\xFAmero de Orden"
    }
  },
  app: {
    modals: {
      similarItems: {
        title: "{{count}} Articulos Similares Encontrados",
        description: "Existen articulos ({{count}}) que tienen un nombre similar al ingresado. Quieres editar alguno de ellos en lugar de crear uno nuevo?",
        btnSuccessText: "Crear Nuevo Articul"
      },
      prepStation: {
        title: "Selecci\xF3n de Ubicaci\xF3n de Impresora",
        description: "El art\xEDculo seleccionado no posee una Ubicaci\xF3n de Impresora asignada, por favor seleccione una:",
        noPrepStations: "No hay Ubicaciones disponibles.",
        noPrepStation: "Sin Ubicaci\xF3n"
      },
      guestCheckDiffModal: {
        itemSortPriority: {
          sortItemsBy: "Ordenar Elementos por",
          secondSortItemsBy: "Segunda prioridad de orden"
        }
      },
      guestReceiptDiffModal: {
        basic: {
          showLogo: "Mostrar Logo",
          showCheckTotals: "Mostrar totales de la cuenta",
          printMerchantCopy: "Imprimir copia del comerciante",
          fontSize: "Tama\xF1o de Fuente",
          fontWeight: "Cuerpo de Fuente",
          spaceBetweenItems: "Espacio entre elementos",
          showSuggestedTips: "Mostrar propinas sugeridas",
          showTipTotalLines: "Imprimir linea Propina/Total",
          tipOption1: "Opci\xF3n de Propina 1",
          tipOption2: "Opci\xF3n de Propina 2",
          tipOption3: "Opci\xF3n de Propina 3",
          showFooterDescription: "Mostrar descripci\xF3n del pie de p\xE1gina",
          footerDescription: "Descripci\xF3n del pie de p\xE1gina",
          showTaxesIndividually: "Mostrar impuestos individualmente",
          printOrderQr: "Imprimir C\xF3digo QR del # de Orden en pie de p\xE1gina"
        },
        items: {
          showItems: "Mostrar Elementos",
          showItemUnitPrice: "Mostrar precio unitario del elemento",
          displayDefaultModifiers: "Mostrar modificador por defecto",
          groupSameModItems: "Agrupar los mismos modificadores de elemento",
          noForDeselectedDefaultModifiers: '"No" para los modificadores por defecto deseleccionados',
          hideModGroupTitles: "Esconder titulo del modificador de grupo",
          addSubForMultiSelectOff: 'Agregar "Sub" cuando la selecci\xF3n multiple este apagada',
          printZeroForFreeModItems: "Imprimir $0.00 para los mod de elementos gratis",
          onlyPrintModItemsWithPrice: "Solo imprimir mod de elementos con precio",
          modifierItemDisplayMode: "Tipo de visualizaci\xF3n del modificador"
        }
      },
      deactivateLicenseFromDevice: {
        title: "Desactivar Licencia",
        description: "\xBFEst\xE1s seguro de que quieres desactivar la licencia"
      },
      userDetailsDiffModal: {
        basic: {
          active: "Estado",
          email: "Correo electr\xF3nico",
          firstName: "Nombre",
          lastName: "Apellidos",
          phoneNumber: "Tel\xE9fono",
          posName: "Nombre de POS",
          payrollId: "ID de N\xF3mina",
          pin: "PIN",
          locationIds: "Ubicaciones",
          roleIds: "Roles",
          webPortalAccess: "Acceso al Portal Web"
        },
        associations: {
          locations: "Ubicaciones",
          roles: "Roles"
        }
      },
      rolesDiffModal: {
        basic: {
          active: "Activo",
          name: "Nombre",
          posName: "Nombre de POS",
          backgroundColor: "Color de fondo",
          textColor: "Color de texto"
        },
        home: {
          registerModuleDefault: "M\xF3dulo de Registro",
          menuModuleDefault: "M\xF3dulo de Men\xFA",
          settingsModuleDefault: "M\xF3dulo de Configuraciones",
          managementModuleDefault: "M\xF3dulo de Gesti\xF3n",
          reportsModuleDefault: "M\xF3dulo de Reportes",
          customersModuleDefault: "M\xF3dulo de Clientes",
          defaultModule: "Abrir autom\xE1ticamente desde la pantalla de bloqueo",
          requireClockInOnPrompt: "Requerir checar entrada al iniciar sesi\xF3n"
        },
        endOfDay: {
          viewShiftSummary: "Ver Resumen de Turno"
        },
        register: {
          registerModuleAvailable: "Permitir acceso a este M\xF3dulo",
          createOrders: "Crear Orden",
          deleteOrders: "Vaciar Orden",
          modifyItemsSentToKitchen: "Modificar Elementos enviados a cocina",
          editOtherUsersOrders: "Modificar una orden perteneciente a otra persona",
          transferOrderOwner: "Transferir el propietario de una orden",
          manageTables: "Gestionar Mesas",
          addAnyDiscount: "Aplicar Descuentos",
          addCustomDiscount: "Crear Descuentos Personalizados",
          overrideLicenseEditingId: 'Tomar el control de la "Edici\xF3n" Control de una orden',
          reprint: "Reimprimir Tickets",
          deletePrintJobs: "Eliminar Tareas de Impresi\xF3n",
          allowChangeMenuType: "Cambiar Men\xFA",
          editItemPrice: "Editar el precio del Elemento",
          allow86: "Permitir 86",
          behaviorOnNewOrder: "Comportamiento en Nueva Orden",
          createChecks: "Crear Cuentas",
          voidRefundPayments: "Anular/Reembolsar Pagos",
          createPayments: "Crear Pagos",
          batch: "Enviar Lote de Pagos",
          manageDrawers: "Gestionar Cajas",
          reopenClosedOrders: "Reabrir Ordenes Cerradas",
          transferPayments: "Transferir Pagos a otra Orden",
          viewDrawerBalance: "Ver Balance de Caja",
          serverBankEnabled: "Banco de Servidor Habilitado",
          allowCashPaymentsToDrawersNotAttached: "Permitir Pagos en Efectivo en Estaciones Sin Cajas",
          createOpenItemsOrModItems: "Crear Articulo Abierto o Elemento Modificador",
          allowNoTaxInclusive: 'Permitir "Sin Impuestos Incluidos"',
          exemptTax: "Impuesto exento",
          manageServiceCharges: "Gestionar cargos por servicio",
          qsrActionOnPay: "QSR - Acci\xF3n al Pagar/Enviar",
          defaultOrderType: "Tipo de Pedido Predeterminada",
          autoFilterTableTabsOrders: "Auto Filtrar Pedidos por Usuario",
          navigationActionOnSendButton: 'TSR - Acci\xF3n al "Enviar"',
          navigationActionOnDoneButton: 'TSR - Acci\xF3n en "Listo"',
          navigationActionOnSendButtontoolTip: 'Select what should happen when using the "send" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
          navigationActionOnSendStayButton: 'TSR - Acci\xF3n al "Enviar y Quedarse"',
          navigationActionOnSendStayButtontoolTip: 'Select what should happen when using the "send and stay" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
          defaultRegisterScreen: "Pantalla inicial por defecto",
          voidIndividualItems: "Anular Art\xEDculos Individuales",
          sendIndividualItems: "Enviar Art\xEDculos Individuales",
          makeHouseChargePayments: "Hacer Pagos de Cuenta de Casa",
          makeGiftCardPayments: "Hacer Pagos de Tarjeta de Regalo",
          navigationActionOnCloseOrder: 'Acci\xF3n al "Cerrar Orden"',
          navigationActionOnTipPending: 'Acci\xF3n al "Propina Pendiente"',
          viewPrinterCenter: "Ver Centro de Impresi\xF3n",
          changePrinterStatus: "Cambiar Estatus de la Impresora",
          transferPrintJobs: "Re-asignarl Impresora de Respaldo",
          reAssignBackupPrinter: "Transferir Trabajos de Impresi\xF3n",
          reprintClosedCheck: "Re-imprimir cuenta cerrada",
          reprintReceipt: "Re-imprimir recibo",
          refundTypeRefund: "Reembolsar",
          refundTypeAsDiscount: "Reembolsar como Descuento",
          refundTypeToBalanceDueOfZero: "Rembolso a Balance de cero",
          refundTypeReplacePayment: "Reemplazar Pago",
          printEndOfShiftReportOnClockOut: "Imprimir informe de fin de turno al checar salida",
          cashPaymentOptions: "Opciones de Pago en Efectivo"
        },
        menu: {
          menuModuleAvailable: "Permitir acceso a este M\xF3dulo",
          accessMasterMenu: "Acceso al Enterprise mode",
          massUpdate: "Actualizaci\xF3n masiva"
        },
        settings: {
          settingsModuleAvailable: "Permitir acceso a este M\xF3dulo",
          accessMasterSettings: "Acceso al Enterprise mode"
        },
        management: {
          managementModuleAvailable: "Permitir acceso a este M\xF3dulo"
        },
        reports: {
          reportsModuleAvailable: "Permitir acceso a este M\xF3dulo"
        },
        customers: {
          customersModuleAvailable: "Permitir acceso a este M\xF3dulo"
        },
        webHomeScreen: {
          dashboardIds: "Tableros",
          defaultDashboardId: "Tablero por defecto",
          noDefaultDashboardId: "Sin Tablero por defecto"
        }
      },
      registerTicketDiffModal: {
        ticketDisplay: {
          showTimestamps: "Mostar hora",
          showSendCourseButton: "Mostrar bot\xF3n de enviar curso",
          autoCollapseLineItems: "Colapsar automaticamente elementos de linea",
          displayDefaultModifiers: "Mostrar modificador por defecto",
          showModifierItemPrice: "Mostrar precio del modificador de elemento",
          hideModGroupTitles: "Esconder titulo del modificador de grupo",
          modifierItemDisplayMode: "Tipo de visualizaci\xF3n del modificador",
          groupSameModItems: "Agrupar los mismos modificadores de elemento",
          addSubForMultiSelectOff: 'Mostrar "Sub" para multiselecci\xF3n apagada',
          noForDeselectedDefaultModifiers: 'Mostrar "No" para mod de elemento deseleccionados',
          separateSentItems: "Separar Elementos Enviados"
        }
      },
      registerModeDiffModal: {
        general: {
          registerDisplay: {
            showModTagBar: "Mostrar barra de modificador de etiqueta",
            showConfirmPopupToRemoveItem: 'Mostrar "ventana de confirmaci\xF3n" para eliminar un elemento',
            showConfirmPopUpOnClearUnsentWithinAnItem: 'Mostrar "ventana de confirmaci\xF3n" al "borrar no enviados" dentro de un elemento',
            showSentItemModificationsOnRegisterTicket: "Mostar enviar modificaciones de Elementos",
            showConfirmPopUpOnLeaveIncompleteItem: 'Mostrar "ventana de confirmaci\xF3n" al navegar fuera de un art\xEDculo incompleto',
            showHotButtonToggle: "Mostrar botones rapidos",
            enforceItemGroupOrderForCombos: "Forzar el orden de los Grupos de Elementos en los combos",
            defaultRestaurantMode: "Modo de Restaurante",
            persistSelectedCategoryOnItemSelection: "Persistir la categor\xEDa seleccionada en la selecci\xF3n de art\xEDculos",
            showNotificationMessageForPrinterErrors: "Mostrar notificaciones de mensajes de error de impresora",
            showPrinterStatusNotifications: "Mostrar notificaciones de estado de impresora",
            firePositionOnRegisterTicket: "Posici\xF3n del envio en el ticket",
            showDoneButton: 'Mostrar Bot\xF3n de "Listo"',
            printHeldItems: "Imprimir elementos retenidos"
          },
          orderTypesAvailable: {
            isCateringAvailable: "Abastecimiento",
            isCurbsideAvailable: "Acera",
            isDeliveryAvailable: "Entrega",
            isDineInAvailable: "Cenar",
            isToGoAvailable: "Para llevar"
          },
          specialTags: {
            active: "Estatus",
            name: "Nombre",
            posName: "Nombre de POS",
            abbreviation: "Abreviaci\xF3n",
            specialTagId: "Etiqueta Especial",
            color: "Color",
            textColor: "Color de texto"
          },
          modifierTags: {
            active: "Estatus",
            name: "Nombre",
            posName: "Nombre de POS",
            checkName: "Nombre del Cheque",
            tagPosition: "Posici\xF3n de la Etiqueta",
            sortPriority: "Prioridad",
            menuTypeIds: "Men\xFAs"
          },
          discountReasons: {
            active: "Estatus",
            name: "Nombre",
            posName: "Nombre de POS",
            sortPriority: "Prioridad",
            isDiscount: "Razones de Anulado o Descuento",
            isVoid: "Razones de Anulado o Descuento"
          },
          timeBasedMenuType: {
            id: "No.",
            time: "Tiempo",
            day: "D\xEDa",
            startTime: "Desde",
            endTime: "Hasta",
            menuTypeId: "Men\xFA",
            defaultMenuTypeId: "Men\xFA por defecto"
          }
        },
        tags: {
          orderSeatTags: {
            sortPriority: "Prioridad",
            active: "Estatus",
            isOrderTag: "Etiqueta de orden o asiento",
            isSeatTag: "Etiqueta de orden o asiento",
            type: "Tipo",
            name: "Nombre",
            posName: "Nombre de POS",
            backgroundColor: "Color",
            textColor: "Color de texto",
            orderTagFavorite: "Orden Favorito",
            seatTagFavorite: "Asiento Favorito"
          },
          openItemTypes: {
            active: "Estatus",
            name: "Nombre",
            posName: "Nombre de POS",
            dontPromptOpenItemName: "No pedir nombre",
            sortPriority: "Prioridad",
            prepStationId: "Ubicacion de Impresora",
            taxIds: "Impuestos"
          }
        },
        tableService: {
          general: {
            seating: "Asientos",
            allowForTableButton: 'Mostrar bot\xF3n de asiento "Para mesa"',
            enableDragDropForSeatPopover: "Habilitar arrastrar y soltar para popover del asiento",
            ticketSeatBar: "Barra de boletos de asientos",
            showConfirmPopUpWhenSendingItemsInSeatView: "Mostrar mensaje de confirmaci\xF3n al enviar elementos en la vista de asiento",
            showSeatOneDescription: "Mostrar una descripci\xF3n de asiento",
            showSendItemsModal: 'Mostrar ventana al usar la tecla "Enviar"',
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: "No permitir la navegaci\xF3n cuando los art\xEDculos no han sido enviados a cocina",
            showIndicatorWhenItemsOnTicketNotSentToKitchen: 'Mostrar indicador de "Art\xEDculos no enviados a cocina"',
            seatingMode: "Modo de Asientos",
            prepStationForFireTicketId: "Ubicaci\xF3n de Impresora para Tickets Iniciados:",
            attachNoSeatToToGo: "Adjuntar asiento para llevar",
            keepTipPendingOrdersAssociatedToTable: "Mantener ordenes pendientes de propina asociadas a la mesa",
            enableMapLayoutDragAndDrop: "Habilitar arrastrar y soltar para la vista de mesas",
            showTableBorderForLoggedInUsersOrders: "Resaltar mesas del usuario",
            showOrderDetailsForNewOrderTsr: "Mostrar detalles de la orden en nueva orden",
            showOrderDetailsForDefaultNewOrder: "Mostrar detalles de la orden en la creaci\xF3n de la orden por defecto",
            showGuestCount: "Mostrar conteo de comensales",
            defaultGuestCountOnNewOrder: "Llenar el conteo de comensales automaticamente.",
            setGuestCountToZeroWhenNoTable: "Fijar conteo de comensales a 0 cuando no hay mesa",
            setGuestCountToZeroOnToGoOrders: "Fijar conteo de comensales a 0 en ordenes para llevar",
            seatManagementButtonFunction: "Funci\xF3n del bot\xF3n de manejo de asientos"
          },
          tableLayout: {
            showSeatsOnTableLayout: "Mostrar el n\xFAmero de asientos para la mesa",
            showTimerOnTableLayout: "Mostrar estatus de temporizador",
            useCleaningStatusOnTableLayout: 'Usar estatus "Limpiando"',
            allowOpenTabsOnTableLayout: "Permitir pesta\xF1as abiertas"
          },
          coursing: {
            coursingMode: "Modo de cursado",
            coursing: "Cursado",
            autoTriggering: "Lanzado automatico",
            active: "Estatus",
            sortPriority: "Prioridad",
            name: "Transcurso",
            posName: "Nombre de POS",
            kitchenName: "Nombre de cocina",
            triggerTime: "Lanzado automatico (min)",
            groupRounds: "Agrupar Rondas"
          }
        },
        quickService: {
          general: {
            assignOrderTag: "Mostrar etiqueta de orden",
            sendOrderToKitchenTrigger: "Enviar orden a la cocina cuando",
            qsrSendAndPayActionButtons: "Enviar y Pagar botones de acci\xF3n",
            showOrderDetailsForNewOrderQsr: "Mostrar detalles de la orden en nueva orden"
          }
        },
        customerFacingDisplay: {
          general: {
            receiptScreenTimeout: "Tiempo de espera de la pantalla del recibo (segundos)",
            requireClientSignature: "Solicitar firma del cliente",
            payThroughCfdOnly: "Pagar solo por CFD",
            promptStarRatings: "Solicitar calificaci\xF3n de estrellas",
            darkMode: "Modo Obscuro",
            promptPrintReceipt: "Solicitar impresi\xF3n del recibo"
          },
          ads: {
            isFacebookActive: "Facebook",
            isXActive: "X",
            isInstagramActive: "Instagram",
            facebookAccount: "Nombre de usuario de Facebook",
            xAccount: "Nombre de usuario de X",
            instagramAccount: "Nombre de usuario de Instagram",
            placeholderBackground: "Fondo del Marcador",
            adTextBackground: "Fondo del texto del anuncio",
            mediaLinksBackground: "Texto/Enlaces de redes sociales"
          },
          tips: {
            showTippingOptionsAtCheckout: "Solicitar propina",
            showCfdTipSelectionOnRegister: "Mostrar propina al cajero",
            defaultSuggestedTip: "Propina sugerida por defecto",
            suggestedTip1: "Opci\xF3n de Propina 1",
            suggestedTip2: "Opci\xF3n de Propina 2",
            suggestedTip3: "Opci\xF3n de Propina 3"
          },
          adsTable: {
            sortPriority: "Prioridad",
            active: "Activo",
            imageUrl: "Imagen",
            title: "Titulo",
            text: "Texto",
            price: "Precio"
          }
        },
        endOfDay: {
          clockOut: {
            requireNoOpenOrders: "Requerir Cero Ordernes abiertas",
            requireNonCashTips: "Requerir no propinas en efectivo",
            requireServerBankSettlement: "Requerir liquidaci\xF3n del banco del servidor",
            netNonCashTipsOnSettlement: "Propinas en liquidaci\xF3n",
            requireCashtipReporting: "Requerir informes de propinas en efectivo",
            requireDrawerSettlement: "Requerir liquidaci\xF3n de caja",
            displayTipsDueInHeader: "Mostrar Propinas Pendientes en Encabezado del Reporte de Turno",
            zeroTipsDueOnClockOut: "Volver cero Propinas pendientes al checar salida",
            autoSettleDrawerId: "Cerrar Caja Autom\xE1ticamente"
          }
        }
      },
      prepStationsDiffModal: {
        active: "Estado",
        name: "Nombre",
        posName: "Nombre de POS",
        printerIds: "Impresora (s)",
        defaultPrepStationId: "Ubicacion de Impresora por defecto"
      },
      kitchenTicketDiffModal: {
        prepStations: {
          applyChangesToOtherPrepStation: {
            title: "Aplicar a otras Ubicaciones de Impresoras",
            buttonTitle: "Aplicar estos cambios a otras Ubicaciones de Impresoras",
            description: "Selecciona las Ubicaciones de Impresoras a los cuales aplicar los cambios",
            applyChanges: "Aplicar cambios",
            selectAllPrepStations: "Seleccionar todas las Ubicaciones de Impresoras",
            applyChangesToAllPrepStations: "Aplicar a Todas las Ubicaciones de Impresoras"
          }
        },
        ticketDisplay: {
          showCheckTotals: "Mostrar totales de cheque",
          showSuggestedTips: "Mostrar propinas sugeridas",
          showTipTotalLines: "Imprimir linea Propina/Total",
          tipOptionOne: "Opci\xF3n de propina 1",
          tipOptionTwo: "Opci\xF3n de propina 2",
          tipOptionThree: "Opci\xF3n de propina 3",
          showFooterDescription: "Mostrar descripci\xF3n del pie de p\xE1gina",
          footerDescription: "Descripci\xF3n del pie de p\xE1gina",
          showItems: "Mostrar art\xEDculos",
          showLogo: "Mostrar Logo",
          fontSize: "Tama\xF1o de Fuente",
          printUnfiredItems: "Imprimir elementos no iniciados",
          printModifications: "Imprimir modificaciones",
          showCourses: "Mostrar Cursos",
          showOrderTags: "Mostrar Etiquetas De Orden",
          showSeatTags: "Mostrar Etiquetas De Asiento",
          headerBlankSpace: "Espacio vacio en la cabecera",
          elementSpacing: "Espacio entre elementos",
          orderTagsFontSize: "Tama\xF1o de Fuente de las etiquetas de orden",
          orderTagColors: "Colores de etiqueta de orden",
          displayDefaultModifiers: "Mostrar modificador por defecto",
          consolidateByItem: "Consolidar por elemento",
          hideModGroupTitles: "Esconder titulo del modificador de grupo",
          groupSameModItems: "Agrupar los mismos modificadores de elemento",
          addSubForMultiSelectOff: 'Agregar "Sub" cuando la selecci\xF3n multiple este apagada',
          noForDeselectedDefaultModifiers: '"No" para los modificadores por defecto deseleccionados',
          modifierItemDisplayMode: "Tipo de visualizaci\xF3n del modificador",
          colorOfModifierItems: "Color de los modificadores de elemento",
          groupBySeat: "Agrupar por asiento",
          updateOrderNewText: "Nuevo Elemento",
          updateOrderVoidText: "Elemento Anulado",
          updateOrderTextPosition: "Posici\xF3n para el texto del Elemento actualizado",
          updateOrderTextColor: "Color del Texto",
          printPriceForFreeModItems: "Imprimir $0.00 para los mod de elementos gratis",
          onlyPrintModItemsWithPrice: "Solo imprimir mod de elementos con precio",
          showItemUnitPrice: "Mostrar precio unitario del elemento",
          taxIndicatorPosition: "Posici\xF3n del Indicador",
          taxIndicatorColor: "Color del Indicador",
          taxIndicator: "Indicador de Impuestos",
          taxExemptIndicator: "Indicador de exenci\xF3n de impuestos",
          showTaxIndicator: "Mostar Indicador de Impuestos",
          fontWeight: "Cuerpo de Fuente",
          sortItemsBy: "Ordenar Elementos por",
          secondSortItemsBy: "Segunda prioridad de orden",
          customTypeNameDineIn: "Nombre personalizado para cenar",
          customTypeNameCurbside: "Nombre personalizado para acera",
          customTypeNameToGo: "Nombre personalizado para llevar",
          customTypeNameDelivery: "Nombre personalizado para entrega",
          customTypeNamePickup: "Nombre personalizado para recoger",
          showCourseName: "Mostrar el nombre del curso",
          changeNoSeatTextInToGoOrders: "Cambiar Texto Sin Asiento En Ordenes Para Llevar",
          showTaxesIndividually: "Mostrar impuestos individualmente",
          printOrderQr: "Imprimir C\xF3digo QR del # de Orden en pie de p\xE1gina"
        }
      },
      generalSettingsDiffModal: {
        information: {
          name: "N/A",
          websiteUrl: "N/A",
          phoneNumber: "N/A",
          digitalLogoUrl: "Logo Digital",
          printLogoUrl: "Logo de Impresi\xF3n",
          organizationPhoneNumber: "N\xFAmero de tel\xE9fono de la organizaci\xF3n",
          locationPhoneNumber: "N\xFAmero de tel\xE9fono de la localizaci\xF3n",
          organizationName: "Nombre de la organizaci\xF3n",
          organizationWebsiteUrl: "Sitio Web de la organizaci\xF3n",
          locationName: "Nombre de la localizaci\xF3n",
          locationWebsiteUrl: "Sitio Web de la localizaci\xF3n",
          streetLine1: "Calle",
          streetLine2: "Calle 2",
          city: "Ciudad",
          state: "Estado",
          postalCode: "C\xF3digo Postal"
        },
        general: {
          clockInMode: "Comportamiento al marcar entrada",
          pinpadLayout: "Dise\xF1o del Pinpad",
          allowUserToBeLoggedIntoMultipleTablets: "Permitir al Usuario Iniciar Sesi\xF3n en Multiples Dispositivos"
        },
        hoursOfOperation: {
          changes: {
            timeZone: "Zona horaria",
            endOfBusinessDay: "Final Del D\xEDa H\xE1bil"
          },
          hoursOfOperation: {
            day: "D\xEDa",
            startTime: "Desde",
            endTime: "Hasta"
          }
        }
      },
      customersDiffModal: {
        basic: {
          firstName: "Nombre",
          middleName: "Segundo Nombre",
          lastName: "Apellido",
          dateOfBirth: "Fecha de Nacimiento",
          email: "Correo Electr\xF3nico",
          phoneNumber: "Numero de Telefono",
          customerNotes: "Notasl del Cliente"
        },
        addressInfo: {
          isDefault: "Por Defecto",
          addressType: "Tipo de Direcci\xF3n",
          addressName: "Nombre del Hotel/Oficina",
          unitNumber: "# de Unidad",
          streetLine1: "Calle 1",
          streetLine2: "Calle 2",
          state: "Estado",
          city: "Ciudad",
          postalCode: "C\xF3digo Postal",
          hotelName: "Nombre del hotel",
          roomNumber: "# de cuarto",
          officeName: "Nombre de la oficina",
          apartmentNumber: "# de departamento"
        }
      },
      freshSheetDiffModal: {
        items: {
          currentAmount: "Cantidad Disponible",
          is86ed: "Es 86",
          freshSheetSortPriority: "Orden",
          name: "Nombre"
        }
      },
      reportingGroupsDiff: {
        changes: {
          name: "Nombre",
          active: "Estatus",
          itemIds: "Articulos",
          comboIds: "Combos"
        }
      },
      itemsDiff: {
        linkedModifierItems: {
          shareNames: "Compartir Nombres",
          sharePrice: "Compartir Precio",
          shareMods: "Compartir Mods"
        },
        guestCheckDisplay: {
          showModifiers: "Mostrar Modificadores",
          showModItemPrice: "Mostrar el precio de los modificadores de Elemento"
        },
        prepStationsChanges: {
          showPrepStationSelectionModal: "Mostrar el modal de selection de Ubicacion de Impresora"
        },
        modifierGroupsExtra: {
          showAllMods: 'Mostar "Todos los Mods"',
          allModsBehavior: 'Comportamiento de "Todos los Mods"',
          showAllModsAlphabetizeButtons: 'Mostar Botones Alfabeticos de "Todos los Mods"',
          showAllModsHalfSizeButtons: 'Botones mitad de tama\xF1o de "Todos los Mods"'
        },
        sectionTitles: {
          changesByMenuTypes: "CAMBIOS POR Men\xFA",
          register: "REGISTRO",
          pricing: "PRECIOS",
          modifierGroups: "MODIFICADORES",
          premadeModifierGroups: "GRUPO MODIFICADOR PRE-HECHO",
          suggestiveOrdering: "ORDEN SUGERIDA",
          inventory: "INVENTARIO",
          prepStations: "UBICACIONES DE IMPRESORAS"
        },
        menuType: {
          description: "Selecciona el Men\xFA para ver sus cambios",
          newMenuType: "Nuevo",
          newModifierGroup: "Nuevo",
          menuTypeRemoved: "Has eliminado este Men\xFA",
          applyChangesToOtherMenuTypes: {
            buttonTitle: "Aplicar estos cambios a otros Men\xFAs",
            title: "Aplicar cambios a otros Men\xFAs",
            description: "Selecciona los Men\xFAs a los cuales aplicar los cambios",
            applyChanges: "Aplicar cambios",
            selectAllMenuTypes: "Seleccionar todos los Men\xFAs",
            deselectAllMenuTypes: "Deseleccionar todos los Men\xFAs"
          }
        },
        master: {
          name: "Nombre",
          customId: "ID Personalizado",
          categoryId: "Categor\xEDa",
          subcategoryId: "Subcategor\xEDa",
          locationIds: "Ubicaciones",
          linkedModifierItems: "Modificador(es) de Elemento vinculado(s)",
          reportingGroupIds: "Grupos de Reporte",
          removeReportingGroupIds: "Remover Grupos de Reporte"
        },
        basic: {
          name: "Nombre",
          posName: "Nombre de POS",
          kdsName: "Nombre en Cocina",
          checkName: "Nombre en Cuenta",
          onlineName: "Nombre en L\xEDnea",
          courseId: "Curso",
          allowSharing: "Permitir divisi\xF3n",
          active: "Estatus",
          activeOnline: "Ocultar art\xEDculo en l\xEDnea",
          delivery: "Deshabilitar entrega",
          calories: "Calorias",
          prepTime: "Tiempo de preparaci\xF3n",
          restrictions: "Restricciones",
          ageRestricted: "Restricci\xF3n de edad",
          ageThreshold: "A partir de",
          imageUrl: "Imagen del art\xEDculo",
          secondaryImageUrl: "Imagen secundaria",
          defaultNoSeat: "Sin Asignar Por Defecto",
          required: "Hacer Requerido"
        },
        registerInfo: {
          transparentBackground: "Fondo Transparente",
          hideItemName: "Ocultar el nombre del Elemento",
          hideComboName: "Ocultar el nombre del Combo",
          customizer: "Customizador",
          customizerShape: "Forma del customizador",
          backgroundColor: "Color de fondo",
          textColor: "Color de texto",
          kdsColor: "Color en Cocina",
          specialTagId: "Etiqueta Especial",
          displayPictureOnCard: "Monstar imagen en la tarjeta del Elemento",
          enterItemDetails: "Ingresar detalles de elementos al agregarlo al ticket",
          exitItemDetailsOnRequiredModCompletion: " Salir de los detalles del articulo al completarlo",
          displayItemPriceOnRegister: "Mostrar el precio del Elemento en el Registro",
          displayComboPriceOnRegister: "Mostrar el precio del Combo en el Registro",
          doneIsForTable: '"Listo" es "Para la mesa"'
        },
        moreInfo: {
          description: "Descripci\xF3n",
          onlineDescription: "Descripci\xF3n en l\xEDnea",
          recipe: "Receta"
        },
        ingredientsExtra: {
          showIngredients: "Mostrar Ingredientes"
        },
        pricing: {
          itemPrice: "Precio base del art\xEDculo",
          onlinePrice: "Precio venta en l\xEDnea",
          deliveryPrice: "Precio de entrega",
          toGoPrice: "Precio para llevar",
          taxInclusive: "Incluye impuestos",
          excludeFromSuggestedTip: "Excluir de la propina sugerida",
          defaultModifiersPrice: "Precio Total",
          itemPriceNormal: "Precio del art\xEDculo",
          modPrice: "Precio del modificador",
          total: "Total",
          excludeFromDiscounts: "Excluir de los descuentos",
          removeFromCheck: "Remover de la cuenta",
          comboBasePrice: "Precio Base Del Combo",
          promptForPrice: "Solicitar Precio",
          taxExempt: "Excensi\xF3n de impuestos"
        },
        dimensions: {
          dimensionsSellBy: "Vender Por",
          dimensionsVolumePerUnit: "Volumen Por Unidad",
          dimensionsWeightPerUnit: "Peso Por Unidad",
          dimensionsVolumeUnit: "Unidad de Volumen",
          dimensionsWeightUnit: "Unidad de Peso"
        },
        inventory: {
          initialAmount: "Cantidad inicial",
          currentAmount: "Cantidad actual",
          resetStockDaily: "Resetear las existencias diario",
          showOnFreshSheet: "Mostrar en frescos",
          noCurrentStock86Item: "Poner art\xEDculo en 86 cuando las existencias sean 0",
          resetStockToInitialAtZero: "Resetear las existencias cuando sean 0",
          trackInventory: "Seguimiento de inventario",
          is86ed: "Es 86",
          actionWhenCurrentStockZero: "Acci\xF3n cuando el inventario llegue a 0",
          showQuantityOnItemCard: "Mostar monto en tarjeta",
          volume: "Volumen",
          unit: "Unidad",
          universalProductCode: "UPC"
        },
        suggestiveOrdering: {
          suggestiveOrdering: "El art\xEDculo tiene un pedido sugerido",
          suggestiveOrderingItemPrice: "Sugerir precio especial",
          suggestiveOrderingPrompt: "Sugerir",
          suggestiveOrderingItemId: "Elemento"
        },
        modifierGroup: {
          active: "Estatus",
          requiredModifierItems: "Requerido",
          includedModifierItems: "Incluido",
          maximumModifierItems: "Maximos",
          defaultModifierGroupPricingVersionId: "Versi\xF3n del precio",
          sortPriority: "Prioridad",
          selectedDefault: "Seleccionados por defecto",
          defaultSelectionPrice: "Precio del modificador",
          advancedModifier: "Modificador Avanzado",
          isAllMod: "Pre-Hecho"
        },
        modifierItem: {
          defaultQuantitySelected: "Cantidad por defecto",
          defaultAmountSelected: "Monto por defecto",
          isSelected: "Seleccionado",
          active: "Estatus",
          includedMasterPrice: "Precio incluido",
          additionalMasterPrice: "Precio adicional",
          includedLightPrice: "Ligero incluido",
          includedRegularPrice: "Regular incluido",
          includedExtraPrice: "Extra incluido",
          additionalLightPrice: "Ligero adicional",
          additionalRegularPrice: "Regular adicional",
          additionalExtraPrice: "Extra adicional",
          maximumQuantity: "Cantidad Maxima"
        },
        taxes: {
          isActive: "Activo",
          menuTypeInheritedTaxes: "Impuestos de Men\xFA Heredados",
          categoryInheritedTaxes: "Impuestos de Categor\xEDa Heredados",
          subcategoryInheritedTaxes: "Impuestos de Subcategor\xEDa Heredados",
          taxIds: "Impuestos Personalizados de Articulo"
        }
      },
      combosDiff: {
        sectionTitles: {
          itemGroups: "GRUPOS DE ELEMENTOS"
        },
        menuType: {
          description: "Selecciona el Men\xFA para ver sus cambios",
          newItemGroup: "Nuevo Grupo de Elementos"
        },
        itemGroup: {
          posName: "Nombre",
          required: "Requerido",
          active: "Activo",
          sortPriority: "Prioridad",
          quantity: "Cantidad"
        },
        itemOfItemGroup: {
          active: "Activo",
          additionalPrice: "Sobrecargo",
          sortPriority: "Prioridad"
        },
        registerInfo: {
          displayPictureOnCard: "Monstar imagen en la tarjeta del Combo"
        },
        taxes: {
          isActive: "Activo",
          menuTypeInheritedTaxes: "Impuestos de Men\xFA Heredados",
          categoryInheritedTaxes: "Impuestos de Categor\xEDa Heredados",
          subcategoryInheritedTaxes: "Impuestos de Subcategor\xEDa Heredados",
          taxIds: "Impuestos Personalizados de Combo"
        }
      },
      specialsDiff: {
        master: {
          name: "Nombre"
        },
        sectionTitles: {
          specialsScheme: "ESQUEMA DE ESPECIALES",
          availability: "DISPONIBILIDAD"
        },
        menuType: {
          description: "Selecciona el Men\xFA para ver los cambios del especial."
        },
        specialsScheme: {
          specialApplyTo: "Aplicar a",
          discountType: "Tipo de descuento",
          discountAmountPercentage: "Porcentaje de Descuento",
          discountAmount: "Cantidad del Descuento",
          thresholdAmount: "Cantidad L\xEDmite",
          buyQuantity: "Compra",
          getQuantity: "Obtienes"
        },
        getItemsFields: {
          mimicItems: "Imitar Comprar Elementos",
          buyItemIds: {
            title: {
              bogo: {
                combos: "Combos de compra",
                items: "Elementos de compra"
              },
              item: {
                combos: "Combos",
                items: "Elementos"
              }
            }
          },
          getItemIds: {
            title: {
              bogo: {
                combos: "Obtener Combos",
                items: "Obtener Elementos"
              }
            }
          }
        }
      },
      menuTypesDiffModal: {
        sectionTitles: {
          taxes: "IMPUESTOS",
          associations: "ASOCIACIONES"
        },
        basic: {
          active: "Estatus",
          posName: "Nombre de POS",
          enableSimpleMode: "Modo simple (Sin barras de categor\xEDas)",
          comboDisplayName: "Nombre de visualizaci\xF3n del Combo",
          coursingType: "Tipo de tiempos",
          defaultToHomeScreen: "Ir a pantalla de inicio despu\xE9s de seleccionar un elemento"
        },
        master: {
          name: "Nombre",
          itemIds: "Art\xEDculos",
          categoryIds: "Categorias",
          comboIds: "Combos"
        },
        moreInfo: {
          description: "Description"
        }
      },
      discountsDiffModal: {
        sectionTitles: {
          taxes: "IMPUESTOS",
          associations: "ASOCIACIONES"
        },
        basic: {
          active: "Estatus",
          posName: "Nombre de POS",
          checkName: "Nombre de Cuenta",
          requireReason: "Requiere Raz\xF3n"
        },
        master: {
          name: "Nombre",
          locationIds: "Localizaciones"
        },
        moreInfo: {
          description: "Descripci\xF3n"
        },
        discountScheme: {
          applyTo: "Aplicar A",
          type: "Tipo de Descuento",
          value: {
            percentage: "Porcentaje del Descuento",
            amount: "Monto del Descuento"
          },
          exclusive: "Descuento Exclusivo",
          taxes: "Impuestos"
        }
      },
      subcategoriesDiffModal: {
        master: {
          name: "Nombre",
          categoryId: "Subcategor\xEDa"
        },
        basic: {
          posName: "Nombre de POS",
          active: "Estatus",
          backgroundColor: "Color de fondo",
          textColor: "Color de texto",
          customizer: "Subcategor\xEDa Customizable",
          imageUrl: "Imagen",
          description: "Descripci\xF3n"
        },
        moreInfo: {
          description: "Descripci\xF3n"
        },
        associations: {
          itemIds: "Articulos",
          comboIds: "Combos"
        }
      },
      categoriesDiffModal: {
        master: {
          name: "Nombre",
          childrenType: "Categor\xEDa Relacionada",
          customizer: "Categor\xEDa Customizable"
        },
        basic: {
          posName: "Nombre de POS",
          active: "Estatus",
          backgroundColor: "Color de fondo",
          textColor: "Color de texto"
        },
        moreInfo: {
          description: "Descripci\xF3n"
        },
        associations: {
          itemIds: "Art\xEDculos",
          subcategoryIds: "Subcategor\xEDas",
          comboIds: "Combos"
        }
      },
      modifierItemsDiffModal: {
        newPricingVersion: "Nuevo",
        sectionTitles: {
          pricing: "PRECIOS"
        },
        master: {
          name: "Nombre"
        },
        basic: {
          posName: "Nombre de POS",
          kdsName: "Nombre en Cocina",
          checkName: "Nombre de Cuenta",
          onlineName: "Nombre en L\xEDnea",
          active: "Activo",
          removeItemTaxExempt: "Remover exenci\xF3n de impuestos del art\xEDculo"
        },
        pricing: {
          description: "Selecciona la versi\xF3n de precio para ver la informaci\xF3n",
          pricingVersionRemoved: "Has eliminado esta versi\xF3n de precios",
          name: "Nombre",
          includedMasterPrice: "Precio Incluido",
          additionalMasterPrice: "Precio Adicional",
          quarterPricePercent: "Precio de la cuarta parte",
          halfPricePercent: "Precio de la mitad",
          includedLightPrice: "Precio chico incluido",
          includedRegularPrice: "Precio Regular incluido",
          includedExtraPrice: "Precio extra incluido",
          additionalLightPrice: "Precio adicional chico",
          additionalRegularPrice: "Precio adicional regular",
          additionalExtraPrice: "Precio adicional extra",
          onSidePrice: "Precio de un lado"
        }
      },
      modifierGroupsDiffModal: {
        newModifierItem: "Nuevo Art\xEDculo",
        selectedDefault: "Seleccionado por default",
        pricingVersionRemoved: "Has eliminado esta versi\xF3n de precios",
        sectionTitles: {
          associations: "ASOCIACIONES",
          modifierItems: "Art\xEDculos de Modificadores"
        },
        master: {
          name: "Nombre"
        },
        basic: {
          posName: "Nombre de POS",
          kdsName: "Nombre en Cocina",
          checkName: "Nombre de Cuenta",
          onlineName: "Nombre en L\xEDnea",
          active: "Activo",
          multiselect: "Selecci\xF3n multiple",
          allowNoneSelection: 'Permitir selecci\xF3n "Ninguno"',
          requiredModifierItems: "Art\xEDculos requeridos",
          includedModifierItems: "Art\xEDculos incluidos",
          maximumModifierItems: "Art\xEDculos Maximos",
          quantityMode: "Tipo de cantidad",
          priceCalcMode: "Modo de precios",
          activeCustomizerSectionSelector: "Activar seccion de selector de pizza",
          hidePriceIfFree: "Ocultar precio si es gratis",
          showModGroupTitleOnRegisterTicket: "Mostrar t\xEDtulo de grupos modificadores en ticket de registro",
          showModGroupTitleOnKitchenTicket: "Mostrar t\xEDtulo de grupos modificadores en ticket de cocina",
          guestCheck: "Mostrar t\xEDtulo de grupos modificadores en Cuenta de Invitado",
          advancedModifier: 'Mostrar en "M\xE1s modificadores"',
          showSearchBar: "Mostrar barra de busqueda",
          searchAllModifierItems: "Buscar todos los Elementos Modificadores",
          global: "Modificador global",
          enableModTags: "Habilitar Etiquetas Modificadoras",
          enableQuantityBar: "Habilitar Barra de Cantidad",
          customizerSlicing: "Rebanado de la Pizza"
        },
        register: {
          backgroundColor: "Fondo",
          textColor: "Texto"
        },
        associations: {
          description: "Selecciona la versi\xF3n del precio para ver la informaci\xF3n"
        },
        modifierItem: {
          active: "Estatus",
          isSelected: "Seleccionado",
          defaultQuantitySelected: "Cantidad por defecto",
          defaultAmountSelected: "Monto por defecto",
          includedMasterPrice: "Precio Incluido",
          additionalMasterPrice: "Precio Adicional",
          quarterPricePercent: "Precio de la cuarta parte",
          halfPricePercent: "Precio de la mitad",
          includedLightPrice: "Precio chico incluido",
          includedRegularPrice: "Precio Regular incluido",
          includedExtraPrice: "Precio extra incluido",
          additionalLightPrice: "Precio adicional chico",
          additionalRegularPrice: "Precio adicional regular",
          additionalExtraPrice: "Precio adicional extra",
          sortPriority: "Prioridad",
          defaultSelectionPrice: "Precio del art\xEDculo",
          linesBefore: "Salt. Liena",
          spacesBefore: "Espacio",
          maximumQuantity: "Cantidad Maxima"
        },
        modifierGroupPricingVersions: {
          name: "Nombre",
          modItemPricingVersions: "Versi\xF3n del precio"
        }
      },
      itemMassUpdate: {
        title: "Actualizaci\xF3n de elementos masiva",
        description: "Por favor seleccione los parametros que determinar\xE1n que grupos de elementos ser\xE1n actualizados y el campo que editar\xE1.",
        itemsIn: {
          label: "Selecciona los elementos en"
        },
        fieldToChange: {
          label: "Campo a cambiar",
          options: {
            taxes: "Impuestos"
          }
        },
        itemsToBeUpdated: {
          label: "Elementos a actualizar"
        },
        buttons: {
          selectItems: "Seleccionar {{count}} elementos"
        },
        categoryOrSubcategory: "Categor\xEDa o Subcategor\xEDa",
        menuTypesPlaceholder: "Selecciona Men\xFAs",
        confirmationTitle: "Entrando al modo de Actualizaci\xF3n de elementos masiva",
        confirmation: "Est\xE1 a punto de modificar {{count}} elementos. Los cambios realizados en estos elementos no se pueden revertir en el futuro. \xBFQuiere continuar?"
      },
      loadingAdd: {
        items: "Agregando Elementos existentes",
        discounts: "Agregando Descuentos existentes",
        combos: "Agregando Combos existentes",
        specials: "Agregando Especiales existentes",
        itemGroups: "Agregando Grupos de Elementos existentes",
        reportingGroups: "Agregando Grupos de Reporte existentes",
        menuTypes: "N/A",
        ingredients: "N/A",
        hotButtons: "N/A",
        modifierGroups: "N/A",
        modifierItems: "N/A",
        categories: "N/A",
        subcategories: "N/A"
      },
      selectLocation: {
        title: "Aplicar a otras ubicaciones",
        selectAll: "SELECCIONAR TODO"
      },
      diffModal: {
        reviewChanges: "Revisar Cambios",
        descriptionForSave: "Por favor revise sus cambios. Cuando termine, haga clic en \u201CGuardar\u201D.",
        youHaveUnsavedChanges: "Tiene cambios no guardados para {{bucket}}.",
        descripTionForContinue: "Por favor revise sus cambios y haga clic en \u201CContinuar\u201D.",
        sectionTitles: {
          basic: "B\xC1SICO",
          commonChanges: "CAMBIOS COMUNES",
          changesByMenuTypes: "CAMBIOS POR Men\xFA",
          massUpdateChanges: "CAMBIOS DE ACTUALIZACI\xD3N MASIVA",
          moreInformation: "M\xC1S INFORMACI\xD3N",
          ingredients: "INGREDIENTES",
          associations: "ASOCIACIONES",
          inventory: "INVENTARIO",
          discountScheme: "ESQUEMA DE DESCUENTO",
          taxes: "IMPUESTOS",
          guestCheckDisplay: "VISUALIZACI\xD3N DE CUENTA DE INVITADO",
          categoriesSubcategories: "CATEGOR\xCDAS Y SUBCATEGOR\xCDAS",
          pricingVersions: "VERSIONES DE PRECIOS",
          settings: {
            home: "INICIO",
            endOfDay: "CIERRE DE D\xCDA",
            register: "REGISTRO",
            menu: "MENU",
            settings: "CONFIGURACIONES",
            management: "GESTI\xD3N",
            roles: "ROLES",
            general: "GENERAL",
            organizationInformation: "INFORMACI\xD3N DE LA ORGANIZACI\xD3N",
            locationInformation: "INFORMACI\xD3N DE LA ORGANIZACI\xD3N",
            hoursOfOperation: "HORAS DE OPERACI\xD3N",
            ticketDisplay: "VISUALIZACI\xD3N DE CONFIGURACIONES DE TICKET",
            customizingReceipts: "PERSONALIZACI\xD3N DE RECIBOS",
            checkDisplay: "VISUALIZACI\xD3N DE CUENTA",
            itemSortPriority: "PRIORIDAD DE ORDEN DE ART\xCDCULO"
          }
        },
        changes: "Cambios",
        change: "Cambio",
        removed: "Removido"
      },
      discardChangesConfirmation: {
        title: "Descartar cambios",
        description: "\xBFDesea descartar los cambios realizados?"
      },
      infoConfirmationModal: {
        unsavedChanges: "Tienes cambios sin guardar",
        unsavedChangesMessage: "\xBFQuieres guardar tus cambios no guardados antes de salir?"
      },
      creationConfirmation: {
        continue: "Continuar Creaci\xF3n",
        exit: "Salir de Creaci\xF3n"
      },
      optionsModal: {
        selectedOptions: "Selected Options",
        noOptionsSelected: "No Options Selected",
        clearOptions: "Clear Options",
        selectedTags: "Selected Tags",
        noTagsSelected: "No Tags Selected",
        clearAllTags: "Clear All Tags",
        clearTags: "Clear Tags"
      },
      clone: {
        title: {
          items: "Clonando Elemento - {{name}}",
          menuTypes: "Clonando Men\xFA - {{name}}",
          modifierGroups: "Clonando Modificador de Grupo - {{name}}",
          modifierItems: "Clonando Modificador de Elemento - {{name}}",
          categories: "Clonando Categor\xEDa - {{name}}",
          subcategories: "Clonando Subcategor\xEDa - {{name}}",
          discounts: "Clonando Descuento - {{name}}",
          combos: "Clonando Combo - {{name}}",
          specials: "Clonando Especial - {{name}}",
          ingredients: "Clonando Ingrediente - {{name}}",
          settings: {
            roles: "Clonando Rol - {{name}}"
          },
          itemGroups: "Clonando Grupo de Elementos - {{name}}",
          reportingGroups: "Clonando Grupo de Reporte - {{name}}"
        },
        description: {
          items: "Por favor ingresa el nuevo nombre para este Elemento",
          menuTypes: "Por favor ingresa el nuevo nombre para este Men\xFA",
          modifierGroups: "Por favor ingresa el nuevo nombre para este Modificador de Grupo",
          modifierItems: "Por favor ingresa el nuevo nombre para este Modificador de Elemento",
          categories: "Por favor ingresa el nuevo nombre para esta Categor\xEDa",
          subcategories: "Por favor ingresa el nuevo nombre para esta Subcategor\xEDa",
          discounts: "Por favor ingresa el nuevo nombre para este Descuento",
          combos: "Por favor ingresa el nuevo nombre para este Combo",
          specials: "Por favor ingresa el nuevo nombre para este Especial",
          ingredients: "Por favor ingresa el nuevo nombre para este Ingrediente",
          settings: {
            roles: "Por favor ingresa el nuevo nombre para este Rol"
          },
          itemGroups: "Por favor ingresa el nuevo nombre para este Grupo de Ingredientes",
          reportingGroups: "Por favor ingresa el nuevo nombre para este Grupo de Reporte"
        },
        placeholder: "Ingresa el nuevo nombre"
      }
    },
    cannotDeleteMenuTypeModal: {
      title: "No se puede borrar este Men\xFA",
      description: "Para poder borrar primero debes asignar otro Men\xFA a los siguientes Articulos:"
    }
  },
  validations: {
    invalidCodePleaseTryAgain: "C\xF3digo inv\xE1lido. Por favor intenta de nuevo.",
    unsavedChanges: "Cambios sin guardar",
    settings: {
      timeBasedMenuTypeError: "Regla No.|divider|en el d\xEDa|divider|con Men\xFA|divider|tiene un rango inv\xE1lido.",
      prepStationVersionTitle: "Ubicacion de Impresora: {{prepStation}}"
    },
    includedModifierItemsInvalid: "Los Elementos Modificadores incluidos no pueden ser mayores al numero de Elementos Modificadores asociados.",
    requiredModifierItemsMIInvalid: "Los Elementos Modificadores requeridos no pueden ser mayores al numero de Elementos Modificadores asociados.",
    requiredModifierItemsInvalid: "El n\xFAmero de Elementos Modificadores requeridos tiene que ser igual o menor al de los Elementos Modificadores incluidos.",
    validationFailed: "Valores faltantes",
    subtitle: "Por favor resuelva los problemas siguientes y vuelva a intentar.",
    discardSubtitle: "Por favor resuelva los problemas siguientes y vuelva a intentar o descarta los cambios.",
    issues: "Problemas",
    issuesInMenuTypes: "Problemas en Men\xFAs en espec\xEDfico",
    nameRequired: "Nombre es obligatorio",
    posNameRequired: "Nombre de POS es obligatorio",
    invalidPin: "PIN es invalido",
    pinAlreadyInUse: "PIN ya est\xE1 en uso",
    firstNameRequired: "Nombres son obligatorios",
    lastNameRequired: "Apellidos son obligatorios",
    premadeModifierGroupRequired: "Grupo Modificadr Pre-Hecho requerido",
    phoneNumberRequired: "N\xFAmero de tel\xE9fono es obligatorio",
    emailRequired: "Debe introducir un correo electr\xF3nico v\xE1lido",
    categoryRequired: "Categor\xEDa es obligatoria",
    subcategoryRequired: "Subcategor\xEDa es obligatoria",
    categoryHasNoSubcategories: "La Categor\xEDa que has escogido no tiene ninguna Subcategor\xEDa, por favor cambia de Categor\xEDa, o asociale una Subcategor\xEDa en el bucket de Categor\xEDas",
    priceRequired: "Precio es obligatorio",
    priceGreaterThanZero: "El precio debe ser mayor a 0",
    valueGreaterThanZero: "El valor debe ser mayor a 0",
    promptMessageRequired: "El mensaje de solicitud para la sugerencia es obligatorio",
    suggestiveOrderingItemRequired: "El Elemento para la sugerencia es requerido",
    notEmpty: "no debe estar vac\xEDo",
    itemMustBelongTo: "El elemento debe pertenecer a una ",
    menuTypeTitle: "Tipo Menu: {{menuType}}",
    itemGroupTitle: "Grupo de Elementos: {{itemGroup}}",
    allChangesSaved: "Se han guardado los cambios",
    reasonRequired: "El motivo es obligatorio",
    reasonRequiredDescription: "Por favor seleccione un motivo.",
    quantityRequired: "La cantidad debe ser mayor que 0",
    discount: {
      title: "No es posible aplicar descuento",
      basePriceZero: "Precio del art\xEDculo es 0",
      totalPriceZero: "Precio Total del art\xEDculo es 0",
      excludedFromDiscounts: "Art\xEDculo excluido de descuentos",
      voidedElement: "Art\xEDculo Anulado"
    },
    noElements: "Sin {{elementName}}",
    permissionRequired: "Permisos requeridos",
    youDontHavePermissionsToManageTables: "No tienes permisos para gestionar mesas.",
    noItems: "Sin art\xEDculos",
    itemGroupUniqueNameRequired: "El nombre de los groupos de elementos necesita ser unico.",
    ingredientNameRepeated: "El nombre de los ingredientes debe ser unico.",
    ingredientTitle: "Ingrediente: {{itemGroup}}",
    itemsOfItemGroupRequired: "Un grupo de elementos necesita al menos un elemento.",
    specials: {
      buyQuantityRequired: '"Compra" debe ser mas grande que cero',
      getQuantityRequired: '"Obtienes" debe ser mas grande que cero',
      availabilityError: "Rango(s) de tiempo de disponibilidad invalidos"
    },
    invalidPhoneNumber: "N\xFAmero de tel\xE9fono inv\xE1lido",
    atLeast1Bucket: "Debe haber al menos 1 {{bucketName}} asociado.",
    comboDisplayNameRequired: "Nombre de visualizaci\xF3n del Combo no puede estar vacio",
    subcategoryMenuTypeItemsIdsRequired: "Debes seleccionar una Subcategor\xEDa para TODOS los Elementos",
    subcategoryMenuTypeCombosIdsRequired: "Debes seleccionar una Subcategor\xEDa para TODOS los Combos",
    uniqueCustomIdRequired: "El ID Personalizado ya existe en otro \xC1rticulo en esta organizaci\xF3n: {{name}} lo est\xE1 usando.",
    modifierItems: {
      maxModifiersErrorTitle: "Cantidad m\xE1xima de modificadores alcanzada",
      maximumReached: "Has alcanzado el n\xFAmero m\xE1ximo de modificadores ({maximumModifierItems}) permitidos para este grupo.",
      wrongQuantity: "No puedes establecer la cantidad: {{quantity}} para este grupo, porque el n\xFAmero m\xE1ximo permitido es {{maximumModifierItems}}."
    },
    startDateInvalid: "Fecha de inicio inv\xE1lida",
    endDateInvalid: "Fecha de finalizaci\xF3n inv\xE1lida",
    endDateBeforeStartDate: "La fecha de finalizaci\xF3n debe ser despu\xE9s de la fecha de inicio",
    startDateRequired: "Fecha de inicio es obligatoria",
    endDateRequired: "Fecha de finalizaci\xF3n es obligatoria",
    specificDateRequired: "Fecha es obligatoria",
    scheduleStartDateTimeRequired: "Fecha de inicio de programaci\xF3n es obligatoria",
    recipientsRequired: "Destinatarios son obligatorios"
  },
  menuScreen: {
    bucketDisabled: "Necesitas crear un Men\xFA primero.",
    deleteToast: "Solo puedes eliminar {{bucket}} en Enterprise Mode.",
    commonSections: {
      registerDisplay: {
        title: "VISUALIZACION EN REGISTRO",
        updatingTitle: "ACTUALIZANDO VISUALIZACION EN REGISTRO",
        registerDisplayOptions: {
          title: "Opciones de visualizaci\xF3n de registro",
          colors: "Colores de registro",
          generalSettings: "Configuraciones generales",
          registerNavigation: "Navegaci\xF3n de registro",
          displayPictureOnCard: "Monstar imagen en la tarjeta del Elemento",
          background: "Fondo",
          text: "Texto",
          image: "Imageen",
          reset: "Reiniciar",
          mods: "Mods",
          global: "Global",
          customizerDisplay: "Presentaci\xF3n del customizador",
          customizerShape: {
            label: "Forma del customizador",
            placeholder: "Selecciona una forma",
            options: {
              square: "Pizza cuadrada",
              round: "Pizza circular"
            }
          },
          specialTag: {
            label: "Etiqueta especial",
            emptyOption: "Sin etiquta especial"
          }
        },
        kdsDisplay: {
          title: "Visualizaci\xF3n en Cocina",
          kdsColor: "Color en Cocina",
          reset: "Reiniciar"
        },
        registerPreview: {
          title: "Vista Previa"
        },
        enterItemDetails: "Ingresar detalles de elementos al agregarlo al ticket",
        exitItemDetailsOnRequiredModsCompletion: "Abandonar detalles del elemento al completarlo"
      }
    },
    hotButtons: {
      giftCards: "Tarjetas de regalo",
      openCashDrawer: "Abrir caja",
      scanId: "Escanear ID",
      openItem: "Art\xEDculo abierto",
      customers: "Clientes",
      item: "Art\xEDculo",
      menuType: "Men\xFA",
      fire: "Disparar",
      newCourse: "Nuevo\nCurso",
      printChecks: "Imprimir Cuenta(s)"
    },
    refreshModal: {
      successButton: "Revisar Cambios",
      edit: {
        settings: {
          title: "Configuraciones Actualizadas",
          description: "Alguien m\xE1s hizo algunos cambios a estas configuraciones recientemente. Los cambios fueron mezclados."
        },
        customers: {
          title: "Cliente Actualizado",
          description: "Alguien m\xE1s hizo algunos cambios a este Cliente recientemente. Los cambios fueron mezclados."
        },
        preview: {
          savingChanges: "Guardando cambios",
          menuUpdated: "Men\xFA actualizado con \xE9xito",
          refresh: {
            outdatedMenu: {
              title: "Versi\xF3n del men\xFA desactualizada",
              description: '\nLa versi\xF3n del men\xFA en esta tablet est\xE1 desactualizada debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor presiona "Refrescar" para obetener la \xFAltima versi\xF3n.'
            },
            outdatedSettings: {
              title: "Versi\xF3n de las configuraciones desactualizada",
              description: '\nLa versi\xF3n de las configuraciones en esta tablet est\xE1 desactualizada debido a que alguien cambi\xF3 las configuraciones desde otro dispositivo.\nPor favor presiona "Refrescar" para obetener la \xFAltima versi\xF3n.'
            },
            outdatedMenuAndSettings: {
              title: "Versi\xF3n del men\xFA y de las configuraciones desactualizada",
              description: '\nLas versiones del men\xFA y de las configuraciones en esta tablet est\xE1 desactualizada debido a que alguien cambi\xF3 el men\xFA o las configuraciones desde otro dispositivo.\nPor favor presiona "Refrescar" para obetener las \xFAltimas versiones.'
            }
          }
        },
        bucketMessages: {
          items: {
            massUpdateTitle: "Elementos actualizados",
            title: "Elemento actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Elemento\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          itemGroups: {
            title: "Grupo de Elemento actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Grupo de Elementos\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          reportingGroups: {
            title: "Grupo de Reporte actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Grupo de Reporte\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          subcategories: {
            title: "Subcategor\xEDa actualizada",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a esta Subcategor\xEDa\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          categories: {
            title: "Categor\xEDa actualizada",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a esta Categor\xEDa\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          menuTypes: {
            title: "Men\xFA actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Men\xFA\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          modifierItems: {
            title: "Modificador de Elemento actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Modificador de Elemento\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          modifierGroups: {
            title: "Modificador de Grupo actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Modificador de Grupo\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          discounts: {
            title: "Descuento actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Descuento\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          combos: {
            title: "Combo actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Combo\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          specials: {
            title: "Especial actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Especial\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          ingredients: {
            title: "Ingrediente actualizado",
            description: 'Alguien cambi\xF3 el men\xFA desde otro dispositivo.\nEsto result\xF3 en un cambio a este Ingrediente\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          hotButtons: {
            title: "N/A",
            description: "N/A"
          }
        }
      },
      create: {
        bucketMessages: {
          items: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          itemGroups: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          reportingGroups: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          subcategories: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          categories: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          menuTypes: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          modifierItems: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          modifierGroups: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          discounts: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          combos: {
            title: "Men\xFA desactualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          specials: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          ingredients: {
            title: "Men\xFA actualizado",
            description: 'El men\xFA en esta tablet se ha actualizado debido a que alguien cambi\xF3 el men\xFA desde otro dispositivo.\nPor favor revisa tus cambios y presiona "Guardar" nuevamente.'
          },
          hotButtons: {
            title: "N/A",
            description: "N/A"
          }
        }
      }
    },
    massUpdate: {
      updating: "Actualizando Elementos Seleccionados"
    },
    refreshToast: {
      title: {
        menu: "Menu Actualizado Remotamente",
        settings: "Configuraciones Actualizadas Remotamente",
        reports: "Reportes Actualizados Remotamente"
      },
      bucketMessages: {
        items: {
          title: "Elemento desactualizado",
          description: "La versi\xF3n de este elemento no es la versi\xF3n m\xE1s actualizada"
        },
        itemGroups: {
          title: "Grupo de Elementos desactualizado",
          description: "La versi\xF3n de este elemento no es la versi\xF3n m\xE1s actualizada"
        },
        menuTypes: {
          title: "Men\xFA desactualizado",
          description: "La versi\xF3n de este Men\xFA no es la versi\xF3n m\xE1s actualizada"
        },
        categories: {
          title: "Categor\xEDa desactualizado",
          description: "La versi\xF3n de esta categor\xEDa no es la versi\xF3n m\xE1s actualizada"
        },
        subcategories: {
          title: "Subcategor\xEDa desactualizado",
          description: "La versi\xF3n de esta subcategor\xEDa no es la versi\xF3n m\xE1s actualizada"
        },
        modifierGroups: {
          title: "Modificador de grupo desactualizado",
          description: "La versi\xF3n de este modificador de grupo no es la versi\xF3n m\xE1s actualizada"
        },
        modifierItems: {
          title: "Modificador de elemento desactualizado",
          description: "La versi\xF3n de este modificador de elemento no es la versi\xF3n m\xE1s actualizada"
        },
        discounts: {
          title: "Descuento desactualizado",
          description: "La versi\xF3n de este Descuento no es la versi\xF3n m\xE1s actualizada"
        },
        combos: {
          title: "Combo desactualizado",
          description: "La versi\xF3n de este Combo no es la versi\xF3n m\xE1s actualizada"
        },
        specials: {
          title: "Especial desactualizado",
          description: "La versi\xF3n de este Especial no es la versi\xF3n m\xE1s actualizada"
        },
        ingredients: {
          title: "Ingrediente desactualizado",
          description: "La versi\xF3n de este Ingrediente no es la versi\xF3n m\xE1s actualizada"
        },
        hotButtons: {
          title: "N/A",
          description: "N/A"
        }
      }
    },
    freshSheetDetails: {
      unsavedChangesModal: {
        description: "Tienes cambios sin guardar. Por favor guarda o descarta tus cambios para poder navegar fuera de esta pagina."
      },
      massUpdate: {
        updating: "Actualizando Elementos Seleccionados"
      },
      addFreshSheetItem: "Agregar elemeto de hoja fresca",
      title: "Hoja Fresca",
      updating: "Actualizando hoja fresca",
      items: {
        name: "Nombre del elemento",
        currentAmount: "Cantidad Disponible",
        is86ed: "Es 86",
        delete: "Eliminar"
      }
    },
    common: {
      settings: {
        register: {
          singular: "Modo de Registro",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        general: {
          singular: "Configuraciones Generales",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        online: {
          singular: "Configuraciones de Pedidos en L\xEDnea",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        registerTicket: {
          singular: "Ticket de Registro",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        lockScreen: {
          singular: "Pantalla de Bloqueo",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        kitchenTicket: {
          singular: "Ticket de Cocina",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        prepStations: {
          singular: "Ubicacion de Impresora",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        printerRules: {
          singular: "Reglas de Impresi\xF3n",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        taxes: {
          singular: "Impuestos",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        dashboards: {
          singular: "Tablero",
          plural: "Tableros",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenseSpecificPrinterRules: {
          singular: "Reglas de Impresi\xF3n espec\xEDficas de licencia",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenseSettings: {
          singular: "Configuraci\xF3n de Licencia",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n de Configuraci\xF3n de Licencia?",
            message: "Actualmente est\xE1s creando una nueva Configuraci\xF3n de Licencia. Antes de salir, debe finalizar la creaci\xF3n de Configuraci\xF3n de Licencia o cancelarla."
          }
        },
        roles: {
          singular: "Rol",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Rol?",
            message: "Usted est\xE1 creando un nuevo Rol. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Rol o cancelarla."
          }
        },
        users: {
          singular: "Usuario",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Usuario?",
            message: "Usted est\xE1 creando un nuevo Usuario. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Usuario o cancelarla."
          }
        },
        devices: {
          singular: "Dispositivo",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        licenses: {
          singular: "Licencia",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        guestCheck: {
          singular: "Cuenta de Invitado",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        guestReceipt: {
          singular: "Recibo de Invitado",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        payments: {
          singular: "Pagos",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        }
      },
      reports: {
        customReports: {
          singular: "Informe Personalizado",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe Personalizado?",
            message: "Actualmente est\xE1s creando un nuevo Informe Personalizado. Antes de salir, debe finalizar la creaci\xF3n del Informe Personalizado o cancelarla."
          }
        },
        itemComboSalesReports: {
          singular: "Informe de ventas de combos y elementos",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de ventas de combos y elementos?",
            message: "Actualmente est\xE1s creando un nuevo Informe de ventas de combos y elementos. Antes de salir, debe finalizar la creaci\xF3n del Informe de ventas de combos y elementos o cancelarla."
          }
        },
        salesOverviewReports: {
          singular: "Informe general de ventas",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe general de ventas?",
            message: "Actualmente est\xE1s creando un nuevo Informe general de ventas. Antes de salir, debe finalizar la creaci\xF3n del Informe general de ventas o cancelarla."
          }
        },
        endOfShiftReport: {
          singular: "Informe de fin de turno",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de fin de turno?",
            message: "Actualmente est\xE1s creando un nuevo Informe de fin de turno. Antes de salir, debe finalizar la creaci\xF3n del Informe de fin de turno o cancelarla."
          }
        },
        creditCardBatchReports: {
          singular: "Informe de cobros con tarjeta de cr\xE9dito",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe cobros con tarjeta de cr\xE9dito?",
            message: "Actualmente est\xE1s creando un nuevo Informe cobros con tarjeta de cr\xE9dito. Antes de salir, debe finalizar la creaci\xF3n del Informe cobros con tarjeta de cr\xE9dito o cancelarla."
          }
        },
        employeeSalesAndTipsReports: {
          singular: "Informe de Ventas por Empleado",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de Ventas por Empleado?",
            message: "Actualmente est\xE1s creando un nuevo Informe de Ventas por Empleado. Antes de salir, debe finalizar la creaci\xF3n del Informe de Ventas por Empleado o cancelarla."
          }
        },
        voidReasonsReports: {
          singular: "Informe de Razones de Anulado",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de Razones de Anulado?",
            message: "Actualmente est\xE1s creando un nuevo Informe de Razones de Anulado. Antes de salir, debe finalizar la creaci\xF3n del Informe de Razones de Anulado o cancelarla."
          }
        },
        inventoryOnHandReports: {
          singular: "Informe de Inventario",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de Inventario?",
            message: "Actualmente est\xE1s creando un nuevo Informe de Inventario. Antes de salir, debe finalizar la creaci\xF3n del Informe de Inventario o cancelarla."
          }
        },
        creditBalancesReports: {
          singular: "Informe de Saldos de Cr\xE9dito",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Informe de Saldos de Cr\xE9dito?",
            message: "Actualmente est\xE1s creando un nuevo Informe de Saldos de Cr\xE9dito. Antes de salir, debe finalizar la creaci\xF3n del Informe de Saldos de Cr\xE9dito o cancelarla."
          }
        }
      },
      forbiddenChangeLocation: {
        title: "No puedes cambiar de ubicaci\xF3n",
        description: {
          categories: "Solo puedes crear Categor\xEDas en Enterprise Mode.",
          subcategories: "Solo puedes crear Subcategor\xEDas en Enterprise Mode.",
          menuTypes: "Solo puedes crear Men\xFAs en Enterprise Mode.",
          modifierItems: "Solo puedes crear Modificadores de Elemento en Enterprise Mode.",
          modifierGroups: "Solo puedes crear Modificadores de Grupo en Enterprise Mode.",
          itemGroups: "N/A",
          reportingGroups: "N/A",
          items: "N/A",
          discounts: "N/A",
          hotButtons: "N/A",
          combos: "N/A",
          specials: "N/A",
          ingredients: "N/A"
        }
      },
      preventLeaveModal: {
        title: "Termina la creaci\xF3n",
        items: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Elementos.",
        menuTypes: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Men\xFAs.",
        categories: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevas Categor\xEDas.",
        subcategories: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevas Subcategor\xEDas.",
        modifierGroups: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Modificadores de Grupo.",
        modifierItems: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Modificadores de Elemento.",
        itemGroups: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Grupos de Elementos.",
        reportingGroups: "Debes terminar la creaci\xF3n y guardar antes de que puedas agregar nuevos Grupos de Reporte.",
        discounts: "N/A",
        hotButtons: "N/A",
        combos: "N/A",
        specials: "N/A",
        ingredients: "N/A"
      },
      editDisabled: {
        items: "Solo puedes eliminar asociaciones de Elementos en Enterprise mode.",
        categories: "Solo puedes eliminar asociaciones de Categor\xEDas en Enterprise mode.",
        subcategories: "Solo puedes eliminar asociaciones de Subcategor\xEDas en Enterprise mode.",
        menuTypes: "Solo puedes eliminar asociaciones de Men\xFAs en Enterprise mode.",
        modifierGroups: "Solo puedes eliminar asociaciones de Modificadores de Grupo en Enterprise mode",
        modifierItems: "Solo puedes eliminar asociaciones de Modificadores de Elemento en Enterprise mode.",
        prepStationsItems: "Solo puedes eliminar Ubicaciones de Impresoras de Elementos en Enterprise mode."
      },
      addDisabled: {
        items: "Solo puedes agregar asociaciones de Elementos en Enterprise mode.",
        categories: "Solo puedes agregar asociaciones de Categor\xEDas en Enterprise mode.",
        subcategories: "Solo puedes agregar asociaciones de Subcategor\xEDas en Enterprise mode.",
        menuTypes: "Solo puedes agregar asociaciones de Men\xFAs en Enterprise mode.",
        modifierGroups: "Solo puedes agregar asociaciones de Modificadores de Grupo en Enterprise mode",
        modifierItems: "Solo puedes agregar asociaciones de Modificadores de Elemento en Enterprise mode."
      },
      associations: "ASOCIACIONES",
      updatingAssociations: "ACTUALIZANDO ASOCIACIONES",
      changesSaved: {
        title: "Cambios guardados",
        description: "Todos los cambios fueron guardados exitosamente"
      },
      bucket: {
        menuTypes: {
          plural: "Men\xFAs",
          singular: "Men\xFA",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Men\xFA?",
            message: "Usted est\xE1 creando un nuevo Men\xFA. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del nuevo Men\xFA o cancelarla."
          }
        },
        categories: {
          plural: "Categor\xEDas",
          singular: "Categor\xEDa",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n de la Categor\xEDa?",
            message: "Usted est\xE1 creando una nueva Categor\xEDa. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n de la Categor\xEDa o cancelarla."
          }
        },
        subcategories: {
          plural: "Subcategor\xEDas",
          singular: "Subcategor\xEDa",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n de la Subcategor\xEDa?",
            message: "Usted est\xE1 creando una nueva Subcategor\xEDa. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n de la Subcategor\xEDa o cancelarla."
          }
        },
        items: {
          plural: "Elementos",
          singular: "Elemento",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Elemento?",
            message: "Usted est\xE1 creando un nuevo Elemento. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Elemento o cancelarla."
          }
        },
        modifierGroups: {
          plural: "Grupos Modificadores",
          singular: "Grupo modificador",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Grupo Modificador?",
            message: "Usted est\xE1 creando un nuevo Grupo Modificador. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Grupo Modificador o cancelarla."
          }
        },
        modifierItems: {
          plural: "Elementos Modificadores",
          singular: "Elemento Modificador",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Elemento Modificador?",
            message: "Usted est\xE1 creando un nuevo Elemento Modificador. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Elemento Modificador o cancelarla."
          }
        },
        discounts: {
          plural: "Descuentos",
          singular: "Descuento",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Descuento?",
            message: "Usted est\xE1 creando un nuevo Descuento. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Descuento o cancelarla."
          }
        },
        hotButtons: {
          singular: "Accesso R\xE1pido",
          plural: "Acessos R\xE1pidos",
          creation: {
            title: "N/A",
            message: "N/A"
          }
        },
        combos: {
          plural: "Combos",
          singular: "Combo",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Combo?",
            message: "Usted est\xE1 creando un nuevo Combo. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Combo o cancelarla."
          }
        },
        specials: {
          plural: "Especiales",
          singular: "Especial",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Especial?",
            message: "Usted est\xE1 creando un nuevo Especial. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Especial o cancelarla."
          }
        },
        ingredients: {
          singular: "Ingrediente",
          plural: "Ingredientes",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Ingrediente?",
            message: "Usted est\xE1 creando un nuevo Ingrediente. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Ingrediente o cancelarla."
          }
        },
        itemGroups: {
          singular: "Grupo de Elementos",
          plural: "Grupos de Elementos",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Grupo de Elementos?",
            message: "Usted est\xE1 creando un nuevo Grupo de Elementos. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Grupo de Elementos o cancelarla."
          }
        },
        reportingGroups: {
          singular: "Grupo de Reporte",
          plural: "Grupos de Reporte",
          creation: {
            title: "\xBFFinalizar la creaci\xF3n del Grupo de Reporte?",
            message: "Usted est\xE1 creando un nuevo Grupo de Reporte. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Grupo de Reporte o cancelarla."
          }
        }
      }
    },
    selectionModal: {
      selectedText: "Elementos Seleccionados",
      selectButton: "SELECCIONAR",
      unselectButton: "QUITAR",
      header: {
        options: {
          cancel: "Cancelar",
          associate: "Asociar"
        }
      },
      locations: {
        title: "Selecciona las ubicaciones",
        titleSingular: "Selecciona Ubicaci\xF3n",
        selectedSectionTitle: "Ubicaciones seleccionadas",
        emptySectionText: "Porfavor selecciona una ubicaci\xF3n existente",
        emptySectionRemoveText: "Porfavor selecciona una ubicaci\xF3n existente para eliminar",
        noCardSelectedText: "Ubicaciones no seleccionadas",
        noAvailableCardsText: "Ubicaciones no disponibles"
      },
      roles: {
        title: "Selecciona las roles",
        titleSingular: "Selecciona Rol",
        selectedSectionTitle: "Roles seleccionadas",
        emptySectionText: "Porfavor selecciona una rol existente",
        noCardSelectedText: "Roles no seleccionadas",
        noAvailableCardsText: "Roles no disponibles"
      },
      dashboards: {
        title: "Selecciona los Tableros",
        titleSingular: "Selecciona un Tablero",
        selectedSectionTitle: "Tableros seleccionados",
        emptySectionText: "Porfavor selecciona un Tablero existente",
        noCardSelectedText: "Tableros no seleccionados",
        noAvailableCardsText: "Tableros no disponibles"
      },
      items: {
        title: "Selecciona los art\xEDculos",
        selectedSectionTitle: "Art\xEDculos seleccionados",
        emptySectionText: "Porfavor selecciona un art\xEDculo existente",
        noCardSelectedText: "Art\xEDculos no seleccionados",
        noAvailableCardsText: "Art\xEDculos no disponibles",
        menuTypes: {
          description: "Selecciona el Men\xFA del cual quieres copiar la informaci\xF3n",
          label: "Mostrar Men\xFAs donde el elemento es",
          status: {
            active: "Men\xFAs activos",
            inactive: "Men\xFAs inactivos"
          }
        }
      },
      ingredients: {
        title: "Selecciona los Ingredientes",
        selectedSectionTitle: "Ingredientes seleccionados",
        emptySectionText: "Porfavor selecciona un Ingrediente existente",
        noCardSelectedText: "Ingredientes no seleccionados",
        noAvailableCardsText: "Ingredientes no disponibles"
      },
      reportingGroups: {
        title: "Selecciona los Grupos de Reporte",
        selectedSectionTitle: "Grupos de Reporte seleccionados",
        emptySectionText: "Porfavor selecciona un Grupo de Reporte existente",
        noCardSelectedText: "Grupos de Reporte no seleccionados",
        noAvailableCardsText: "Grupos de Reporte no disponibles"
      },
      modifierItems: {
        title: "Selecciona los elementos modificadores",
        selectedSectionTitle: "Opciones Seleccionadas",
        emptySectionText: "Porfavor selecciona un elemento modificador existente",
        noCardSelectedText: "Elementos modificadores no seleccionados",
        noAvailableCardsText: "Elementos modificadores no disponibles"
      },
      modifierGroups: {
        selectedSectionTitle: "Opciones Seleccionadas",
        title: "Selecciona modificadores de grupo",
        emptySectionText: "Porfavor selecciona un modificador de grupo existente",
        emptySectionRemoveText: "Porfavor selecciona un modificador de grupo existente para eliminar",
        noCardSelectedText: "Modificadores de grupo no seleccionados",
        noAvailableCardsText: "Modificadores de grupo no disponibles"
      },
      itemGroups: {
        selectedSectionTitle: "Opciones Seleccionadas",
        title: "Selecciona grupo de elementos",
        emptySectionText: "Porfavor selecciona un grupo de elementos existente",
        emptySectionRemoveText: "Porfavor selecciona un grupo de elementos existente para eliminar",
        noCardSelectedText: "Grupos de elementos no seleccionados",
        noAvailableCardsText: "Grupos de elementos no disponibles"
      },
      subcategories: {
        title: "Selecciona Subcategor\xEDas",
        selectedSectionTitle: "Subcategor\xEDas seleccionadas",
        emptySectionText: "Porfavor selecciona una subcategor\xEDa existente",
        noCardSelectedText: "Subcategor\xEDas no seleccionadas",
        noAvailableCardsText: "Subcategir\xEDas no disponibles"
      },
      menuTypes: {
        selectedSectionTitle: "Men\xFAs seleccionados",
        title: "Selecciona Men\xFAs",
        createTitle: "Creando nuevo Elemento",
        description: "Selecciona los Men\xFAs que quieres que esten disponibles en este elemento",
        emptySectionText: "Porfavor selecciona un Men\xFA existente",
        noCardSelectedText: "Men\xFAs no seleccionados",
        noAvailableCardsText: "Men\xFAs no disponibles",
        allMenuTypes: "Todos los Men\xFAs"
      },
      categories: {
        selectedSectionTitle: "Categor\xEDas seleccionadas",
        title: "Selecciona categor\xEDas",
        emptySectionText: "Porfavor selecciona una categor\xEDa existente",
        noCardSelectedText: "Categor\xEDas no seleccionadas",
        noAvailableCardsText: "Categor\xEDas no disponibles"
      },
      discounts: {
        selectedSectionTitle: "Descuentos seleccionados",
        title: "Selecciona Descuentos",
        emptySectionText: "Porfavor selecciona un Descuento existente",
        noCardSelectedText: "Descuentos no seleccionados",
        noAvailableCardsText: "Descuentos no disponibles"
      },
      combos: {
        selectedSectionTitle: "Combos seleccionados",
        title: "Selecciona Combos",
        emptySectionText: "Porfavor selecciona un Combo existente",
        noCardSelectedText: "Combos no seleccionados",
        noAvailableCardsText: "Combos no disponibles",
        menuTypes: {
          label: "Mostrar Men\xFAs donde el Combo es"
        },
        locations: {
          title: "Ubicaciones de los restaurantes",
          description: "Ubicaciones de los restaurantes a los que el Combo pertenece.",
          emptyCardsMessage: "Ninguna Ubicaci\xF3n adicional para este Combo"
        }
      },
      combosItems: {
        selectedSectionTitle: "Elementos/Combos seleccionados",
        title: "Selecciona Elementos/Combos",
        emptySectionText: "Porfavor selecciona un Elemento/Combo existente",
        noCardSelectedText: "Elementos/Combos no seleccionados",
        noAvailableCardsText: "Elementos/Combos no disponibles",
        locations: {
          emptyCardsMessage: "Ninguna Ubicaci\xF3n adicional para este Elemento/Combo"
        }
      },
      specials: {
        selectedSectionTitle: "Especiales seleccionados",
        title: "Selecciona Especiales",
        emptySectionText: "Porfavor selecciona un Especial existente",
        noCardSelectedText: "Especiales no seleccionados",
        noAvailableCardsText: "Especiales no disponibles",
        menuTypes: {
          label: "Mostrar Men\xFAs donde el Especial es"
        }
      },
      prepStations: {
        title: "Selecciona las Ubicaciones de Impresoras",
        selectedSectionTitle: "Ubicaciones de Impresoras seleccionadas",
        emptySectionText: "Porfavor selecciona una Ubicaci\xF3n de Impresora",
        noCardSelectedText: "Ubicaciones de Impresoras no seleccionadas",
        noAvailableCardsText: "Ubicaciones de Impresoras no disponibles"
      },
      taxes: {
        title: "Selecciona los Impuestos",
        selectedSectionTitle: "Impuestos seleccionados",
        emptySectionText: "Porfavor selecciona un Impuesto",
        noCardSelectedText: "Impuestos no seleccionados",
        noAvailableCardsText: "Impuestos no disponibles"
      }
    },
    sectionsTitles: {
      basic: "Basico",
      register: "Visualizaci\xF3n en Registro",
      taxes: "Impuestos",
      guestCheckDisplay: "Pantalla del Comprobante",
      inventory: "Inventario",
      moreInfo: "M\xE1s Informaci\xF3n",
      ingredients: "Ingredientes",
      modifiers: "Modificadores",
      modItems: "Elementos Modificadores",
      itemsAndModItems: "Elementos y Elementos Modificadores",
      association: "Asociaciones",
      linkedModItems: "Modificadores Asociados",
      printerLocations: "Ubicaciones de Impresoras",
      suggestiveOrdering: "Pedido Sugerido",
      specials: "Ofertas Especiales",
      reportingGroups: "Reportes",
      pricing: "Precios",
      nestedMods: "Modificadores Anidados",
      modGroupsAndItems: "Grupos Modificadores y Elementos",
      availability: "Disponibilidad",
      specialScheme: "Esquema de Especiales",
      itemGroups: "Grupos de Elementos",
      discountScheme: "Esquema de Descuento"
    },
    bucketElement: {
      menuTypes: "Men\xFA",
      categories: "Categor\xEDa",
      subcategories: "Subcategor\xEDa",
      items: "Elemento",
      modifierGroups: "Modificador de Grupo",
      modifierItems: "Modificador de Elemento",
      discounts: "Descuento",
      combos: "Combo",
      specials: "Especial",
      ingredients: "Ingrediente",
      itemGroups: "Grupo de Art\xEDculos",
      reportingGroups: "Grupo de Reportes"
    },
    commonFields: {
      basic: {
        title: "B\xC1SICO",
        description: 'Los nombres de POS, Cocina, y Cuenta ser\xE1n el campo "Nombre" si no se especifica un nombre para ellos.',
        name: "Nombre",
        posName: "Nombre de POS",
        kdsName: "Nombre en Cocina",
        checkName: "Nombre de Cuenta",
        onlineName: "Nombre en L\xEDnea",
        advancedOptions: "Opciones avanzadas",
        ticketDisplayOptions: "Opciones de visualizaci\xF3n de tickets",
        customizerSelector: "Cutomizador de Pizza",
        backgroundColor: "Color de fondo",
        textColor: "Color de texto"
      }
    },
    menuLocation: {
      noLocationsMessage: "No hay ubicaciones en este grupo",
      actionButtons: {
        addNewCategory: "Agregar nueva categor\xEDa",
        addExistingCategory: "Agregar categor\xEDa existente",
        cloneCategoryTag: "Clonando categor\xEDa - {{element}}",
        addNewMenuType: "Agregar nuevo Men\xFA",
        addExistingMenuType: "Agregar Men\xFA existente",
        cloneMenuTypeTag: "Clonando Men\xFA - {{element}}",
        addNewLocation: "Agregar nueva Ubicaci\xF3n",
        addExistingLocation: "Agregar Ubicaci\xF3n existente",
        addNewSubcategory: "Agregar nueva Subcategor\xEDa",
        addExistingSubcategory: "Agregar Subcategor\xEDa existente",
        cloneSubcategoryTag: "Clonando Subcategor\xEDa - {{element}}",
        addNewItem: "Agregar nuevo Elemento",
        addExistingItem: "Agregar Elemento existente",
        cloneItemTag: "Clonando Elemento - {{element}}",
        addNewModifierItem: "Agregar nuevo Modificador de elemento",
        addExistingModifierItem: "Agregar Modificador de elemento existente",
        cloneModifierItemTag: "Clonando Modificador de elemento - {{element}}",
        addNewModifierGroup: "Agregar nuevo Modificador de grupo",
        addExistingModifierGroup: "Agregar Modificador de grupo existente",
        cloneModifierGroupTag: "Clonando Modificador de group - {{element}}",
        addNewPricingVersion: "Agregar nueva versi\xF3n del precio",
        addNewCategoryTag: "Nueva categor\xEDa",
        addExistingCategoryTag: "Nategor\xEDa existente",
        addNewMenuTypeTag: "Nuevo Men\xFA",
        addExistingMenuTypeTag: "Nipo de Men\xFA existente",
        addNewLocationTag: "Nueva Ubicaci\xF3n",
        addExistingLocationTag: "Nbicaci\xF3n existente",
        addNewSubcategoryTag: "Nueva Subcategor\xEDa",
        addExistingSubcategoryTag: "Nubcategor\xEDa existente",
        addNewItemTag: "Nuevo Elemento",
        deleteItems: "Eliminar Elementos",
        addExistingItemTag: "Elemento existente",
        addNewModifierItemTag: "Nuevo Modificador de elemento",
        addNewItemGroupTag: "Nuevo grupo de articulos",
        addNewItemGroup: "Agregar Nuevo grupo de articulos",
        addNewReportingGroupTag: "Nuevo grupo de reporte",
        addNewReportingGroup: "Agregar Nuevo grupo de reporte",
        addExistingReportingGroup: "Agregar Grupo de Reporte Existente",
        addExistingReportingGroupTag: "Grupo de Reporte Existente",
        addExistingItemGroupTag: "Grupo de Elementos existente",
        addExistingItemGroup: "Agregar Grupo de Elementos existente",
        addExistingModifierItemTag: "Modificador de elemento existente",
        addNewModifierGroupTag: "Nuevo Modificador de grupo",
        addExistingModifierGroupTag: "Modificador de grupo existente",
        addNewSpecial: "Agregar nuevo especial",
        addExistingSpecial: "Agregar especial existente",
        addNewDiscount: "Agregar Nuevo Descuento",
        addNewDiscountTag: "Nuevo Descuento",
        addExistingDiscount: "Agregar Descuento Existente",
        addExistingDiscountTag: "Descuento Existente",
        addNewCombo: "Agregar Nuevo Combo",
        addNewComboTag: "Nuevo Combo",
        addNewSpecialTag: "Nuevo Especial",
        addExistingSpecialTag: "Especial Existente",
        addExistingCombo: "Agregar Combo Existente",
        addExistingComboTag: "Combo Existente",
        addNewRole: "Agregar Nuevo Rol",
        addNewRoleTag: "Nuevo Rol",
        addExistingRole: "Agregar Rol Existente",
        addExistingRoleTag: "Rol Existente",
        addNewIngredient: "Agregar Nuevo Ingrediente",
        addExistingIngredient: "Agregar Ingrediente Existente",
        addNewIngredientTag: "Nuevo Ingrediente",
        addExistingIngredientTag: "Ingrediente Existente"
      }
    },
    itemDetails: {
      dimensions: {
        title: "Dimensiones",
        dimensionsSellBy: {
          label: "Vender Por",
          options: {
            unit: "Unidad",
            volume: "Volumen",
            weight: "Peso"
          }
        }
      },
      reportingSection: {
        title: "Reportes",
        emptyCardsMessage: "Ningun Grupo de Reporte para este Articulo",
        removeReportingSection: {
          title: "Remover Grupos de Reporte",
          description: "Selecciona los Grupos de Reporte a remover de todos los Articulos selecctionados",
          empty: "Sin Grupos de Reporte para Remover"
        },
        addReportingSection: {
          title: "Agregar Grupos de Reporte",
          description: "Selecciona los Grupos de Reporte a agregar de todos los Articulos selecctionados",
          empty: "Sin Grupos de Reporte para Agregar"
        }
      },
      customId: "ID Personalizado",
      taxesSection: {
        removeTaxesSection: {
          title: "Remover Impuestos Personalizados",
          description: "Selecciona los Impuestos Personalizados a remover de todos los Articulos selecctionados",
          empty: "Sin Impuestos Personalizados para Remover"
        },
        addTaxesSection: {
          title: "Agregar Impuestos Personalizados",
          description: "Selecciona los Impuestos Personalizados a agregar de todos los Articulos selecctionados",
          empty: "Sin Impuestos Personalizados para Agregar"
        }
      },
      categoriesSubcategories: {
        title: "Categor\xEDas y Subcategor\xEDas",
        removeCategoriesSection: {
          title: "Remover Categor\xEDas y Subcategor\xEDas",
          description: "Selecciona los Categor\xEDas a remover de todos los Articulos selecctionados",
          empty: "Sin Categor\xEDas para Remover"
        },
        addCategoriesSection: {
          title: "Agregar Categor\xEDas y Subcategor\xEDas",
          description: "Selecciona los Categor\xEDas a agregar de todos los Articulos selecctionados",
          empty: "Sin Categor\xEDas para Agregar"
        }
      },
      modifierGroupsSection: {
        activeModifierGroupError: "El Grupo Modificador est\xE1 inactivo, asi que no puedes mostrarlo en este Elemento",
        nestedModifiers: "Modificadores anidados",
        nestedModifierstoolTip: "Nested Modifiers allow a modifier item to call a modifier group.\nFor example, a steak comes with a side salad.  The side salad is the modifier item. The side salad as a modifier item can then call the assigned Nested Modifier Group \u201Cdressing choice\u201D when the side salad is selected.",
        addModifierGroup: "A\xF1adir Grupo Modificador",
        modifierGroup: "Grupo modificador",
        modifierName: "Nombre del modificador: {{name}}",
        quantity: "Cantidad",
        multiselect: "Selecci\xF3n m\xFAltiple",
        pricingMode: "Modo de precio",
        editModifier: "Editar modificador",
        selectedDefault: "Seleccionado por default",
        required: "Requerido",
        included: "Inc.",
        maximum: "Max.",
        totalPrice: "Precio del modificador",
        hideModifierGroup: "Ocultar grupo modificador",
        showAllPricing: "Mostrar los precios",
        pricingVersion: "Versi\xF3n del precio",
        noModifierItemsAssignedToThisGroup: "No hay art\xEDculos modificadores asignados a este grupo",
        noModiferGroupsAssignedToThisItem: "No hay grupos modificadores asignados a este art\xEDculo",
        itemModsSubsectionTitle: "Mods de art\xEDculo",
        allMods: {
          title: "Todos los mods",
          description: "Cualquier cambio realizado en los campos a continuaci\xF3n o en el precio del Modificador de Elemento ser\xE1 una anulaci\xF3n personalizada espec\xEDfica para este elemento, representada por un punto azul",
          showAllModsAlphabetizeButtons: 'Mostar Botones Alfabeticos de "Todos los Mods"',
          showAllModsHalfSizeButtons: 'Botones mitad de tama\xF1o de "Todos los Mods"',
          allModsBehavior: {
            options: {
              all: "Todos",
              associated: "Asociados",
              premade: "Pre-Hechos"
            }
          }
        }
      },
      pricingSection: {
        title: "Precios",
        updatingTitle: "Actualizando Precios",
        description: "El precio base del elemento se tomar\xE1 si el precio de venta en l\xEDnea y con entrega est\xE1n vacios.",
        allLocationsBtn: "Ver precios para todas las ubicaciones",
        itemPrice: "Precio base del art\xEDculo",
        itemPricetoolTip: "Standard price of item when ordered. Default price seen on physical menu.",
        onlinePrice: "Precio venta en l\xEDnea",
        onlinePricetoolTip: "Price of item when ordered via online ordering. Price may include adjustments for convenience, service fees or special promotions.",
        deliveryPrice: "Precio con entrega",
        deliveryPricetoolTip: "Price of item when ordered for delivery. Price may include adjustments for packaging, delivery fees, or third-party delivery apps.",
        toGoPrice: "Precio para llevar",
        toGoPricetoolTip: "Price of item when ordered for takeout or pickup",
        increaseOrDecrease: "Incrementar o Disminuir",
        isTaxInclusive: "Impuestos incluidos",
        isTaxInclusivetoolTip: "When enabled, this setting calculates the tax as an inclusive tax, meaning the displayed price of the menu item already includes the applicable tax. The system will automatically determine and separate the tax portion from the total item price.",
        excludeFromSuggestedTip: "Excluir de las sugerencias",
        excludeFromSuggestedTiptoolTip: "When enabled, this item will not be included in the calculation of the Suggested Tip amount",
        excludeFromDiscounts: "Excluir de los descuentos",
        excludeFromDiscountstoolTip: "When enabled, the item will not be eligible for discounts",
        removeFromCheck: "Remover de la cuenta",
        removeFromCheckToolTip: "Exluye de la cuenta y del impresion de cuenta del huesped",
        taxExempt: "Excensi\xF3n de impuestos",
        taxExemptToolTip: "Cuando esta habilitado, no se cobra impuesto por este art\xEDculo"
      },
      associations: {
        title: "Modificadores Asociados",
        linkedModItems: "Elementos Modificadores Asociados"
      },
      itemLocation: {
        title: "UBICACI\xD3N DEL ELEMENTO",
        category: "Categor\xEDa",
        categorytoolTip: "Select the Category to which the item belongs. Item will display in that category on the register",
        subcategory: "Subcategor\xEDa",
        subcategorytoolTip: "Select the Subcategory to which the item belongs.  If the Category does contain Subcategories, and a Subcategory is not assigned to this item, the item will appear in the \u201CAll\u201D Subcategory within the Category.",
        removeLocation: "Eliminar",
        locations: {
          sectionTitle: "Ubicaciones Adicionales",
          title: "Ubicaciones de los restaurantes",
          description: "Ubicaciones de los restaurantes a los que el elemento pertenece.",
          emptyCardsMessage: "Ninguna Ubicaci\xF3n adicional para este elemento"
        },
        locationsAdd: {
          title: "Agregar ubicaciones de restaurantes",
          description: "Seleccione ubicaciones de restaurantes para agregar a todos los art\xEDculos seleccionados",
          emptyCardsMessage: "No hay ubicaciones de restaurantes para agregar a los art\xEDculos seleccionados"
        },
        locationsRemove: {
          title: "Eliminar ubicaciones de restaurantes",
          description: "Seleccione las ubicaciones de restaurantes para eliminar de todos los elementos seleccionados",
          emptyCardsMessage: "No hay ubicaciones de restaurantes para eliminar de los elementos seleccionados"
        },
        specials: {
          title: "Especiales",
          description: "El orden en el que se muestran los Especiales aqu\xED, es el orden con el cual ser\xE1n mostrados en el m\xF3dulo de Registro. Presione el bot\xF3n de Editar para ordenarlos a su preferencia, arrastrando y soltando los elementos.",
          emptyCardsMessage: "Ning\xFAn especial para este elemento"
        }
      },
      prepStationsSection: {
        title: "UBICACIONES DE IMPRESORAS",
        prepStations: {
          title: "Ubicaciones de Impresoras",
          toolTip: 'Add and select the printer locations where this menu item will print. If no printer locations are added, the Printer Locations Selection Modal will appear when the item is ordered, prompting the user to manually select where the item will print.\nWhen "Show Printer Location Selection Modal" is disabled, the item will not print to any remote devices',
          addTitle: "A\xF1adir Ubicaciones de Impresoras",
          removeTitle: "Eliminar Ubicaciones de Impresoras",
          disabledActionToast: {
            title: "Alerta"
          },
          actionButtons: {
            addExistingStation: "A\xF1adir Ubicaci\xF3n de Impresora Existente"
          },
          emptyCardsMessage: "Ninguna Ubicaci\xF3n de Impresora para este elemento",
          emptyRemoveCardsMessage: "Ninguna Ubicaci\xF3n de Impresora para Eliminar",
          showPrepStationSelectionModal: "Mostrar el modal de selection de Ubicaci\xF3n de Impresora"
        }
      },
      suggestiveOrdering: {
        title: "ORDEN SUGERIDA",
        toolTip: "After ordering the menu item, a prompt will display asking if the item below should be added to the ticket.",
        updatingTitle: "ACTUALIZANDO ORDEN SUGERIDA",
        promptCheckText: "Solicitar una sugerencia a la usuario despu\xE9s de ordenar",
        promptCheckTexttoolTip: "Enable to prompt the user to ask to add the following item to the Order",
        addButtonText: "Presiona para a\xF1adir un articulo",
        addButtonLabel: "Presiona para cambiar",
        allowSpecialPrice: "Permitir Precio Especial",
        allowSpecialPricetoolTip: "Enable to allow the Suggested Item to be added to the Order at a special price, different from the regular price on the menu",
        inputs: {
          suggestionPrice: {
            label: "Precio Especial Sugerido",
            toolTip: "Enter the amount the Suggested Item will be sold for as part of the Suggestion Prompt",
            placeholder: "Agrega un precio especial sugerido"
          },
          prompt: {
            label: "Solicitud",
            toolTip: "Enter any information that should be displayed to the user as part of the Suggestion Prompt",
            placeholder: "Agrega solicitud"
          }
        }
      },
      applyChangesToMenuType: {
        error: {
          title: "Advertencia de Mezclado",
          description: "Alguno de los Ingredientes no fueron encontrados en los otros Men\xFAs. Por favor revisa los cambios que ser\xE1n aplicados a los otros Men\xFAs."
        }
      },
      inventorySection: {
        title: "INVENTARIO",
        description: "Controla los niveles de existencia para los items. El seguimiento est\xE1 compartido con todos los Men\xFAs para este Elemento.\nCualquier cambio se copiar\xE1 automaticamente a todos los otros Men\xFAs.",
        shortDescription: "Controla los niveles de existencia para los items.",
        trackInventory: "Seguimiento de inventario",
        initialAmountInStock: "Cantidad inicial en existencia",
        initialAmountInStocktoolTip: "Set the quantity of an item available at the start of a tracking period. This value represents the starting inventory and is used to track sales and inventory depletion.",
        currentAmountInStock: "Cantidad actual en existencia",
        currentAmountInStocktoolTip: "Quantity of an item that is currently available in inventory",
        "86ItemWhenCurrentStockIs0": "Es 86",
        "86ItemWhenCurrentStockIs0toolTip": "Enable to set an item out of stock and unavailable for sale",
        showOnFreshSheet: "Mostrar en hojas frescas",
        showOnFreshSheettoolTip: "When enabled, item will show in the Fresh Sheet",
        resetCurrentStockDaily: "Resetear las existencias diariamente",
        resetStockToInitialWhenAt0: "Resetear existencias al inicial cuando sea 0",
        volume: "Volumen",
        actionWhenCurrentStockZero: {
          label: "Acci\xF3n cuando el inventario llegue a 0",
          toolTip: `Select what happens when stock hits zero for an item
86'd - Item is marked as 86'd, making it unavailable
Reset to Initial - System automatically reverts the current stock to the "initial quantity in stock"
No Action - No action is taken by the system and allows for manual intervention by staff to decide the next steps`,
          placeholder: "Selecciona una opci\xF3n",
          options: {
            null: "Sin acci\xF3n",
            "86": "86",
            resetToInitial: "Reiniciar al valor inicial"
          }
        },
        showQuantityOnItemCard: "Mostar monto en tarjeta",
        showQuantityOnItemCardtoolTip: "Enable to display the Current Quantity count in the upper right corner of the menu item card",
        universalProductCode: "UPC",
        universalProductCodetoolTip: "Enter the barcode number in this field so the menu item can be rung up by scanning the barcode on the product"
      },
      registerDisplay: {
        title: "VISUALIZACION EN REGISTRO",
        updatingTitle: "ACTUALIZANDO VISUALIZACION EN REGISTRO",
        registerDisplayOptions: {
          title: "Opciones de visualizaci\xF3n de registro",
          colors: "Colores de registro",
          displayPictureOnCard: "Monstar imagen en la tarjeta del Elemento",
          displayPictureOnCardtoolTip: "Enable to display uploaded image on the menu item button on the register",
          background: "Fondo",
          text: "Texto",
          image: "Imagen",
          uploadImage: "Subir imagen",
          uploadSecondaryImage: "Subir imagen secundaria",
          reset: "Reiniciar",
          mods: "Mods",
          global: "Global",
          customizerDisplay: "Presentaci\xF3n del customizador",
          customizerDisplaytoolTip: "Enable to have the customizer display appear when ordering this item. Customizer display will allow for modifying the whole, half, or quarter of an item. Typically used for pizza.",
          customizerShape: {
            label: "Forma del customizador",
            placeholder: "Selecciona una forma",
            toolTip: "This field becomes active if \u201Ccustomizer display\u201D option is enabled. Select either \u201Csquare\u201D or \u201Cround\u201D for the shape of the item.",
            options: {
              square: "Pizza cuadrada",
              round: "Pizza circular"
            }
          },
          specialTag: {
            label: "Etiqueta especial",
            toolTip: "Select a special tag to appear in the bottom right corner of a menu item card.",
            emptyOption: "Sin etiquta especial"
          }
        },
        kdsDisplay: {
          title: "Visualizaci\xF3n en Cocina",
          kdsColor: "Color en Cocina",
          kdsColortoolTip: "Color the item will display as on the Kitchen Display System",
          reset: "Reiniciar"
        },
        registerPreview: {
          title: "Vista Previa"
        },
        enterItemDetails: "Ingresar detalles de elementos al agregarlo al ticket",
        enterItemDetailstoolTip: "For use when an item has no required modifiers. When enabled, after adding the menu item to the order, user will automatically be taken to the Item Details screen where optional modifiers can be added. When this option is disabled, the user will need to select the menu item in the ticket to enter the Item Details screen to modify the item",
        exitItemDetailsOnRequiredModsCompletion: "Abandonar detalles del elemento al completarlo",
        exitItemDetailsOnRequiredModsCompletiontoolTip: "Enable to close the Item Details modification window after all required modifiers have been selected for the menu item",
        transparentBackground: "Image Overlay",
        transparentBackgroundtoolTip: "This field becomes active if an image has been uploaded for the menu item. Enable to place the uploaded item image on top of the background.",
        displayItemPriceOnRegister: "Mostrar el precio del Elemento en la carta",
        displayItemPriceOnRegistertoolTip: "Enable to display the menu item price in the upper left corner of the menu item button on the register",
        hideItemName: "Ocultar el nombre del Elemento",
        hideItemNametoolTip: "Enable to prevent the item name from displaying on the item card. Typically used when an image has been uploaded for the menu item.",
        doneIsForTable: '"Listo" es "Para la mesa"'
      },
      hiddenItemSection: {
        itemsTitle: {
          inactive: "Oculto debido a Categor\xEDa/Subcategor\xEDa inactiva"
        },
        title: {
          empty: "Oculto debido a que no hay Categor\xEDa",
          inactive: "Oculto debido a Categoria inactiva",
          simpleMode: "Oculto debido a modo simple en el Men\xFA"
        },
        itemDescription: {
          categoryInactive: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. la categoria conteniendo este elemento est\xE1 inactiva y no se mostrar\xE1 en el m\xF3dulo de registro.',
          categoryEmpty: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. Por favor asocia una Categor\xEDa para ver este Elemento en el Registro.',
          subcategoryInactive: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. la subcategoria conteniendo este elemento est\xE1 inactiva y no se mostrar\xE1 en el m\xF3dulo de registro.',
          subcategoryEmpty: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. Por favor asocia una Subcategor\xEDa para ver este Elemento en el Registro.',
          menuTypeSimpleMode: '"{{menuTypeName}}" est\xE1 en modo simple y el {{bucket}} ni sus respectivas Categor\xEDa/Subcategor\xEDa se encuentran en la pantalla de inicio.',
          couple: "No existe una relaci\xF3n de Categor\xEDa y Subcategor\xEDa donde ambas esten activas"
        },
        comboDescription: {
          categoryInactive: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. la categoria conteniendo este Combo est\xE1 inactiva y no se mostrar\xE1 en el m\xF3dulo de registro.',
          categoryEmpty: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. Por favor asocia una Categor\xEDa para ver este Combo en el Registro.',
          subcategoryInactive: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. la subcategoria conteniendo este Combo est\xE1 inactiva y no se mostrar\xE1 en el m\xF3dulo de registro.',
          subcategoryEmpty: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. Por favor asocia una Subcategor\xEDa para ver este Combo en el Registro.'
        },
        subcategoryDescription: {
          categoryInactive: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. La categor\xEDa que contiene la subcategor\xEDa est\xE1 inactiva y no se mostrar\xE1 en el m\xF3dulo de registro.',
          categoryEmpty: '"{{name}}" no se est\xE1 mostrando en el m\xF3dulo de registro. Por favor asocia una Categor\xEDa para ver esta Subcategor\xEDa en el Registro.'
        },
        button: {
          category: "Editar categor\xEDa",
          subcategory: "Editar subcategor\xEDa",
          menuType: "Editar Men\xFA",
          review: "Revisar"
        }
      },
      noMenuType: {
        title: "Ning\xFAn Men\xFA a\xF1adido",
        description: "Por favor a\xF1ade un nuevo Men\xFA en la parte superior derecha de la secci\xF3n de Men\xFAs para continuar"
      },
      menuTypes: {
        title: "Men\xFAs",
        description: "Seleccione el Men\xFA para ver la informaci\xF3n de este Elemento.",
        onHomeScreen: "En Pantalla de Inicio",
        active: "Men\xFAs activos",
        inactive: "Men\xFAs inactivos",
        toastRemoveErrorTitle: "No es posible remover este Men\xFA",
        toastRemoveErrorDescription: "Necesita al menos un Men\xFA agregado",
        filterModal: {
          statusText: "Mostrar Men\xFAs con estatus:"
        }
      },
      noElementFoundMessage: "Este elemento no existe en {{location}}",
      createNewElement: {
        loading: "Creando elemento",
        success: "Elemento creado satisfactoriamente",
        error: "Error al enviar el nuevo elemento"
      },
      editElement: {
        loading: "Actualizando elemento",
        success: "Elemento actualizado satisfactoriamente",
        error: "Error al actualizar el elemento"
      },
      deleteElement: {
        loading: "Eliminando elemento",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el elemento"
      },
      unassociateElement: {
        loading: "Desasociando elemento",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el elemento"
      },
      validationFields: {
        name: "Name",
        posName: "POS Name",
        kdsName: "Kitchen Name",
        checkName: "Check Name",
        onlineName: "Online Name",
        categoryId: "Category",
        subcategoryId: "Subcategory",
        itemPrice: "Item Price",
        suggestiveOrdering: "Suggestive Ordering",
        suggestiveOrderingItemPrice: "Suggestive Price",
        suggestiveOrderingPrompt: "Suggestive Ordering Prompt"
      },
      moreInformation: {
        title: "M\xC1S INFORMACI\xD3N",
        updatingTitle: "ACTUALIZANDO M\xC1S INFORMACI\xD3N",
        inputs: {
          description: {
            label: "Descripci\xF3n",
            toolTip: "Enter the information that will display in the \u201Cdescription\u201D field when the Item Details window is open. Max 1000 characters",
            placeholder: "Agrega una descripci\xF3n"
          },
          onlineDescription: {
            label: "Descripci\xF3n en l\xEDnea",
            toolTip: "Enter the description for the item that will display when ordering online",
            placeholder: "Agrega una descripci\xF3n"
          },
          recipe: {
            label: "Receta",
            toolTip: "Enter important recipe information here such as ingredients, preparation instructions, portion size, cooking equipment, glassware, and allergens.",
            placeholder: "Agrega la receta"
          }
        }
      },
      basic: {
        namesTitle: "Nombres",
        nameInfo: "Nombre del elemento en el men\xFA principal, este es el nombre que se mostrar\xE1 en el POS, KDS y el pedido en l\xEDnea si estos campos se dejan vac\xEDos.",
        posNameInfo: "El nombre del elemento que se mostrar\xE1 en el POS (Punto de Venta).",
        checkNameInfo: "El nombre del elemento que se mostrar\xE1 en la comprobaci\xF3n.",
        onlineNameInfo: "El nombre del elemento que se mostrar\xE1 en el Pedido en L\xEDnea."
      },
      linkedModItems: {
        title: 'Modificadores asociados a "{{name}}"'
      }
    },
    itemGroupDetails: {
      noElementFoundMessage: "Este Grupo de Elementos no existe en {{location}}",
      createNewElement: {
        loading: "Creando Grupo de Elementos",
        success: "Grupo de Elementos creado satisfactoriamente",
        error: "Error al enviar el nuevo Grupo de Elementos"
      },
      editElement: {
        loading: "Actualizando Grupo de Elementos",
        success: "Grupo de Elementos actualizado satisfactoriamente",
        error: "Error al actualizar el Grupo de Elementos"
      },
      deleteElement: {
        loading: "Eliminando Grupo de Elementos",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Grupo de Elementos"
      },
      unassociateElement: {
        loading: "Desasociando Grupo de Elementos",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Grupo de Elementos"
      },
      basic: {
        required: "Hacer Requerido",
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Grupo de Elementos antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Grupos de Elementos en Enterprise mode"
        }
      },
      associations: {
        items: {
          description: "Los Elementos debajo pertenecen a este Grupo de Elementos",
          showUpcharge: "Mostrar Costo Extra"
        },
        combos: {
          subtitle: 'Combos usando "{{name}}"',
          description: "Este Grupo de Elementos est\xE1 siendo usando en los Combos listados debajo",
          emptyCardsMessage: "Ningun Combos est\xE1 usando este Grupo de Elementos"
        }
      }
    },
    reportingGroupDetails: {
      noElementFoundMessage: "Este Grupo de Reporte no existe en {{location}}",
      createNewElement: {
        loading: "Creando Grupo de Reporte",
        success: "Grupo de Reporte creado satisfactoriamente",
        error: "Error al enviar el nuevo Grupo de Reporte"
      },
      editElement: {
        loading: "Actualizando Grupo de Reporte",
        success: "Grupo de Reporte actualizado satisfactoriamente",
        error: "Error al actualizar el Grupo de Reporte"
      },
      deleteElement: {
        loading: "Eliminando Grupo de Reporte",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Grupo de Reporte"
      },
      optionsDisabled: {
        creation: "Debes terminar la creaci\xF3n de este Grupo de Reporte antes de clonarlo o eliminarlo.",
        location: "Solo puedes clonar o eliminar Grupos de Reporte en Enterprise mode"
      },
      associations: {
        items: {
          description: "Este Grupo de Reporte est\xE1 siendo usado en los Articulos listados debajo.",
          emptyCardsMessage: "Ningun Articulo est\xE1 usando este Grupo de Reporte"
        },
        combos: {
          description: "Este Grupo de Reporte est\xE1 siendo usado en los Combos listados debajo.",
          emptyCardsMessage: "Ningun Combo est\xE1 usando este Grupo de Reporte"
        }
      }
    },
    categoryDetails: {
      noElementFoundMessage: "Esta categor\xEDa no existe en {{location}}",
      createNewElement: {
        loading: "Creando categor\xEDa",
        success: "Categor\xEDa creada satisfactoriamente",
        error: "Error al enviar la nueva categor\xEDa"
      },
      editElement: {
        loading: "Actualizando categor\xEDa",
        success: "Categor\xEDa actualizada satisfactoriamente",
        error: "Error al actualizar la categor\xEDa"
      },
      deleteElement: {
        loading: "Eliminando categor\xEDa",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar la categor\xEDa"
      },
      unassociateElement: {
        loading: "Desasociando categor\xEDa",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar la categor\xEDa"
      },
      childrenType: {
        options: {
          item: "Elementos/Combos",
          subcategory: "Subcategor\xEDas"
        }
      },
      basic: {
        title: "B\xC1SICO",
        toolTip: "Subcategories allow further grouping of items within a category. Up to 10 subcategories can be added to a category. Subcategories will display when their parent category is selected.\nExamples: \nCategory Beer>Subcategories Draft Beer, Bottle Beer\nCategory Entrees>Subcategories Chicken, Steak, Seafood",
        name: "Nombre",
        posName: "Nombre de POS",
        hide: "Ocultar Categor\xEDa",
        hideInfo: "Ocultar Categor\xEDa",
        customizer: "Categor\xEDa Customizable",
        previewTitle: "Vista Previa:",
        children: "Hijos de la Categor\xEDa",
        childrenPlaceholder: "Hijos de la Categor\xEDa",
        childrenItems: "Elementos/Combos",
        childrenSubcategories: "Subcategor\xEDas",
        childrenTypeModal: {
          title: "Cambio de tipo de hijo:",
          subcategories: {
            body: "Esto crear\xE1 automaticamente una subcategor\xEDa llamada Other y asignar\xE1 todos los elementos y combos existentes en esta categor\xEDa a esta subcategor\xEDa. Despu\xE9s puede renombrar la categor\xEDa Other, o crear nuevas subcategor\xEDas y asociarlas a esta categor\xEDa."
          },
          items: {
            body: "Esto borrar\xE1 automaticamente todas las subcategor\xEDas que fueron asociadas a esta categor\xEDa. Todos los elementos y combos que pertenec\xEDan a estas subcategor\xEDas seguir\xE1n asociadas a esta categor\xEDa."
          }
        },
        removeAssociationsModal: {
          title: "Elimina las asociaciones de la categor\xEDa",
          subcategories: {
            body: "Para poder eliminar, por favor reasigna todas las subcategor\xEDas a otra categor\xEDa."
          },
          items: {
            body: "Para poder eliminar, por favor reasigna todos los elementos y combos a otra categor\xEDa."
          }
        },
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de esta Categor\xEDa antes de clonarla o eliminarla.",
          location: "Solo puedes clonar o eliminar Categor\xEDas en Enterprise mode."
        }
      },
      taxesSection: {
        title: "IMPUESTOS",
        toolTip: "Add the taxes that apply to all items in this category. Individual menu items can have the taxes removed, or custom tax rates added on an item-by-item basis.",
        categoryTaxes: "Impuestos Personalizados de categor\xEDa",
        emptyCardsMessage: "Ningun impuesto asignado a esta categor\xEDa",
        table: {
          headers: {
            taxRateName: "Nombre de la tasa de impuestos",
            type: "Tipo",
            tax: "Impuestos",
            details: "Detalles",
            enable: "Habilitado"
          }
        }
      },
      associations: {
        title: " de Subcategor\xEDas, Elementos, Combos y Men\xFAs",
        subcategories: {
          title: "Subcategor\xEDas",
          description: "Las subcategor\xEDas listadas a continuaci\xF3n son las subcategor\xEDas habilitadas en la versi\xF3n de elemento y combo asociada al grupo de ubicaci\xF3n.",
          emptyCardsMessage: "Ninguna subcategor\xEDa para esta categor\xEDa",
          addExistingSubcategory: "Transferir Subcategor\xEDa existente",
          noSubcategory: "Sin Subcategor\xEDa",
          noCategory: "Sin Categor\xEDa"
        },
        items: {
          title: "Elementos",
          description: "Elementos asignados a esta categor\xEDa.",
          emptyCardsMessage: "Ningun elemento para esta categor\xEDa"
        },
        combos: {
          title: "Combos",
          description: "Combos asignados a esta categor\xEDa.",
          emptyCardsMessage: "Ningun Combo para esta categor\xEDa"
        },
        menuTypes: {
          title: "Men\xFAs",
          description: "Los Men\xFAs listados a continuaci\xF3n son los Men\xFAs habilitados en los elementos y combos asociados a esta categor\xEDa.",
          emptyCardsMessage: "Ningun Men\xFA para esta categor\xEDa"
        }
      }
    },
    subcategoryDetails: {
      noElementFoundMessage: "Esta subcategor\xEDa no existe en {{location}}",
      basic: {
        title: "B\xC1SICO",
        toolTip: "Subcategories allow further grouping of items within a category. Up to 10 subcategories can be added to a category. Subcategories will display when their parent category is selected.\nExamples: \nCategory Beer>Subcategories Draft Beer, Bottle Beer\nCategory Entrees>Subcategories Chicken, Steak, Seafood",
        name: "Nombre",
        posName: "Nombre de POS",
        hide: "Ocultar Subcategor\xEDa",
        hideInfo: "Ocultar Subcategor\xEDa",
        previewTitle: "Vista Previa:",
        customizer: "Subcategor\xEDa Customizable de tama\xF1o",
        customizertoolTip: "Should only be enabled for subcategories that will include menu items using the Customizer Display. Enable to be prompted for a size selection for the item prior to adding forced or optional modifiers. This feature allows changing sizes of menu items while also changing the Modifier Item Pricing Versions. An example of when to enable this would be a pizza subcategory, where the user is selecting the size of the pizza first, and topping costs change based on the size of the pizza ordered.",
        deleteModal: {
          title: "Elimina las asociaciones de la subcategor\xEDa",
          body: "Para poder eliminarla, por favor reasigna todos los elementos a otra subcategor\xEDa."
        },
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de esta Subcategor\xEDa antes de clonarla o eliminarla.",
          location: "Solo puedes clonar o eliminar Subcategor\xEDas en Enterprise mode."
        }
      },
      associations: {
        title: "de Categor\xEDa, Elementos y Combos",
        category: {
          label: "Categor\xEDa",
          toolTip: "Select the Category to which the Subcategory belongs",
          placeholder: "Selecciona una categor\xEDa"
        },
        items: {
          title: "Elementos",
          description: "El orden en el que se muestran los elementos aqu\xED, es el orden con el cual ser\xE1n mostrados en el m\xF3dulo de Registro. Presione el bot\xF3n de Editar para ordenarlos a su preferencia, arrastrando y soltando los elementos.",
          emptyCardsMessage: "Ningun elemento para esta subcategor\xEDa"
        },
        combos: {
          title: "Combos",
          description: "El orden en el que se muestran los Combos aqu\xED, es el orden con el cual ser\xE1n mostrados en el m\xF3dulo de Registro. Presione el bot\xF3n de Editar para ordenarlos a su preferencia, arrastrando y soltando los elementos.",
          emptyCardsMessage: "Ningun Combo para esta subcategor\xEDa"
        }
      },
      taxesSection: {
        title: "IMPUESTOS",
        toolTip: "Add the taxes that apply to all items in this subcategory. Individual menu items can have the taxes removed, or custom tax rates added on an item-by-item basis.",
        subcategoryTaxes: "Impuestos Expec\xEDficos de Subcategor\xEDa",
        emptyCardsMessage: "Ningun impuesto asignado a esta subcategor\xEDa"
      },
      createNewElement: {
        loading: "Creando subcategor\xEDa",
        success: "Subcategor\xEDa creada satisfactoriamente",
        error: "Error al enviar la nueva subcategor\xEDa"
      },
      editElement: {
        loading: "Actualizando subcategor\xEDa",
        success: "Subcategor\xEDa actualizada satisfactoriamente",
        error: "Error al actualizar la subcategor\xEDa"
      },
      deleteElement: {
        loading: "Eliminando subcategor\xEDa",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar la subcategor\xEDa"
      }
    },
    menuTypeDetails: {
      noElementFoundMessage: "Este Men\xFA no tiene ning\xFAn elemento en {{location}}",
      createNewElement: {
        loading: "Creando Men\xFA",
        success: "Men\xFA creado satisfactoriamente",
        error: "Error al enviar el nuevo Men\xFA"
      },
      editElement: {
        loading: "Actualizando Men\xFA",
        success: "Men\xFA actualizado satisfactoriamente",
        error: "Error al actualizar el Men\xFA"
      },
      deleteElement: {
        loading: "Eliminando Men\xFA",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Men\xFA"
      },
      unassociateElement: {
        loading: "Desasociando Men\xFA",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Men\xFA"
      },
      basic: {
        hide: "Ocultar Men\xFA",
        online: "Men\xFA Online",
        enableSimpleMode: "Modo simple",
        enableSimpleModetoolTip: "Enable for a menu with no categories. When in an order, no search bar will appear for searching within the menu. Screen layout is simple, with the category buttons removed, there is more space on screen for additional menu items",
        onlineInfo: "Men\xFA Disponible Online",
        hideInfo: "Ocultar Men\xFA",
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Men\xFA antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Men\xFAs en Enterprise mode"
        },
        comboDisplayName: "Nombre de visualizaci\xF3n del Combo",
        comboDisplayNametoolTip: "Enter the name a \u201Ccombo\u201D will display as in this menu. For example, Value Meal, Set Menu, Package Deal, Platter",
        disableCoursing: "Deshabilitar tiempos",
        disableCoursingtoolTip: "Enable to turn off coursing for items in this menu",
        enableRounding: "Habilitar ordenar por rondas",
        enableRoundingtoolTip: "Enable to allow items in this menu to be grouped \u201Cby round\u201D.  Typically used for drinks, items will be assigned to a round and can quickly be reordered by round",
        defaultToHomeScreen: "Ir a pantalla de inicio despu\xE9s de seleccionar un elemento",
        coursingType: "Tipo de tiempos",
        coursingTypeOptions: {
          none: "Ninguno",
          coursing: "Tiempos",
          rounding: "Rondas"
        },
        coursingDisabledLabel: "Los tiempos est\xE1n deshabilitados actualmente. Por favor aseg\xFArate de que tu organizaci\xF3n o licencia no sea QSR y verifica que los tiempos est\xE9n habilitados en tu configuraci\xF3n."
      },
      itemAssociations: {
        title: "ASOCIACIONES DE ELEMENTOS",
        subtitle: "Categor\xEDas",
        label: "Las Categor\xEDas a continuaci\xF3n son las Categor\xEDas habilitadas en las Versiones de Art\xEDculos y Combos asociadas al Grupo de Ubicaci\xF3n.",
        emptyCardsMessage: "Ninguna categor\xEDa para este Men\xFA"
      },
      assignedItems: {
        title: "ELEMENTOS ASIGNADOS",
        subtitle: "Elementos",
        label: "Elementos asignados a este Men\xFA",
        actionButtons: {
          addNewItem: "Agregar nuevo Elemento",
          addExistingItem: "Agregar Elemento existente"
        },
        emptyCardsMessage: "Ningun elemento para este Men\xFA"
      },
      assignedCombos: {
        title: "COMBOS ASIGNADOS",
        subtitle: "Combos",
        label: "Combos asignados a este Men\xFA",
        emptyCardsMessage: "Ningun Combo para este Men\xFA"
      },
      taxes: {
        title: "Impuestos",
        menuTypeTaxes: "Impuestos Personalizados de Men\xFA",
        emptyCardsMessage: "Ningun impuesto asignado a este Men\xFA"
      },
      associations: {
        title: " de Elementos, Combos, Categor\xEDas y Subcategor\xEDas"
      }
    },
    modifierGroupDetails: {
      noElementFoundMessage: "Este modificador de grupo no existe en {{location}}",
      createNewElement: {
        loading: "Creando modificador de grupo",
        success: "Modificador de grupo creado satisfactoriamente",
        error: "Error al enviar el nuevo modificador de grupo"
      },
      editElement: {
        loading: "Actualizando modificador de grupo",
        success: "Modificador de group actualizado satisfactoriamente",
        error: "Error al actualizar el modificador de grupo"
      },
      deleteElement: {
        loading: "Eliminando modificador de grupo",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el modificador de grupo"
      },
      unassociateElement: {
        loading: "Desasociando modificador de grupo",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el modificador de grupo"
      },
      associations: {
        title: 'Elementos y Elementos modificadores usando "{{name}}"',
        items: {
          title: 'Elementos usando "{{name}}"',
          description: "Este modificador de grupo est\xE1 siendo usado por los siguientes elementos.",
          emptyCardsMessage: "Ningun elemento para este modificador de grupo"
        },
        modifierItems: {
          modItems: "Elementos Modificadores",
          title: 'Modificadores de elemento usando "{{name}}"',
          description: "Este modificador de grupo esta siendo usado en los siguientes modificadores de elemento.",
          emptyCardsMessage: "No Modifier Items for this Modifier Group",
          showPricing: "Mostrar Precios",
          showPricingtoolTip: "Select to view and change the Included and Additional price for each modifier item based on pricing version",
          showMaximums: "Mostrar Maximos"
        },
        modifierGroups: {
          title: "Versiones de precio del modificador de grupo",
          description: "Selecciona la versi\xF3n de precio que quieras ver la informaci\xF3n",
          emptyCardsMessage: "Ninguna versi\xF3n de precio para este modificador de grupo",
          editMaximums: "Editar Maximos"
        },
        modifierItemsPricing: {
          title: "Modificadores",
          description: "El orden como se muestra aqui es el orden que sera mostrado en registro. Presiona el boton de editar para acomodar los items en el orden deseado.",
          emptyCardsMessage: "No Modifier Items for this Modifier Group",
          modals: {
            updatePricingVersion: "Actualizar versi\xF3n del precio",
            addPricingVersion: "A\xF1adir versi\xF3n del precio",
            deletePricingVersion: "Eliminar versi\xF3n del precio",
            pricingVersionName: "Nombre de la Versi\xF3n del precio"
          },
          editDisabled: "Solo puedes eliminar Versiones de Precio de Modificadores de Grupo en Enterprise mode.",
          addDisabled: "Solo puedes agregar Versiones de Precio de Modificadores de Grupo en Enterprise mode.",
          breaksSpacesModal: {
            title: "Agregar Espacios en Blanco/Saltos de linea",
            blankSpaces: "Espacios en blanco antes de los Items",
            lineBreaks: "Saltos del linea antes de los Items"
          },
          maximumQuantity: "Maximum Quantity"
        }
      },
      basic: {
        quantityMode: "Tipo de cantidad",
        quantityModetoolTip: "Select the behavior for the quantity of modifier items entered\nx1,x2,x3 - One or more of each item can be added to the menu item. For example, adding a quantity of salad dressings when prompted for a dressing choice, or selecting individual bottled beers in a \u201Cbeer bucket\u201D menu item\nLt,Reg,Ext - Modifiers added will display as Light, Regular or Extra when using the modifier.  For example, a burger comes with lettuce, tomato, and onion.  The user will be able to adjust the modifiers using the \u2013 and + sign to indicate light or extra of the chosen modifier.  Extra Lettuce, light onion in this example.\nNone - Modifiers will appear either selected or unselected",
        requiredModifierItems: "Art\xEDculos requeridos",
        requiredModifierItemstoolTip: "Enter the number of required modifiers that are part of the menu item. These are required choices, and the user is unable to complete the menu item until all required selections have been made.",
        selectRequired: "Selecciona requeridos",
        includedModifierItems: "Art\xEDculos incluidos",
        includedModifierItemstoolTip: "Enter the number of modifier items that are included as part of the menu item",
        maximumModifierItems: "Art\xEDculos Maximos",
        maximumModifierItemstooltip: "Enter the maximum number of modifier items that are allowed to be ordered for this modifier group",
        noMax: "Sin Maximo",
        pricingMode: "Modo de precio",
        pricingModetoolTip: "Select the pricing mode that will be used when modifiers have upcharges\nMaximize - The system prioritizes the most expensive upcharge modifiers, resulting in the best deal for the restaurant. This mode ensures any potential upcharges are maximized.\nExample: A customer is allowed to add premium toppings sandwich, and the first two are free.  The customer chooses Bacon ($1.00), Cheddar ($1.00) and Avocado ($2.00).  The system will charge $2.00 for the avocado, even if the avocado was entered as one of the first two modifiers.  The $1.00 toppings will be considered the free items in this example.\nMinimize - The system prioritizes the modifiers so that any upcharges result in the best deal for the customer, making the item the least expensive based on modifiers added to the item.\nExample: A customer is allowed to add premium toppings sandwich, and the first two are free.  The customer chooses Bacon ($1.00), Cheddar ($1.00) and Avocado ($2.00).  The system will minimize the price, causing the Avocado ($2.00) to be one of the free toppings, and will add the upcharge of $1.00 for either Bacon or Cheddar depending on the order they were entered.",
        selectIncluded: "Selecciona incluidos",
        hideModifierGroup: "Ocultar Grupo modificador",
        multiselect: "Selecci\xF3n multiple",
        multiselecttoolTip: "Allows the selection of multiple modifiers in the modifier group. De-select to allow only one choice/entry to be made in this modifier group.",
        activatePizzaSectionSelector: "Activar selector de customizado",
        activatePizzaSectionSelectortoolTip: "Enable to show the customizer selector for this menu item. This is used when an item can be modified by the whole, half, and quarters. Typically used for pizza.",
        allowNoneSelection: 'Permitir selecci\xF3n "Ninguno"',
        allowNoneSelectiontoolTip: "Enable to allow user to select \u201Cnone\u201D when the modifier group is displayed on screen. A user is not required to make a choice of modifier and may select \u201Cnone\u201D to move on.",
        hidePriceIfFree: "Ocultar precio si es gratis",
        showModGroupTitleOn: "Mostrar t\xEDtulo de grupos modificadores en:",
        showModGroupTitleOntoolTip: "The Mod Group Title serves as a header that categorizes and organizes the individual modifiers selected by Modifier Group.",
        showModGroupTitleOnRegisterTicket: "Ticket de registro",
        showModGroupTitleOnRegisterTickettoolTip: "Enable to show the Mod Group Title on the Register Ticket, so the user entering the order can see the Mod Group Title followed by the modifiers in the ticket detail area",
        showModGroupTitleOnKitchenTicket: "Ticket de cocina",
        showModGroupTitleOnKitchenTickettoolTip: "Enable to show the Mod Group Title on the Kitchen Ticket, so the kitchen staff can see the Mod Group Title followed by the modifiers on the kitchen ticket",
        guestCheck: "Cuenta de Invitado",
        guestChecktoolTip: "Enable to show the Mod Group Title on the Guest check, so the customer can see the Mod Group Title followed by the modifiers on the guest check",
        advancedModifier: 'Mostrar en "M\xE1s modificadores"',
        showSearchBar: "Mostrar barra de busqueda",
        showSearchBartoolTip: "Enable to display a search bar in the modifier group on the register, to search for a modifier by name",
        searchAllModifierItems: "Buscar todos los Elementos Modificadores",
        searchAllModifierItemstoolTip: "This option becomes available when \u201CShow Search Bar\u201D is enabled. Enable to allow searching all modifier items in the Search Bar.",
        global: "Modificador global",
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Modificador de Grupo antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Modificadores de Grupo en Enterprise mode"
        },
        enableModTags: "Habilitar Etiquetas Modificadoras",
        enableModTagstoolTip: "Enable to allow user to use the Mod Tags for this menu item. This will allow the user access to the No, On Side, Lite, Extra, and any custom mod tags when selecting a modifier in this modifier group",
        enableQuantityBar: "Habilitar Barra de Cantidad",
        enableQuantityBartoolTip: "For use when Quantity Mode is set to x1,x2,x3. Enable to add a quantity bar in the item details area when modifying a menu item.",
        customizerSlicing: {
          title: "Rebanado de la Pizza",
          halves: "Mitades",
          quarters: "Cuartos"
        }
      }
    },
    modifierItemDetails: {
      noElementFoundMessage: "Este modificador de elemento no existe en {{location}}",
      createNewElement: {
        loading: "Creando modificador de elemento",
        success: "Modificador de elemento creado satisfactoriamente",
        error: "Error al enviar el nuevo modificador de elemento"
      },
      editElement: {
        loading: "Actualizando modificador de elemento",
        success: "Modificador de elemento actualizado satisfactoriamente",
        error: "Error al actualizar el modificador de elemento"
      },
      deleteElement: {
        loading: "Eliminando modificador de elemento",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el modificador de elemento"
      },
      unassociateElement: {
        loading: "Desasociando modificador de elemento",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el modificador de elemento"
      },
      basic: {
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Modificador de Elemento antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Modificadores de Elemento en Enterprise mode"
        },
        removeItemTaxExempt: "Remover exenci\xF3n de impuestos del art\xEDculo",
        removeItemTaxExemptToolTip: "Si activas esta opci\xF3n, siempre se aplicar\xE1n impuestos a este art\xEDculo, sin importar si normalmente est\xE1 exento"
      },
      associations: {
        title: ' Grupos de Modificadores y Elementos usando "{{name}}"',
        modifierGroups: {
          title: 'Modificadores de grupo usando "{{name}}"',
          description: "Este modificador de elemento est\xE1 siendo usado por los siguientes modificadores de grupo.",
          emptyCardsMessage: "Ningun modificador de grupo para este modificador de elemento",
          activeModifierGroupError: "El Grupo Modificador est\xE1 inactivo, asi que no puedes mostrarlo en este Modificador de Elemento"
        },
        linkedItem: {
          title: "Elemento Vinculado",
          emptyCardsMessage: "Ningun Elemento vinculado para este Modificador de Elemento"
        }
      },
      pricing: {
        title: "PRECIOS",
        subtitle: "Versiones de precio del modificador del art\xEDculo",
        description: "Selecciona la versi\xF3n de precio que quieras ver la informaci\xF3n",
        labels: {
          price: "Precio",
          includedPrice: "Precio Incluido",
          additionalPrice: "Precio adicional",
          lightPrice: "Precio chico",
          regularPrice: "Precio Regular",
          extraPrice: "Precio extra",
          includedLightPrice: "Precio chico incluido",
          includedRegularPrice: "Precio Regular incluido",
          includedExtraPrice: "Precio extra incluido",
          additionalLightPrice: "Precio adicional chico",
          additionalRegularPrice: "Precio adicional regular",
          additionalExtraPrice: "Precio adicional extra",
          applyQuarterHalfAndWholePricing: "Aplicar precio de cuarta parte, mitad y entero",
          applyQuarterHalfAndWholePricingtooltip: "Only in use when the modifier item belongs to a modifier group using the \u201CActivate Customizer Selector\u201D option. Set the percentage of the price that will apply when adding the modifier to a quarter or half of a parent item. Typically used with pizza, to change the price for toppings added to quarter or half of the pizza.",
          quarterPrice: "Precio de la cuarta parte",
          halfPrice: "Precio de la mitad",
          wholePrice: "Precio entero",
          pricingMode: "Modo de precio",
          otherOptions: "Otras opciones",
          advancedPricingMode: "Mode de precio avanzado",
          advancedPricingModetoolTip: "Enable to allow additional pricing options for the modifier item. x1, x2,x3 pricing, Light/Regular/Extra/On the Side pricing, and quarter/half/whole pricing",
          x1x2x3PricingModeTitle: "Pricing for modifier items when the item belongs to a modifier group using the \u201CX1,X2,X3\u201D Quantity Mode. Prices can be $0.00, negative or positive dollar values.",
          x1x2x3IncludedPrice: "Set the price for the modifier item when it is included with the parent item.\nFor example, a burger comes with a choice of side.  Fries ($0.00) or Side Salad ($1.00).  This would be the amount entered in the included price field.",
          x1x2x3AdditionalPrice: "Set the price for the modifier item when it is ordered as an additional modifier, not part of the included quantity that comes with an item.\nFor example, a specialty pizza can have additional toppings added.  Pepperoni as an additional topping is $2.00.  This would be the amount entered in the additional price field.",
          LtRegExtPricingModeTitle: "Pricing for modifier items when the item belongs to a modifier group using the \u201CLt, Reg,Ext\u201D Quantity Mode. Prices can be $0.00, negative or positive dollar values.",
          LtRegExtIncludedLightPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CLight\u201D option is selected.",
          LtRegExtAdditionalLightPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CLight\u201D option is selected.",
          LtRegExtIncludedRegularPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CRegular\u201D option is selected.",
          LtRegExtAdditionalRegularPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CRegular\u201D option is selected.",
          LtRegExtIncludedExtraPrice: "Set the price for the modifier item when it is included with the parent item, and the \u201CExtra\u201D option is selected.",
          LtRegExtAdditionalExtraPrice: "Set the price for the modifier item when it is ordered as an additional modifier, and the \u201CExtra\u201D option is selected.",
          masterPrice: "Precio",
          onSidePrice: "Precio de un lado",
          onSidePricetoolTip: "Set the price for the modifier item when it is ordered using the \u201Con the side\u201D mod tag."
        },
        editDisabled: "Solo puedes eliminar Versiones de Precio de Modificadores de Elemento en Enterprise mode.",
        addDisabled: "Solo puedes agregar Versiones de Precio de Modificadores de Elemento en Enterprise mode."
      },
      modifier: {
        buttonDisabled: {
          title: "No puedes modificar",
          body: "Solo puedes modificar un Modificador de Elemento por defecto dentro de su Modificador de Grupo."
        }
      }
    },
    itemGroupsDetails: {
      associations: {
        title: " de Elementos y Combos",
        items: {
          title: "Elementos",
          description: "Elementos asignados a este grupo de elementos.",
          emptyCardsMessage: "Ningun elemento para este grupo de elementos"
        },
        combos: {
          title: "Combos",
          description: "Combos asignados a este grupo de elementos.",
          emptyCardsMessage: "Ningun Combo para este grupo de elementos"
        }
      },
      itemAssociationsSection: {
        showUpCharge: "Mostrar cargo adicional"
      },
      basic: {
        required: "Hacer Requerido",
        upCharge: "Cargo Adicional",
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Grupo de elementos antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Grupos de elementos en Enterprise mode"
        }
      }
    },
    discountDetails: {
      discountScheme: {
        inputs: {
          applyTo: {
            label: "Aplicar a",
            placeholder: "Aplicar a",
            toolTip: "Select whether the discount is an item discount or applies to the entire order\nItem - Discount applied to a single item\nOrder - Discount applied to entire order, for all items eligible for discount",
            options: {
              item: "Elemento",
              order: "Orden"
            }
          },
          discountType: {
            label: "Tipo de Descuento",
            placeholder: "Selecciona un Tipo de Descuento",
            toolTip: "Select which method of discounting applies to the item/order\nPercent - Percent discount on the item/order\nFixed - Dollar amount discount on the item/order",
            options: {
              percent: "Porcentaje",
              fixed: "Fijo",
              override: "Sobrescribir"
            }
          },
          value: {
            percentage: {
              label: "Porcentaje del Descuento",
              toolTip: "Enter the percent off that will be applied for the discount",
              placeholder: "Porcentaje del Descuento"
            },
            amount: {
              label: "Cantidad del Descuento",
              toolTip: "Enter the dollar amount of the fixed discount",
              placeholder: "Cantidad del Descuento"
            },
            override: {
              label: "Sobreescribir Precio",
              placeholder: "Sobreescribir Precio"
            }
          },
          taxes: {
            label: "Impuestos",
            placeholder: "Impuestos",
            toolTip: "Select whether taxes will be applied before or after the item/order when using the discount\nApply Before: Discount will be applied before taxes are calculated on the item/order.  Any applicable sales tax will be due on the item/order\nApply After: Discount will be applied after taxes are calculated on the item/order.  Applicable sales taxes will be calculated based on the taxes due after the item/order is discounted. ",
            options: {
              applyBefore: "Aplicar Antes",
              applyAfter: "Aplicar Desp\xFAes"
            }
          },
          exclusive: {
            label: "Descuento Exclusivo"
          }
        }
      },
      noElementFoundMessage: "Este Descuento no existe en {{location}}",
      createNewElement: {
        loading: "Creando Descuento",
        success: "Descuento creado satisfactoriamente",
        error: "Error al enviar el nuevo Descuento"
      },
      editElement: {
        loading: "Actualizando Descuento",
        success: "Descuento actualizado satisfactoriamente",
        error: "Error al actualizar el Descuento"
      },
      deleteElement: {
        loading: "Eliminando Descuento",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Descuento"
      },
      unassociateElement: {
        loading: "Desasociando Descuento",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Descuento"
      }
    },
    comboDetails: {
      reportingSection: {
        emptyCardsMessage: "Ningun Grupo de Reporte para este Combo"
      },
      menuTypes: {
        title: "Men\xFAs",
        description: "Selecciona los Men\xFAs que quieres que esten disponibles en este Combo",
        sectionDescription: "Seleccione el Men\xFA para ver la informaci\xF3n de este Combo.",
        emptyCardsMessage: "Ningun Men\xFA para este Combo",
        emptyActiveCardsMessage: "Ningun Men\xFA activo para este Combo",
        emptyInactiveCardsMessage: "Ningun Men\xFA inactivo para este Combo"
      },
      applyChangesToMenuType: {
        error: {
          title: "Advertencia de Mezclado",
          description: "Alguno de los Elementos o Grupo de Elementos no fueron encontrados en los otros Men\xFAs. Por favor revisa los cambios que ser\xE1n aplicados a los otros Men\xFAs."
        }
      },
      noElementFoundMessage: "Este combo no existe en {{location}}",
      createNewElement: {
        loading: "Creando combo",
        success: "Combo creado satisfactoriamente",
        error: "Error al enviar el nuevo combo"
      },
      editElement: {
        loading: "Actualizando combo",
        success: "Combo actualizado satisfactoriamente",
        error: "Error al actualizar el combo"
      },
      deleteElement: {
        loading: "Eliminando combo",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el combo"
      },
      unassociateElement: {
        loading: "Desasociando combo",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el combo"
      },
      registerDisplay: {
        hideComboName: "Ocultar el nombre del Combo",
        displayComboPriceOnRegister: "Mostrar el precio del Combo en el Registro",
        uploadImage: "Subir Imagen",
        uploadSecondaryImage: "Subir Imagen Secundaria"
      },
      basic: {
        showComboOnline: "Mostrar Combo en l\xEDnea",
        sharingLabel: "Permitir Compartir Combo"
      },
      pricingSection: {
        isTaxInclusive: "Impuestos Incluidos"
      },
      taxesSection: {
        comboTaxes: "Impuestos Expec\xEDficos de Combo"
      },
      itemGroups: {
        editItemGroup: "Editar Grupo de Elementos",
        activeItemGroupError: "El Grupo de Elementos est\xE1 inactivo, asi que no puedes mostrarlo en este Combo",
        description: "Debajo se encuentran los Grupos de Elementos asociados a este Combo, cualquier cambio hecho a los Grupos de Elementos, ser\xE1 una sobrecarga, reperesentada por un punto azul"
      },
      associations: {
        title: "de Categor\xEDa y Subcategor\xEDa"
      }
    },
    specialDetails: {
      menuTypes: {
        title: "Men\xFAs",
        description: "Selecciona los Men\xFAs que quieres que esten disponibles en este Especial",
        sectionDescription: "Seleccione el Men\xFA para ver la informaci\xF3n de este Especial.",
        emptyCardsMessage: "Ningun Men\xFA para este Especial",
        emptyActiveCardsMessage: "Ningun Men\xFA activo para este Especial",
        emptyInactiveCardsMessage: "Ningun Men\xFA inactivo para este Especial"
      },
      applyChangesToMenuType: {
        error: {
          title: "Advertencia de Mezclado",
          description: "Alguno de los Elementos/Combos no fueron encontrados en los otros Men\xFAs. Por favor revisa los cambios que ser\xE1n aplicados a los otros Men\xFAs."
        }
      },
      associations: {
        title: "de Elementos y Combos",
        addExistingItemCombo: "Agregar Elemento/Combo existente",
        restaurantLocations: {
          title: "Ubicaciones de los restaurantes",
          description: "Ubicaciones de los restaurantes a los que el Especial pertenece.",
          emptyCardsMessage: "Ninguna Ubicaci\xF3n adicional para este Especial"
        },
        buyItemIds: {
          emptyCardsMessage: {
            bogo: "Ningun Elemento/Combo de compra para este Especial",
            item: "Ningun Elemento/Combo para este Especial"
          },
          title: {
            bogo: "Elementos/Combos de Compra",
            item: "Elementos/Combos"
          },
          description: {
            bogo: 'Elementos/Combos que el cliente tiene que "Comprar" para poder optar a Comprar X Obtener X',
            item: "Elementos/Combos a los que pertenece el Especial:"
          }
        },
        getItemIds: {
          mimicItems: "Imitar Comprar Elementos/Combos",
          mimicOverlay: "Obtener Elementos/Combos est\xE1 imitando (copiando) comprar Elementos/Combos",
          clearAllItems: "Borrar todos",
          emptyCardsMessage: {
            bogo: "Ningun Elemento/Combo para obtener en este Especial"
          },
          title: {
            bogo: "Obtener Elementos/Combos"
          },
          description: {
            bogo: 'Art\xEDculos/Combos a los que se puede aplicar el Descuento Especial, previa compra de la cantidad "Comprar".'
          }
        }
      },
      scheme: {
        title: "ESQUEMA DE ESPECIALES",
        toolTip: "Item/Combo - menu items assigned will be able to be discounted by a set amount\nOrder - the entire order will be able to be discounted by a set amount\nBuy X Get X - Set the parameters for the menu items that can be ordered to trigger the special, and set the items that will be awarded, as well as the discount amount. ",
        discountTypetoolTip: "Select which method of discounting applies to this item\nPercent - Percent discount on the item/combo\nFixed - Dollar amount discount on the item/combo\nOverride - Set a price for the item/combo that will override the regular menu price while the special is in effect",
        discountPercentagetoolTip: "Enter the percent off that will be applied during the time the special is available",
        discountAmounttoolTip: "Enter the dollar amount of the fixed discount",
        discountOverridetoolTip: "Enter the dollar amount of the fixed discount",
        applyTo: {
          options: {
            item: "Elemento/Combo",
            order: "Orden",
            bogo: "Compra X Obten X"
          }
        },
        inputs: {
          thresholdAmount: {
            label: "Cantidad L\xEDmite"
          },
          buyQuantity: {
            label: "Compra:",
            toolTip: "Enter the purchase quantity required to trigger the special",
            error: "Cero No Permitido"
          },
          getQuantity: {
            label: "Obtienes:",
            toolTip: "Enter the quantity to be awarded when the trigger threshold is met",
            error: "Cero No Permitido"
          }
        }
      },
      noElementFoundMessage: "Este Especial no existe en {{location}}",
      createNewElement: {
        loading: "Creando Especial",
        success: "Especial creado satisfactoriamente",
        error: "Error al enviar el nuevo Especial"
      },
      editElement: {
        loading: "Actualizando Especial",
        success: "Especial actualizado satisfactoriamente",
        error: "Error al actualizar el Especial"
      },
      deleteElement: {
        loading: "Eliminando Especial",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Especial"
      },
      unassociateElement: {
        loading: "Desasociando Especial",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Especial"
      },
      basic: {
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Especial antes de clonarlo o eliminarlo.",
          location: "Solo puedes clonar o eliminar Especiales en Enterprise mode."
        }
      },
      availability: {
        title: "DISPONIBILIDAD",
        toolTip: "Set the days and times the special will be available",
        table: {
          title: "Tiempos Disponibles",
          addTime: "Agregar Tiempo",
          noData: "Sin Tiempos"
        }
      }
    },
    ingredientDetails: {
      noElementFoundMessage: "Este Ingrediente no existe en {{location}}",
      createNewElement: {
        loading: "Creando Ingrediente",
        success: "Ingrediente creado satisfactoriamente",
        error: "Error al enviar el nuevo Ingrediente"
      },
      editElement: {
        loading: "Actualizando Ingrediente",
        success: "Ingrediente actualizado satisfactoriamente",
        error: "Error al actualizar el Ingrediente"
      },
      deleteElement: {
        loading: "Eliminando Ingrediente",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Ingrediente"
      },
      unassociateElement: {
        loading: "Desasociando Ingrediente",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Ingrediente"
      },
      associations: {
        title: "de Elementos",
        description: "Elementos asignados a este Ingrediente",
        selectionModal: {
          menuTypeDescription: "Selecciona los Men\xFAs en los que quieres incluir este Ingrediente."
        },
        emptyCardsMessage: "Ning\xFAn Elemento para este Ingrediente"
      }
    },
    noElementToast: {
      title: "Elemento no encontrado"
    },
    itemsMain: {
      showListView: "Mostrar Vista de Lista",
      table: {
        varies: "*Var\xEDa",
        noTaxes: "Sin Impuestos",
        noCategories: "Sin Categor\xEDas",
        noModifierGroups: "Sin Grupos Modificadores",
        noReportingGroups: "Sin Grupos de Reporte",
        noPrinterLocations: "Sin Ubicaciones de Impresoras",
        headers: {
          name: "Nombre",
          price: "Precio",
          taxes: "Impuestos",
          quantity: "Cant.",
          categoriesSubcategories: "Cat./Subcat.",
          modifierGroups: "Grupos Modificadores",
          printerLocations: "Ubicaciones de Impresoras",
          reportingGroups: "Grupos de Reporte"
        }
      },
      massUpdate: {
        button: "Actualizaci\xF3n masiva",
        massUpdateInformation: {
          itemsSelectedFrom: "Elementos seleccionados de",
          editItemsSelection: "Editar selecci\xF3n de elementos",
          viewSelection: "Ver Selecci\xF3n"
        }
      },
      multiselect: {
        button: "Selecci\xF3n multiple",
        multiselectInformation: {
          itemsSelectedFrom: "Elementos seleccionados de",
          editItemsSelection: "Editar selecci\xF3n de elementos",
          viewSelection: "Ver Selecci\xF3n"
        }
      }
    },
    combosMain: {
      table: {
        noItemGroups: "Sin Grupos de Elementos"
      }
    },
    specialsMain: {
      table: {
        bogo: "Compra {{buy}} Obten {{get}}"
      }
    },
    menuTypesMain: {
      table: {
        headers: {
          itemCount: "Artic.|Combos|Cat.|Subcat."
        }
      },
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Men\xFAs desde Enterprise mode."
      }
    },
    ingredientsMain: {
      table: {
        headers: {
          items: "Articulos Asociados"
        }
      },
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Ingredientes desde Enterprise mode."
      }
    },
    reportingGroupsMain: {
      table: {
        noCombos: "Sin Combos",
        headers: {
          combos: "Combos Asociados"
        }
      }
    },
    categoryMain: {
      table: {
        noSubcategories: "Sin Subcategor\xEDas",
        headers: {
          itemCount: "Artic.|Combos"
        }
      },
      menuTypesDropdown: {
        label: "Men\xFA",
        placeholder: "Men\xFA"
      },
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Categor\xEDas desde Enterprise mode."
      }
    },
    subcategoriesMain: {
      categoriesDropdown: {
        label: "Categor\xEDa",
        placeholder: "Categor\xEDa"
      },
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Subcategor\xEDas desde Enterprise mode."
      }
    },
    modifierItemsMain: {
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar \xCDtems Modificadores desde el Enterprise mode."
      },
      modifierGroupDropdownLabel: "Asignado a Grupo de Modificador",
      table: {
        inStock: "En Existencia",
        headers: {
          pricing: "Precios",
          is86ed: "Inventario",
          nestedModifiers: "Modificadores anidados",
          modifierGroups: "Mod de Grupo usando este Mod de Elemento"
        }
      }
    },
    modifierGroupsMain: {
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Grupos Modificadores desde el Enterprise mode."
      },
      table: {
        noModifierItems: "Sin Elementos Modificadores",
        headers: {
          quantityMode: "Tipo de Cantidad",
          maximumModifierItems: "Max",
          includedModifierItems: "Incl.",
          requiredModifierItems: "Req.",
          modifierItems: "Elementos Modificadores",
          itemCount: "Elementos associ."
        }
      }
    },
    itemGroupsMain: {
      disabledActionToast: {
        title: "Alerta",
        description: "Solo puedes agregar Grupos de Articulos desde el Enterprise mode."
      }
    }
  },
  customersScreen: {
    newCustomer: "Nuevo Cliente",
    diffModal: {
      title: "Detalles Del Cliente"
    },
    errors: {
      dateOfBirth: "Formato invalido de fecha de nacimiento",
      firstName: "Primer nombre es obligatorio",
      lastName: "Apellido es obligatorio",
      phoneNumber: {
        empty: "El n\xFAmero de telefono no puede estar vac\xEDo.",
        invalid: "El n\xFAmero de telefono debe ser de 10 digitos.",
        duplicated: "Un cliente con este tel\xE9fono ya existe."
      }
    },
    singular: "Cliente",
    plural: "Clientes",
    creation: {
      title: "\xBFFinalizar la creaci\xF3n del Cliente?",
      message: "Usted est\xE1 creando un nuevo Cliente. Antes de salir de esta pantalla, debe finalizar la creaci\xF3n del Cliente o cancelarla."
    },
    editElement: {
      loading: "Actualizando Cliente",
      success: "Cliente actualizado satisfactoriamente",
      error: "Error al actualizar el Cliente"
    },
    createNewElement: {
      loading: "Creando Cliente",
      success: "Cliente creado satisfactoriamente",
      error: "Error al enviar el nuevo Cliente"
    },
    mainScreen: {
      searchingMessage: "Buscando Cliente",
      loadingMessage: "Cargando Clientes",
      emptyDataText: "Ning\xFAn cliente ha sido registrada a\xFAn"
    },
    basic: {
      firstName: "Nombre",
      middleName: "Segundo Nombre",
      lastName: "Apellido",
      dateOfBirth: "Fecha de Nacimiento",
      email: "Email",
      phoneNumber: "Numero de Telefono",
      customerNotes: "Notasl del Cliente",
      contactDetails: "Detalles de Contacto"
    },
    addressInfo: {
      title: "INFORMACI\xD3N DE DIRECCI\xD3N",
      emptyDataText: "Ninguna direcci\xF3n ha sido registrada a\xFAn",
      addressType: {
        house: "Casa",
        hotel: "Hotel",
        office: "Oficina",
        apartment: "Departamento"
      },
      addressInfoModal: {
        title: {
          create: "Crear Direcci\xF3n del Cliente",
          edit: "Editar Direcci\xF3n del Cliente"
        }
      },
      table: {
        isDefault: "Por Defecto",
        addressType: "Tipo de Direcci\xF3n",
        streetLine1: "Calle 1",
        streetLine2: "Calle 2",
        city: "Ciudad",
        state: "Estado",
        postalCode: "C\xF3digo Postal",
        addressName: "Nombre del Hotel/Oficina",
        unitNumber: "# de Unidad",
        apartmentNumber: "# de departamento",
        officeName: "Nombre de la oficina",
        hotelName: "Nombre del hotel",
        roomNumber: "# de cuarto"
      }
    },
    cardInfo: {
      title: "INFORMACI\xD3N DE TARJETAS",
      emptyDataText: "Ninguna tarjeta ha sido registrada a\xFAn",
      cardType: {
        MasterCard: "MasterCard",
        Visa: "Visa",
        AmericanExpress: "American Express"
      },
      table: {
        lastFourDigits: "\xFAltimos 4 digitos de la tarjeta",
        cardType: "Tipo de Tarjeta",
        dateOfLastUsed: "Fecha de \xFAltimo uso"
      }
    },
    orders: {
      title: "ORDENES",
      summary: {
        totalOfOrdersPlaced: "# total de ordenes colocadas",
        avgSpend: "Avg Gastado",
        lifetimeSpend: "Gastado en toda la vida",
        avgTip: "Avg Propina %",
        avgTipAmount: "Avg monto de propina",
        percentageBreakdownOfDineIn: "% De desglose para comer aqui",
        percentageBreakdownOfDelivery: "% De desglose para entrega",
        percentageBreakdownOfToGo: "% De desglose para llevar",
        percentageBreakdownOfCatering: "% De desglose para abastecimiento"
      },
      lastOrders: {
        title: "Ordenes Previas",
        emptyDataText: "Ninguna ordern ha sido registrada",
        table: {
          orderId: "Id de Orden",
          createdAt: "Tiempo de Creaci\xF3n",
          total: "Monto Total",
          locationId: "Nombre de la Locaci\xF3n",
          status: "Estatus"
        }
      }
    }
  },
  viewAllOrdersScreen: {
    modals: {
      filter: {
        title: "FILTROS",
        subtitle: "Todas las \xF3rdenes",
        orderOwner: "Encargado de la orden",
        orderStatus: "Estatus de la orden",
        orderType: "Tipo de orden",
        orderCreated: "Fecha de creaci\xF3n",
        orderModified: "Fecha de modificaci\xF3n",
        selectedOwners: "Encargados seleccionados",
        noOwnersSelected: "Sin encargados seleccionados",
        dineIn: "Comer aqu\xED",
        curbside: "Curbside",
        pickUp: "Recoger",
        delivery: "Entrega",
        toGo: "Llevar",
        today: "Hoy",
        start: "Inicio",
        end: "Fin",
        orderStatusNames: {
          open: "Abierta",
          "tip-pending": "Propina Pendiente",
          failed: "Fallida",
          closed: "Cerrada",
          other: "Otro"
        },
        orderSubstatusNames: {
          initiated: "Iniciada",
          ordered: "Ordenado",
          checkPrinted: "Cheque Impreso",
          "tip-pending": "Propina Pendiente",
          batchPending: "Batch Pending",
          complete: "Completada",
          readyForPickup: "Lista para recoger",
          onTheWay: "En camino",
          voided: "Anulada"
        },
        itemOptions: {
          reprintToKitches: "Reimprimir en Cocina",
          voidItem: "Anular \xC1rticulo",
          unvoidItem: "Desanular \xC1rticulo",
          deleteItem: "Remover \xC1rticulo"
        },
        editingNotAllowed: {
          title: "No se puede editar",
          description: "No se puede editar la orden porque est\xE1 siendo editada por otro usuario."
        },
        batchPayments: {
          title: "Confirmaci\xF3n de pagos",
          description: "Se har\xE1 la confirmaci\xF3n de todos los pagos con tarjeta.",
          batchPay: "Confirmar",
          pendingTipPaymentsWarning: "Algunos pagos no se ha confirmado la propina.",
          continue: "\xBFSeguro que desea continuar?",
          resume: {
            title: "Estado de pagos por lote",
            description: "Por favor revise la lista siguiente de los resultados de la confirmaci\xF3n de pagos.",
            success: "Pagos confirmados con \xE9xito por terminal",
            failed: "Pagos con confiraci\xF3n fallida por terminal"
          },
          selectTerminals: "Seleccionar terminales",
          selectTerminalsDescription: "Seleccione las terminales que desea confirmar.",
          error: {
            title: "Error al solicitar la confirmaci\xF3n de los pagos",
            description: "Hubo un error al solicitar la confirmaci\xF3n de los pagos. Por favor intente de nuevo."
          }
        }
      }
    }
  },
  settingsModule: {
    selectionModal: {
      printers: {
        title: "Seleccionar impresora",
        selectedSectionTitle: "Impresoras seleccionados",
        emptySectionText: "Por favor seleccione una impresora existente para asociar",
        noCardSelectedText: "Impresoras no seleccionados",
        noAvailableCardsText: "Impresoras no disponibles"
      }
    },
    devices_licenses: {
      addTablet: "Agregar Tablet",
      editTabletModal: {
        title: "Editar Tablet",
        titleAdd: "Agregar Tablet",
        success: "Tablet actualizada exitosamente",
        successAdd: "Tablet a\xF1adida exitosamente"
      },
      addPrinter: "A\xF1adir Impresora",
      editPrinterModal: {
        title: "Editar Impresora",
        titleAdd: "A\xF1adir Impresora",
        success: "Impresora actualizada exitosamente",
        successAdd: "Impresora a\xF1adida exitosamente",
        successRemove: "Impresora eliminada exitosamente",
        selectBackupPrinter: "Selecciona Impresora de Respaldo",
        selectPrinterMake: "Selecciona Marca de Impresora",
        selectType: "Selecciona Tipo",
        deletePrinter: "Eliminar Impresora"
      },
      title: "Dispositivos y Licencias",
      addLicenses: "A\xF1adir Licencias",
      addTerminal: "A\xF1adir Terminal",
      myLicenseSettings: "Mi Configuraci\xF3n de Licencia",
      currentDevice: "Dispositivo Actual",
      deactivate: {
        loading: "Desactivando Licencia"
      },
      associateLocation: {
        loading: "Cambiando Ubicaci\xF3n de Licencia"
      },
      editElement: {
        success: "Configuraci\xF3n de Dispositivos y Licencias actualizado satisfactoriamente",
        error: "Error al actualizar la Configuraci\xF3n de Dispositivos y Licencias",
        loading: "Actualizando Configuraci\xF3n de Dispositivos y Licencias"
      },
      buttons: {
        devices: "Dispositivos",
        licenses: "Licencias",
        printers: "Impresoras",
        tablets: "Tablets",
        terminals: "Terminales",
        connectPrinter: "Conectar Impresora"
      },
      tabletsTable: {
        name: "Nombre",
        status: "Estado",
        license: "Licencia",
        androidId: "Android ID #",
        appVersion: "Versi\xF3n de App",
        emptyDataTitle: "A\xFAn no se han agregado tablets",
        emptyDataSubtitle: 'Presione el bot\xF3n "Agregar tablet" para agregar nuevas tablets',
        emptyBySearchTitle: "No se han encontrado resultados para tu b\xFAsqueda",
        emptyBySearchSubtitle: "Aseg\xFArate de que todas las palabras est\xE9n escritas correctamente",
        activate: "Activar",
        deactivate: "Desactivar",
        notLicensed: "Sin Licencia"
      },
      licensesTable: {
        licenseSerial: "# Serial de Licencia",
        nickname: "Nombre",
        activationDate: "Fecha de Activaci\xF3n",
        licenseType: "Tipo de Licencia",
        location: "Ubicaci\xF3n",
        associatedDevice: "Dispositivo Asociado",
        actions: "Acciones",
        emptyDataTitle: "A\xFAn no se han agregado licencias",
        emptyDataSubtitle: 'Presione el bot\xF3n "A\xF1adir Licencia" para agregar nuevas Licencias',
        emptyBySearchTitle: "No se han encontrado resultados para tu b\xFAsqueda",
        emptyBySearchSubtitle: "Aseg\xFArate de que todas las palabras est\xE9n escritas correctamente",
        deactivate: "Desactivar",
        activationCode: "C\xF3digo de Activaci\xF3n:",
        noDevice: "Sin Dispositivo",
        actionsButtons: {
          editLicenseSettings: "Editar configuraci\xF3n de licencia",
          changeLocation: "Cambiar Ubicaci\xF3n"
        }
      },
      printersTable: {
        name: "Nombre",
        deviceSerial: "Dispositivo # Serial",
        make: "Marca",
        model: "Modelo",
        paperWidth: "Ancho de Papel",
        type: "Tipo",
        backupPrinter: "Impresora de Respaldo",
        status: "Estado",
        macAddress: "Direcci\xF3n MAC",
        actions: "Acciones",
        emptyDataTitle: "A\xFAn no se han agregado impresoras",
        emptyDataSubtitle: 'Presione el bot\xF3n "Conectar impresora" para agregar nuevas impresoras',
        emptyBySearchTitle: "No se han encontrado resultados para tu b\xFAsqueda",
        emptyBySearchSubtitle: "Aseg\xFArate de que todas las palabras est\xE9n escritas correctamente",
        positionOne: "Caja Posici\xF3n 1",
        positionTwo: "Caja Posici\xF3n 2",
        showInPrinterCenter: "Mostrar en el Centro de Impresi\xF3n"
      },
      terminalsTable: {
        name: "Nombre",
        tpn: "TPN",
        authKey: "Clave de Autenticaci\xF3n",
        authToken: "Token de Autenticaci\xF3n",
        licenses: "Licencias",
        actions: "Acciones",
        emptyDataTitle: "A\xFAn no se han a\xF1adido Terminales",
        emptyDataSubtitle: 'Pulse el bot\xF3n "Conectar Terminal" para a\xF1adir nuevas Terminales',
        emptyBySearchTitle: "No hay resultados para su b\xFAsqueda",
        emptyBySearchSubtitle: "Aseg\xFArese de que todas las palabras est\xE9n escritas correctamente",
        noLicenses: "No Licenses",
        associatedLicenses: "Licencias Asociadas"
      },
      editTerminalModal: {
        title: "Editar Terminal",
        success: "Terminal Actualizada Exitosamente",
        associateLicense: "Asociar Licencia",
        associatedLicense: "Licencia Asociada",
        deleteTerminal: "Eliminar Terminal",
        deleteSuccess: "Terminal Eliminada Exitosamente"
      }
    },
    usersSettings: {
      webPortalAccess: "Acceso al Portal Web",
      roles: "Roles",
      description: "Add all roles the user may select to sign in to the register",
      generateNewPin: "Generate New PIN",
      enterEmailAddress: "Por favor ingrese la direcci\xF3n de correo electr\xF3nico que desea asociar a este nuevo usuario",
      activeSwitchInfo: "El estatus de un usuario solo puede ser cambiado para ubicaciones individuales",
      addExistingUser: "Asignar Usuario a Ubicaci\xF3n",
      addNewUser: "Agregar nuevo usuario",
      addNewUserTag: "Nuevo usuario",
      addingNewUser: "A\xF1adiendo nuevo usuario",
      editElement: {
        loading: "Actualizando usuario",
        success: "Usuario actualizado satisfactoriamente",
        error: "Error al actualizar el usuario"
      },
      selectionModal: {
        selectButton: "SELECCIONAR",
        QUITARButton: "DESELECCIONAR",
        header: {
          options: {
            cancel: "Cancelar",
            associate: "A\xF1adir usuario"
          }
        },
        selectedSectionTitle: "Usuarios seleccionados",
        title: "Seleccionar usuarios",
        emptySectionText: "Por favor seleccione un usuario existente para asociar",
        noCardSelectedText: "Usuarios no seleccionados",
        noAvailableCardsText: "Usuarios no disponibles"
      },
      locationSelectionModal: {
        rolesSectionDescription: "Seleccion al menos 1 rol para asociar a"
      },
      createNewElement: {
        loading: "Creando Usuario",
        success: "Usuario creado satisfactoriamente",
        error: "Error al enviar el nuevo Usuario"
      },
      emailErrorToast: {
        emailToastErrorTitleLocation: "El usuario ya existe en la ubicaci\xF3n actual",
        emailToastErrorTitleOrganization: "El usuario ya existe en la organizaci\xF3n actual",
        emailToastErrorDescription: "Por favor ingrese un correo electr\xF3nico diferente"
      },
      loader: {
        text: "Buscando usuario por E-mail:"
      },
      deleteElement: {
        loading: "Eliminando Usuario",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar al Usuario"
      },
      forbiddenChangesToasts: {
        deactivateCurrentUser: {
          title: "No se puede Desactivar",
          description: "No puedes desactivar tu propio usuario."
        },
        removeAcccessToCurrentUser: {
          title: "No se puede Remover Acceso",
          description: "No puedes remover el acceso al portal web a tu propio usuario."
        }
      },
      unassociateElement: {
        loading: "Desasociando Usuario",
        success: "Desasociado satisfactoriamente",
        error: "Error al desasociar el Usuario"
      }
    },
    guestCheckSettings: {
      title: "Cuenta de Invitado",
      subtitle: "CONFIGURACIONES DE CUENTA DE INVITADO",
      customizingReceipts: {
        title: "PERSONALIZACI\xD3N DE ENCABEZADO/PIE DE P\xC1GINA DE P\xC1GINA",
        checkHeader: "Encabezado de Cuenta",
        checkFooter: "Pie de P\xE1gina de Cuenta"
      },
      editElement: {
        loading: "Actualizando Configuraciones de Cuenta de Invitado",
        success: "Configuraciones de Cuenta de Invitado actualizadas satisfactoriamente",
        error: "Error al actualizar las Configuraciones de Cuenta de Invitado"
      },
      sortItemsBy: {
        options: {
          registerCourse: "Curso de Registro",
          menuCourse: "Curso de Men\xFA",
          timeAddedToTicket: "Tiempo Agregado al Ticket",
          timeSentToKitchen: "Tiempo Enviado a Cocina"
        }
      },
      secondSortItemsBy: {
        options: {
          alphabetical: "Alfabeticamente",
          alphabeticalReverse: "Alfabeticamente Inverso",
          timeAddedToTicket: "Tiempo Agregado al Ticket"
        }
      },
      taxIndicators: {
        title: "Indicadores de Impuestos",
        taxIndicatorPosition: "Posici\xF3n del Indicador",
        taxIndicatorColor: "Color del Indicador",
        taxIndicator: "Indicador de Impuestos",
        taxExemptIndicator: "Indicador de exenci\xF3n de impuestos",
        showTaxIndicator: "Mostar Indicador de Impuestos"
      },
      customOrderTypeNames: {
        title: "Custom Order Type Names"
      }
    },
    guestReceiptSettings: {
      editElement: {
        success: "Configuraci\xF3n de Recibo de Invitado Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Recibo de Invitado",
        loading: "Actualizando Configuraci\xF3n de Recibo de Invitado"
      },
      checkDisplay: {
        showCheckTotals: "Mostrar totales de la cuenta",
        printMerchantCopy: "Imprimir copia del comerciante",
        showTaxesIndividually: "Mostrar impuestos individualmente",
        printOrderQr: "Imprimir C\xF3digo QR del # de Orden en pie de p\xE1gina"
      },
      suggestedTips: {
        title: "Propinas Sugeridas",
        showSuggestedTips: "Mostrar propinas sugeridas",
        showTipTotalLines: "Imprimir linea Propina/Total",
        tipOption1: "Opci\xF3n de Propina 1",
        tipOption2: "Opci\xF3n de Propina 2",
        tipOption3: "Opci\xF3n de Propina 3"
      },
      footerDescription: {
        title: "Descripci\xF3n de Pie de P\xE1gina",
        showFooterDescription: "Mostrar descripci\xF3n del pie de p\xE1gina",
        addFooterDescription: "Agregar descripci\xF3n del pie de p\xE1gina"
      },
      items: {
        title: "Elementos",
        showItems: "Mostrar Elementos"
      }
    },
    licenseSpecificPrinterRules: {
      editElement: {
        success: "Configuraci\xF3n de Reglas de Impresi\xF3n Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Reglas de Impresi\xF3n",
        loading: "Actualizando Configuraci\xF3n de Reglas de Impresi\xF3n"
      }
    },
    userDetailsSettings: {
      title: "Datos del usuario",
      noElementFoundMessage: "Este usuario no existe en {{location}}",
      emailModalPlaceholder: "usuario@ejemplo.com",
      resendInvite: "Reenviar invitaci\xF3n",
      resendInviteRequest: {
        loading: "Reenviando Invitaci\xF3n",
        success: "Invitaci\xF3n Reenviada",
        error: "Error al Reenviar Invitaci\xF3n"
      },
      basic: {
        email: "Correo electr\xF3nico",
        firstName: "Nombre",
        lastName: "Apellidos",
        phone: "Tel\xE9fono",
        pin: "PIN",
        pintoolTip: "Enter the number the user will use to clock in and sign into the register",
        changeEmailBtn: "Cambiar correo electr\xF3nico",
        changeUserBtn: "Cambiar cuenta de TT",
        changeEmailTitle: "Cambiar correo electr\xF3nico del usuario",
        changeAccountTitle: "Cambiar Email de la Cuenta de TableTurn",
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Usuario antes de eliminarlo.",
          location: "Solo puedes eliminar Usuarios en Enterprise mode."
        },
        tableTurnAccount: "Cuenta de Table Turn",
        organizationAccount: "Cuenta de la organizaci\xF3n",
        userStatus: "Estado del usuario:",
        orgStatus: "Estado de la organizaci\xF3n:",
        swipeCardDescription: "Desliza o ingresa el n\xFAmero de tarjeta para ligar a este usuario",
        linkCard: "Asociar Tarjeta",
        status: {
          new: {
            name: "Nuevo usuario TableTurn",
            userStatusDescription: "Este correo electr\xF3nico no existe en TT. Una vez que termine de crear el usuario, p\xEDdale que revise su correo electr\xF3nico y siga los pasos para verificar su direcci\xF3n de correo electr\xF3nico.",
            orgStatusDescription: ""
          },
          unverified: {
            name: "Esperando confirmaci\xF3n de la organizaci\xF3n",
            userStatusDescription: "Este correo electr\xF3nico ya existe dentro de TT, por lo que su informaci\xF3n est\xE1 precompletada. Debido a que el usuario a\xFAn no ha verificado su correo electr\xF3nico, todos los datos son editables. Una vez que termine de agregar el usuario a su organizaci\xF3n, p\xEDdale que revise su correo electr\xF3nico y siga los pasos para verificar su direcci\xF3n de correo electr\xF3nico.",
            orgName: "Esperando la confirmacion de la organizati\xF3n",
            orgStatusDescription: "Este usuario no inici\xF3 sesi\xF3n en el portal ni acept\xF3 la invitaci\xF3n a esta organizaci\xF3n. A\xFAn puede iniciar sesi\xF3n en esta ubicaci\xF3n y utilizar todas las funciones."
          },
          verified: {
            name: "Verificado TableTurn",
            userStatusDescription: "Este correo electr\xF3nico ya existe para un usuario verificado dentro de TT, por lo que su informaci\xF3n est\xE1 precompletada. Para cambiar esta informaci\xF3n, haga que el usuario inicie sesi\xF3n en el portal.",
            orgName: "Organizaci\xF3n verficada",
            orgStatusDescription: "El usuario est\xE1 verificado en su organizaci\xF3n y puede acceder a su portal web para ver la informaci\xF3n permitida."
          },
          noVerificationRequired: {
            name: "Confirmaci\xF3n No Requerida",
            userStatusDescription: "Este usuario no tiene acceso al portal web de esta organizaci\xF3n.",
            orgName: "Confirmaci\xF3n No Requerida",
            orgStatusDescription: "Este usuario no tiene acceso al portal web de esta organizaci\xF3n."
          }
        }
      },
      associations: {
        clockedInError: {
          title: "No se puede eliminar el Rol",
          description: "{{userName}} ha marcado entrada como {{roleName}}"
        },
        locationsSubsectionTitle: "Ubicaciones de restaurantes",
        locationsSubsectionSubtitle: "Seleccione la ubicaci\xF3n para la que desea ver los roles del usuario",
        emptyLocationsMessage: "Usuario no asignado a ninguna ubicaci\xF3n",
        emptyRolesMessage: "No hay roles asociados a este usuario en esta ubicaci\xF3n"
      }
    },
    prepStationsSettings: {
      title: "Ubicaciones de Impresoras",
      addPrepStationButtonText: "A\xF1adir Ubicacion de Impresora",
      addPrinterButtonText: "A\xF1adir impresora",
      selectedPrinters: "Impresoras seleccionadas",
      noPrintersSelected: "No hay impresoras seleccionadas",
      printers: "Impresoras",
      printerTypes: {
        receipt: "Recibo",
        kitchen: "Cocina",
        sticky: "Sticky"
      },
      general: {
        status: "Estado",
        name: "Nombre",
        posName: "Nombre de POS",
        printers: "Impresora (s) - Si multipes impresoras son agregadas, la primera impresora disponible imprimir\xE1 el ticket."
      },
      editElement: {
        success: "Successfully updated Prep Stations Settings",
        error: "Error updating Prep Stations Settings",
        loading: "Updating Prep Stations Settings"
      },
      errors: {
        name: "Error en la tabla de Ubicaciones de Impresoras."
      },
      defaultPrepStationSection: {
        title: "UBICACION DE IMPRESORA POR DEFECTO",
        description: "Si una Ubicacion de Impresora por defecto es seleccionada, todos los Elementos que no esten asociados a una Ubicaci\xF3n de Impresora ser\xE1n impresos en esta Ubicaci\xF3n de Impresora.",
        defaultPrepStationId: {
          label: "Selecciona la Ubicaci\xF3n de Impresora por defecto",
          noDefaultPrepStation: "Sin Ubicaci\xF3n de Impresora por Defecto"
        }
      }
    },
    licenseSettings: {
      overrides: "Sobreescribir",
      description: " - Establezca \xFAnicamente las siguientes configuraciones espec\xEDficas para esta licencia si desea sobreescribir la configuraci\xF3n predeterminada de su restaurante.",
      createNewElement: {
        loading: "Creando Configuracion de licencia",
        success: "Configuraci\xF3n de Licencia creada correctamente",
        error: "Error al crear Configuraci\xF3n de Licencia"
      },
      editElement: {
        success: "Configuraci\xF3n de Licencia Actualizada Correctamente",
        error: "Error al Actualizar la Configuraci\xF3n de Licencia",
        loading: "Actualizando Configuraci\xF3n de Licencia"
      },
      errors: {
        registerAutoLock: "Ingrese un tiempo valido para el Cierre de Sesi\xF3n Autom\xE1tico.",
        nickname: "Apodo es requerido.",
        revenueCenterId: "Centro de Ingresos es requerido.",
        defaultServiceAreaId: "\xC1rea de Servicio Predeterminada es requerida.",
        eGiftCardTerminalId: "Un numero de 4 es requerido para el ID de Terminal."
      },
      basicSettings: {
        title: "AJUSTES B\xC1SICOS DE LICENCIA",
        description: "Seleccione la Configuraci\xF3n B\xE1sica para esta Licencia",
        nickname: "Nombre",
        stationNumber: "Numero",
        revenueCenter: "Centro de Ingresos (Para Informes)",
        registerAutoLogout: "Tiempo de logout autom\xE1tico",
        registerAutoLogouttoolTip: "Enter the amount of time in seconds before the register will log out due to inactivity",
        language: "Idioma",
        displayMode: "Modo de Visualizaci\xF3n (Claro/Oscuro)",
        fontSize: "Tama\xF1o de Fuente",
        restaurantMode: "Modo Restaurante",
        menu: "Men\xFA",
        suppressSuggestiveOrderingPrompts: "Suprimir Sugerencias de Pedido ",
        printOrderNumberOnSend: "Imprimir n\xFAmero de pedido al enviar",
        nicknamePlaceholder: "Apodo",
        autoLogoutPlaceholder: "Tiempo",
        languageDropdownOptions: {
          english: "Ingl\xE9s",
          spanish: "Espa\xF1ol"
        },
        displayModeDropdownOptions: {
          light: "Claro",
          dark: "Oscuro"
        },
        fontSizeDropdownOptions: {
          small: "Peque\xF1o",
          normal: "Normal",
          big: "Grande"
        },
        restaurantModeDropdownOptions: {
          tsr: "Servicio de Mesa",
          qsr: "Servicio R\xE1pido"
        }
      },
      paymentSettings: {
        title: "CONFIGURACIONES DE PAGO",
        description: "Establecer la configuraci\xF3n de pago para esta licencia",
        eGiftCardTerminalId: "ID de Terminal Egift",
        acceptHousePayments: "Aceptar pagos de la casa"
      },
      tableServiceOrderSettings: {
        title: "CONFIGURACI\xD3N DEL ORDEN DE SERVICIO DE MESA",
        description: "Establecer la configuraci\xF3n del pedido para este dispositivo",
        makingAndPlacingOrders: "Realizar y colocar pedidos",
        defaultServiceArea: "\xC1rea de Servicio Predeterminada",
        defaultServiceAreaOptions: {
          all: "Todos",
          no_table: "Sin Mesa",
          to_go: "Para llevar",
          delivery: "Entrega",
          catering: "Abastecimiento"
        },
        suppressCoursing: "Suprimir Cursado",
        suppressSeating: "Suprimir Asientos",
        suppressAutoTriggering: "Suprimir Disparo Autom\xE1tico"
      },
      quickServiceOrderSettings: {
        title: "CONFIGURACI\xD3N DE PEDIDOS DE SERVICIO R\xC1PIDO",
        description: "Establecer la configuraci\xF3n del pedido para esta licencia",
        sendAndPaymentSettings: "Configuraci\xF3n de env\xEDo y pago",
        customerFacingDisplay: "Pantalla Mostrada al Cliente",
        useCFD: "Usar PMD",
        sendAndPaymentActionButtons: "Botones de acci\xF3n enviar y pagar",
        sendOrderToKitchenWhen: "Enviar pedido a la cocina cuando:",
        sendAndPayOverrideDropdownOptions: {
          sendOnly: "Solo Enviar",
          payOnly: "Solo Pagar",
          both: "Ambos"
        },
        SendToKitchenOverrideDropdownOptions: {
          paymentCompleted: "Pago Completado",
          paymentInitiated: "Pago Iniciado"
        }
      },
      printerSettings: {
        title: "CONFIGURACI\xD3N DE IMPRESORA",
        description: "Seleccione la configuraci\xF3n de impresi\xF3n para este dispositivo",
        printing: "Impresi\xF3n",
        autoPrint: "Imprime autom\xE1ticamente una ficha para todos los pedidos realizados",
        printReceiptOnPayment: "Imprime autom\xE1ticamente un recibo cuando se realiza un pago",
        viewEditPrintingRules: "Ver / Editar Reglas de Impresi\xF3n",
        overrideDescription: "Las reglas de impresi\xF3n lo ayudan a garantizar que los pedidos entrantes se impriman desde las impresoras correctas de su restaurante.",
        defaultCheckPrinter: {
          description: "Impresora de Cuentas",
          modalTitle: "Impresora Principal",
          noPrinter: "No Impresora"
        }
      },
      deviceDeactivation: {
        title: "DESACTIVACI\xD3N DEL DISPOSITIVO",
        description: "Al desactivar el dispositivo se eliminar\xE1 la licencia de este dispositivo. Todos los datos y configuraciones permanecer\xE1n con la licencia y se eliminar\xE1n de este dispositivo.",
        button: "Desactivar dispositivo"
      }
    },
    roleDetailsSettings: {
      basic: {
        displayOptions: {
          title: "Opciones de Visualizaci\xF3n",
          description: "Select the text color and background color that will display for the role when prompted to select a role upon clock in"
        },
        optionsDisabled: {
          creation: "Debes terminar la creaci\xF3n de este Rol antes de clonarlo.",
          location: "Solo puedes clonar Roles en Enterprise mode."
        }
      },
      home: {
        title: "INICIO",
        homeScreenDefaultModules: {
          noAccess: "Sin Acceso",
          title: "M\xF3dulos por Defecto de pantalla de inicio",
          description: 'Todos los m\xF3dulos a los que tiene acceso este rol estan listados a continuaci\xF3n. Los m\xF3dulos que estan "encendidos" (en azul) son los que ser\xE1n mostrados en la pantalla de inicio. Activa y desactiva los m\xF3dulos pulsando sobre ellos.',
          emptyCardMessage: "Sin m\xF3dulos",
          modules: {
            registerModuleDefault: "Registro",
            menuModuleDefault: "Men\xFA",
            settingsModuleDefault: "Configuraciones",
            managementModuleDefault: "Gesti\xF3n",
            reportsModuleDefault: "Reportes",
            homeModuleDefault: "Inicio",
            customersModuleDefault: "Clientes"
          }
        },
        autoOpenFromLockScreen: {
          title: "Pantalla de inicio por defecto",
          description: "Selecciona el m\xF3dulo que se abrir\xE1 autom\xE1ticamente cuando el usuario entre al sistema."
        },
        requireClockInOnPrompt: "Requerir checar entrada al iniciar sesi\xF3n",
        requireClockInOnPromptToolTip: "Si se encuentra habilitado, el usuario ser\xE1 requerido a checar entrada al iniciar sesi\xF3n"
      },
      general: {
        title: "PANTALLA DE INICIO DE LA TABLETA"
      },
      endOfDay: {
        title: "Fin del D\xEDa",
        endOfDayPermissions: {
          viewShiftSummary: {
            label: "Resumen de Turno al final del d\xEDa",
            options: {
              always: "Siempre",
              never: "Nunca",
              onClockout: "Al checkar salida"
            }
          }
        }
      },
      register: {
        title: "REGISTRO",
        description: "Los siguientes permisos son los asociados a una Orden propiedad de un usuario con este rol",
        navigationOnAction: {
          title: "Pantallas por defecto para m\xF3dulo de caja",
          description: "Seleccione la pantalla por defecto que se mostrar\xE1 cuando el usuario seleccione el m\xF3dulo de caja",
          qsrActionOnPay: {
            label: "QSR - Acci\xF3n al Pagar/Enviar",
            toolTip: "Select what will happen when a user finishes taking payment on an order\nLogout - user will be signed out\nNew Order - user will begin a new order\nView Orders - user will be taken to the Orders screen, displaying all open orders for the current user",
            options: {
              logout: "Cerrar sesi\xF3n",
              newOrder: "Nueva Orden",
              viewOrders: "Ver Ordenes"
            }
          },
          navigationActionOnSendButton: {
            label: 'TSR - Acci\xF3n al "Env\xEDar"',
            toolTip: 'Select what should happen when using the "send" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
            options: {
              viewTables: "Ver Mesas",
              viewOrders: "Ver Ordenes"
            }
          },
          navigationActionOnDoneButton: {
            label: 'TSR - Acci\xF3n en "Listo"'
          },
          navigationActionOnSendStayButton: {
            label: 'TSR - Acci\xF3n al "Env\xEDar y Quedarse"',
            toolTip: 'Select what should happen when using the "send and stay" key\nLogout - user is signed out of the system\nView Tables - user is taken to the table layout map\nView Orders - user is taken to the orders screen',
            options: {
              stayInOrder: "Permanecer en la Orden"
            }
          },
          defaultRegisterScreen: {
            label: "Pantalla inicial por defecto",
            toolTip: "Select what will happen when a user selects the register module\nEnter Order - user will be taken to the default menu to begin adding items to the ticket\nStay In Table Layout - user will stay on the Table Layout screen",
            options: {
              viewTables: "Ver Mesas",
              viewTabs: "Ver Tabs",
              viewOrders: "Ver Ordenes",
              newOrder: "Nueva Orden"
            }
          },
          navigationActionOnCloseOrder: {
            label: "Acci\xF3n al Cerrar Orden",
            toolTip: "Selecciona la acci\xF3n a ejecutar o la pantalla a la cual navegar autom\xE1ticamente cuando una orden pase a status Cerrada"
          },
          navigationActionOnTipPending: {
            label: "Acci\xF3n al Propina Pendiente",
            toolTip: "Selecciona la acci\xF3n a ejecutar cuando una orden pase a status Propina Pendiente"
          },
          navigationActionOnPrintChecks: {
            label: "Action on Print Checks",
            toolTip: "Select what should happen when the user prints checks\n<1/>Logout - user is signed out of the system\n<1/>View Tables - user is taken to the table layout map\n<1/>View Orders - user is taken to the orders screen",
            options: {
              sendAndLogout: "Send Items And Logout",
              sendAndViewTables: "Send Items And View Tables",
              sendAndViewTabs: "Send Items And View Tabs",
              sendAndViewOrders: "Send Items And View Orders",
              sendAndClearRegister: "Send Items And Clear Register",
              send: "Send Items",
              none: "None"
            }
          },
          navigationActionOnFire: {
            label: "Acci\xF3n al enviar a cocina",
            toolTip: "Selecciona la acci\xF3n a ejecutar o la pantalla a la cual navegar autom\xE1ticamente cuando una orden pase a status Enviada a Cocina"
          },
          defaultOrderType: {
            label: "Tipo de Pedido Predeterminada",
            toolTip: "Seleccione cu\xE1l ser\xE1 el tipo de pedido predeterminado entre cenar en el lugar o para llevar",
            options: {
              dineIn: "Comer aqu\xED",
              toGo: "Para Llevar"
            }
          },
          autoFilterTableTabsOrders: {
            label: "Auto Filtrar Pedidos por Usuario",
            toolTip: "Permite el filtrado autom\xE1tico de pedidos por usuario"
          }
        },
        orderPermissionsForOwners: {
          title: "Permisos de Ordenes para Propietarios",
          description: "Los siguientes permisos son los asociados a una Orden propiedad de un usuario con este rol.",
          createOrders: "Crear Orden",
          createOrderstoolTip: "Enable to allow users to begin a new order via the table layout or \u201Cnew order\u201D button",
          deleteOrders: "Vaciar Orden",
          deleteOrderstoolTip: 'Enable to allow the user to use the "void order" key',
          modifyItemsSentToKitchen: "Modificar Elementos enviados a imprimir",
          modifyItemsSentToKitchentoolTip: "Enable to allow user to modify items which have already been sent to remote printers",
          manageTables: "Gestionar Mesas",
          manageTablestoolTip: "Enable to allow user to merge/unmerge tables, set table availability and status",
          addAnyDiscount: "Aplicar Descuentos",
          addCustomDiscounttoolTip: "Enable to allow user to enter a custom percent, fixed, or override discount when discounting an item or ticket",
          addAnyDiscounttoolTip: "Enable to allow user to apply discounts to an order. If option is disabled, user will be prompted for authorization before being able to apply discounts to an order.",
          addCustomDiscount: "Crear Descuentos Personalizados",
          editItemPrice: "Editar el precio del Elemento",
          allow86: "Permitir 86",
          allow86toolTip: "Enable to allow user to use the \u201C86\u201D key to remove an item from the menu",
          editItemPricetoolTip: "Enable to allow user to edit an item\u2019s price using the \u201Cedit price\u201D key",
          allowChangeMenuType: "Mostrar Selector de Men\xFA",
          allowChangeMenuTypetoolTip: "Enable to allow user to navigate between different menus using the Menu Selector",
          createOpenItemsOrModItems: "Crear Articulo Abierto o Elemento Modificador",
          createOpenItemsOrModItemstoolTip: "Enable to allow user to use \u201COpen Item\u201D or \u201COpen Mod\u201D keys, creating a custom name and price for an item or modifier",
          exemptTax: "Impuesto exento",
          exemptTaxtoolTip: "Excentar el impuesto",
          allowNoTaxInclusive: 'Permitir "Sin Impuestos Incluidos"',
          allowNoTaxInclusiveToolTip: "Permite eliminar el monto del impuesto del precio del art\xEDculo para los art\xEDculos con impuestos incluidos y agrega el impuesto base al precio total del art\xEDculo",
          manageServiceCharges: "Gestionar cargos por servicio",
          manageServiceChargestoolTip: "Habilitar para permitir que el usuario agregue o elimine cargos por servicio",
          voidIndividualItems: "Anular Art\xEDculos Individuales",
          voidIndividualItemstoolTip: "Enable to allow user to void individual items from an order",
          sendIndividualItems: "Enviar Art\xEDculos Individuales",
          sendIndividualItemstoolTip: "Enable to allow user to send individual items to the kitchen"
        },
        orderPermissionsForNonOwners: {
          title: "Permisos de Ordenes que pertenecen a otros usuarios",
          description: "Los siguientes permisos son los asociados a una Orden que no pertenece a un usuario con este rol.",
          editOtherUsersOrders: "Modificar una orden perteneciente a otro usuario",
          editOtherUsersOrderstoolTip: "Enable to allow current user to view and make changes to an order belonging to another user",
          transferOrderOwner: "Transferir el propietario de una orden",
          transferOrderOwnertoolTip: "Enable to allow user to transfer an order to a different user",
          overrideLicenseEditingId: 'Tomar el control de la "Edici\xF3n" Control de una orden',
          overrideLicenseEditingIdtoolTip: "When the same order is opened on multiple devices at the same time, only one user can have \u201Cedit\u201D control of an order. When this option is enabled, a user who is in \u201Cview mode\u201D when accessing an order, can override control of the order and take edit control of the order allowing for modifications to the order"
        },
        printingPermissions: {
          title: "Permisos de Impresi\xF3n",
          reprint: "Reimprimir Tickets",
          reprinttoolTip: "Habilitar para permitir al usuario reimprimir un ticket",
          deletePrintJobs: "Eliminar Trabajos de Impresi\xF3n",
          deletePrintJobstoolTip: "Habilitar para permitir al usuario eliminar un trabajo de impresi\xF3n"
        },
        behaviorOnNewOrder: {
          label: "Comportamiento en Nueva Orden",
          toolTip: "Select what will happen when a user begins a new order\nEnter Order - user will be taken to the default menu to begin adding items to the ticket\nStay In Table Layout - user will stay on the Table Layout screen",
          options: {
            enter_order: "Entrar a la orden",
            stay_in_table_layout: "Permanecer en la disposicion de las mesas"
          }
        },
        payments: {
          title: "Pagos",
          createChecks: "Crear Cuentas separadas / Cuentas divididas",
          createCheckstoolTip: "Enable to allow user to split ticket into multiple checks when tendering the order",
          voidRefundPayments: "Anular/Reembolsar Pagos",
          voidRefundPaymentstoolTip: "Habilitar para permitir al usuario anular o reembolsar un pago.",
          createPayments: "Crear Pagos",
          createPaymentstoolTip: "Enable to allow user to apply payments to split checks",
          transferPayments: "Transferir Pagos a Otra Orden",
          transferPaymentsTooltip: "Habilitar para permitir al usuario transferir pagos de una orden a otra",
          batch: "Enviar Lote de Pagos",
          makeHouseChargePayments: "Hacer Pagos de Cuenta de Casa",
          makeHouseChargePaymentstoolTip: "Habilitar para permitir al usuario hacer pagos a una cuenta de casa",
          makeGiftCardPayments: "Hacer Pagos de Tarjeta de Regalo",
          makeGiftCardPaymentstoolTip: "Habilitar para permitir al usuario hacer pagos con tarjetas de regalo"
        },
        drawers: {
          title: "Cajas",
          manageDrawers: "Gestionar Cajas",
          viewDrawerBalance: "Ver Balance de Caja",
          serverBankEnabled: "Banco de Servidor Habilitado",
          allowCashPaymentsToDrawersNotAttached: "Permitir Pagos en Efectivo en Estaciones Sin Cajas",
          cashPaymentOptions: {
            label: "Opciones de Pago en Efectivo",
            options: {
              payToDrawerOnly: "Pagar solo a la Caja",
              payToServerBankOnly: "Pagar solo al Banco de Servidor"
            }
          }
        },
        refundOptions: {
          title: "Opciones de Reembolso",
          refundTypeRefund: "Reembolsar",
          refundTypeAsDiscount: "Reembolsar como Descuento",
          refundTypeToBalanceDueOfZero: "Rembolso a Balance de cero",
          refundTypeReplacePayment: "Reemplazar Pago"
        }
      },
      allowAccessToThisModule: "Permitir acceso a este M\xF3dulo",
      settings: {
        cannotDeactivate: {
          title: "No se puede desactivar",
          description: "No puedes desactivar las configuraciones para el rol que tienes actualmente activo."
        }
      },
      createNewElement: {
        loading: "Creando Rol",
        success: "Rol creado satisfactoriamente",
        error: "Error al enviar el nuevo Rol"
      },
      editElement: {
        loading: "Actualizando Rol",
        success: "Rol actualizado satisfactoriamente",
        error: "Error al actualizar el Rol"
      },
      deleteElement: {
        loading: "Eliminando Rol",
        success: "Eliminado satisfactoriamente",
        error: "Error al eliminar el Rol"
      },
      reports: { title: "REPORTES" },
      webHomeScreen: {
        title: "PANTALLA DE INICIO DE LA WEB",
        description: "Tablero por defecto seleccionado en azul.",
        dashboards: {
          emptyCardsMessage: "Ning\xFAn Tablero para este Rol"
        }
      }
    },
    bucketBar: {
      header: {
        text: "CONFIGURACI\xD3N"
      },
      general: {
        text: "General",
        onlineOrdering: "Pedidos en l\xEDnea"
      },
      accounts: {
        text: "Cuentas",
        users: "Usuarios",
        roles: "Roles"
      },
      printing: {
        text: "Impresiones",
        prepStations: "Ubicaciones de Impresoras",
        printingRules: "Reglas de Impresi\xF3n",
        tickets: {
          text: "Tickets",
          registerTicket: "Ticket de Registro",
          kitchenTicket: "Ticket de cocina",
          customerReceipt: "Cuenta de cliente"
        }
      },
      management: "Gesti\xF3n",
      lockScreen: "Pantalla de bloqueo",
      homeScreen: "Pantalla de Inicio",
      menu: "Men\xFA",
      register: {
        text: "Registro",
        registerMode: "Modo de Registro"
      },
      taxes: "Impuestos",
      payments: "Pagos"
    },
    tabs: {
      general: {
        general: "General",
        onlineOrdering: "Online Ordering"
      },
      accounts: {
        accounts: "Cuentas",
        users: "Usuarios",
        roles: "Roles"
      },
      printing: {
        printing: "Impresi\xF3n",
        prepStations: "Ubicaciones de Impresoras",
        printingRules: "Reglas de impresi\xF3n",
        ticket: "Ticket",
        registerTicket: "Ticket de registro",
        kitchenTicket: "Ticket de cocina",
        guestReceipt: "Recibo del inivittado"
      },
      management: "Gesti\xF3n",
      lockScreen: "Bloquear pantalla",
      homeScreen: "Pantalla de inicio",
      register: {
        register: "Modificadores",
        registerMode: "Modo de registro"
      },
      payments: "Pagos",
      taxes: "Impuestos"
    },
    lockScreenSettings: {
      title: "Configuraci\xF3n de Pantalla de Bloqueo",
      editElement: {
        success: "Configuraci\xF3n de Pantalla de Bloqueo Actualizada",
        error: "Error al Actualizar la Configuraci\xF3n de Pantalla de Bloqueo",
        loading: "Actualizando Configuraci\xF3n de Pantalla de Bloqueo"
      },
      basic: {
        title: "CONFIGURACIONES B\xC1SICAS",
        description: "Las configuraciones b\xE1sicas para la Pantalla de Bloqueo est\xE1n listadas abajo.",
        general: {
          title: "Configuraciones Generales",
          showGiftCardButton: "Mostrar Bot\xF3n de Tarjeta de Regalo"
        },
        announcement: {
          title: "Anuncio",
          titleInput: {
            label: "T\xEDtulo"
          },
          descriptionInput: {
            label: "Descripci\xF3n"
          }
        }
      },
      tabs: {
        title: "PESTA\xD1AS",
        description: "Las siguientes ser\xE1n mostradas en Pantalla de Bloqueo.",
        tab: {
          showFreshSheetTab: "Mostrar Pesta\xF1a de Hoja Fresca",
          showSeatingLayoutTab: "Mostrar Pesta\xF1a de Distrubuci\xF3n de Asientos",
          showEmployeesTab: "Mostrar Pesta\xF1a de Empleados",
          showLocationsTab: "Mostrar Pesta\xF1a de Ubicaciones"
        }
      }
    },
    generalSettings: {
      title: "Configuraciones Generales",
      editElement: {
        success: "Configuraci\xF3n General Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n General",
        loading: "Actualizando Configuraci\xF3n General"
      },
      errors: {
        organizationInformation: {
          name: {
            singleLocation: "El nombre de la organizaci\xF3n/ubicaci\xF3n no puede estar vac\xEDo.",
            location: "El nombre de la ubicaci\xF3n no puede estar vac\xEDo.",
            master: "El nombre de la organizaci\xF3n no puede estar vac\xEDo."
          },
          websiteUrl: {
            empty: {
              singleLocation: "El sitio web de la organizaci\xF3n/ubicaci\xF3n no puede estar vac\xEDo.",
              location: "El sitio web de la ubicaci\xF3n no puede estar vac\xEDo.",
              master: "El sitio web de la organizaci\xF3n no puede estar vac\xEDo."
            },
            invalid: {
              singleLocation: "El sitio web de la organizaci\xF3n/ubicaci\xF3n es inv\xE1lido.",
              location: "El sitio web de la ubicaci\xF3n es inv\xE1lido.",
              master: "El sitio web de la organizaci\xF3n es inv\xE1lido."
            }
          },
          streetLine1: "La calle no puede estar vac\xEDa.",
          city: "La ciudad no puede estar vac\xEDa.",
          postalCode: {
            empty: "El c\xF3digo postal no puede estar vac\xEDo.",
            invalid: "El c\xF3digo postal debe ser de 5 digitos."
          },
          endOfBusinessDay: {
            empty: "Final Del D\xEDa H\xE1bil es requerido.",
            invalid: "Final Del D\xEDa H\xE1bil es invalido."
          }
        },
        operationalDayHours: "Rango(s) inv\xE1lidos de tiempo en Horas de Operaci\xF3n"
      },
      organizationInformation: {
        title: {
          singleLocation: "INFORMACI\xD3N DE LA ORGANIZACI\xD3N/UBICACI\xD3N",
          master: "INFORMACI\xD3N DE LA ORGANIZACI\xD3N",
          location: "INFORMACI\xD3N DE LA UBICACI\xD3N"
        },
        organizationName: {
          label: {
            singleLocation: "Nombre de la organizaci\xF3n/localizaci\xF3n",
            master: "Nombre de la organizaci\xF3n",
            location: "Nombre de la localizaci\xF3n"
          },
          description: {
            singleLocation: "Ingresa el nombre de tu organizaci\xF3n/localizaci\xF3n",
            master: "Ingresa el nombre de tu organizaci\xF3n",
            location: "Ingresa el nombre de tu localizaci\xF3n"
          }
        },
        organizationWebsite: {
          label: {
            singleLocation: "Sitio Web de la organizaci\xF3n/localizaci\xF3n",
            master: "Sitio Web de la organizaci\xF3n",
            location: "Sitio Web de la localizaci\xF3n"
          },
          description: {
            singleLocation: "Ingresa el sitio web de tu organizaci\xF3n/localizaci\xF3n",
            master: "Ingresa el sitio web de tu organizaci\xF3n",
            location: "Ingresa el sitio web de tu localizaci\xF3n"
          }
        },
        organizationPhoneNumber: {
          label: {
            singleLocation: "N\xFAmero de tel\xE9fono de la organizaci\xF3n/localizaci\xF3n",
            master: "N\xFAmero de tel\xE9fono de la organizaci\xF3n",
            location: "N\xFAmero de tel\xE9fono de la localizaci\xF3n"
          },
          description: {
            singleLocation: "Ingresa el n\xFAmero de tel\xE9fono de tu organizaci\xF3n/localizaci\xF3n",
            master: "Ingresa el n\xFAmero de tel\xE9fono de tu organizaci\xF3n",
            location: "Ingresa el n\xFAmero de tel\xE9fono de tu localizaci\xF3n"
          }
        },
        organizationLogo: {
          title: "Logo",
          digitalLogoUrl: {
            title: "Digital",
            description: "Carga tu logo digital"
          },
          printLogoUrl: {
            title: "Impresi\xF3n",
            description: "Carga tu logo de impresi\xF3n"
          },
          modalTitle: {
            digital: "Carga una imagen del logo digital",
            print: "Carga una imagen del logo de impresi\xF3n"
          }
        },
        organizationAddress: {
          title: {
            singleLocation: "Direcci\xF3n de la organizaci\xF3n/localizaci\xF3n",
            master: "Direcci\xF3n de la organizaci\xF3n",
            location: "Direcci\xF3n de la localizaci\xF3n"
          },
          streetLine1: "Calle",
          streetLine2: "Calle 2",
          city: "Ciudad",
          state: "Estado",
          postalCode: "C\xF3digo Postal"
        }
      },
      hoursOfOperation: {
        title: "HORAS DE OPERACI\xD3N",
        timeZone: {
          label: "Selecciona tu zona horaria"
        },
        times: {
          title: "Horas de operaci\xF3n"
        },
        endOfBusinessDay: {
          label: "Final Del D\xEDa H\xE1bil",
          placeholder: "Selecciona un Tiempo"
        }
      },
      generalSettings: {
        title: "CONFIGURACIONES GENERALES",
        clockInMode: {
          title: "Comportamiento al marcar entrada",
          toolTip: "Auto - When not clocked in, upon first sign in user will be prompted to select the role they will be clocking in as, and they system will automatically clock in that user.\nManual - User will be prompted to select a role when signing in, and will need to navigate to the home page to manually use the \u201Cclock in\u201D button to register their time punch.\nPrompt - When not clocked in, upon first sign in user will be prompted to select the role they will be clocking in as, then a prompt will display on screen asking to choose \u201Cclock in\u201D or \u201Clater\u201D",
          label: "Selecciona el comportamiento al marcar entrada que desees que pase para los empleados.",
          values: {
            manual: "Manual",
            prompt: "Solicitar",
            auto: "Auto"
          }
        },
        pinpadLayout: {
          title: "Dise\xF1o del Teclado Num\xE9rico",
          label: "Selecciona el dise\xF1o del Teclado Num\xE9rico que desees que se muestre en el sistema.",
          values: {
            telephone: "Tel\xE9fono",
            calculator: "Calculadora"
          }
        },
        usersLogin: {
          title: "Inicio de Sesi\xF3n",
          allowUserToBeLoggedIntoMultipleTablets: {
            title: "Permitir al Usuario Iniciar Sesi\xF3n en Multiples Dispositivos"
          }
        }
      }
    },
    onlineSettings: {
      title: "Configuraci\xF3n para Ordenar en L\xEDnea",
      basic: {
        title: "BASICO",
        acceptingOrders: "Aceptando Ordenes",
        acceptingOrdersDisabled: {
          title: "Aceptar Ordenes Deshabilitado",
          description: "Recolecci\xF3n o entrega debe ser habilitado para aceptar ordenes."
        },
        defaultMenuTypeId: "Men\xFA Predeterminado",
        onlineMenuTimes: "Tiempos de Men\xFA en L\xEDnea",
        scheduleOutOrder: "Programar ordenes"
      },
      pickup: {
        title: "Recoger",
        pickupIsActive: "Ofrecer Recoger",
        pickupBufferTime: "Tiempo de Recoger",
        pickupAvailability: "Disponibilidad de Recoger"
      },
      delivery: {
        title: "Entrega",
        deliveryIsActive: "Ofrecer Entrega",
        deliveryBufferTime: "Tiempo de Entrega",
        deliveryAvailability: "Disponibilidad de Entrega",
        copyPickupTimes: "Copiar Tiempos de Recoger",
        deliveryRadius: "Radio de Entrega",
        deliveryAvailabilitySetToPickupTimes: "La disponibilidad de entrega estan configurados como los tiempos de recoger."
      },
      pageDesign: {
        title: "Dise\xF1o de P\xE1gina",
        description: "Personaliza la apariencia de tu p\xE1gina para adaptarse a tu marca.",
        showItemImage: "Mostrar Im\xE1genes de Art\xEDculos en Ordenar en L\xEDnea",
        allowSpecialInstructionsOnItems: "Permitir Instrucciones Especiales en Art\xEDculos",
        brandingColors: "Colores de Marca",
        mainColor: "Color Principal",
        secondaryColor: "Color Secundario",
        tertiaryColor: "Color Terciario",
        backgroundColor: "Color de Fondo",
        banner: "Banner",
        showBanner: "Mostrar Banner",
        bannerDescription: "Descripci\xF3n del Banner",
        showCalories: "Mostrar Calor\xEDas"
      },
      tips: {
        title: "Propinas",
        description: "Clientes pueden elegir entre 3 tipos de propinas sugeridas o ingresar una cantidad personalizada.",
        showTippingAtCheckout: "Solicitar propina",
        showCfdTipSelectionOnRegister: "Mostrar propina al cajero",
        suggestedTipDefault: "Propina Seleccionada por defecto",
        noDefaultTip: "Sin propina por defecto",
        suggestedTip1: "Propina Sugerida 1",
        suggestedTip2: "Propina Sugerida 2",
        suggestedTip3: "Propina Sugerida 3"
      },
      editElement: {
        success: "Configuraci\xF3n de Ordenar en L\xEDnea Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Ordenar en L\xEDnea",
        loading: "Actualizando Configuraci\xF3n de Ordenar en L\xEDnea"
      }
    },
    printerRulesSettings: {
      title: "Reglas de impresi\xF3n",
      subTitle: "Las reglas de impresi\xF3n se llevar\xE1n a cabo seg\xFAn la prioridad establecida a continuaci\xF3n en orden de arriba a abajo; puede reordenar las reglas arrastrando y soltando.",
      addRuleText: "Agregar Regla",
      masterUnavailable: "Las reglas de impresi\xF3n deben de agregarse para una ubicaci\xF3n especifica",
      editElement: {
        success: "Configuraci\xF3n de Reglas de Impresi\xF3n Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Reglas de Impresi\xF3n",
        loading: "Actualizando Configuraci\xF3n de Reglas de Impresi\xF3n"
      },
      printerRulesTable: {
        emptyDataTitle: "A\xFAn no se han agregado reglas",
        emptyDataSubtitle: 'Presione el bot\xF3n "Agregar regla" para agregar nuevas reglas de impresi\xF3n',
        name: "Nombre",
        namePlaceholder: "Nombre",
        serviceArea: "\xC1rea de Servicio",
        orderType: "Tipo de Orden",
        daysOfWeek: "D\xEDas de Semana",
        startTime: "Tiempo de Inicio",
        endTime: "Tiempo de Finalizaci\xF3n",
        fromStation: "De Ubicaci\xF3n de Impresora",
        toStation: "A Ubici\xF3n de Impresora",
        order: "Orden",
        errors: {
          name: "Nombre es requerido.",
          fromPrepStationId: "De Ubicaci\xF3n de Impresora es requerido.",
          toPrepStationId: "A Ubicaci\xF3n de Impresora es requerido.",
          equalPrepStations: "La Ubicacion de Impresora de origen no puede ser la misma que la Ubicaci\xF3n de Impresora de destino.",
          timeOverlap: "El Tiempo de Inicio debe ser anterior al Tiempo de Finalizaci\xF3n."
        }
      },
      all: "Todas",
      abbreviatedDays: {
        monday: "Lu",
        tuesday: "Ma",
        wednesday: "Mi",
        thursday: "Ju",
        friday: "Vi",
        saturday: "Sa",
        sunday: "Do",
        noSelected: "Sin D\xEDas Seleccionados",
        all: "Todos"
      }
    },
    taxesSettings: {
      title: "Impuestos",
      titleLong: "Configuraci\xF3n de Impuestos",
      disabled: "Taxes can only be edited in Enterprise mode",
      addTax: "Agregar Impuesto",
      editElement: {
        success: "Configuraci\xF3n de Impuestos Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Impuestos",
        loading: "Actualizando Configuraci\xF3n de Impuestos"
      },
      noElementFoundMessage: "Este Impuesto no existe en {{location}}",
      errors: {
        name: "Nombre de Tasa Impositiva es requerido.",
        orderTypes: "Tipos de Orden es requerido.",
        rate: "Tasa debe ser mayor a 0.",
        interval: "Intervalo debe ser mayor a 0.",
        to: "Desde (Precio de venta) debe ser mayor que Hasta (Precio de venta)."
      },
      taxesTable: {
        emptyDataTitle: "A\xFAn no se han agregado impuestos",
        emptyDataSubtitle: 'Presione el bot\xF3n "Agregar Impuesto" para agregar nuevos impuestos',
        locationEmptyDataSubtitle: 'En Enterprise mode, Presione el bot\xF3n "Agregar Impuesto" para agregar nuevos impuestos',
        name: "Nombre de Tasa Impositiva",
        orderType: "Tipo de Orden",
        type: "Tipo",
        taxType: "Tipo De Impuesto",
        taxTypeData: "Datos de Tipo de Impuesto",
        tax: "Impuesto",
        actions: "Acciones",
        orderTypes: "Tipos de Orden",
        selectTaxType: "Selecciona un Tipo de Impuesto",
        rate: "Tasa",
        interval: "Intervalo",
        unit: "Unidad",
        addRow: "Agregar Fila",
        taxTypes: {
          percent: "Porcentaje (%)",
          fixed: "Fijo",
          table: "Tabla de Impuestos",
          volumetric: "Volum\xE9trico"
        },
        taxTableType: {
          from: "Desde (Precio de venta)",
          to: "Hasta (Precio de venta)",
          tax: "Impuesto",
          priceDifference: "Diferencia de Precio",
          repeat: "Repetir",
          delete: "Eliminar"
        },
        unitTypes: {
          ml: "mL",
          l: "L",
          gal: "Gal",
          qt: "Qt",
          pnt: "Pnt",
          flOz: "fl oz"
        }
      }
    },
    dashboardsSettings: {
      editElement: {
        success: "Tablero Actualizada Satisfactoriamente",
        error: "Error al Actualizar el Tablero",
        loading: "Actualizando Tablero"
      }
    },
    registerTicketSettings: {
      title: "Ticket de Registro",
      ticketDisplay: {
        title: "VISUALICI\xD3N DE LAS CONFIGURACIONES DEL TICKET",
        separateSentItems: "Separar Elementos Enviados",
        separateSentItemstoolTip: "Enable to have all sent items grouped together at the bottom of the register ticket. A \u201CSent\u201D header will display within the ticket, and all sent items will appear below this header.",
        ticketDisplay: {
          title: "Visualizaci\xF3n del ticket",
          showTimestamps: "Mostar hora",
          showTimestampstoolTip: "Enable to show a timestamp in the register ticket for every menu item, showing when the item was ordered. Once the item has been sent, it will display the sent time.",
          showSendCourseButton: "Mostrar bot\xF3n de enviar curso",
          showSendCourseButtontoolTip: "Enable to display a \u201Csend\u201D button within each course header. This allows the user to send an individual course, rather than using the send or send/stay buttons to send the entire order.",
          autoCollapseLineItems: "Colapsar automaticamente elementos de linea",
          autoCollapseLineItemstoolTip: "When this option is enabled, a menu item will display collapsed in the register ticket, showing only the menu item name and price. Modifiers will be hidden in the register ticket, unless actively adding or editing that menu item."
        },
        modifiersDisplay: {
          title: "Visualizaci\xF3n de modificador",
          displayDefaultModifiers: "Mostrar modificador por defecto",
          displayDefaultModifierstoolTip: "Enable to display the default, pre-assigned modifiers that belong to a menu item. For example, a burger is configured with the default modifiers lettuce, tomato, onion. With this option enabled, lettuce, tomato, and onion will display on the register ticket when the item is ordered.",
          showModifierItemPrice: "Mostrar precio del modificador de elemento",
          showModifierItemPricetoolTip: "Enable to have individual modifier item prices display on register ticket",
          hideModGroupTitles: "Esconder titulo del modificador de grupo",
          hideModGroupTitlestoolTip: "Enable this option to hide the modifier group names on the Register Ticket",
          groupSameModItems: "Agrupar los mismos modificadores de elemento",
          groupSameModItemstoolTip: "When enabled, this option will cause modifier items that are the same to consolidate and display as a quantity of items on the register ticket. For example, ordering two sides for fries would appear as Fries (x2). When disabled, modifier items will not consolidate, and appear as separate entries either in a vertical list or comma separated depending on the \u201Cmodifiers display type\u201D selected.",
          addSubForMultiSelectOff: 'Mostrar "Sub" para multiselecci\xF3n apagada',
          addSubForMultiSelectOfftoolTip: "This option only applies when \u201Cmulti-select\u201D is off for a modifier group and a default modifier is assigned. When enabled, the word SUB will be added to the replaced modifier in the modifier group.",
          noForDeselectedDefaultModifiers: 'Mostrar "No" para mod de elemento deseleccionados',
          modifierItemDisplayMode: {
            label: "Tipo de visualizaci\xF3n del modificador",
            toolTip: "Select how modifiers will display on the register ticket\nVertical list: Modifiers will appear as one modifier per line vertically below the menu item\nComma Separated: Modifiers will appear as a comma separated list extending the width of the register ticket, then continue on the next line below",
            options: {
              comma: "Separado por coma",
              vertical: "Lista vertical"
            }
          }
        }
      },
      editElement: {
        success: "Configuraci\xF3n del Ticket Actualizada",
        error: "Error al actualizar la Configuraci\xF3n del Ticket",
        loading: "Actualizando Configuraci\xF3n del Ticket"
      }
    },
    kitchenTicketSettings: {
      prepStationsSection: {
        title: "Ubicaciones de Impresoras",
        description: "Selecciona la Ubicacion de Impresora de la cual quieres ver la informaci\xF3n del ticket.",
        active: "Ubicaciones de Impresoras activas",
        inactive: "Ubicaciones de Impresoras inactivas",
        filterLabel: "Estatus de la Ubicacion de Impresora:",
        emptyCardsMessage: "Sin Ubicaciones de Impresoras",
        emptyActiveCardsMessage: "Sin Ubicaciones de Impresoras activas",
        emptyInactiveCardsMessage: "Sin Ubicaciones de Impresoras inactivas",
        pullFrom: "Jalar Desde",
        pullFromTitle: "Selecciona la ubicaci\xF3n de impresora para jalar",
        pushTo: "Empujar a"
      },
      printTest: {
        success: "Ejemplo de Ticket de Cocina enviado a la impresora {{printerName}}."
      },
      editElement: {
        success: "Configuraci\xF3n de Ticket de Cocina actualizado satisfactoriamente",
        error: "Error al actualizar la Configuraci\xF3n de Ticket de Cocina",
        loading: "Actualizando Configuraci\xF3n de Ticket de Cocina"
      },
      errors: {
        ticketDisplay: {
          updateOrderNewText: "Nuevo Elemento de la visualizaci\xF3n de la actualizaci\xF3n de orden no puede estar vacio.",
          updateOrderVoidText: "Elemento Anulado de la visualizaci\xF3n de la actualizaci\xF3n de orden no puede estar vacio."
        }
      },
      customizingReceiptsTable: {
        value: {
          options: {
            updateStatus: 'Estatus de la actualizaci\xF3n ("Nuevo" or "Actualizaci\xF3n")',
            orderType: "Tipo de orden",
            orderName: 'Nombre de Orden (ej. "Alex")',
            orderNumber: "N\xFAmero de Orden",
            table: "Mesa",
            placedBy: "colocado por",
            server: "Mesero",
            dateAndTime: "Tiempo y Fecha",
            stationName: "Nombre de la Ubicaci\xF3n de Impresora",
            address: "Direcci\xF3n (Solo ordenes de entrega)",
            guestCount: "N\xFAmero de Invitados",
            itemNameAndQuantity: "Nombre del Elemento y cantidad",
            seatNumber: "N\xFAmero de asiento",
            seatTags: "Etiquetas de asiento",
            modifiersInfo: "Informaci\xF3n de los Modificadores",
            organizationName: "Nombre de la organizaci\xF3n",
            locationName: "Nombre de la localizaci\xF3n",
            locationAddress: "Direcci\xF3n de la localizaci\xF3n",
            checkName: "Nombre de Cuenta",
            deliveryAddress: "Direcci\xF3n de Entrega",
            phoneNumber: "N\xFAmero de tel\xE9fono",
            time: "Tiempo"
          }
        },
        justify: {
          options: {
            left: "Izquierda",
            center: "Centro",
            right: "Derecha"
          }
        },
        fontSize: {
          options: {
            a11: "Fuente A W1 H1",
            b11: "Fuente B W1 H1",
            a12: "Fuente A W1 H2",
            b12: "Fuente B W1 H2",
            a21: "Fuente A W2 H1",
            b21: "Fuente B W2 H1",
            a22: "Fuente A W2 H2",
            b22: "Fuente B W2 H2"
          }
        },
        fontWeight: {
          options: {
            light: "Ligero",
            normal: "Normal",
            bold: "Negritas"
          }
        },
        line: {
          options: {
            none: "Ninguno",
            above: "Encima",
            below: "Debajo"
          }
        }
      },
      printerColors: {
        negative: "Negative",
        black: "Negro"
      },
      ticketDisplay: {
        title: "Visualizaci\xF3n del ticket",
        printUnfiredItems: "Imprimir elementos no iniciados",
        printModifications: "Imprimir modificaciones",
        printUnfiredItemstoolTip: "Enable this setting to include any items that have not yet been fired to appear on the ticket. These items will be listed under a header labeled ****NOT FIRED**** at the bottom of the ticket.",
        showCourses: "Mostrar Cursos",
        showCoursestoolTip: "Enable to print each course header in the body of the kitchen ticket, with menu items belonging to that course displaying directly below the course header.",
        showSeats: "Mostrar Asientos",
        showSeatTags: "Mostrar Etiquetas De Asiento",
        showOrderTags: "Mostrar Etiquetas De Orden",
        printOrderQr: "Imprimir C\xF3digo QR del # de Orden en pie de p\xE1gina",
        showOrderTagstooltip: "Enable to have any order tags print on the kitchen ticket. Order tags will print below the ticket header, and above the ticket body where menu items display.",
        orderTagColors: {
          label: "Colores de Ordenes Cambiadas"
        },
        headerBlankSpace: {
          label: "Espacio vacio en la cabecera",
          toolTip: "Select the amount of space that will be added above the kitchen ticket header. This will create additional blank space at the top of the kitchen ticket. This could be used to move text down the ticket, so everything displays without being covered while on the Rail/Board in the kitchen.",
          options: {
            zero: '0"',
            zeroTwoFive: '0.25"',
            zeroFive: '0.5"',
            zeroSevenFive: '0.75"',
            one: '1"',
            oneTwoFive: '1.25"',
            oneFive: '1.5"',
            oneSevenFive: '1.75"',
            two: '2.0"'
          }
        },
        elementSpacing: {
          label: "Espacio entre elementos",
          toolTip: "Select the amount of vertical space to be added between menu items in the body of the kitchen ticket",
          options: {
            zero: '0"',
            zeroTwoFive: '0.25"',
            zeroFive: '0.5"'
          }
        },
        orderTagsFontSize: {
          label: "Tama\xF1o de Fuente de las etiquetas de orden"
        },
        showCourseName: "Mostrar el nombre del curso",
        showCourseNameTooltip: "Habilita o deshabilita la visualizaci\xF3n del nombre del curso en la cabecera del area del ticket.",
        changeNoSeatTextInToGoOrders: "Cambiar Texto Sin Asiento En Ordenes Para Llevar"
      },
      modifierDisplay: {
        title: "Visualizaci\xF3n de modificador",
        displayDefaultModifiers: "Mostrar modificador por defecto",
        displayDefaultModifierstoolTip: "Enable to print the default, pre-assigned modifiers that belong to a menu item. For example, a burger is configured with the default modifiers lettuce, tomato, onion. With this option enabled, lettuce, tomato, and onion will print on the kitchen ticket, unless deselected/modified by the user.",
        consolidateByItem: "Consolidar por elemento",
        consolidateByItemtoolTip: "When enabled, the same menu items ordered multiple times are grouped together on the ticket. Modifiers for each item are listed separately, separated by a dotted line to indicate they belong to another instance of that menu item.",
        hideModGroupTitles: "Esconder titulo del modificador de grupo",
        hideModGroupTitlestooltip: "Enable this option to hide the modifier group names on the kitchen ticket.",
        groupSameModItems: "Agrupar los mismos modificadores de elemento",
        addSubForMultiSelectOff: 'Agregar "Sub" cuando la selecci\xF3n multiple este apagada',
        addSubForMultiSelectOfftoolTip: "This option only applies when \u201Cmulti-select\u201D is off for a modifier group and a default modifier is assigned. When enabled, the word SUB will be added to the replaced modifier in the modifier group.",
        noForDeselectedDefaultModifiers: '"No" para los modificadores por defecto deseleccionados',
        groupBySeat: "Agrupar por asiento",
        groupBySeattoolTip: "Enable to group menu items by seat in the ticket body. A header will display the seat number, and all items assigned to that seat will print under that seat number.\nWhen this option is disabled, each menu item will print the seat number to which it belongs directly below the menu item name, and above the modifiers for the item.",
        modifierItemDisplayMode: {
          label: "Tipo de visualizaci\xF3n del modificador",
          toolTip: "Select how modifiers will display on the kitchen ticket\nVertical list: Modifiers will print as one modifier per line vertically below the menu item\nComma Separated: Modifiers will print as a comma separated list extending the width of the kitchen ticket, then continue on the next line below"
        },
        colorOfModifierItems: {
          label: "Color de los modificadores de elemento"
        },
        printPriceForFreeModItems: "Imprimir los precios para los mod de elementos gratis",
        onlyPrintModItemsWithPrice: "Solo imprimir mod de elementos con precio"
      },
      updateOrderDisplay: {
        title: "Visualizaci\xF3n de la actualizaci\xF3n de orden",
        toolTip: "Configure these settings to control the behavior for items that have already been sent to a remote order device",
        updateOrderNewText: "Nuevo Elemento",
        updateOrderNewTexttoolTip: 'Enter the text that will display next to any modifiers updated on a previously sent order. This text will appear either before or after the modifier item, depending on the choice in the "position for udated item text" option.',
        updateOrderVoidText: "Elemento Anulado",
        updateOrderVoidTexttoolTip: 'Enter the text that will display next to any items that are voided. This text will appear either before or after the voided item, depending on the choice in the "position for updated item text" option.',
        updateOrderTextPosition: {
          label: "Posici\xF3n para el texto del Elemento actualizado",
          toolTip: "Select whether the \u201Cnew item indicator\u201D or \u201Citem voided indicator\u201D will print before or after the updated menu item"
        }
      }
    },
    paymentsSettings: {
      customTenders: {
        title: "Cuentas Personalizadas",
        addCustomTender: "Agregar Cuenta Personalizada",
        navigationBox: {
          description: "Crear cuentas personalizadas para hacer pagos en las ordenes.",
          button: "Ver/Editar Cuentas Personalizadas"
        },
        allowsTips: "Permitir Propinas",
        autoConfirmTip: "Auto-Confirmar Propina",
        printReceipt: "Imprimir Recibo",
        printMerchantCopy: "Imprimir copia del comerciante",
        printTipTotalLines: "Impirimr Propina/Total de Lineas"
      },
      title: "Configuraciones de Pagos",
      errors: {
        customTenders: {
          name: "Error en la tabla de cuentas personalizadas."
        },
        name: "Nombre es requerido",
        posName: "Nombre de POS",
        orderTypes: "Tipo(s) de Orden son requeridas.",
        serviceAreas: "\xC1rea(s) de Servicio son requeridas.",
        charge: "Cantidad debe ser mayor a 0.",
        eGiftCardMerchantId: "ID de comerciante debe ser de 4 d\xEDgitos.",
        eGiftCardLocationId: "ID de Ubicaci\xF3n debe ser de 4 d\xEDgitos.",
        batchTime: {
          empty: "Tiempo por lotes es requerido.",
          invalid: "Tiempo por lotes es invalido."
        }
      },
      general: {
        title: "CONFIGURACIONES GENERALES",
        description: "Las siguientes configuraciones impactar\xE1n las acciones generales de los pagos.",
        confirmDrawerStartingBalance: "Confirmar Balance inicial de Caja",
        printChecksOnCloseOrder: "Imprimir Cheques al Cerrar Orden",
        acceptHousePayments: "Aceptar pagos de la casa",
        housePaymentsSettings: {
          title: "Configuraci\xF3n de Pagos de la Casa"
        },
        preAuthOptions: {
          title: "Opciones Pre-Autenticaci\xF3n",
          defaultPreAuthAmount: "Cantidad Pre-Autenticada por Defecto",
          dueExceedsPreAuth: "Mostrar Indicador si lo debido excede Cantidad Pre-Autenticada"
        },
        batchSettings: {
          title: "Ajustes Por Lotes",
          automatedBatching: "Procesamiento de Lotes Automatizado",
          batchTime: "Tiempo por lotes"
        },
        forceAllPaidOrdersToTipPending: 'Forzar todas las ordenes pagadas a "Propina Pendiente"',
        requireManualClosingPostTip: "Requerir cerrar manualmente Post-Propina"
      },
      tenderTypes: {
        title: "TIPOS DE PAGO",
        description: "L\u2202os siguientes ajustes afectar\xE1n los tipos de pago.",
        tenderTypes: "Tipos de Pago",
        defaultTenders: "Pagos Predeterminados",
        status: "Estado",
        name: "Nombre",
        allowTips: "Permite Propinas",
        autoConfirmTip: "Confirmar Propina Autom\xE1ticamente",
        printReceipt: "Imprimir Recibo",
        printMerchantCopy: "Imprimir Copia del Comerciante",
        printTipTotalLines: "Imprimir L\xEDneas de Propina/Total",
        backgroundColor: "Color de Fondo",
        textColor: "Color de Texto",
        card: "Tarjeta",
        cash: "Efectivo",
        giftCard: "Tarjeta de Regalo",
        house: "Casa",
        enableEGiftIntegration: "Habilitar Integraci\xF3n de Regalos Electr\xF3nicos",
        eGiftIntegration: "Integraci\xF3n de Regalos Electr\xF3nicos",
        eGiftCardMerchantId: "ID de Comerciante",
        eGiftCardLocationId: "ID de Ubicaci\xF3n",
        acceptCashPayments: "Aceptar Pagos en Efectivo",
        cashBackgroundColor: "Color de Fondo para Efectivo",
        cashTextColor: "Color de Texto para Efectivo",
        cashPrintMerchantCopy: "Imprimir Copia del Comerciante (Efectivo)",
        cashPrintReceipt: "Imprimir Recibo (Efectivo)",
        acceptCreditCardPayments: "Aceptar Pagos con Tarjeta de Cr\xE9dito",
        creditCardBackgroundColor: "Color de Fondo para Tarjeta de Cr\xE9dito",
        creditCardTextColor: "Color de Texto para Tarjeta de Cr\xE9dito",
        creditCardAllowTips: "Permitir Propinas para Tarjeta de Cr\xE9dito",
        creditCardAutoConfirmTip: "Confirmar Propina Autom\xE1ticamente (Tarjeta de Cr\xE9dito)",
        creditCardPrintMerchantCopy: "Imprimir Copia del Comerciante (Tarjeta de Cr\xE9dito)",
        creditCardPrintReceipt: "Imprimir Recibo (Tarjeta de Cr\xE9dito)",
        creditCardPrintTip: "Imprimir L\xEDnea de Propina/Total (Tarjeta de Cr\xE9dito)",
        acceptHousePayments: "Aceptar Pagos de Casa",
        houseBackgroundColor: "Color de Fondo para Casa",
        houseTextColor: "Color de Texto para Casa",
        houseAllowTips: "Permitir Propinas para Casa",
        houseAutoConfirmTip: "Confirmar Propina Autom\xE1ticamente (Casa)",
        housePrintMerchantCopy: "Imprimir Copia del Comerciante (Casa)",
        housePrintReceipt: "Imprimir Recibo (Casa)",
        housePrintTip: "Imprimir L\xEDnea de Propina/Total (Casa)",
        enableGiftCardPayments: "Aceptar Pagos con Tarjeta de Regalo",
        giftCardBackgroundColor: "Color de Fondo para Tarjeta de Regalo",
        giftCardTextColor: "Color de Texto para Tarjeta de Regalo",
        giftCardAllowTips: "Permitir Propinas para Tarjeta de Regalo",
        giftCardAutoConfirmTip: "Confirmar Propina Autom\xE1ticamente (Tarjeta de Regalo)",
        giftCardPrintMerchantCopy: "Imprimir Copia del Comerciante (Tarjeta de Regalo)",
        giftCardPrintReceipt: "Imprimir Recibo (Tarjeta de Regalo)",
        giftCardPrintTip: "Imprimir L\xEDnea de Propina/Total (Tarjeta de Regalo)"
      },
      drawerSettings: {
        title: "Configuraciones de Caja",
        description: "Las siguientes configuraciones impactar\xE1n las acciones de caja."
      },
      tipSettings: {
        title: "Configuraci\xF3n de Propinas",
        tipPayoutMethod: "M\xE9todo de Pago de Propinas",
        tipDistribution: "Distribuci\xF3n de Propinas",
        splitTipInterval: "Intervalo",
        shareBy: "Compartir Por",
        rolesContributingToPool: "Roles que Contribuyen al Fondo",
        rolesReceivingFromPool: "Roles que Reciben del Fondo",
        sharingRules: "Reglas de Compartir",
        from: "De",
        to: "Para",
        percentageGreater: "El porcentaje es mayor que 100%. Introduzca una cantidad v\xE1lida.",
        percentageSmaller: "El porcentaje es menor que 100%. Introduzca una cantidad v\xE1lida.",
        percentageContributed: "% Contribuido",
        percentageReceived: "% Recibido",
        contributor: "Contribuyente",
        recipient: "Receptor",
        contribution: "Contribuci\xF3n",
        emptySharingRules: "Sin Reglas",
        sharingRule: "Regla de Compartir",
        manual: "Manual",
        payroll: "N\xF3mina",
        individual: "Individual",
        poolingRules: "Reglas de Agrupaci\xF3n",
        percentageContributedRequired: "% Contribuido debe ser mayor que 0%.",
        addContributor: "A\xF1adir Contribuyente",
        emptyContributorsPool: "Sin Contribuidores",
        emptyRecipientsPool: "Sin Receptores",
        noRecipientsError: "Receptores son requeridos.",
        noContributorsError: "Contribuidores son requeridos.",
        pooling: "Agrupaci\xF3n",
        sharing: "Compartiendo",
        percentageReceivedRequired: "% Recibido debe ser mayor a 0%.",
        addRecipients: "A\xF1adir Recipientes",
        role: "Rol",
        splittingRules: "Reglas de Divisi\xF3n",
        interval: "Intervalo",
        shift: "Turno",
        evenly: "Uniformemente",
        day: "Jornada Completa",
        tipSharing: "Compartir Propinas",
        defaultTipInput: "Input de propina predeterminado",
        newTotal: "Total incluyendo propina",
        tipAmount: "Cantidad de Propina"
      },
      serviceChargeSettings: {
        title: "Configuraciones de Cargo por Servicio",
        serviceCharges: "Cargos por Servicio",
        status: "Estado",
        name: "Nombre",
        charge: "Cargo",
        actions: "Acciones",
        prePostDiscount: "Pre/Post - Descuento",
        posName: "Nombre de POS",
        editServiceCharge: "Editar Cargo por Servicio",
        chargeType: "Tipo de Cargo",
        autoApply: "Aplicar Autom\xE1ticamente",
        fixed: "Cantidad Espec\xEDfica",
        percent: "Porcentaje Espec\xEDfico",
        customDollar: "Cantidad Personalizada",
        customPercent: "Porcentaje Personalizado",
        amount: "Cantidad",
        minimumGuests: "Invitados M\xEDnimos",
        assignTo: "Asignar A",
        associatedTaxes: "Impuestos Asociados",
        addServiceCharge: "A\xF1adir Cargo por Servicio",
        selectOrderTypes: "Seleccionar Tipos de Orden",
        restaurant: "Restaurante",
        checkOwner: "Verificar Propietario",
        postDiscount: "Post-Descuento",
        preDiscount: "Pre-Descuento",
        tableEmptyDataTitle: "Sin Cargos por Servicio",
        selectServiceAreas: "Seleccionar \xC1reas de Servicio",
        discount: "Pre/Post - Descuento",
        orderTypes: "Tipo(s) de Orden",
        serviceAreas: "\xC1rea(s) de Servicio",
        minGuests: "Min. Invitados",
        taxes: "Impuestos",
        server: "Mesero",
        post: "Post",
        pre: "Pre",
        noOrderTypes: "Sin Tipos de Orden",
        noServiceAreas: "Sin \xC1reas de Servicio",
        active: {
          true: "Activo",
          false: "Inactivo"
        }
      },
      dualPricing: {
        title: "Precio Dual",
        listPrice: {
          label: "Precio de Lista",
          options: {
            cash: "Efectivo",
            card: "Tarjeta"
          }
        },
        price: {
          card: "Precio en Efectivo",
          cash: "Precio con Tarjeta"
        }
      },
      editElement: {
        success: "Configuraci\xF3n de Pagos Actualizada Satisfactoriamente",
        error: "Error al Actualizar la Configuraci\xF3n de Pagos",
        loading: "Actualizando Configuraci\xF3n de Pagos"
      }
    },
    coursing: {
      noCourse: "Sin Curso"
    },
    registerModeSettings: {
      editElement: {
        success: "Configuraci\xF3n de modo de registro actualizado satisfactoriamente",
        error: "Error al actualizar la Configuraci\xF3n de modo de registro",
        loading: "Actualizando Configuraci\xF3n de modo de registro"
      },
      general: {
        title: "CONFIGURACIONES GENERALES",
        description: "Las siguientes configuraciones impactaran las acciones generales del registro.",
        registerDisplay: {
          title: "Pantalla de Registro",
          showConfirmPopup: "Confirm to remove an Item",
          showConfirmPopupTooltip: "Enable to allow a pop up confirmation message to display when removing an item from a ticket.",
          enforceItemGroupOrderForCombos: "Require combo items to be entered according to display order",
          enforceItemGroupOrderForCombosTooltip: "Enable to require that combo items be entered based on the sequence in which they prompt while ordering. Disable to allow user to enter required combo item choices in any sequence.",
          persistSelectedCategoryOnItemSelection: "Persist selected menu category on item selection",
          persistSelectedCategoryOnItemSelectionTooltip: "Enable to remain in the current menu category after adding a menu item. Disable to revert to the default menu category after adding a menu item.",
          showConfirmPopUpOnClearUnsentWithinAnItem: 'Confirm on "clear unsent"',
          showConfirmPopUpOnClearUnsentWithinAnItemTooltip: "Enable to allow a pop up confirmation message to display when using the \u201Cclear unsent\u201D key to remove all unsent items from the ticket.",
          showSentItemModificationsOnRegisterTicket: "Show sent Item Modifications",
          showSentItemModificationsOnRegisterTicketTooltip: "When enabled, after an item has been sent, any modifiers added will display in green text on the ticket detail area.",
          showConfirmPopUpOnLeaveIncompleteItem: "Confirm when navigating away from an incomplete Item",
          showConfirmPopUpOnLeaveIncompleteItemTooltip: "Enable to allow a pop up confirmation message to display when navigating away from an item that is unfinished, where required choices still need to be selected.",
          showHotButtonToggle: "Show Hot Buttons toggle",
          showHotButtonToggleTooltip: "This setting controls the visibility of the 10 Hot Buttons on the bottom of the register screen. When enabled, a \u201CShow/Hide Hot Buttons\u201D button will appear, which much be selected to display or hide the Hot Buttons. If the option is not enabled, the hot buttons will always display.",
          showModTagBar: "Mostrar barra de modificador de etiqueta",
          showModTagBarToolTip: "Enable to display the Mod Tag Bar on the register. The Mod Tag Bar allows modifications to menu items by adding a prefix or suffix to customize the menu item, such as \u2018add\u2019, \u2018no\u2019, \u2018sub\u2019, \u2018extra\u2019. When this option is disabled, no mod tags will appear for any menu items.",
          comboDisplayName: "Nombre de visualizaci\xF3n del Combo",
          showNotificationMessageForPrinterErrors: "Mostrar notificaciones de mensajes de error de impresora",
          showNotificationMessageForPrinterErrorsTooltip: "Esta configuraci\xF3n determina si una alerta ser\xE1 mostrada cuando un Articulo falla al ser impreso en la cocina.",
          showPrinterStatusNotifications: "Mostrar notificaciones de estado de impresora",
          showPrinterStatusNotificationsTooltip: "Esta configuraci\xF3n determina si se debe mostrar una alerta cuando cambia el estado de la impresora.",
          firePositionOnRegisterTicket: "Posici\xF3n del envio en el ticket",
          firePositionOnRegisterTicketTooltip: "Posici\xF3n donde se muestra el tiempo envio en el ticket.",
          showDoneButton: 'Mostrar Bot\xF3n de "Listo"',
          printHeldItems: "Imprimir elementos retenidos"
        },
        defaultRestaurantMode: {
          label: "Modo de Restaurante",
          tooltip: "Select which method of service will be used for placing orders:\nTable Service - Full-service restaurant, seating, coursing, table layout options\nQuick Service - Pay-at-order workflow, takeout and delivery concepts",
          options: {
            tsr: "Servicio de Mesa",
            qsr: "Servicio R\xE1pido"
          }
        },
        firePositionOnRegisterTicket: {
          label: "Posici\xF3n del envio en el ticket",
          tooltip: "Posici\xF3n donde se muestra el tiempo envio en el ticket.",
          options: {
            top: "Arriba",
            bottom: "Abajo",
            topCommaSeparated: "Arriba & Separado por comas",
            bottomCommaSeparated: "Abajo & Separado por comas"
          }
        },
        specialTags: {
          title: "Etiquetas Especiales",
          description: "Special tags can identify a menu item with a specific characteristic. These are customizable and could be used to alert to food allergens, dietary restrictions, promotions, spicy/heat levels, or customer favorites.",
          loadingMoreMessage: "Cargando Etiquetas Especiales",
          linkText: "Ver / Editar Etiquetas Especiales",
          addSpecialTag: "Agregar etiqueta especial",
          status: "Estatus",
          name: "Nombre",
          posName: "Nombre de POS",
          abbreviation: "Abreviaci\xF3n",
          abbreviationToolTip: "Enter the abbreviation for the Special Tag that will appear in the bottom right corner of the item card. This field may only contain up to 2 characters.",
          color: "Color",
          textColor: "Color de texto",
          delete: "Eliminar"
        },
        modTags: {
          title: "Etiquetas Modificadoras",
          description: "Mod tags all text to be added before (prefix) or after (suffix) a modifier. Examples: Extra, Add, No, Lite, On Side.",
          loadingMoreMessage: "Cargando m\xE1s Etiquetas Modificadoras",
          linkText: "Ver / Editar Etiquetas Modificadoras",
          addModTag: "Agregar Etiqueta Modificadora",
          status: "Estatus",
          name: "Nombre",
          posName: "Nombre de POS",
          dontPromptOpenItemName: "No pedir nombre",
          checkName: "Nombre de la Cocina/Cheque",
          tagPosition: "Posici\xF3n de la Etiqueta",
          tagPositionTooltip: "Choose whether the tag should appear before or after the modifier item. This selection determines the placement of the tag in relation to the modifier.",
          menuType: "Tipo(s) de Men\xFA",
          menuTypeTooltip: "Assign the mod tag to the appropriate menu(s). Mod tags can belong to a single menu, multiple menus, or all menus.",
          menuTypeModalDescription: "Selecciona todos los tipo(s) de menu donde quieres que este dsponible esta etiqueta modificadora",
          delete: "Eliminar",
          allMenuTypes: "Todos los Men\xFAs"
        },
        orderTypes: {
          title: "Tipo de ordenes disponibles",
          toolTip: "Select which order types will be available for use on the register",
          catering: "Abastecimiento",
          curbside: "Acera",
          delivery: "Entrega",
          dineIn: "Comer aqu\xED",
          toGo: "Para Llevar"
        },
        discountReasons: {
          title: "Razones de Anulado / Descuento",
          description: "Discount reasons are the list of reasons that can appear when a discount is used on a ticket. These can help determine why a discount took place.",
          loadingMoreMessage: "Cargando m\xE1s Razones de Descuento",
          linkText: "Ver / Editar Razones de Descuento",
          addDiscountReason: "Agregar Raz\xF3n de Descuento",
          status: "Estatus",
          name: "Nombre",
          posName: "Nombre de POS",
          delete: "Eliminar",
          voidOrDiscountReasons: {
            title: "Razones de Anulado o Descuento",
            options: {
              voidOnly: "Solo Anulado",
              discountOnly: "Solo Descuento",
              both: "Ambos"
            }
          }
        },
        timeBasedMenuType: {
          noData: "Sin Reglas",
          copyRules: {
            button: "Copiar Reglas",
            popover: {
              title: "COPIAR REGLAS A"
            }
          },
          id: "No.",
          invalidRange: "Rango Inv\xE1lido",
          title: "Tipo de men\xFA basado en tiempo",
          menuType: "Tipo de Men\xFA",
          time: "Tiempo",
          delete: "Eliminar",
          defaultMenuType: {
            label: "Tipo de Men\xFA por defecto",
            toolTip: "Select the menu that will display first when a new ticket is begun."
          },
          dayFilter: {
            label: "D\xEDa"
          },
          defaultMenuTypeRules: {
            title: "Reglas de Tipo de Men\xFA por defecto",
            toolTip: "Select a day of the week to customize the default menu that will be displayed and the time which the menu will appear as the default. Click and drag to set the time ranges or click the time boxes to bring up a pop up window which will allow a time selection.",
            addRule: "Agregar Regla"
          }
        }
      },
      tags: {
        title: "CONFIGURACIONES DE ETIQUETAS",
        description: "Las siguientes tablas listan las opciones de razones y etiquetas para el Registro.",
        seatOrderTags: {
          loadingMoreMessage: "Cargando m\xE1s etiquetas",
          title: "Etiquetas de Orden/Asiento",
          description: "Seat/Order tags allow tags to be assigned to individual seats or tickets. These tags are customizable and will be categorized as allergens, special occasions, or other descriptor.",
          linkText: "Ver / Editar Etiquetas de Orden",
          addModTag: "Agregar Etiqueta",
          status: "Estatus",
          orderOrSeatTag: {
            title: "Etiquetas de Orden/Asiento",
            toolTip: "Select whether this tag can be assigned to a seat, to an order, or to both",
            options: {
              seatOnly: "Solo Asiento",
              orderOnly: "Solo Orden",
              both: "Ambos"
            }
          },
          type: {
            title: "Tipo",
            toolTip: "Select the appropriate category for the tag from the dropdown menu: Allergy, Descriptor, or Special Event. The tag will appear within that category on the register.",
            options: {
              allergy: "Alergia",
              attribute: "Descriptor",
              milestone: "Evento Especial"
            }
          },
          name: "Nombre",
          posName: "Nombre de POS",
          seatTagFavorite: "Asiento favorito",
          orderTagFavorite: "Orden favorita",
          color: "Color",
          textColor: "Color de texto",
          delete: "Eliminar"
        },
        openItemTypes: {
          title: "Tipos de Elementos abiertos",
          description: "Open Item Types allow for the creation of categories or specific items that a privileged employee can add to a ticket. The employee will be prompted to enter a custom name for the item and a price. Examples: Open Food, Open Liquor, Corkage Fee, or Room Rental.",
          printLocationTooltip: "Select a prep station for the item to designate where it will be printed.",
          linkText: "Ver / Editar Tipos de Elementos abiertos",
          addOpenItemType: "Agregar Tipo de Elemento abierto",
          table: {
            headers: {
              taxIds: "Impuestos",
              taxTooltip: "Add one or more tax rates for the item by selecting the applicable tax rates from the list."
            },
            emptyMessage: "Sin Tipos de Elementos abiertos"
          }
        }
      },
      tableService: {
        title: "CONFIGURACIONES DEL SERVICIO DE MESA",
        toolTip: "Set the general settings for the Table Service Restaurant Mode",
        description: "Coloca los ajustes generales para el modo Restaurante que seleccionaste (Servicio de mesa)",
        general: {
          title: "Configuraciones generales",
          keepTipPendingOrdersAssociatedToTable: "Mantener ordenes pendientes de propina asociadas a la mesa",
          enableMapLayoutDragAndDrop: "Habilitar arrastrar y soltar para la vista de mesas",
          showTableBorderForLoggedInUsersOrders: "Resaltar mesas del usuario",
          seating: {
            title: "Asientos",
            description: "Enable to allow for seat entry options when in an order. Disable to have all seat entry functions turned off",
            allowForTableButton: 'Mostrar bot\xF3n de asiento "Para mesa"',
            allowForTabletoolTip: "Enable to allow a menu item to be for the table rather than assigned to an individual seat",
            doneIsForTable: '"Listo" es "Para mesa"',
            enableDragDropForSeatPopover: "Habilitar arrastrar y soltar para popover del asiento",
            enableDragDropForSeatPopovertooltip: "Enable to allow a user to tap and hold a seat, then drag the seat to another to another seat to order the same menu item for the chosen seat. Drag and drop allows for multiple seat entries without the seat modification window closing.",
            showTicketSeatBar: "Mostrar barra de boletos de asientos",
            attachNoSeatToToGo: "Adjuntar asiento para llevar",
            attachNoSeatToToGotoolTip: "Enable so that when using \u201CTo Go\u201D in the seat modification window, the menu item will be assigned to \u201Cno seat\u201D rather than a seat number.",
            showConfirmPopUpWhenSendingItemsInSeatView: "Confirmar al enviar elementos en la vista de asiento",
            showConfirmPopUpWhenSendingItemsInSeatViewtoolTip: 'When in Seat View and using the "send" key, this option displays a pop up confirmation box to choose whether to send only the items for the selected seat or the entire order.  When this option is disabled, the system will send only the items for the selected seat.',
            showSeatOneDescription: "Mostrar una descripci\xF3n de asiento",
            seatingMode: {
              label: "Modo de Asientos",
              toolTip: "Prompt - Always prompt for seat number when adding an item to an Order\nNo Prompt - User is responsible for selecting a seat number before a menu item is added, no prompt will display to select a seat number\nHybrid - Allows user to select a seat number before adding a menu item to the order. If a seat is not selected, the user will be prompted to select a seat number when an item is added to an Order",
              options: {
                prompt: "Solicitar",
                no_prompt: "No Solicitar",
                hybrid: "Hibrido"
              }
            },
            showOrderDetailsForNewOrderTsr: "Mostrar detalles de la orden en nueva orden",
            showOrderDetailsForDefaultNewOrder: "Mostrar detalles de la orden en la creaci\xF3n de la orden por defecto",
            showGuestCount: "Mostrar conteo de comensales",
            defaultGuestCountOnNewOrder: "Llenar el conteo de comensales automaticamente.",
            setGuestCountToZeroWhenNoTable: "Fijar conteo de comensales a 0 cuando no hay mesa",
            setGuestCountToZeroOnToGoOrders: "Fijar conteo de comensales a 0 en ordenes para llevar",
            showOrderDetailsForNewOrderTsrtoolTip: "Habilita el dialogo para crear una nueva orden. Esto mostrar\xE1 el n\xFAmero de orden, tipo, nombre, descripci\xF3n y etiquetas.",
            showOrderDetailsForDefaultNewOrderToolTip: "Habilita la pantalla de detalles de la orden cuando se accede directo a una nuvea orden.",
            showGuestCountTooltip: "Muestra u oculta la informaci\xF3n del conteo de comensales en la pantalla de detalles de la orden.",
            defaultGuestCountOnNewOrderTooltip: "Activo rellena automaticamente el conteo de comensales en la pantalla de detalles de la orden basado en la informaci\xF3n de la mesa. Inactivo no lo hace y debe ser introducido manualmente.",
            setGuestCountToZeroWhenNoTableTooltip: "Activo, el conteo de comensales se fijar\xE1 a 0 cuando no haya mesa seleccionada. Inactivo, el conteo de comensales ser\xE1 el n\xFAmero de asientos en la mesa seleccionada.",
            setGuestCountToZeroOnToGoOrdersTooltip: "Activo, el conteo de comensales se fijar\xE1 a 0 cuando la orden sea para llevar. Inactivo, el conteo de comensales ser\xE1 el n\xFAmero de asientos en la mesa seleccionada.",
            ticketSeatBar: {
              label: "Barra de boletos de asientos",
              toolTip: "Select how seat options will behave and display above the ticket detail area\nNone - No seat information appears above the ticket detail area\nCarousel - Items appear in the ticket detail area filtered by seat.  Arrows on the left and right sides allow for scrolling through seats to see items for each seat, and an \u201CAll Seats\u201D to show all items in the Order\nButtons w/Filter - Buttons for \u201CNo Seat\u201D, \u201CFor Table\u201D, \u201CAll Seats\u201D, and each seat will appear above the ticket detail area. Based on the selection, filtering will occur to show the items attached to the selected seat. Allows for viewing items ordered by seat, and the ability to add menu items to the selected seat.\nButtons No Filter - Buttons for \u201CNo Seat\u201D, \u201CFor Table\u201D, \u201CAll Seats\u201D, and each seat will appear above the ticket detail area.  No filtering will occur on the ticket based on the selection.  Allows for easy selection of a seat choice before adding an item to the Order",
              options: {
                none: "Ninguno",
                carousel: "Carrusel",
                buttonsWithFilter: "Botones c / Filtro",
                buttonsNoFilter: "Botones Sin Filtro"
              }
            },
            seatManagementButtonFunction: {
              label: "Funci\xF3n del bot\xF3n de manejo de asientos",
              options: {
                seatTagsOnly: "Solamente Etiquetas de Asiento",
                allowPreselectSeats: "Permite pre seleccionar asientos"
              }
            }
          },
          guests: {
            title: "Configuracines para n\xFAmero de comensales y pantalla de detalles"
          },
          sendToKitchen: {
            title: "Configuraciones para mandar a cocina",
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: "No permitir la navegaci\xF3n cuando los art\xEDculos no han sido enviados a cocina",
            showPopUpOnNavigateIfItemsOnTicketNotSentToKitchentoolTip: "Cuando esto se encuentra habilitado, el usuario no podr\xE1 navegar fuera de la orden a menos que todos los Art\xEDculos en el ticket sean enviados a la cocina o sean puestos en espera.",
            showIndicatorWhenItemsOnTicketNotSentToKitchen: 'Mostrar indicador de "Art\xEDculos no enviados a cocina"',
            showIndicatorWhenItemsOnTicketNotSentToKitchentoolTip: "Muestra un icono en las mesas con ordenes que contengan Art\xEDculos no enviados a cocina.",
            showSendItemsModal: 'Mostrar ventana al usar la tecla "Enviar"',
            showSendItemsModaltooltip: "Enable to allow a pop up window to display when using the send key. This window shows a confirmation list of all items to be sent, and allows items to be selected and unselected for sending",
            prepStationForFireTicketIdTooltip: "Choose the printer that will receive the FIRE ticket when the Fire button is used on the register. This ticket will notify the kitchen to prepare the next course in the sequence.",
            prepStationForFireTicketId: "Ubicaci\xF3n de Impresora para Tickets Iniciados:"
          }
        },
        tableLayout: {
          title: "Disposici\xF3n de las mesas",
          description: "Las siguientes configuraciones impactar\xE1n como se ver\xE1 la pesta\xF1a para ver las mesas en el m\xF3dulo de Registro",
          showSeatsOnTableLayout: "Mostrar el n\xFAmero de asientos por mesa",
          showSeatsOnTableLayouttoolTip: "Enable to have the default number of seats display on each table in the table layout",
          showTimerOnTableLayout: "Mostrar temporizador en la mesa",
          showTimerOnTableLayouttooltip: "Enable to show a timer below each table on the table layout which shows the length of time (in hours and minutes) since the table was begun",
          useCleaningStatusOnTableLayout: 'Usar estatus "Limpiando"',
          useCleaningStatusOnTableLayouttoolTip: "Enable to have a table put in \u201Ccleaning\u201D status once payment has been made on a ticket. Table will display as red \u201Ccleaning\u201D and will need to be manually \u201Cset available\u201D before the table can be used again",
          allowOpenTabsOnTableLayout: "Permitir pesta\xF1as abiertas",
          allowOpenTabsOnTableLayouttooltip: "Enable to allow the creation of orders which are not assigned to a table.  Disable to require all orders be opened via a table on the table layout"
        },
        coursing: {
          title: "Cursos",
          description: "Enable to use coursing which allows for ordering menu items by course.",
          coursingMode: {
            label: "Modo de cursado",
            toolTip: "Select which method of coursing will be used\n<1/>On The Fly - In this mode, courses are sent to the kitchen as they are ready, rather than following a predetermined schedule. The user is responsible for timing and firing each course.\n<1/>Predetermined - Courses are pre-defined and fired according to a set sequence.  Menu items would also typically be linked to a set course when using the Predetermined option for coursing.",
            options: {
              onTheFly: "Sobre la marcha",
              predefined: "Predeterminado"
            }
          },
          disabledOverlay: "Cursado esta desactivado",
          disabledOnTheFlyOverlay: "Cursado est\xE1 establecido sobre la marcha",
          linkTitle: "Cursos Predeterminados",
          linkDescription: "Crear y manejar cursos para asociar con tus Elementos.",
          linkButton: "Ver / Editar Cursos",
          loadingMoreMessage: "Cargando m\xE1s Cursos",
          addCourse: "A\xF1adir curso",
          status: "Estatus",
          course: "Curso",
          posName: "Nombre de POS",
          kitchenName: "Nombre de cocina",
          autoTrigger: "Disparador automatico (min)",
          delete: "Eliminar",
          grouping: "Agrupaci\xF3n",
          groupByRounds: "Agrupar por Rondas"
        }
      },
      quickService: {
        title: "CONFIGURACIONES DE SERVICIO RAPIDO",
        description: "Coloca los ajustes generales para servicio r\xE1pido.",
        general: {
          title: "Configuraciones generales",
          assignOrderTag: "Mostrar etiqueta de orden",
          enableSimpleMode: "Modo simple (Sin barras de categor\xEDas)",
          showOrderDetailsForNewOrderQsr: "Mostrar detalles de la orden en nueva orden",
          showOrderDetailsForNewOrderQsrtoolTip: "When beginning an order, the order details window will appear prompting for Order Type, Name, and Description to be entered if desired. Order Tags can also be added here. Disable to be taken to the default menu, with no order details entry, when a new order is started.",
          sendOrderToKitchenTrigger: {
            label: "Enviar orden a imprimir cuando:",
            toolTip: "Select when the order will be sent to remote printing devices\nPayment Initiated - Order will send when payment is initiated at register\nPayment Completed - Order will send when ticket has been paid in full",
            options: {
              paymentInitiated: "Pago iniciado",
              paymentCompleted: "Pago completado"
            }
          },
          qsrSendAndPayActionButtons: {
            label: "Enviar y Pagar botones de acci\xF3n",
            toolTip: 'Select which buttons display, and their action, when in QSR Mode\nPay Only - When entering an order, the "payment" button is available to finish an order. The Order will send to the kitchen depending on what is selected in the "Send Order to Kitchen When" field\nSend Only - When entering an Order, the "Send" button is available to be used to send the order. The Order will be tendered later through the Orders screen. One example would be a Drive-Thru, where the order is taken and sent, but no payment collected immediately\nBoth - The Send, Send/Stay, and Payment buttons are available when entering an order, allowing the user to either send the order manually or take payment on the order',
            options: {
              payOnly: "Solo Pagar",
              sendOnly: "Solo Enviar",
              both: "Ambos"
            }
          }
        }
      },
      customerFacingDisplay: {
        title: "PANTALLA ORIENTADA AL CLIENTE",
        description: "Establece las configuraciones generales para la pantalla orientada al cliente.",
        general: {
          receiptScreenTimeout: "Tiempo de espera de la pantalla del recibo (segundos)",
          requireClientSignature: "Solicitar firma del cliente",
          payThroughCfdOnly: "Pagar solo por CFD",
          promptStarRatings: "Solicitar calificaci\xF3n de estrellas",
          darkMode: "Modo Obscuro",
          promptPrintReceipt: "Solicitar impresi\xF3n del recibo"
        },
        adsSettings: {
          title: "Configuraciones de anuncios",
          description: "El nombre de usuario colocado aqu\xED ser\xE1 mostrado en los anuncios CFD.",
          adsTable: {
            image: {
              title: "Carga una imagen del anuncio"
            },
            addAd: "Agregar Anuncio",
            imageUrl: "Imagen",
            title: "Titulo",
            text: "Texto",
            price: "Precio"
          },
          ads: {
            title: "Anuncios",
            description: "Agrega la imagen que ser\xE1 mostrada en cada promoci\xF3n. El titulo, texto y el precio (si es que existe).",
            viewEditAds: "Ver/Editar Anuncios"
          },
          addYourUserName: "Agrega tu nombre de usuario de {{socialMedia}}",
          colorSettings: {
            title: "Configuraciones de colores",
            placeholderBackground: "Fondo del Marcador",
            adTextBackground: "Fondo del texto del anuncio",
            mediaLinksBackground: "Texto/Enlaces de redes sociales"
          }
        },
        tips: {
          defaultSuggestedTip: {
            label: "Propina sugerida por defecto"
          }
        }
      },
      endOfDay: {
        title: "END OF DAY SETTINGS",
        description: "Ajustes para el flujo del fin de d\xEDa.",
        clockOut: {
          title: "Ajustes de salida",
          requireNoOpenOrders: "Requerir Cero Ordernes abiertas",
          requireNonCashTips: "Requerir no propinas en efectivo",
          requireServerBankSettlement: "Requerir liquidaci\xF3n del banco del servidor",
          netNonCashTipsOnSettlement: "Propinas en liquidaci\xF3n",
          requireCashtipReporting: "Requerir informes de propinas en efectivo",
          requireDrawerSettlement: "Requerir liquidaci\xF3n de caja",
          displayTipsDueInHeader: "Mostrar Propinas Pendientes en Encabezado del Reporte de Turno",
          zeroTipsDueOnClockOut: "Volver cero Propinas pendientes al checar salida",
          autoSettleDrawerId: "Cerrar Caja Autom\xE1ticamente"
        }
      },
      errors: {
        modifierTags: {
          name: "Error en la tabla de etiquetas modificadoras."
        },
        ads: {
          name: "Error en la tabla de anuncios."
        },
        specialTags: {
          name: "Error en la tabla de etiquetas especiales."
        },
        orderSeatTags: {
          name: "Error en la tabla de asientos/ordenes."
        },
        courses: {
          name: "Error en la tabla de cursos."
        },
        discountReasons: {
          name: "Error en la tabla de razones de descuento."
        },
        defaultMenuTypeTimes: {
          time: "Rango(s) invalidos de el tiempo del Men\xFA"
        },
        openItemTypes: {
          name: "Error en la tabla de los Tipos de Elemento abierto."
        }
      }
    },
    tableLayoutCreator: {
      messages: {
        updatingLayoutPleaseWait: "Actualizando dise\xF1o, por favor espere...",
        changesSaved: "Cambios guardados satisfactoriamente",
        errorUpdatingLayout: "Error al actualizar el dise\xF1o",
        errorSavingChanges: "Ocurrio un error al guardar los cambios. Por favor, int\xE9ntelo de nuevo.",
        unableToDeleteTable: {
          title: "No se puede borrar",
          message: "Esta mesa esta relacionada a una orden"
        },
        unableToDeleteServiceArea: {
          title: "No se puede borrar",
          message: "Este \xC1rea de Servicio continene mesas relacionadas a ordenes"
        },
        elementOverflows: {
          title: "El elemento se desborda",
          description: "El elemento no cabe en la cuadr\xEDcula"
        }
      },
      serviceArea: "\xC1rea de servicio",
      serviceAreas: "\xC1reas de servicio",
      addServiceArea: "A\xF1adir \xC1rea de Servicio",
      updateServiceArea: "Editar \xC1rea de Servicio",
      noServiceArea: {
        title: "Bienvenido al creador de disposici\xF3n de mesas",
        message: "Empieza por a\xF1adir una nueva area de servicio",
        noServiceAreas: "Sin \xC1reas de Servicio"
      },
      noLayout: {
        title: "El Dise\xF1o esta vac\xEDo",
        message: "Empieza por a\xF1adir una mesa o elemento al dise\xF1o"
      },
      buttons: {
        rearrange: "Reacomodar",
        undo: "Deshacer",
        addTable: "A\xF1adir mesa",
        addElement: "A\xF1adir elemento"
      },
      bottomSheet: {
        newElement: "Nuevo Elemento",
        newTable: "Nueva Mesa",
        tableShapes: {
          circle: "Circulo",
          square: "Cuadrado",
          rectangle: "Rect\xE1ngulo"
        },
        elements: {
          table: " Mesa",
          barriers: "Barreras",
          others: "Otros",
          wall: "Pared",
          station: "Estaci\xF3n",
          custom: "Personalizado",
          window: "Ventana",
          door: "Puerta",
          plant: "Planta"
        }
      },
      sideBar: {
        detailsPanel: "{{type}}, detalles",
        name: "Nombre",
        tableType: "Tipo de mesa",
        selectTableType: "Selecciona el tipo de mesa",
        seats: "Sillas",
        geometryOptions: "Opciones de geometr\xEDa",
        size: "Tama\xF1o",
        small: "Peque\xF1o",
        large: "Largo",
        rotate: "Rotacci\xF3n"
      },
      modals: {
        title: "Actualizar \xC1reas de Servicio",
        name: "Nombre del \xC1rea de Servicio",
        revenueCenter: "Centro de Ingresos",
        noRevenueCenters: "Sin Centros de Ingresos",
        selectRevenueCenter: "Selecciona el Centro de Ingresos",
        isActiveInRegister: "Mostrar en el m\xF3dulo de registrar",
        removeServiceArea: "Remover \xC1rea de Servicio",
        forceNoTaxInclusive: 'Forzar "Sin Impuestos Incluidos"'
      }
    }
  },
  authentication: {
    welcomeBack: "\xA1Bienvenido de nuevo!",
    needHelp: "\xBFNecesitas ayuda?",
    inactivity: {
      title: "Sesi\xF3n Expirada",
      description: "Tu sesion ha sido cerrada debido a inactividad."
    },
    timeSummary: {
      clockIn: {
        alreadyClockedIn: "El usuario ya ha iniciado turno"
      }
    },
    login: {
      dontHaveAnAccount: "\xBFNo tienes cuenta a\xFAn?",
      signUp: "Registrate",
      callOrText: "Llamar o mensaje",
      insertPassword: "Ingrese la contrase\xF1a",
      incorrectEmailOrPassword: "La combinaci\xF3n de correo electr\xF3nico y contrase\xF1a es incorrecta."
    },
    forgotPassword: {
      forgotPassword: "\xBFOlvidaste la contrase\xF1a?",
      enterYourEmailToBegin: "Ingresa tu correo electr\xF3nico para comenzar con el restablecimiento de la contrase\xF1a",
      incorrectEmail: "Corro electr\xF3nico incorrecto. Por favor intenta de nuevo",
      sendCode: "Enviar c\xF3digo",
      sendingCode: "Enviando c\xF3digo",
      rememberPassword: "\xBFRecuerdas tu contrase\xF1a?"
    },
    verifyCode: {
      enterVerificationCode: "Ingresa el c\xF3digo de verificaci\xF3n",
      weHaveSentAVerificationCode: "Hemos enviado un c\xF3digo de verificaci\xF3n a",
      verifyCode: "Verificar c\xF3digo",
      verifyingCode: "Verificando c\xF3digo",
      didntGetTheCode: "\xBFNo recibiste el c\xF3digo?",
      resend: "Reenviar",
      resending: "Reenviando"
    },
    resetPassword: {
      resetPassword: "Restablecer contrase\xF1a",
      pleaseCreateNewPassword: "Por favor crea una nueva contrase\xF1a para continuar.",
      newPassword: "Nueva contrase\xF1a",
      confirmPassword: "Confirmar contrase\xF1a",
      thePasswordConfirmationDoesntMatch: "La contrase\xF1a no coincide.",
      passwordMustBe: {
        passwordMustBe: "La contrase\xF1a debe tener:",
        atLeast8Characters: "Al menos 8 caracteres",
        atLeastOneCapitalLetter: "Al menos una may\xFAscula",
        atLeastOneSmallLetter: "Al menos una min\xFAscula",
        atLeastOneNumberOrSymbol: "Al menos un n\xFAmero o s\xEDmbolo"
      },
      resettingPassword: "Restableciendo contrase\xF1a"
    },
    passwordChanged: {
      passwordChanged: "Contrase\xF1a actualizada",
      passwordHasBeenSuccessfullyChanged: "Tu contrase\xF1a ha sido actualizada correctamente. Por favor usa tu nueva contrase\xF1a para iniciar sesi\xF3n.",
      backToLogin: "Regresar al inicio de sesi\xF3n"
    },
    signUp: {
      accountInfo: {
        firstName: "Nombre",
        lastName: "Apellido",
        phoneNumber: "N\xFAmero de tel\xE9fono",
        alreadyHaveAnAccount: "\xBFYa tienes una cuenta?",
        createAnAccount: "CREAR UNA CUENTA",
        "10DigitsPhone": "10 d\xEDgitos"
      },
      wrongEmail: "\xBFCorreo electr\xF3nico incorrecto?",
      wrongPhoneNumber: "\xBFN\xFAmero de tel\xE9fono incorrecto?",
      changePhoneNumber: "Cambiar n\xFAmero",
      verifyCodeInstructions: "Ingresa el c\xF3digo de verificaci\xF3n que hemos enviado a",
      toVerifyEmail: "para verificar tu correo electr\xF3nico",
      toVerifyPhoneNumber: "para verificar tu n\xFAmero de tel\xE9fono",
      accountCreated: {
        title: "\xA1Bienvenid@ {{user}}!",
        description: "Tu cuenta ha sido creada con \xE9xito. Por favor inicia sesi\xF3n para elegir tu organizaci\xF3n.",
        continueToSignIn: "Continuar al inicio de sesi\xF3n"
      },
      steps: {
        accountInformation: "Informaci\xF3n de la cuenta",
        confirmEmail: "Confirmar correo electr\xF3nico",
        confirmPhone: "Confirmar tel\xE9fono",
        accountCreated: "CUENTA CREADA CON \xC9XITO"
      },
      changeEmail: {
        changeEmail: "Cambiar correo",
        newEmail: "Nuevo correo electr\xF3nico",
        title: "Cambiar correo electr\xF3nico",
        description: "Ingresa un correo electr\xF3nico diferente para enviarte un nuevo c\xF3digo de verificaci\xF3n.",
        sendVerificationCode: "Enviar c\xF3digo de verificaci\xF3n"
      },
      changePhone: {
        changePhoneNumber: "Cambiar n\xFAmero de tel\xE9fono",
        newPhone: "Nuevo n\xFAmero de tel\xE9fono",
        description: "Ingresa un n\xFAmero de tel\xE9fono diferente para enviarte un nuevo c\xF3digo de verificaci\xF3n."
      }
    },
    signUpInvitation: {
      welcome: "\xA1Bienvenido a TABLETURN!",
      description: "te ha invitado a unirte a su organizaci\xF3n en Tableturn. Por favor crea una cuenta para comenzar.",
      getStarted: "Get Started"
    }
  },
  loggedIn: {
    myOrganizations: {
      title: "Seleccione una organizaci\xF3n para continuar",
      description: "Puedes a\xF1adir una nueva organizaci\xF3n si la organizaci\xF3n no esta en la lista",
      addOrganization: "A\xF1adir organizaci\xF3n"
    }
  },
  reports: {
    addEditScreen: {
      customReportsEdit: "Editar Informe Personalizado",
      customReportsAdd: "Agregar Informe Personalizado",
      itemComboSalesReportsEdit: "Editar Informe de Ventas de Combo de Art\xEDculos",
      itemComboSalesReportsAdd: "Agregar Informe de Ventas de Combo de Art\xEDculos",
      salesOverviewReportsEdit: "Editar Informe de Resumen de Ventas",
      salesOverviewReportsAdd: "Agregar Informe de Resumen de Ventas",
      endOfShiftReportsEdit: "Editar Informe de Fin de Turno",
      endOfShiftReportsAdd: "Agregar Informe de Fin de Turno",
      creditCardBatchReportsEdit: "Editar Informe de Cobros de Tarjeta de Cr\xE9dito",
      creditCardBatchReportsAdd: "Agregar Informe de Cobros de Tarjeta de Cr\xE9dito",
      employeeSalesAndTipsReportsEdit: "Editar Informe de Ventas por Empleado",
      employeeSalesAndTipsReportsAdd: "Agregar Informe de Ventas por Empleado",
      voidReasonsReportsEdit: "Editar Informe de Razones de Anulado",
      voidReasonsReportsAdd: "Agregar Informe de Razones de Anulado",
      inventoryOnHandReportsEdit: "Editar Informe de Inventario",
      inventoryOnHandReportsAdd: "Agregar Informe de Inventario",
      creditBalancesReportsEdit: "Editar Informe de Saldos de Cr\xE9dito",
      creditBalancesReportsAdd: "Agregar Informe de Saldos de Cr\xE9dito",
      reportSettings: "CONFIGURACI\xD3N DE INFORMES",
      scheduling: "Programaci\xF3n"
    },
    displaySettings: "Configuraci\xF3n de Datos",
    filtros: "Filtros",
    fields: {
      name: "Nombre",
      isFavorited: "Favorito",
      isActive: "Estatus",
      groupBy: "Agrupar Por",
      groupByOptions: {
        category: "Categor\xEDas",
        reporting_groups: "Grupos de Reporte"
      },
      reportType: "Tipo de Reporte",
      reportPeriod: "Periodo del Reporte",
      period: "Tiempo",
      periodSubtitle: "El periodo del informe se basa en un d\xEDa de trabajo que termina a las {{time}}.",
      periodOptions: {
        custom: "Personalizado",
        specificDate: "Fecha Espec\xEDfica",
        today: "Hoy",
        yesterday: "Ayer",
        this_week: "Esta Semana",
        last_week: "Semana Pasada",
        this_month: "Este Mes",
        last_month: "Mes Pasado",
        this_quarter: "Este Trimestre",
        last_quarter: "Trimestre Pasado",
        this_year: "Este A\xF1o",
        last_year: "A\xF1o Pasado"
      },
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      specificDate: "Fecha",
      categoryIds: "Categor\xEDas",
      subcategoryIds: "Subcategor\xEDas",
      reportingGroupIds: "Grupos de Reporte",
      orderStatuses: "Estados de Pedido",
      orderTypes: "Tipos de Pedido",
      orderTypeOptions: {
        "dine in": "Comer aqu\xED",
        to_go: "Para llevar",
        delivery: "Entrega",
        curbside: "Acera",
        catering: "Catering"
      },
      ownerIds: "Due\xF1os",
      showSalesByMenuType: "Mostrar Ordenes por Men\xFA",
      showSalesByOrderType: "Mostrar Ordenes por Tipo de Pedido",
      isSchedulingEnabled: "Programar",
      template: "Plantilla",
      templateOptions: {
        default: "Por Default",
        legacy: "Antigua"
      },
      fileType: "Tipo de Archivo",
      fileTypeOptions: {
        pdf: "PDF",
        csv: "CSV",
        xls: "XLS",
        json: "JSON"
      },
      scheduleStartDateTime: "Fecha de Inicio",
      repeatType: "Repetir",
      repeatTypeOptions: {
        daily: "Diario",
        weekly: "Semanal",
        quarterly: "Trimestral",
        monthly: "Mensual",
        yearly: "Anual"
      },
      recipients: "Destinatarios",
      noRecipients: "Sin destinatarios",
      showModItemsSales: "Mostrar Art\xEDculos Modificadores Con Precios",
      combineForAll: "Combinar para Todos",
      showSalesByRole: "Mostrar Ventas por Rol",
      doNotPrintOrderHistory: "No Imprimir Historial de la Orden"
    }
  },
  toasts: {
    customerRemoved: {
      title: "Cliente eliminado",
      description: "El cliente que est\xE1 editando no existe m\xE1s."
    },
    cannotAccessLocation: {
      title: "No Se Puede Acceder",
      description: "Tu usuario est\xE1 inactivo en esta ubicaci\xF3n."
    },
    settingRemoved: {
      title: "Configuraci\xF3n eliminada",
      description: "La configuraci\xF3n que est\xE1 editando no existe m\xE1s."
    }
  },
  managementModule: {
    employeesScreen: {
      title: "Empleados",
      topBar: {
        filters: {
          status: {
            title: "Estado Actual",
            all: "Todos",
            clockedIn: "Marc\xF3 entrada",
            clockedOut: "Marc\xF3 salida"
          }
        },
        clockedInThisPeriod: "Marc\xF3 entrada en este periodo",
        timePeriod: {
          title: "Periodo de Tiempo",
          today: "Hoy",
          yesterday: "Ayer",
          week: "Semana",
          month: "Mes",
          year: "A\xF1o",
          custom: {
            button: "Personalizado",
            start: "Fecha de inicio",
            end: "Fecha de fin"
          }
        }
      },
      employeesTable: {
        loading: "Cargando Empleados...",
        pin: "PIN",
        name: "Nombre",
        status: "Estado Actual",
        role: "Rol",
        hours: "Horas",
        sales: "Ventas",
        tipsEarned: "Propinas ganadas",
        tipsPaid: "Propinas pagadas",
        tipsDue: "Propinas debidas",
        actions: "Acciones",
        lastClockIn: "\xDAltima entrada",
        payTip: "Pagar Propina"
      },
      employeeDetailsTable: {
        loading: "Cargando Turnos...",
        payRollId: "ID de n\xF3mina",
        hoursWorked: "Horas trabajadas",
        shift: "Turno",
        report: "Reporte",
        addShift: "Agregar Turno",
        editShiftModal: {
          title: "Editar Turno",
          startOfShift: "Inicio del Turno",
          endOfShift: "Fin del Turno"
        }
      }
    }
  }
};
var resources = {
  en: {
    translation: en_default
  },
  es: {
    translation: es_default
  }
};
i18n.init({
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
    // not needed for react as it escapes by default
  },
  resources
});
if (i18n.services.formatter) {
  i18n.services.formatter.add("DATE", (value, lng, { timeZone }) => {
    const dateFormat = {
      weekday: "long",
      month: "short",
      day: "2-digit",
      timeZone
    };
    if (lng)
      return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(dateFormat);
    else
      return DateTime.fromJSDate(value).toLocaleString(dateFormat);
  });
  i18n.services.formatter.add("WEEKDAY", (value, lng, { timeZone }) => {
    const dateFormat = {
      weekday: "long",
      timeZone
    };
    if (lng)
      return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(dateFormat);
    else
      return DateTime.fromJSDate(value).toLocaleString(dateFormat);
  });
  i18n.services.formatter.add("DATE_HUGE", (value, lng) => {
    if (lng)
      return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime.DATE_HUGE);
    else
      return DateTime.fromJSDate(value).toLocaleString(DateTime.DATE_HUGE);
  });
  i18n.services.formatter.add(
    "TIME",
    (value, lng, { timeZone, addSeconds }) => {
      const timeFormat = __spreadProps(__spreadValues({
        hour: "numeric",
        minute: "2-digit"
      }, addSeconds ? { second: "2-digit" } : {}), {
        timeZone
      });
      let date = DateTime.fromJSDate(value);
      if (!date.isInDST) {
        date = date.plus({ hours: 1 });
      }
      if (lng)
        return date.setLocale(lng).toLocaleString(timeFormat);
      else
        return date.toLocaleString(timeFormat);
    }
  );
}
var i18n_config_default = i18n;

export { en_default, es_default, i18n_config_default };
